const tokens = {
  "breakpoints.sm": {
    "value": "20em",
    "variable": "var(--ikokJA)"
  },
  "breakpoints.md": {
    "value": "30em",
    "variable": "var(--kSvAmr)"
  },
  "breakpoints.lg": {
    "value": "48em",
    "variable": "var(--uwdhN)"
  },
  "breakpoints.xl": {
    "value": "64em",
    "variable": "var(--eyfDzy)"
  },
  "breakpoints.xxl": {
    "value": "80em",
    "variable": "var(--dymagS)"
  },
  "sizes.breakpoint-sm": {
    "value": "20em",
    "variable": "var(--eomHOU)"
  },
  "sizes.breakpoint-md": {
    "value": "30em",
    "variable": "var(--iujnmj)"
  },
  "sizes.breakpoint-lg": {
    "value": "48em",
    "variable": "var(--gThSgZ)"
  },
  "sizes.breakpoint-xl": {
    "value": "64em",
    "variable": "var(--cssArG)"
  },
  "sizes.breakpoint-xxl": {
    "value": "80em",
    "variable": "var(--bfIHqC)"
  },
  "spacing.-25": {
    "value": "var(--ieWSsg)",
    "variable": "var(--ieWSsg)"
  },
  "spacing.-50": {
    "value": "var(--kKbbUK)",
    "variable": "var(--kKbbUK)"
  },
  "spacing.-100": {
    "value": "var(--bIgSVm)",
    "variable": "var(--bIgSVm)"
  },
  "spacing.-150": {
    "value": "var(--hmVCZH)",
    "variable": "var(--hmVCZH)"
  },
  "spacing.-200": {
    "value": "var(--cJysOB)",
    "variable": "var(--cJysOB)"
  },
  "spacing.-250": {
    "value": "var(--bIrbJs)",
    "variable": "var(--bIrbJs)"
  },
  "spacing.-300": {
    "value": "var(--GHwVU)",
    "variable": "var(--GHwVU)"
  },
  "spacing.-350": {
    "value": "var(--gmJDqV)",
    "variable": "var(--gmJDqV)"
  },
  "spacing.-400": {
    "value": "var(--gqmheD)",
    "variable": "var(--gqmheD)"
  },
  "spacing.-500": {
    "value": "var(--envllW)",
    "variable": "var(--envllW)"
  },
  "spacing.-600": {
    "value": "var(--foMLfl)",
    "variable": "var(--foMLfl)"
  },
  "spacing.-700": {
    "value": "var(--dlVPmE)",
    "variable": "var(--dlVPmE)"
  },
  "spacing.-800": {
    "value": "var(--dUcYJv)",
    "variable": "var(--dUcYJv)"
  },
  "spacing.-900": {
    "value": "var(--bRmcQO)",
    "variable": "var(--bRmcQO)"
  },
  "spacing.-1000": {
    "value": "var(--iUTQca)",
    "variable": "var(--iUTQca)"
  },
  "spacing.-1100": {
    "value": "var(--drMEwr)",
    "variable": "var(--drMEwr)"
  },
  "spacing.-1200": {
    "value": "var(--bkFxjg)",
    "variable": "var(--bkFxjg)"
  },
  "spacing.-1300": {
    "value": "var(--gWTVct)",
    "variable": "var(--gWTVct)"
  },
  "spacing.-1400": {
    "value": "var(--iNucni)",
    "variable": "var(--iNucni)"
  },
  "spacing.-1500": {
    "value": "var(--dkmQHz)",
    "variable": "var(--dkmQHz)"
  },
  "spacing.-1600": {
    "value": "var(--bdfJuo)",
    "variable": "var(--bdfJuo)"
  },
  "spacing.-1800": {
    "value": "var(--dofCJK)",
    "variable": "var(--dofCJK)"
  },
  "spacing.-2400": {
    "value": "var(--jOLCgx)",
    "variable": "var(--jOLCgx)"
  },
  "spacing.-negative-25": {
    "value": "var(--cKgcde)",
    "variable": "var(--cKgcde)"
  },
  "spacing.-zero": {
    "value": "var(--LDKR)",
    "variable": "var(--LDKR)"
  },
  "spacing.Accordion.gap.-header-toPanel": {
    "value": "var(--bNqZoO)",
    "variable": "var(--bNqZoO)"
  },
  "spacing.Accordion.gap.-betweenAccordions": {
    "value": "var(--ffvvjI)",
    "variable": "var(--ffvvjI)"
  },
  "spacing.Accordion.Header.gap.-leading": {
    "value": "var(--bwpRTD)",
    "variable": "var(--bwpRTD)"
  },
  "spacing.Accordion.Header.gap.-trailing": {
    "value": "var(--dZFXRZ)",
    "variable": "var(--dZFXRZ)"
  },
  "spacing.Accordion.Header.gap.-trailingLabel-toIcon": {
    "value": "var(--eLQeLG)",
    "variable": "var(--eLQeLG)"
  },
  "spacing.Accordion.Header.padding.-horz": {
    "value": "var(--iuySXb)",
    "variable": "var(--iuySXb)"
  },
  "spacing.Accordion.Header.padding.-vert": {
    "value": "var(--eyrvPl)",
    "variable": "var(--eyrvPl)"
  },
  "spacing.Accordion.Panel.padding.-horz": {
    "value": "var(--hlrcK)",
    "variable": "var(--hlrcK)"
  },
  "spacing.Accordion.Panel.padding.-top": {
    "value": "var(--bZoLmy)",
    "variable": "var(--bZoLmy)"
  },
  "spacing.Accordion.Panel.padding.-bottom": {
    "value": "var(--eJStZW)",
    "variable": "var(--eJStZW)"
  },
  "spacing.AdornedInput.sm.gap.-input-toAdornment": {
    "value": "var(--giWyZn)",
    "variable": "var(--giWyZn)"
  },
  "spacing.AdornedInput.sm.padding.-horz": {
    "value": "var(--cktADH)",
    "variable": "var(--cktADH)"
  },
  "spacing.AdornedInput.sm.padding.-horz-readOnly": {
    "value": "var(--jcghdc)",
    "variable": "var(--jcghdc)"
  },
  "spacing.AdornedInput.sm.padding.-vert": {
    "value": "var(--kwodqp)",
    "variable": "var(--kwodqp)"
  },
  "spacing.AdornedInput.md.gap.-input-toAdornment": {
    "value": "var(--KPzA)",
    "variable": "var(--KPzA)"
  },
  "spacing.AdornedInput.md.padding.-horz": {
    "value": "var(--jSyZtM)",
    "variable": "var(--jSyZtM)"
  },
  "spacing.AdornedInput.md.padding.-horz-readOnly": {
    "value": "var(--iBRrrv)",
    "variable": "var(--iBRrrv)"
  },
  "spacing.AdornedInput.md.padding.-vert": {
    "value": "var(--hZgzVm)",
    "variable": "var(--hZgzVm)"
  },
  "spacing.AdornedInput.lg.gap.-input-toAdornment": {
    "value": "var(--duzHvi)",
    "variable": "var(--duzHvi)"
  },
  "spacing.AdornedInput.lg.padding.-horz": {
    "value": "var(--bWShQy)",
    "variable": "var(--bWShQy)"
  },
  "spacing.AdornedInput.lg.padding.-horz-readOnly": {
    "value": "var(--bSfKZF)",
    "variable": "var(--bSfKZF)"
  },
  "spacing.AdornedInput.lg.padding.-vert": {
    "value": "var(--eQVQQI)",
    "variable": "var(--eQVQQI)"
  },
  "spacing.Alert.gap.-content-toActions": {
    "value": "var(--eGWKPV)",
    "variable": "var(--eGWKPV)"
  },
  "spacing.Alert.gap.-leading": {
    "value": "var(--gXuGeT)",
    "variable": "var(--gXuGeT)"
  },
  "spacing.Alert.gap.-trailing": {
    "value": "var(--irgxnF)",
    "variable": "var(--irgxnF)"
  },
  "spacing.Alert.gap.message.-toFlexArea": {
    "value": "var(--cLyUkK)",
    "variable": "var(--cLyUkK)"
  },
  "spacing.Alert.padding.-horz": {
    "value": "var(--iqzGnv)",
    "variable": "var(--iqzGnv)"
  },
  "spacing.Alert.padding.-vert": {
    "value": "var(--qtDOZ)",
    "variable": "var(--qtDOZ)"
  },
  "spacing.Alert.CloseButton.margin.-top": {
    "value": "var(--gmvJmF)",
    "variable": "var(--gmvJmF)"
  },
  "spacing.Alert.CloseButton.margin.-right": {
    "value": "var(--hCMzIC)",
    "variable": "var(--hCMzIC)"
  },
  "spacing.Anchor.-icon-toLabel": {
    "value": "var(--kkfdlA)",
    "variable": "var(--kkfdlA)"
  },
  "spacing.Avatar.Badge.padding.sm.-default": {
    "value": "var(--iDvLBT)",
    "variable": "var(--iDvLBT)"
  },
  "spacing.Avatar.Badge.padding.sm.-bare": {
    "value": "var(--jQETGw)",
    "variable": "var(--jQETGw)"
  },
  "spacing.Avatar.Badge.padding.md.-default": {
    "value": "var(--gSeFVY)",
    "variable": "var(--gSeFVY)"
  },
  "spacing.Avatar.Badge.padding.md.-bare": {
    "value": "var(--koIlbn)",
    "variable": "var(--koIlbn)"
  },
  "spacing.Avatar.Badge.padding.lg.-default": {
    "value": "var(--vMQFG)",
    "variable": "var(--vMQFG)"
  },
  "spacing.Avatar.Badge.padding.lg.-bare": {
    "value": "var(--KhwPF)",
    "variable": "var(--KhwPF)"
  },
  "spacing.Avatar.Badge.offset.sm.-horz": {
    "value": "var(--kUuDvn)",
    "variable": "var(--kUuDvn)"
  },
  "spacing.Avatar.Badge.offset.sm.-vert": {
    "value": "var(--dOQuzN)",
    "variable": "var(--dOQuzN)"
  },
  "spacing.Avatar.Badge.offset.md.-horz": {
    "value": "var(--fdERLI)",
    "variable": "var(--fdERLI)"
  },
  "spacing.Avatar.Badge.offset.md.-vert": {
    "value": "var(--fslsBW)",
    "variable": "var(--fslsBW)"
  },
  "spacing.Avatar.Badge.offset.lg.-horz": {
    "value": "var(--rVvfG)",
    "variable": "var(--rVvfG)"
  },
  "spacing.Avatar.Badge.offset.lg.-vert": {
    "value": "var(--eURnlI)",
    "variable": "var(--eURnlI)"
  },
  "spacing.Badge.gap.-label-toIcon": {
    "value": "var(--cwZWSr)",
    "variable": "var(--cwZWSr)"
  },
  "spacing.Badge.padding.-horz": {
    "value": "var(--hfSeCc)",
    "variable": "var(--hfSeCc)"
  },
  "spacing.Badge.padding.-vert": {
    "value": "var(--heXOQG)",
    "variable": "var(--heXOQG)"
  },
  "spacing.Banner.gap.-leading": {
    "value": "var(--hGxWwp)",
    "variable": "var(--hGxWwp)"
  },
  "spacing.Banner.gap.-trailing": {
    "value": "var(--dQDpNT)",
    "variable": "var(--dQDpNT)"
  },
  "spacing.Banner.gap.text-toActions.-horz": {
    "value": "var(--kkQFep)",
    "variable": "var(--kkQFep)"
  },
  "spacing.Banner.gap.text-toActions.-vert": {
    "value": "var(--cDzzfb)",
    "variable": "var(--cDzzfb)"
  },
  "spacing.Banner.padding.-horz": {
    "value": "var(--koEjuJ)",
    "variable": "var(--koEjuJ)"
  },
  "spacing.Banner.padding.-vert": {
    "value": "var(--grHYuP)",
    "variable": "var(--grHYuP)"
  },
  "spacing.Banner.CloseButton.margin.-top": {
    "value": "var(--SaYWL)",
    "variable": "var(--SaYWL)"
  },
  "spacing.Banner.CloseButton.margin.-right": {
    "value": "var(--hsjrNs)",
    "variable": "var(--hsjrNs)"
  },
  "spacing.ButtonGroup.gap.-horz": {
    "value": "var(--kEzFgX)",
    "variable": "var(--kEzFgX)"
  },
  "spacing.ButtonGroup.gap.-vert": {
    "value": "var(--hdUbmd)",
    "variable": "var(--hdUbmd)"
  },
  "spacing.ButtonGroup.conjoined.gap.-default": {
    "value": "var(--wXnJf)",
    "variable": "var(--wXnJf)"
  },
  "spacing.ButtonGroup.conjoined.gap.-offsetBorder": {
    "value": "var(--jOoSsZ)",
    "variable": "var(--jOoSsZ)"
  },
  "spacing.ButtonGroup.bare.gap.-horz": {
    "value": "var(--Oqoky)",
    "variable": "var(--Oqoky)"
  },
  "spacing.ButtonGroup.bare.gap.-vert": {
    "value": "var(--kQreUc)",
    "variable": "var(--kQreUc)"
  },
  "spacing.ButtonGroup.textButton.padding.padding.-horz": {
    "value": "var(--XtnQS)",
    "variable": "var(--XtnQS)"
  },
  "spacing.ButtonGroup.textButton.padding.padding.-vert": {
    "value": "var(--chjxts)",
    "variable": "var(--chjxts)"
  },
  "spacing.Button.xs.gap.-label-toIcon": {
    "value": "var(--eABAkm)",
    "variable": "var(--eABAkm)"
  },
  "spacing.Button.xs.padding.-horz": {
    "value": "var(--evDSnJ)",
    "variable": "var(--evDSnJ)"
  },
  "spacing.Button.xs.padding.-vert": {
    "value": "var(--krIemT)",
    "variable": "var(--krIemT)"
  },
  "spacing.Button.sm.gap.-label-toIcon": {
    "value": "var(--hbtXPD)",
    "variable": "var(--hbtXPD)"
  },
  "spacing.Button.sm.padding.bare.-horz": {
    "value": "var(--ldipmR)",
    "variable": "var(--ldipmR)"
  },
  "spacing.Button.sm.padding.-horz": {
    "value": "var(--hbHbQA)",
    "variable": "var(--hbHbQA)"
  },
  "spacing.Button.sm.padding.-vert": {
    "value": "var(--eoWFjK)",
    "variable": "var(--eoWFjK)"
  },
  "spacing.Button.md.gap.-label-toIcon": {
    "value": "var(--iaPdzs)",
    "variable": "var(--iaPdzs)"
  },
  "spacing.Button.md.padding.bare.-horz": {
    "value": "var(--hHWvke)",
    "variable": "var(--hHWvke)"
  },
  "spacing.Button.md.padding.-horz": {
    "value": "var(--jpBmpz)",
    "variable": "var(--jpBmpz)"
  },
  "spacing.Button.md.padding.-vert": {
    "value": "var(--hUZAHR)",
    "variable": "var(--hUZAHR)"
  },
  "spacing.Button.lg.gap.-label-toIcon": {
    "value": "var(--ZFidy)",
    "variable": "var(--ZFidy)"
  },
  "spacing.Button.lg.padding.bare.-horz": {
    "value": "var(--kxVnxc)",
    "variable": "var(--kxVnxc)"
  },
  "spacing.Button.lg.padding.-horz": {
    "value": "var(--koxNQp)",
    "variable": "var(--koxNQp)"
  },
  "spacing.Button.lg.padding.-vert": {
    "value": "var(--gQLMgf)",
    "variable": "var(--gQLMgf)"
  },
  "spacing.Calendar.Body.gap.-header-toDays": {
    "value": "var(--dFyAoE)",
    "variable": "var(--dFyAoE)"
  },
  "spacing.Calendar.Body.padding.-horz": {
    "value": "var(--hUveGy)",
    "variable": "var(--hUveGy)"
  },
  "spacing.Calendar.Controls.-gap": {
    "value": "var(--daEYjf)",
    "variable": "var(--daEYjf)"
  },
  "spacing.Calendar.Controls.padding.-horz": {
    "value": "var(--pnGHi)",
    "variable": "var(--pnGHi)"
  },
  "spacing.Calendar.DayOfWeek.padding.-bottom": {
    "value": "var(--bqRvuH)",
    "variable": "var(--bqRvuH)"
  },
  "spacing.Calendar.Day.margin.-horz": {
    "value": "var(--cgwSnx)",
    "variable": "var(--cgwSnx)"
  },
  "spacing.Calendar.Day.margin.-vert": {
    "value": "var(--hslhYj)",
    "variable": "var(--hslhYj)"
  },
  "spacing.Calendar.Root.gap.-controls-toBody": {
    "value": "var(--eLFqsS)",
    "variable": "var(--eLFqsS)"
  },
  "spacing.Calendar.YearSelect.padding.-left": {
    "value": "var(--hWiArN)",
    "variable": "var(--hWiArN)"
  },
  "spacing.Calendar.YearSelect.gap.-select-toButton": {
    "value": "var(--bvJrtJ)",
    "variable": "var(--bvJrtJ)"
  },
  "spacing.Card.Footer.margin.-to-Body": {
    "value": "var(--bOnbxr)",
    "variable": "var(--bOnbxr)"
  },
  "spacing.Card.Footer.padding.-from-Footer": {
    "value": "var(--kNYjsI)",
    "variable": "var(--kNYjsI)"
  },
  "spacing.Card.Header.margin.-to-Body": {
    "value": "var(--dwuSMF)",
    "variable": "var(--dwuSMF)"
  },
  "spacing.Card.Header.padding.-from-Header": {
    "value": "var(--dcHlDg)",
    "variable": "var(--dcHlDg)"
  },
  "spacing.Card.Root.-padding": {
    "value": "var(--ByWEY)",
    "variable": "var(--ByWEY)"
  },
  "spacing.Carousel.Heading.gap.-heading-toNav": {
    "value": "var(--cODAIL)",
    "variable": "var(--cODAIL)"
  },
  "spacing.Carousel.Heading.gap.-heading-toDescription": {
    "value": "var(--hqSTyc)",
    "variable": "var(--hqSTyc)"
  },
  "spacing.Carousel.Heading.gap.-betweenNav": {
    "value": "var(--brfXwr)",
    "variable": "var(--brfXwr)"
  },
  "spacing.Carousel.Heading.padding.-headingArea-toSlideArray": {
    "value": "var(--gpBTCQ)",
    "variable": "var(--gpBTCQ)"
  },
  "spacing.Carousel.Root.-gap-carousel-toButton": {
    "value": "var(--brfroS)",
    "variable": "var(--brfroS)"
  },
  "spacing.Carousel.SkipLink.-margin": {
    "value": "var(--eICkag)",
    "variable": "var(--eICkag)"
  },
  "spacing.Carousel.SlideArray.padding.-top": {
    "value": "var(--gtcYMO)",
    "variable": "var(--gtcYMO)"
  },
  "spacing.Carousel.SlideArray.padding.-bottom": {
    "value": "var(--hqSBIm)",
    "variable": "var(--hqSBIm)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.none.-padding-horz": {
    "value": "var(--fpHVeU)",
    "variable": "var(--fpHVeU)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.xs.-padding-horz": {
    "value": "var(--jQCgnR)",
    "variable": "var(--jQCgnR)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.sm.-padding-horz": {
    "value": "var(--jHHxTg)",
    "variable": "var(--jHHxTg)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.md.-padding-horz": {
    "value": "var(--gnccdr)",
    "variable": "var(--gnccdr)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.lg.-padding-horz": {
    "value": "var(--fxDmsh)",
    "variable": "var(--fxDmsh)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.xl.-padding-horz": {
    "value": "var(--iygrpu)",
    "variable": "var(--iygrpu)"
  },
  "spacing.Carousel.SlideArray.slideGap.-xxs": {
    "value": "var(--bMeelm)",
    "variable": "var(--bMeelm)"
  },
  "spacing.Carousel.SlideArray.slideGap.-xs": {
    "value": "var(--iEOVPS)",
    "variable": "var(--iEOVPS)"
  },
  "spacing.Carousel.SlideArray.slideGap.-sm": {
    "value": "var(--leIUvH)",
    "variable": "var(--leIUvH)"
  },
  "spacing.Carousel.SlideArray.slideGap.-md": {
    "value": "var(--cFfLhw)",
    "variable": "var(--cFfLhw)"
  },
  "spacing.Carousel.SlideArray.slideGap.-lg": {
    "value": "var(--cgzvKq)",
    "variable": "var(--cgzvKq)"
  },
  "spacing.Carousel.SlideArray.slideGap.-xl": {
    "value": "var(--gRNUmF)",
    "variable": "var(--gRNUmF)"
  },
  "spacing.ChipGroup.gap.-horz": {
    "value": "var(--bpFLBX)",
    "variable": "var(--bpFLBX)"
  },
  "spacing.ChipGroup.gap.vert.-default": {
    "value": "var(--bASdGr)",
    "variable": "var(--bASdGr)"
  },
  "spacing.ChipGroup.gap.vert.-tighter": {
    "value": "var(--hhEQiB)",
    "variable": "var(--hhEQiB)"
  },
  "spacing.ChipGroup.padding.-horz": {
    "value": "var(--fgUYoc)",
    "variable": "var(--fgUYoc)"
  },
  "spacing.ChipGroup.padding.-vert": {
    "value": "var(--dfzGia)",
    "variable": "var(--dfzGia)"
  },
  "spacing.ChipGroup.padding.screen.-leading": {
    "value": "var(--fePwvu)",
    "variable": "var(--fePwvu)"
  },
  "spacing.ChipGroup.padding.screen.-trailing": {
    "value": "var(--dGbdfc)",
    "variable": "var(--dGbdfc)"
  },
  "spacing.Chip.padding.-horz": {
    "value": "var(--fTmwWf)",
    "variable": "var(--fTmwWf)"
  },
  "spacing.Chip.padding.-vert": {
    "value": "var(--dgnWVZ)",
    "variable": "var(--dgnWVZ)"
  },
  "spacing.Chip.gap.-leading": {
    "value": "var(--iyFPiX)",
    "variable": "var(--iyFPiX)"
  },
  "spacing.Chip.gap.-trailing": {
    "value": "var(--hXVhUN)",
    "variable": "var(--hXVhUN)"
  },
  "spacing.Chip.gap.-inputChip-trailing": {
    "value": "var(--dLTNDs)",
    "variable": "var(--dLTNDs)"
  },
  "spacing.Chip.Close.margin.-left": {
    "value": "var(--haKccD)",
    "variable": "var(--haKccD)"
  },
  "spacing.Chip.Close.-padding": {
    "value": "var(--jdixam)",
    "variable": "var(--jdixam)"
  },
  "spacing.CloseButton.-padding": {
    "value": "var(--hIkYOv)",
    "variable": "var(--hIkYOv)"
  },
  "spacing.CloseButton.-margin": {
    "value": "var(--ioAyOA)",
    "variable": "var(--ioAyOA)"
  },
  "spacing.Combobox.ChipsOverflow.trailingTextArea.gap.-limitNumber-toText": {
    "value": "var(--evRaQM)",
    "variable": "var(--evRaQM)"
  },
  "spacing.Combobox.Clear.margin.-horz": {
    "value": "var(--uyWED)",
    "variable": "var(--uyWED)"
  },
  "spacing.Combobox.Heading.gap.-leading": {
    "value": "var(--OuZxZ)",
    "variable": "var(--OuZxZ)"
  },
  "spacing.Combobox.Heading.padding.-horz": {
    "value": "var(--gEWQAJ)",
    "variable": "var(--gEWQAJ)"
  },
  "spacing.Combobox.Heading.padding.-vert": {
    "value": "var(--kGSZib)",
    "variable": "var(--kGSZib)"
  },
  "spacing.Combobox.Option.gap.-leading": {
    "value": "var(--efUQli)",
    "variable": "var(--efUQli)"
  },
  "spacing.Combobox.Option.padding.-horz": {
    "value": "var(--cEmPgy)",
    "variable": "var(--cEmPgy)"
  },
  "spacing.Combobox.Option.padding.-vert": {
    "value": "var(--eAPILw)",
    "variable": "var(--eAPILw)"
  },
  "spacing.Combobox.Trigger.sm.gap.-close-toSelect": {
    "value": "var(--cLDufK)",
    "variable": "var(--cLDufK)"
  },
  "spacing.Combobox.Trigger.sm.gap.-default": {
    "value": "var(--hKxeuB)",
    "variable": "var(--hKxeuB)"
  },
  "spacing.Combobox.Trigger.sm.gap.-trailing": {
    "value": "var(--hyUpmI)",
    "variable": "var(--hyUpmI)"
  },
  "spacing.Combobox.Trigger.sm.padding.-horz": {
    "value": "var(--hXvBKi)",
    "variable": "var(--hXvBKi)"
  },
  "spacing.Combobox.Trigger.sm.padding.-vert": {
    "value": "var(--EazRg)",
    "variable": "var(--EazRg)"
  },
  "spacing.Combobox.Trigger.md.gap.-close-toSelect": {
    "value": "var(--iHLLR)",
    "variable": "var(--iHLLR)"
  },
  "spacing.Combobox.Trigger.md.gap.-default": {
    "value": "var(--ZyjuC)",
    "variable": "var(--ZyjuC)"
  },
  "spacing.Combobox.Trigger.md.gap.-trailing": {
    "value": "var(--loeztP)",
    "variable": "var(--loeztP)"
  },
  "spacing.Combobox.Trigger.md.padding.-horz": {
    "value": "var(--cZhzap)",
    "variable": "var(--cZhzap)"
  },
  "spacing.Combobox.Trigger.md.padding.-vert": {
    "value": "var(--dfvEuv)",
    "variable": "var(--dfvEuv)"
  },
  "spacing.Combobox.Trigger.lg.gap.-close-toSelect": {
    "value": "var(--ilLOgL)",
    "variable": "var(--ilLOgL)"
  },
  "spacing.Combobox.Trigger.lg.gap.-default": {
    "value": "var(--fQJoMg)",
    "variable": "var(--fQJoMg)"
  },
  "spacing.Combobox.Trigger.lg.gap.-trailing": {
    "value": "var(--dZTStB)",
    "variable": "var(--dZTStB)"
  },
  "spacing.Combobox.Trigger.lg.padding.-horz": {
    "value": "var(--iFxhSD)",
    "variable": "var(--iFxhSD)"
  },
  "spacing.Combobox.Trigger.lg.padding.-vert": {
    "value": "var(--iTUIcF)",
    "variable": "var(--iTUIcF)"
  },
  "spacing.DateInput.sm.gap.-input-toAdornment": {
    "value": "var(--jOTGFE)",
    "variable": "var(--jOTGFE)"
  },
  "spacing.DateInput.sm.gap.-leading": {
    "value": "var(--iFUAoQ)",
    "variable": "var(--iFUAoQ)"
  },
  "spacing.DateInput.sm.gap.-trailing": {
    "value": "var(--fYwVCm)",
    "variable": "var(--fYwVCm)"
  },
  "spacing.DateInput.sm.padding.-horz": {
    "value": "var(--khbGKw)",
    "variable": "var(--khbGKw)"
  },
  "spacing.DateInput.sm.padding.-horz-readOnly": {
    "value": "var(--gITNIv)",
    "variable": "var(--gITNIv)"
  },
  "spacing.DateInput.sm.padding.-vert": {
    "value": "var(--eiKHUu)",
    "variable": "var(--eiKHUu)"
  },
  "spacing.DateInput.md.gap.-input-toAdornment": {
    "value": "var(--dZYgxr)",
    "variable": "var(--dZYgxr)"
  },
  "spacing.DateInput.md.gap.-leading": {
    "value": "var(--kPRNlP)",
    "variable": "var(--kPRNlP)"
  },
  "spacing.DateInput.md.gap.-trailing": {
    "value": "var(--kquzZV)",
    "variable": "var(--kquzZV)"
  },
  "spacing.DateInput.md.padding.-horz": {
    "value": "var(--cFsqub)",
    "variable": "var(--cFsqub)"
  },
  "spacing.DateInput.md.padding.-horz-readOnly": {
    "value": "var(--bDBNVE)",
    "variable": "var(--bDBNVE)"
  },
  "spacing.DateInput.md.padding.-vert": {
    "value": "var(--iTcIJp)",
    "variable": "var(--iTcIJp)"
  },
  "spacing.DateInput.lg.gap.-input-toAdornment": {
    "value": "var(--fcTFFd)",
    "variable": "var(--fcTFFd)"
  },
  "spacing.DateInput.lg.gap.-leading": {
    "value": "var(--DrCUF)",
    "variable": "var(--DrCUF)"
  },
  "spacing.DateInput.lg.gap.-trailing": {
    "value": "var(--hCcRnL)",
    "variable": "var(--hCcRnL)"
  },
  "spacing.DateInput.lg.padding.-horz": {
    "value": "var(--dInPBN)",
    "variable": "var(--dInPBN)"
  },
  "spacing.DateInput.lg.padding.-horz-readOnly": {
    "value": "var(--jyuhfe)",
    "variable": "var(--jyuhfe)"
  },
  "spacing.DateInput.lg.padding.-vert": {
    "value": "var(--lefWKz)",
    "variable": "var(--lefWKz)"
  },
  "spacing.DateInput.HelperArea.gap.-icon-toText": {
    "value": "var(--dPCHNL)",
    "variable": "var(--dPCHNL)"
  },
  "spacing.DatePicker.Backdrop.padding.default.-horz": {
    "value": "var(--eQOwou)",
    "variable": "var(--eQOwou)"
  },
  "spacing.DatePicker.Backdrop.padding.default.-vert": {
    "value": "var(--jqWtrY)",
    "variable": "var(--jqWtrY)"
  },
  "spacing.DatePicker.Content.padding.-vert": {
    "value": "var(--cggrVF)",
    "variable": "var(--cggrVF)"
  },
  "spacing.DatePicker.Content.padding.-horz": {
    "value": "var(--brmcbn)",
    "variable": "var(--brmcbn)"
  },
  "spacing.DatePicker.Footer.padding.-gap-toContent": {
    "value": "var(--krUHMJ)",
    "variable": "var(--krUHMJ)"
  },
  "spacing.DatePicker.Trigger.padding.sm.-horz": {
    "value": "var(--bDkaGd)",
    "variable": "var(--bDkaGd)"
  },
  "spacing.DatePicker.Trigger.padding.md.-horz": {
    "value": "var(--coGlie)",
    "variable": "var(--coGlie)"
  },
  "spacing.DatePicker.Trigger.padding.lg.-horz": {
    "value": "var(--htEqIo)",
    "variable": "var(--htEqIo)"
  },
  "spacing.DateTimeBlock.Root.gap.-toLabel": {
    "value": "var(--hRGpWX)",
    "variable": "var(--hRGpWX)"
  },
  "spacing.DateTimeBlock.Root.gap.-toTime": {
    "value": "var(--fIYUhg)",
    "variable": "var(--fIYUhg)"
  },
  "spacing.DateTimeBlock.Dates.gap.-toCard": {
    "value": "var(--dssjqc)",
    "variable": "var(--dssjqc)"
  },
  "spacing.DateTimeBlock.Dates.gap.-toNav": {
    "value": "var(--joEzQh)",
    "variable": "var(--joEzQh)"
  },
  "spacing.DateTimeBlock.Day.padding.-horz": {
    "value": "var(--jTsPvA)",
    "variable": "var(--jTsPvA)"
  },
  "spacing.DateTimeBlock.Day.padding.-vert": {
    "value": "var(--boTXJi)",
    "variable": "var(--boTXJi)"
  },
  "spacing.DateTimeBlock.Wrap.padding.horz.-outer": {
    "value": "var(--bPNWc)",
    "variable": "var(--bPNWc)"
  },
  "spacing.DateTimeBlock.Wrap.padding.horz.-inner": {
    "value": "var(--buLcuL)",
    "variable": "var(--buLcuL)"
  },
  "spacing.Dropdown.Body.padding.-horz": {
    "value": "var(--iDpjzn)",
    "variable": "var(--iDpjzn)"
  },
  "spacing.Dropdown.Body.padding.-vert": {
    "value": "var(--TEkWl)",
    "variable": "var(--TEkWl)"
  },
  "spacing.Dropdown.Footer.padding.-horz": {
    "value": "var(--exdgGe)",
    "variable": "var(--exdgGe)"
  },
  "spacing.Dropdown.Footer.padding.-vert": {
    "value": "var(--jwpFXA)",
    "variable": "var(--jwpFXA)"
  },
  "spacing.Dropdown.Heading.gap.-leading": {
    "value": "var(--limXIv)",
    "variable": "var(--limXIv)"
  },
  "spacing.Dropdown.Heading.padding.-horz": {
    "value": "var(--liLbbf)",
    "variable": "var(--liLbbf)"
  },
  "spacing.Dropdown.Heading.padding.-vert": {
    "value": "var(--gcxASd)",
    "variable": "var(--gcxASd)"
  },
  "spacing.FieldSet.gap.-controls-toHelperArea": {
    "value": "var(--bMcHtG)",
    "variable": "var(--bMcHtG)"
  },
  "spacing.FieldSet.gap.-controls-toLegendArea": {
    "value": "var(--dzLmtp)",
    "variable": "var(--dzLmtp)"
  },
  "spacing.FieldSet.helperArea.gap.-text-toIcon": {
    "value": "var(--fLvtit)",
    "variable": "var(--fLvtit)"
  },
  "spacing.FieldSet.labelArea.gap.-legend-toRequred": {
    "value": "var(--dnHVom)",
    "variable": "var(--dnHVom)"
  },
  "spacing.FieldSet.labelArea.gap.-legend-toOptional": {
    "value": "var(--UZRKA)",
    "variable": "var(--UZRKA)"
  },
  "spacing.FieldSet.labeledControlArea.gap.-vert": {
    "value": "var(--dTkVJe)",
    "variable": "var(--dTkVJe)"
  },
  "spacing.FieldSet.labeledControlArea.padding.-left": {
    "value": "var(--dlEvvf)",
    "variable": "var(--dlEvvf)"
  },
  "spacing.FormField.gap.-field-toHelperArea": {
    "value": "var(--dquxNs)",
    "variable": "var(--dquxNs)"
  },
  "spacing.FormField.gap.-field-toLabelArea": {
    "value": "var(--iSzYxI)",
    "variable": "var(--iSzYxI)"
  },
  "spacing.FormField.HelperArea.gap.-icon-toText": {
    "value": "var(--icfFMp)",
    "variable": "var(--icfFMp)"
  },
  "spacing.FormField.labelArea.gap.-label-toRequired": {
    "value": "var(--cMPOPA)",
    "variable": "var(--cMPOPA)"
  },
  "spacing.FormField.labelArea.gap.-label-toOptional": {
    "value": "var(--kstHYr)",
    "variable": "var(--kstHYr)"
  },
  "spacing.Form.FormActions.-marginTop": {
    "value": "var(--hItNSr)",
    "variable": "var(--hItNSr)"
  },
  "spacing.Form.FormField.-marginBottom": {
    "value": "var(--kQFJwY)",
    "variable": "var(--kQFJwY)"
  },
  "spacing.Form.FieldSet.-marginBottom": {
    "value": "var(--cjtJzQ)",
    "variable": "var(--cjtJzQ)"
  },
  "spacing.Gleam.padding.-horz": {
    "value": "var(--bKKlVz)",
    "variable": "var(--bKKlVz)"
  },
  "spacing.IconButton.xs.-padding": {
    "value": "var(--gCvLoM)",
    "variable": "var(--gCvLoM)"
  },
  "spacing.IconButton.sm.-padding": {
    "value": "var(--gCGMel)",
    "variable": "var(--gCGMel)"
  },
  "spacing.IconButton.md.-padding": {
    "value": "var(--exmvqC)",
    "variable": "var(--exmvqC)"
  },
  "spacing.IconButton.lg.-padding": {
    "value": "var(--kTjthY)",
    "variable": "var(--kTjthY)"
  },
  "spacing.InlineFeedback.gap.-icon-toText": {
    "value": "var(--JxPsN)",
    "variable": "var(--JxPsN)"
  },
  "spacing.Input.HelperArea.gap.-icon-toText": {
    "value": "var(--jMhILX)",
    "variable": "var(--jMhILX)"
  },
  "spacing.Input.sm.gap.-leading": {
    "value": "var(--dfmEQU)",
    "variable": "var(--dfmEQU)"
  },
  "spacing.Input.sm.gap.-trailing": {
    "value": "var(--gkPDwq)",
    "variable": "var(--gkPDwq)"
  },
  "spacing.Input.sm.padding.-horz": {
    "value": "var(--pRoqY)",
    "variable": "var(--pRoqY)"
  },
  "spacing.Input.sm.padding.-horz-readOnly": {
    "value": "var(--dZXdTf)",
    "variable": "var(--dZXdTf)"
  },
  "spacing.Input.sm.padding.-vert": {
    "value": "var(--pVTga)",
    "variable": "var(--pVTga)"
  },
  "spacing.Input.md.gap.-leading": {
    "value": "var(--fEScIz)",
    "variable": "var(--fEScIz)"
  },
  "spacing.Input.md.gap.-trailing": {
    "value": "var(--hDlZld)",
    "variable": "var(--hDlZld)"
  },
  "spacing.Input.md.padding.-horz": {
    "value": "var(--iZfXRz)",
    "variable": "var(--iZfXRz)"
  },
  "spacing.Input.md.padding.-horz-readOnly": {
    "value": "var(--emWtgg)",
    "variable": "var(--emWtgg)"
  },
  "spacing.Input.md.padding.-vert": {
    "value": "var(--jeiKV)",
    "variable": "var(--jeiKV)"
  },
  "spacing.Input.lg.gap.-leading": {
    "value": "var(--ihKinF)",
    "variable": "var(--ihKinF)"
  },
  "spacing.Input.lg.gap.-trailing": {
    "value": "var(--drlMfP)",
    "variable": "var(--drlMfP)"
  },
  "spacing.Input.lg.padding.-horz": {
    "value": "var(--mCtXJ)",
    "variable": "var(--mCtXJ)"
  },
  "spacing.Input.lg.padding.-horz-readOnly": {
    "value": "var(--kWVeqm)",
    "variable": "var(--kWVeqm)"
  },
  "spacing.Input.lg.padding.-vert": {
    "value": "var(--yzKXP)",
    "variable": "var(--yzKXP)"
  },
  "spacing.LabeledControl.gap.-control-toLabel": {
    "value": "var(--iyRHQq)",
    "variable": "var(--iyRHQq)"
  },
  "spacing.LabeledControl.padding.vert.-control": {
    "value": "var(--klgjbJ)",
    "variable": "var(--klgjbJ)"
  },
  "spacing.LabeledControl.padding.vert.-label": {
    "value": "var(--jjDwWg)",
    "variable": "var(--jjDwWg)"
  },
  "spacing.LabeledControl.padding.vert.switch.-md": {
    "value": "var(--IfNwo)",
    "variable": "var(--IfNwo)"
  },
  "spacing.LabeledControl.padding.vert.switch.-lg": {
    "value": "var(--jgSjDG)",
    "variable": "var(--jgSjDG)"
  },
  "spacing.LabeledInput.LabelArea.padding.top.-default": {
    "value": "var(--lbiAhm)",
    "variable": "var(--lbiAhm)"
  },
  "spacing.LabeledInput.LabelArea.padding.top.-active": {
    "value": "var(--fOdETB)",
    "variable": "var(--fOdETB)"
  },
  "spacing.LabeledInput.padding.-horz": {
    "value": "var(--itaYAE)",
    "variable": "var(--itaYAE)"
  },
  "spacing.LabeledInput.padding.-horz-readOnly": {
    "value": "var(--kWQsFH)",
    "variable": "var(--kWQsFH)"
  },
  "spacing.LabeledInput.padding.-top": {
    "value": "var(--fZXSoQ)",
    "variable": "var(--fZXSoQ)"
  },
  "spacing.LabeledInput.padding.-bottom": {
    "value": "var(--hHBZkU)",
    "variable": "var(--hHBZkU)"
  },
  "spacing.Layout.Content.-padding": {
    "value": "var(--bRUVWB)",
    "variable": "var(--bRUVWB)"
  },
  "spacing.Layout.Root.-gap": {
    "value": "var(--euQPXF)",
    "variable": "var(--euQPXF)"
  },
  "spacing.List.Item.padding.-horz": {
    "value": "var(--bByHKn)",
    "variable": "var(--bByHKn)"
  },
  "spacing.List.Item.padding.-vert": {
    "value": "var(--jCTNnJ)",
    "variable": "var(--jCTNnJ)"
  },
  "spacing.List.Item.padding.first.-top": {
    "value": "var(--khGGSU)",
    "variable": "var(--khGGSU)"
  },
  "spacing.List.Item.padding.last.-bottom": {
    "value": "var(--edKiiQ)",
    "variable": "var(--edKiiQ)"
  },
  "spacing.List.padding.-nested-horz": {
    "value": "var(--hXVPET)",
    "variable": "var(--hXVPET)"
  },
  "spacing.List.group-gap.-default": {
    "value": "var(--kdMLHa)",
    "variable": "var(--kdMLHa)"
  },
  "spacing.Menu.Heading.gap.-leading": {
    "value": "var(--kguSJj)",
    "variable": "var(--kguSJj)"
  },
  "spacing.Menu.Heading.padding.-horz": {
    "value": "var(--klUTcP)",
    "variable": "var(--klUTcP)"
  },
  "spacing.Menu.Heading.padding.-vert": {
    "value": "var(--bRbGeR)",
    "variable": "var(--bRbGeR)"
  },
  "spacing.Menu.Item.gap.-leading": {
    "value": "var(--enhQG)",
    "variable": "var(--enhQG)"
  },
  "spacing.Menu.Item.padding.-horz": {
    "value": "var(--cpRmZa)",
    "variable": "var(--cpRmZa)"
  },
  "spacing.Menu.Item.padding.-vert": {
    "value": "var(--coarbc)",
    "variable": "var(--coarbc)"
  },
  "spacing.Modal.Backdrop.padding.default.-horz": {
    "value": "var(--dWMTNz)",
    "variable": "var(--dWMTNz)"
  },
  "spacing.Modal.Backdrop.padding.default.-vert": {
    "value": "var(--fneGkh)",
    "variable": "var(--fneGkh)"
  },
  "spacing.Modal.Backdrop.padding.fullScreen.-horz": {
    "value": "var(--jUawSX)",
    "variable": "var(--jUawSX)"
  },
  "spacing.Modal.Backdrop.padding.fullScreen.-vert": {
    "value": "var(--lgwPIJ)",
    "variable": "var(--lgwPIJ)"
  },
  "spacing.Modal.Body.padding.-horz": {
    "value": "var(--gJGKlL)",
    "variable": "var(--gJGKlL)"
  },
  "spacing.Modal.Body.padding.-vert": {
    "value": "var(--ginhbx)",
    "variable": "var(--ginhbx)"
  },
  "spacing.Modal.CloseButton.margin.-top": {
    "value": "var(--fHZiHg)",
    "variable": "var(--fHZiHg)"
  },
  "spacing.Modal.CloseButton.margin.-right": {
    "value": "var(--kdbPEP)",
    "variable": "var(--kdbPEP)"
  },
  "spacing.Modal.Content.-offset": {
    "value": "var(--hGGlpk)",
    "variable": "var(--hGGlpk)"
  },
  "spacing.Modal.Footer.padding.-horz": {
    "value": "var(--eLrTOK)",
    "variable": "var(--eLrTOK)"
  },
  "spacing.Modal.Footer.padding.-vert": {
    "value": "var(--kQXvXk)",
    "variable": "var(--kQXvXk)"
  },
  "spacing.Modal.Header.padding.-left": {
    "value": "var(--cZODTM)",
    "variable": "var(--cZODTM)"
  },
  "spacing.Modal.Header.padding.-vert": {
    "value": "var(--eIeyvq)",
    "variable": "var(--eIeyvq)"
  },
  "spacing.Modal.Header.padding.-right": {
    "value": "var(--gfrCur)",
    "variable": "var(--gfrCur)"
  },
  "spacing.NumberRating.gap.-star-toNumber": {
    "value": "var(--fIykaA)",
    "variable": "var(--fIykaA)"
  },
  "spacing.Page.padding.horz.-desktop": {
    "value": "var(--hnYpHx)",
    "variable": "var(--hnYpHx)"
  },
  "spacing.Page.padding.horz.-tablet": {
    "value": "var(--iFMWbV)",
    "variable": "var(--iFMWbV)"
  },
  "spacing.Page.padding.horz.-mobile": {
    "value": "var(--geTjSP)",
    "variable": "var(--geTjSP)"
  },
  "spacing.Page.padding.-bottom": {
    "value": "var(--iXcABO)",
    "variable": "var(--iXcABO)"
  },
  "spacing.Page.Breadcrumb.margin.top.-desktop": {
    "value": "var(--ifRZDY)",
    "variable": "var(--ifRZDY)"
  },
  "spacing.Page.Breadcrumb.margin.top.-tablet": {
    "value": "var(--keLiNY)",
    "variable": "var(--keLiNY)"
  },
  "spacing.Page.Breadcrumb.margin.top.-mobile": {
    "value": "var(--ejkCRy)",
    "variable": "var(--ejkCRy)"
  },
  "spacing.Page.Breadcrumb.margin.-bottom": {
    "value": "var(--eoKPXz)",
    "variable": "var(--eoKPXz)"
  },
  "spacing.Page.Content.margin.vert.-desktop": {
    "value": "var(--hMBFQY)",
    "variable": "var(--hMBFQY)"
  },
  "spacing.Page.Content.margin.vert.-tablet": {
    "value": "var(--gIawWs)",
    "variable": "var(--gIawWs)"
  },
  "spacing.Page.Content.margin.vert.-mobile": {
    "value": "var(--eNPPne)",
    "variable": "var(--eNPPne)"
  },
  "spacing.Page.Header.margin.bottom.-desktop": {
    "value": "var(--kAkcVA)",
    "variable": "var(--kAkcVA)"
  },
  "spacing.Page.Header.margin.bottom.-tablet": {
    "value": "var(--bzYExs)",
    "variable": "var(--bzYExs)"
  },
  "spacing.Page.Header.margin.bottom.-mobile": {
    "value": "var(--fsQubG)",
    "variable": "var(--fsQubG)"
  },
  "spacing.Page.Header.margin.top.-desktop": {
    "value": "var(--ifTgwQ)",
    "variable": "var(--ifTgwQ)"
  },
  "spacing.Page.Header.margin.top.-tablet": {
    "value": "var(--hQAGNU)",
    "variable": "var(--hQAGNU)"
  },
  "spacing.Page.Header.margin.top.-mobile": {
    "value": "var(--eeatXS)",
    "variable": "var(--eeatXS)"
  },
  "spacing.Pagination.Item.-between-pages": {
    "value": "var(--cBFJON)",
    "variable": "var(--cBFJON)"
  },
  "spacing.Pagination.JumpItem.-to-controls": {
    "value": "var(--fJoCVK)",
    "variable": "var(--fJoCVK)"
  },
  "spacing.Pagination.JumpItem.padding.-horz": {
    "value": "var(--dBcrqX)",
    "variable": "var(--dBcrqX)"
  },
  "spacing.Pagination.JumpItem.padding.-vert": {
    "value": "var(--cQtiUd)",
    "variable": "var(--cQtiUd)"
  },
  "spacing.Pagination.Root.-gap-toDivider": {
    "value": "var(--bEhpys)",
    "variable": "var(--bEhpys)"
  },
  "spacing.PhotoCarousel.Dots.-gap-betweenMarkers": {
    "value": "var(--daecYr)",
    "variable": "var(--daecYr)"
  },
  "spacing.PhotoCarousel.Dots.margin.-bottom": {
    "value": "var(--gTrRnX)",
    "variable": "var(--gTrRnX)"
  },
  "spacing.PhotoCarousel.Dots.padding.-horz": {
    "value": "var(--itTKAI)",
    "variable": "var(--itTKAI)"
  },
  "spacing.PhotoCarousel.Dots.padding.-vert": {
    "value": "var(--lhqmIi)",
    "variable": "var(--lhqmIi)"
  },
  "spacing.Popover.Backdrop.padding.default.-horz": {
    "value": "var(--ePmISV)",
    "variable": "var(--ePmISV)"
  },
  "spacing.Popover.Backdrop.padding.default.-vert": {
    "value": "var(--bFEQiL)",
    "variable": "var(--bFEQiL)"
  },
  "spacing.Popover.Body.padding.-horz": {
    "value": "var(--kcThjh)",
    "variable": "var(--kcThjh)"
  },
  "spacing.Popover.Body.padding.-vert": {
    "value": "var(--jciJBL)",
    "variable": "var(--jciJBL)"
  },
  "spacing.Popover.CloseButton.margin.-top": {
    "value": "var(--gOcrjS)",
    "variable": "var(--gOcrjS)"
  },
  "spacing.Popover.CloseButton.margin.-right": {
    "value": "var(--CeQbN)",
    "variable": "var(--CeQbN)"
  },
  "spacing.Popover.Header.gap.-leading": {
    "value": "var(--kxAJFK)",
    "variable": "var(--kxAJFK)"
  },
  "spacing.Popover.Header.padding.-left": {
    "value": "var(--ehavRK)",
    "variable": "var(--ehavRK)"
  },
  "spacing.Popover.Header.padding.-vert": {
    "value": "var(--kEeelc)",
    "variable": "var(--kEeelc)"
  },
  "spacing.Popover.Header.padding.-right": {
    "value": "var(--ioWowZ)",
    "variable": "var(--ioWowZ)"
  },
  "spacing.ProgressMeter.gap.-label-toMeta": {
    "value": "var(--bfbDpi)",
    "variable": "var(--bfbDpi)"
  },
  "spacing.ProgressMeter.gap.horizontal.-node-toLabel": {
    "value": "var(--hcYNuk)",
    "variable": "var(--hcYNuk)"
  },
  "spacing.ProgressMeter.gap.vertical.-node-toLabel": {
    "value": "var(--jVfGpA)",
    "variable": "var(--jVfGpA)"
  },
  "spacing.ProgressMeter.padding.-tag-top": {
    "value": "var(--hRHmIs)",
    "variable": "var(--hRHmIs)"
  },
  "spacing.PropertyCard.BadgeArea.-gap": {
    "value": "var(--cSGGbk)",
    "variable": "var(--cSGGbk)"
  },
  "spacing.PropertyCard.Badge.padding.-horz": {
    "value": "var(--gJKbyC)",
    "variable": "var(--gJKbyC)"
  },
  "spacing.PropertyCard.Badge.padding.-vert": {
    "value": "var(--iXTKxQ)",
    "variable": "var(--iXTKxQ)"
  },
  "spacing.PropertyCard.DataArea.dataDivider.-gap-toDataItem": {
    "value": "var(--MlMti)",
    "variable": "var(--MlMti)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.between-dataItems.-default": {
    "value": "var(--bTLfsn)",
    "variable": "var(--bTLfsn)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.between-dataItems.-loading": {
    "value": "var(--dMXXdC)",
    "variable": "var(--dMXXdC)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.-dataArea1-toIcon": {
    "value": "var(--hDVbwX)",
    "variable": "var(--hDVbwX)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.-horz": {
    "value": "var(--gnCbqQ)",
    "variable": "var(--gnCbqQ)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.-top": {
    "value": "var(--bsXpWo)",
    "variable": "var(--bsXpWo)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.-bottom": {
    "value": "var(--iKVqPg)",
    "variable": "var(--iKVqPg)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.between-dataItems.-default": {
    "value": "var(--bdBQll)",
    "variable": "var(--bdBQll)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.between-dataItems.-loading": {
    "value": "var(--fmNUyQ)",
    "variable": "var(--fmNUyQ)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.-dataArea1-toIcon": {
    "value": "var(--hnhnEZ)",
    "variable": "var(--hnhnEZ)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.-horz": {
    "value": "var(--bblBne)",
    "variable": "var(--bblBne)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.-top": {
    "value": "var(--fppvLi)",
    "variable": "var(--fppvLi)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.-bottom": {
    "value": "var(--cRlyXe)",
    "variable": "var(--cRlyXe)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.between-dataItems.-default": {
    "value": "var(--daEFPI)",
    "variable": "var(--daEFPI)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.between-dataItems.-loading": {
    "value": "var(--kmjEeB)",
    "variable": "var(--kmjEeB)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.-dataArea1-toIcon": {
    "value": "var(--fvjhEs)",
    "variable": "var(--fvjhEs)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.-horz": {
    "value": "var(--cTilsH)",
    "variable": "var(--cTilsH)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.-top": {
    "value": "var(--eEJIpr)",
    "variable": "var(--eEJIpr)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.-bottom": {
    "value": "var(--ZnlKz)",
    "variable": "var(--ZnlKz)"
  },
  "spacing.PropertyCard.FlexArea.gap.-dataWrapper-toFlexArea": {
    "value": "var(--fHKjRO)",
    "variable": "var(--fHKjRO)"
  },
  "spacing.PropertyCard.FlexArea.padding.-horz": {
    "value": "var(--gDXDFn)",
    "variable": "var(--gDXDFn)"
  },
  "spacing.PropertyCard.FlexArea.padding.-vert": {
    "value": "var(--iBIBiJ)",
    "variable": "var(--iBIBiJ)"
  },
  "spacing.PropertyCard.PhotoHeader.margin.-horz": {
    "value": "var(--gQLpmv)",
    "variable": "var(--gQLpmv)"
  },
  "spacing.PropertyCard.PhotoHeader.margin.-vert": {
    "value": "var(--hASgMx)",
    "variable": "var(--hASgMx)"
  },
  "spacing.PropertyCard.PhotoFooter.logo.padding.-horz": {
    "value": "var(--hlfwJk)",
    "variable": "var(--hlfwJk)"
  },
  "spacing.PropertyCard.PhotoFooter.logo.padding.-vert": {
    "value": "var(--bvYjsK)",
    "variable": "var(--bvYjsK)"
  },
  "spacing.PropertyCard.Root.sm.gap.-card-toDataArea5": {
    "value": "var(--leTSFy)",
    "variable": "var(--leTSFy)"
  },
  "spacing.PropertyCard.Root.horiz.gap.-card-toDataArea5": {
    "value": "var(--bEpUmm)",
    "variable": "var(--bEpUmm)"
  },
  "spacing.PropertyCard.SaveButton.padding.-top": {
    "value": "var(--cujLhE)",
    "variable": "var(--cujLhE)"
  },
  "spacing.PropertyCard.SaveButton.padding.-right": {
    "value": "var(--gncOYP)",
    "variable": "var(--gncOYP)"
  },
  "spacing.PropertyCard.SaveButton.padding.-bottom": {
    "value": "var(--gATURI)",
    "variable": "var(--gATURI)"
  },
  "spacing.PropertyCard.SaveButton.padding.-left": {
    "value": "var(--kkcFcY)",
    "variable": "var(--kkcFcY)"
  },
  "spacing.Range.Root.margin.-vert": {
    "value": "var(--ebimgE)",
    "variable": "var(--ebimgE)"
  },
  "spacing.Range.Handle.margin.-top": {
    "value": "var(--ckWLMC)",
    "variable": "var(--ckWLMC)"
  },
  "spacing.RatingStars.gap.-between-stars": {
    "value": "var(--fFJOJd)",
    "variable": "var(--fFJOJd)"
  },
  "spacing.RatingStars.gap.-stars-toContent": {
    "value": "var(--cNHGJR)",
    "variable": "var(--cNHGJR)"
  },
  "spacing.RatingStars.gap.-star-toNumber": {
    "value": "var(--jBfKhs)",
    "variable": "var(--jBfKhs)"
  },
  "spacing.RatingStars.gap.-divider-toContent": {
    "value": "var(--SIBf)",
    "variable": "var(--SIBf)"
  },
  "spacing.ShowHide.Button.margin.-top": {
    "value": "var(--erXIUm)",
    "variable": "var(--erXIUm)"
  },
  "spacing.ShowHide.gap.-label-toIcon": {
    "value": "var(--jjEfAp)",
    "variable": "var(--jjEfAp)"
  },
  "spacing.ShowHide.gap.-button-toContent": {
    "value": "var(--ekXPFz)",
    "variable": "var(--ekXPFz)"
  },
  "spacing.Switch.Track.md.padding.-horz": {
    "value": "var(--bMdaDF)",
    "variable": "var(--bMdaDF)"
  },
  "spacing.Switch.Track.md.padding.-vert": {
    "value": "var(--bndXcH)",
    "variable": "var(--bndXcH)"
  },
  "spacing.Switch.Track.lg.padding.-horz": {
    "value": "var(--bEWBPD)",
    "variable": "var(--bEWBPD)"
  },
  "spacing.Switch.Track.lg.padding.-vert": {
    "value": "var(--cgYpWl)",
    "variable": "var(--cgYpWl)"
  },
  "spacing.Switch.Handle.md.position.-top": {
    "value": "var(--hLAhSQ)",
    "variable": "var(--hLAhSQ)"
  },
  "spacing.Switch.Handle.md.position.-left": {
    "value": "var(--kgwRjw)",
    "variable": "var(--kgwRjw)"
  },
  "spacing.Switch.Handle.lg.position.-top": {
    "value": "var(--bnQnIW)",
    "variable": "var(--bnQnIW)"
  },
  "spacing.Switch.Handle.lg.position.-left": {
    "value": "var(--dIMWZC)",
    "variable": "var(--dIMWZC)"
  },
  "spacing.Table.Cell.gap.-icon-toLabel": {
    "value": "var(--bYZrAz)",
    "variable": "var(--bYZrAz)"
  },
  "spacing.Table.Cell.padding.size.sm.-horz": {
    "value": "var(--cqdTGj)",
    "variable": "var(--cqdTGj)"
  },
  "spacing.Table.Cell.padding.size.sm.-vert": {
    "value": "var(--gFctQl)",
    "variable": "var(--gFctQl)"
  },
  "spacing.Table.Cell.padding.size.md.-horz": {
    "value": "var(--hXJpwg)",
    "variable": "var(--hXJpwg)"
  },
  "spacing.Table.Cell.padding.size.md.-vert": {
    "value": "var(--jnwRqe)",
    "variable": "var(--jnwRqe)"
  },
  "spacing.Table.Cell.padding.size.lg.-horz": {
    "value": "var(--cxwWLi)",
    "variable": "var(--cxwWLi)"
  },
  "spacing.Table.Cell.padding.size.lg.-vert": {
    "value": "var(--dsWmDY)",
    "variable": "var(--dsWmDY)"
  },
  "spacing.Tabs.gap.-leading": {
    "value": "var(--fYbadB)",
    "variable": "var(--fYbadB)"
  },
  "spacing.Tabs.gap.-trailing": {
    "value": "var(--bYpqpT)",
    "variable": "var(--bYpqpT)"
  },
  "spacing.Tabs.-offsetBorder": {
    "value": "var(--dfAadf)",
    "variable": "var(--dfAadf)"
  },
  "spacing.Tabs.padding.-panel": {
    "value": "var(--gWIeqQ)",
    "variable": "var(--gWIeqQ)"
  },
  "spacing.Tabs.padding.-horz": {
    "value": "var(--jxAGIl)",
    "variable": "var(--jxAGIl)"
  },
  "spacing.Tabs.padding.-vert": {
    "value": "var(--khVvNT)",
    "variable": "var(--khVvNT)"
  },
  "spacing.Tabs.padding.file.active.-top": {
    "value": "var(--dvTDYf)",
    "variable": "var(--dvTDYf)"
  },
  "spacing.Tag.sm.gap.-label-toIcon": {
    "value": "var(--ioVLjH)",
    "variable": "var(--ioVLjH)"
  },
  "spacing.Tag.sm.padding.-horz": {
    "value": "var(--dDoFBQ)",
    "variable": "var(--dDoFBQ)"
  },
  "spacing.Tag.sm.padding.-vert": {
    "value": "var(--idUucK)",
    "variable": "var(--idUucK)"
  },
  "spacing.Tag.md.gap.-label-toIcon": {
    "value": "var(--cFfuoA)",
    "variable": "var(--cFfuoA)"
  },
  "spacing.Tag.md.padding.-horz": {
    "value": "var(--haOdqX)",
    "variable": "var(--haOdqX)"
  },
  "spacing.Tag.md.padding.-vert": {
    "value": "var(--QKiwd)",
    "variable": "var(--QKiwd)"
  },
  "spacing.TextButton.gap.-label-toIcon": {
    "value": "var(--jDlTnB)",
    "variable": "var(--jDlTnB)"
  },
  "spacing.TextButton.padding.-horz": {
    "value": "var(--eqFQxq)",
    "variable": "var(--eqFQxq)"
  },
  "spacing.TextButton.padding.-vert": {
    "value": "var(--fzZijY)",
    "variable": "var(--fzZijY)"
  },
  "spacing.Textarea.padding.-horz": {
    "value": "var(--gEyEaD)",
    "variable": "var(--gEyEaD)"
  },
  "spacing.Textarea.padding.-horz-readOnly": {
    "value": "var(--vEpgo)",
    "variable": "var(--vEpgo)"
  },
  "spacing.Textarea.padding.-vert": {
    "value": "var(--kVwiEp)",
    "variable": "var(--kVwiEp)"
  },
  "spacing.Toast.gap.-content-toAction": {
    "value": "var(--iXated)",
    "variable": "var(--iXated)"
  },
  "spacing.Toast.gap.-leading": {
    "value": "var(--dRdCFI)",
    "variable": "var(--dRdCFI)"
  },
  "spacing.Toast.gap.-trailing": {
    "value": "var(--eoFbYO)",
    "variable": "var(--eoFbYO)"
  },
  "spacing.Toast.padding.-horz": {
    "value": "var(--iThVU)",
    "variable": "var(--iThVU)"
  },
  "spacing.Toast.padding.-vert": {
    "value": "var(--caNeNe)",
    "variable": "var(--caNeNe)"
  },
  "spacing.Toast.CloseButton.margin.-top": {
    "value": "var(--gGJMCC)",
    "variable": "var(--gGJMCC)"
  },
  "spacing.Toast.CloseButton.margin.-right": {
    "value": "var(--euRCSx)",
    "variable": "var(--euRCSx)"
  },
  "spacing.ToggleButton.sm.gap.-label-toIcon": {
    "value": "var(--gtgfbp)",
    "variable": "var(--gtgfbp)"
  },
  "spacing.ToggleButton.sm.padding.bare.-horz": {
    "value": "var(--gGJogb)",
    "variable": "var(--gGJogb)"
  },
  "spacing.ToggleButton.sm.padding.bare.-horz-narrow": {
    "value": "var(--cJpYmt)",
    "variable": "var(--cJpYmt)"
  },
  "spacing.ToggleButton.sm.padding.bare.-horz-narrowest": {
    "value": "var(--dqbDeH)",
    "variable": "var(--dqbDeH)"
  },
  "spacing.ToggleButton.sm.padding.-horz": {
    "value": "var(--eiQEuW)",
    "variable": "var(--eiQEuW)"
  },
  "spacing.ToggleButton.sm.padding.-vert": {
    "value": "var(--jNnzUs)",
    "variable": "var(--jNnzUs)"
  },
  "spacing.ToggleButton.md.gap.-label-toIcon": {
    "value": "var(--fjSVfq)",
    "variable": "var(--fjSVfq)"
  },
  "spacing.ToggleButton.md.padding.bare.-horz": {
    "value": "var(--dwYtSU)",
    "variable": "var(--dwYtSU)"
  },
  "spacing.ToggleButton.md.padding.bare.-horz-narrow": {
    "value": "var(--fgZCvW)",
    "variable": "var(--fgZCvW)"
  },
  "spacing.ToggleButton.md.padding.bare.-horz-narrowest": {
    "value": "var(--cWeqzc)",
    "variable": "var(--cWeqzc)"
  },
  "spacing.ToggleButton.md.padding.-horz": {
    "value": "var(--fHajJ)",
    "variable": "var(--fHajJ)"
  },
  "spacing.ToggleButton.md.padding.-vert": {
    "value": "var(--dKVsMv)",
    "variable": "var(--dKVsMv)"
  },
  "spacing.ToggleButton.lg.gap.-label-toIcon": {
    "value": "var(--gMSDxQ)",
    "variable": "var(--gMSDxQ)"
  },
  "spacing.ToggleButton.lg.padding.bare.-horz": {
    "value": "var(--kEUXji)",
    "variable": "var(--kEUXji)"
  },
  "spacing.ToggleButton.lg.padding.bare.-horz-narrow": {
    "value": "var(--frFILY)",
    "variable": "var(--frFILY)"
  },
  "spacing.ToggleButton.lg.padding.bare.-horz-narrowest": {
    "value": "var(--caDONi)",
    "variable": "var(--caDONi)"
  },
  "spacing.ToggleButton.lg.padding.-horz": {
    "value": "var(--kFyAvX)",
    "variable": "var(--kFyAvX)"
  },
  "spacing.ToggleButton.lg.padding.-vert": {
    "value": "var(--eNTpWF)",
    "variable": "var(--eNTpWF)"
  },
  "spacing.ToggleCard.Footer.margin.-to-Body": {
    "value": "var(--gSeOjl)",
    "variable": "var(--gSeOjl)"
  },
  "spacing.ToggleCard.Footer.padding.-from-Footer": {
    "value": "var(--jpBqSy)",
    "variable": "var(--jpBqSy)"
  },
  "spacing.ToggleCard.Header.margin.-to-Body": {
    "value": "var(--fSjNIT)",
    "variable": "var(--fSjNIT)"
  },
  "spacing.ToggleCard.Header.padding.-from-Header": {
    "value": "var(--fgPYq)",
    "variable": "var(--fgPYq)"
  },
  "spacing.ToggleCard.Root.-padding": {
    "value": "var(--txHQa)",
    "variable": "var(--txHQa)"
  },
  "spacing.Tooltip.mWeb.padding.-horz": {
    "value": "var(--bOYYAQ)",
    "variable": "var(--bOYYAQ)"
  },
  "spacing.Tooltip.mWeb.padding.-vert": {
    "value": "var(--jEggW)",
    "variable": "var(--jEggW)"
  },
  "spacing.Tooltip.desktop.padding.-horz": {
    "value": "var(--ipLmUL)",
    "variable": "var(--ipLmUL)"
  },
  "spacing.Tooltip.desktop.padding.-vert": {
    "value": "var(--dkOyop)",
    "variable": "var(--dkOyop)"
  },
  "spacing.TriggerText.-padding": {
    "value": "var(--dbWCmG)",
    "variable": "var(--dbWCmG)"
  },
  "spacing.UpsellBanner.Action.margin.content-toActions.-horz": {
    "value": "var(--kvIRaJ)",
    "variable": "var(--kvIRaJ)"
  },
  "spacing.UpsellBanner.Action.margin.content-toActions.-vert": {
    "value": "var(--gqXmhD)",
    "variable": "var(--gqXmhD)"
  },
  "spacing.UpsellBanner.Body.margin.heading-toMessage.-horz": {
    "value": "var(--fUHwFU)",
    "variable": "var(--fUHwFU)"
  },
  "spacing.UpsellBanner.Body.margin.heading-toMessage.-vert": {
    "value": "var(--iqJBxK)",
    "variable": "var(--iqJBxK)"
  },
  "spacing.UpsellBanner.Header.margin.-content-toClose": {
    "value": "var(--gfbWGl)",
    "variable": "var(--gfbWGl)"
  },
  "spacing.UpsellBanner.Root.gap.-leading": {
    "value": "var(--iGkwIx)",
    "variable": "var(--iGkwIx)"
  },
  "spacing.UpsellBanner.Root.gap.-trailing": {
    "value": "var(--kNMYvT)",
    "variable": "var(--kNMYvT)"
  },
  "spacing.UpsellBanner.Root.padding.-horz": {
    "value": "var(--iDhaul)",
    "variable": "var(--iDhaul)"
  },
  "spacing.UpsellBanner.Root.padding.-vert": {
    "value": "var(--bfVzDn)",
    "variable": "var(--bfVzDn)"
  },
  "spacing.UpsellBanner.CloseButton.margin.-top": {
    "value": "var(--hJHynY)",
    "variable": "var(--hJHynY)"
  },
  "spacing.UpsellBanner.CloseButton.margin.-right": {
    "value": "var(--cZWSCT)",
    "variable": "var(--cZWSCT)"
  },
  "spacing.Upsell.Action.margin.-content-toActions": {
    "value": "var(--eykslP)",
    "variable": "var(--eykslP)"
  },
  "spacing.Upsell.Body.margin.-heading-toMessage": {
    "value": "var(--cpFKXy)",
    "variable": "var(--cpFKXy)"
  },
  "spacing.Upsell.Header.gap.-content-toClose": {
    "value": "var(--XCyuN)",
    "variable": "var(--XCyuN)"
  },
  "spacing.Upsell.Legal.margin.-content-toActions": {
    "value": "var(--vkpyO)",
    "variable": "var(--vkpyO)"
  },
  "spacing.Upsell.Root.gap.-img-toText": {
    "value": "var(--laNBLB)",
    "variable": "var(--laNBLB)"
  },
  "spacing.Upsell.Root.gap.-icon-toText": {
    "value": "var(--gCsqnd)",
    "variable": "var(--gCsqnd)"
  },
  "spacing.Upsell.Root.padding.-horz": {
    "value": "var(--aAMAN)",
    "variable": "var(--aAMAN)"
  },
  "spacing.Upsell.Root.padding.-vert": {
    "value": "var(--jaTNpz)",
    "variable": "var(--jaTNpz)"
  },
  "spacing.Upsell.CloseButton.margin.-top": {
    "value": "var(--wsvUA)",
    "variable": "var(--wsvUA)"
  },
  "spacing.Upsell.CloseButton.margin.-right": {
    "value": "var(--bpUfxn)",
    "variable": "var(--bpUfxn)"
  },
  "spacing.VerticalNav.Divider.padding.-vert": {
    "value": "var(--dAQaqk)",
    "variable": "var(--dAQaqk)"
  },
  "spacing.VerticalNav.Divider.gap.-toNavItems": {
    "value": "var(--coeCWC)",
    "variable": "var(--coeCWC)"
  },
  "spacing.VerticalNav.Heading.padding.-horz": {
    "value": "var(--gMewhn)",
    "variable": "var(--gMewhn)"
  },
  "spacing.VerticalNav.Heading.padding.-vert": {
    "value": "var(--iLWGTF)",
    "variable": "var(--iLWGTF)"
  },
  "spacing.VerticalNav.Item.gap.-leading": {
    "value": "var(--bDlGZK)",
    "variable": "var(--bDlGZK)"
  },
  "spacing.VerticalNav.Item.padding.-horz": {
    "value": "var(--dvbYUm)",
    "variable": "var(--dvbYUm)"
  },
  "spacing.VerticalNav.Item.padding.-vert": {
    "value": "var(--kkTJOo)",
    "variable": "var(--kkTJOo)"
  },
  "spacing.VerticalNav.List.gap.-betweenItems": {
    "value": "var(--kcoIZB)",
    "variable": "var(--kcoIZB)"
  },
  "spacing.VerticalNav.List.padding.-vert": {
    "value": "var(--ebedhT)",
    "variable": "var(--ebedhT)"
  },
  "spacing.VerticalNav.Root.padding.-vert": {
    "value": "var(--fXnZST)",
    "variable": "var(--fXnZST)"
  },
  "spacing.VerticalNav.Root.padding.-horz": {
    "value": "var(--kUBZjt)",
    "variable": "var(--kUBZjt)"
  },
  "spacing.device.margin.-mobile": {
    "value": "var(--dPWswx)",
    "variable": "var(--dPWswx)"
  },
  "spacing.device.margin.-tablet": {
    "value": "var(--cVXwjX)",
    "variable": "var(--cVXwjX)"
  },
  "spacing.device.margin.-desktop": {
    "value": "var(--jMivYf)",
    "variable": "var(--jMivYf)"
  },
  "spacing.-tightest": {
    "value": "var(--gOoWtX)",
    "variable": "var(--gOoWtX)"
  },
  "spacing.-tighter": {
    "value": "var(--hLkrWi)",
    "variable": "var(--hLkrWi)"
  },
  "spacing.-tight": {
    "value": "var(--jKknzl)",
    "variable": "var(--jKknzl)"
  },
  "spacing.-default": {
    "value": "var(--hRrfDo)",
    "variable": "var(--hRrfDo)"
  },
  "spacing.-loose": {
    "value": "var(--dmLIIl)",
    "variable": "var(--dmLIIl)"
  },
  "spacing.-looser": {
    "value": "var(--bqtQgP)",
    "variable": "var(--bqtQgP)"
  },
  "spacing.-none": {
    "value": "var(--jWXhYR)",
    "variable": "var(--jWXhYR)"
  },
  "spacing.-conjoined-offsetBorder": {
    "value": "var(--gYvjwC)",
    "variable": "var(--gYvjwC)"
  },
  "spacing.layout.-tightest": {
    "value": "var(--gilTII)",
    "variable": "var(--gilTII)"
  },
  "spacing.layout.-tighter": {
    "value": "var(--icAmQN)",
    "variable": "var(--icAmQN)"
  },
  "spacing.layout.-tight": {
    "value": "var(--btpFxC)",
    "variable": "var(--btpFxC)"
  },
  "spacing.layout.-default": {
    "value": "var(--bArDtj)",
    "variable": "var(--bArDtj)"
  },
  "spacing.layout.-loose": {
    "value": "var(--fgohXG)",
    "variable": "var(--fgohXG)"
  },
  "spacing.layout.-looser": {
    "value": "var(--fpICwE)",
    "variable": "var(--fpICwE)"
  },
  "spacing.layout.-loosest": {
    "value": "var(--fxUeRh)",
    "variable": "var(--fxUeRh)"
  },
  "spacing.layout.vast.-default": {
    "value": "var(--dGXRfu)",
    "variable": "var(--dGXRfu)"
  },
  "spacing.layout.vast.-loose": {
    "value": "var(--lfGjAb)",
    "variable": "var(--lfGjAb)"
  },
  "spacing.layout.vast.-looser": {
    "value": "var(--ibzIPx)",
    "variable": "var(--ibzIPx)"
  },
  "spacing.micro.-tight": {
    "value": "var(--gYfDtm)",
    "variable": "var(--gYfDtm)"
  },
  "spacing.micro.-default": {
    "value": "var(--kbxbWf)",
    "variable": "var(--kbxbWf)"
  },
  "spacing.-xxs": {
    "value": "var(--eooIFU)",
    "variable": "var(--eooIFU)"
  },
  "spacing.-xs": {
    "value": "var(--icrUDE)",
    "variable": "var(--icrUDE)"
  },
  "spacing.-sm": {
    "value": "var(--jolVMp)",
    "variable": "var(--jolVMp)"
  },
  "spacing.-md": {
    "value": "var(--eEeglK)",
    "variable": "var(--eEeglK)"
  },
  "spacing.-lg": {
    "value": "var(--fFUZAQ)",
    "variable": "var(--fFUZAQ)"
  },
  "spacing.-xl": {
    "value": "var(--gvVjyT)",
    "variable": "var(--gvVjyT)"
  },
  "spacing.Accordion.Header.gap.-between-tags": {
    "value": "var(--fRjuod)",
    "variable": "var(--fRjuod)"
  },
  "spacing.Alert.gap.-message-toFlexArea": {
    "value": "var(--cLyUkK)",
    "variable": "var(--cLyUkK)"
  },
  "spacing.ButtonGroup.textButton.padding.-horz": {
    "value": "var(--hXLxzu)",
    "variable": "var(--hXLxzu)"
  },
  "spacing.ButtonGroup.textButton.padding.-vert": {
    "value": "var(--gihyzU)",
    "variable": "var(--gihyzU)"
  },
  "spacing.FormField.HelperArea.gap.-text-toCharCount": {
    "value": "var(--gKblKh)",
    "variable": "var(--gKblKh)"
  },
  "spacing.Input.sm.gap.-input-toAdornment": {
    "value": "var(--hzyLYM)",
    "variable": "var(--hzyLYM)"
  },
  "spacing.Input.md.gap.-input-toAdornment": {
    "value": "var(--dJoDHL)",
    "variable": "var(--dJoDHL)"
  },
  "spacing.Input.lg.gap.-input-toAdornment": {
    "value": "var(--gmgJmR)",
    "variable": "var(--gmgJmR)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.-dataArea1-toSupportRows": {
    "value": "var(--fqMqrq)",
    "variable": "var(--fqMqrq)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.-dataArea1-toSupportRows": {
    "value": "var(--jZLUXs)",
    "variable": "var(--jZLUXs)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.-dataArea1-toSupportRows": {
    "value": "var(--gFynLZ)",
    "variable": "var(--gFynLZ)"
  },
  "colors.aqua.50": {
    "value": "var(--ijOKtU)",
    "variable": "var(--ijOKtU)"
  },
  "colors.aqua.100": {
    "value": "var(--iVuGjk)",
    "variable": "var(--iVuGjk)"
  },
  "colors.aqua.200": {
    "value": "var(--gYRMgf)",
    "variable": "var(--gYRMgf)"
  },
  "colors.aqua.300": {
    "value": "var(--ILIhq)",
    "variable": "var(--ILIhq)"
  },
  "colors.aqua.400": {
    "value": "var(--ksjdvN)",
    "variable": "var(--ksjdvN)"
  },
  "colors.aqua.500": {
    "value": "var(--eccZwY)",
    "variable": "var(--eccZwY)"
  },
  "colors.aqua.600": {
    "value": "var(--cfAftT)",
    "variable": "var(--cfAftT)"
  },
  "colors.aqua.700": {
    "value": "var(--hePKUa)",
    "variable": "var(--hePKUa)"
  },
  "colors.aqua.800": {
    "value": "var(--gCqBEp)",
    "variable": "var(--gCqBEp)"
  },
  "colors.aqua.900": {
    "value": "var(--mkxFA)",
    "variable": "var(--mkxFA)"
  },
  "colors.aqua.950": {
    "value": "var(--jxpOQR)",
    "variable": "var(--jxpOQR)"
  },
  "colors.black": {
    "value": "var(--qLIrn)",
    "variable": "var(--qLIrn)"
  },
  "colors.blue.50": {
    "value": "var(--glmLoi)",
    "variable": "var(--glmLoi)"
  },
  "colors.blue.100": {
    "value": "var(--bYrJpO)",
    "variable": "var(--bYrJpO)"
  },
  "colors.blue.200": {
    "value": "var(--hoTvPd)",
    "variable": "var(--hoTvPd)"
  },
  "colors.blue.300": {
    "value": "var(--bMEoOM)",
    "variable": "var(--bMEoOM)"
  },
  "colors.blue.375": {
    "value": "var(--fpxnpO)",
    "variable": "var(--fpxnpO)"
  },
  "colors.blue.400": {
    "value": "var(--hIEEwj)",
    "variable": "var(--hIEEwj)"
  },
  "colors.blue.500": {
    "value": "var(--cgpxvS)",
    "variable": "var(--cgpxvS)"
  },
  "colors.blue.600": {
    "value": "var(--hwRjVh)",
    "variable": "var(--hwRjVh)"
  },
  "colors.blue.700": {
    "value": "var(--bUCcUQ)",
    "variable": "var(--bUCcUQ)"
  },
  "colors.blue.800": {
    "value": "var(--golFsv)",
    "variable": "var(--golFsv)"
  },
  "colors.blue.900": {
    "value": "var(--LWyse)",
    "variable": "var(--LWyse)"
  },
  "colors.blue.950": {
    "value": "var(--eJQij)",
    "variable": "var(--eJQij)"
  },
  "colors.legacy.coolGray.100": {
    "value": "var(--jUnxAi)",
    "variable": "var(--jUnxAi)"
  },
  "colors.legacy.coolGray.200": {
    "value": "var(--fTPNJx)",
    "variable": "var(--fTPNJx)"
  },
  "colors.legacy.coolGray.300": {
    "value": "var(--oVyBg)",
    "variable": "var(--oVyBg)"
  },
  "colors.legacy.coolGray.400": {
    "value": "var(--icsKyf)",
    "variable": "var(--icsKyf)"
  },
  "colors.legacy.coolGray.500": {
    "value": "var(--cxyvpO)",
    "variable": "var(--cxyvpO)"
  },
  "colors.legacy.coolGray.600": {
    "value": "var(--jMwuXZ)",
    "variable": "var(--jMwuXZ)"
  },
  "colors.legacy.orangeRed.100": {
    "value": "var(--goNItf)",
    "variable": "var(--goNItf)"
  },
  "colors.legacy.orangeRed.200": {
    "value": "var(--gjjzuI)",
    "variable": "var(--gjjzuI)"
  },
  "colors.legacy.orangeRed.300": {
    "value": "var(--cWjaDF)",
    "variable": "var(--cWjaDF)"
  },
  "colors.legacy.orangeRed.400": {
    "value": "var(--bkmuRi)",
    "variable": "var(--bkmuRi)"
  },
  "colors.legacy.orangeRed.500": {
    "value": "var(--VSStP)",
    "variable": "var(--VSStP)"
  },
  "colors.legacy.orangeRed.600": {
    "value": "var(--QoJvs)",
    "variable": "var(--QoJvs)"
  },
  "colors.dataViz.gray.100": {
    "value": "var(--cNpHCV)",
    "variable": "var(--cNpHCV)"
  },
  "colors.dataViz.gray.200": {
    "value": "var(--jcjcam)",
    "variable": "var(--jcjcam)"
  },
  "colors.dataViz.gray.300": {
    "value": "var(--jehHKn)",
    "variable": "var(--jehHKn)"
  },
  "colors.dataViz.gray.400": {
    "value": "var(--hRHJIs)",
    "variable": "var(--hRHJIs)"
  },
  "colors.dataViz.gray.500": {
    "value": "var(--hTGpst)",
    "variable": "var(--hTGpst)"
  },
  "colors.dataViz.gray.600": {
    "value": "var(--cTeaqO)",
    "variable": "var(--cTeaqO)"
  },
  "colors.dataViz.gray.700": {
    "value": "var(--cVcGaP)",
    "variable": "var(--cVcGaP)"
  },
  "colors.dataViz.gray.800": {
    "value": "var(--eKjpOw)",
    "variable": "var(--eKjpOw)"
  },
  "colors.dataViz.gray.900": {
    "value": "var(--eMhVyx)",
    "variable": "var(--eMhVyx)"
  },
  "colors.dataViz.gray.1000": {
    "value": "var(--kqhtAh)",
    "variable": "var(--kqhtAh)"
  },
  "colors.dataViz.gray.1100": {
    "value": "var(--dbbUsw)",
    "variable": "var(--dbbUsw)"
  },
  "colors.dataViz.gray.1200": {
    "value": "var(--hiIdRr)",
    "variable": "var(--hiIdRr)"
  },
  "colors.dataViz.green.100": {
    "value": "var(--hCxkGz)",
    "variable": "var(--hCxkGz)"
  },
  "colors.dataViz.green.200": {
    "value": "var(--hICTZU)",
    "variable": "var(--hICTZU)"
  },
  "colors.dataViz.green.300": {
    "value": "var(--gkdztp)",
    "variable": "var(--gkdztp)"
  },
  "colors.dataViz.green.400": {
    "value": "var(--lhTSwK)",
    "variable": "var(--lhTSwK)"
  },
  "colors.dataViz.green.500": {
    "value": "var(--iNMbAL)",
    "variable": "var(--iNMbAL)"
  },
  "colors.dataViz.green.600": {
    "value": "var(--iTRKUg)",
    "variable": "var(--iTRKUg)"
  },
  "colors.dataViz.green.700": {
    "value": "var(--hvsqnB)",
    "variable": "var(--hvsqnB)"
  },
  "colors.dataViz.green.800": {
    "value": "var(--fKSRoi)",
    "variable": "var(--fKSRoi)"
  },
  "colors.dataViz.green.900": {
    "value": "var(--dqLasj)",
    "variable": "var(--dqLasj)"
  },
  "colors.dataViz.green.1000": {
    "value": "var(--lnMKwX)",
    "variable": "var(--lnMKwX)"
  },
  "colors.dataViz.green.1100": {
    "value": "var(--jQgFbe)",
    "variable": "var(--jQgFbe)"
  },
  "colors.dataViz.green.1200": {
    "value": "var(--laFlwd)",
    "variable": "var(--laFlwd)"
  },
  "colors.gray.50": {
    "value": "var(--dcmCJN)",
    "variable": "var(--dcmCJN)"
  },
  "colors.gray.100": {
    "value": "var(--ePJGsV)",
    "variable": "var(--ePJGsV)"
  },
  "colors.gray.200": {
    "value": "var(--dnVpUm)",
    "variable": "var(--dnVpUm)"
  },
  "colors.gray.300": {
    "value": "var(--bMJKSL)",
    "variable": "var(--bMJKSL)"
  },
  "colors.gray.400": {
    "value": "var(--jSiOQk)",
    "variable": "var(--jSiOQk)"
  },
  "colors.gray.500": {
    "value": "var(--iqXjOJ)",
    "variable": "var(--iqXjOJ)"
  },
  "colors.gray.600": {
    "value": "var(--gPiTqa)",
    "variable": "var(--gPiTqa)"
  },
  "colors.gray.700": {
    "value": "var(--fnXooz)",
    "variable": "var(--fnXooz)"
  },
  "colors.gray.800": {
    "value": "var(--fKIyfA)",
    "variable": "var(--fKIyfA)"
  },
  "colors.gray.900": {
    "value": "var(--ejwTdZ)",
    "variable": "var(--ejwTdZ)"
  },
  "colors.gray.950": {
    "value": "var(--jympbw)",
    "variable": "var(--jympbw)"
  },
  "colors.green.50": {
    "value": "var(--hXozqf)",
    "variable": "var(--hXozqf)"
  },
  "colors.green.100": {
    "value": "var(--iDDIAz)",
    "variable": "var(--iDDIAz)"
  },
  "colors.green.200": {
    "value": "var(--khfuXU)",
    "variable": "var(--khfuXU)"
  },
  "colors.green.300": {
    "value": "var(--hypAVx)",
    "variable": "var(--hypAVx)"
  },
  "colors.green.400": {
    "value": "var(--wGfza)",
    "variable": "var(--wGfza)"
  },
  "colors.green.500": {
    "value": "var(--jdlUVz)",
    "variable": "var(--jdlUVz)"
  },
  "colors.green.600": {
    "value": "var(--kGNHsU)",
    "variable": "var(--kGNHsU)"
  },
  "colors.green.700": {
    "value": "var(--hXXNqx)",
    "variable": "var(--hXXNqx)"
  },
  "colors.green.800": {
    "value": "var(--bAQeLK)",
    "variable": "var(--bAQeLK)"
  },
  "colors.green.900": {
    "value": "var(--khvUij)",
    "variable": "var(--khvUij)"
  },
  "colors.green.950": {
    "value": "var(--cbdKOS)",
    "variable": "var(--cbdKOS)"
  },
  "colors.orange.50": {
    "value": "var(--NQTLQ)",
    "variable": "var(--NQTLQ)"
  },
  "colors.orange.100": {
    "value": "var(--JsfmQ)",
    "variable": "var(--JsfmQ)"
  },
  "colors.orange.200": {
    "value": "var(--gBjjlD)",
    "variable": "var(--gBjjlD)"
  },
  "colors.orange.300": {
    "value": "var(--QMCLK)",
    "variable": "var(--QMCLK)"
  },
  "colors.orange.400": {
    "value": "var(--ijESlZ)",
    "variable": "var(--ijESlZ)"
  },
  "colors.orange.500": {
    "value": "var(--czilMg)",
    "variable": "var(--czilMg)"
  },
  "colors.orange.600": {
    "value": "var(--iqZpKT)",
    "variable": "var(--iqZpKT)"
  },
  "colors.orange.700": {
    "value": "var(--cGCJla)",
    "variable": "var(--cGCJla)"
  },
  "colors.orange.800": {
    "value": "var(--dUhLNN)",
    "variable": "var(--dUhLNN)"
  },
  "colors.orange.900": {
    "value": "var(--jzgOMQ)",
    "variable": "var(--jzgOMQ)"
  },
  "colors.orange.950": {
    "value": "var(--igBpVl)",
    "variable": "var(--igBpVl)"
  },
  "colors.purple.50": {
    "value": "var(--ksTgfC)",
    "variable": "var(--ksTgfC)"
  },
  "colors.purple.100": {
    "value": "var(--iCdJRO)",
    "variable": "var(--iCdJRO)"
  },
  "colors.purple.200": {
    "value": "var(--dWAXWh)",
    "variable": "var(--dWAXWh)"
  },
  "colors.purple.300": {
    "value": "var(--jcWlLI)",
    "variable": "var(--jcWlLI)"
  },
  "colors.purple.400": {
    "value": "var(--eLlnzT)",
    "variable": "var(--eLlnzT)"
  },
  "colors.purple.500": {
    "value": "var(--jRGBpu)",
    "variable": "var(--jRGBpu)"
  },
  "colors.purple.600": {
    "value": "var(--fmdPtN)",
    "variable": "var(--fmdPtN)"
  },
  "colors.purple.700": {
    "value": "var(--kszdjo)",
    "variable": "var(--kszdjo)"
  },
  "colors.purple.800": {
    "value": "var(--kMigIv)",
    "variable": "var(--kMigIv)"
  },
  "colors.purple.900": {
    "value": "var(--eDhKZa)",
    "variable": "var(--eDhKZa)"
  },
  "colors.purple.950": {
    "value": "var(--eadxYH)",
    "variable": "var(--eadxYH)"
  },
  "colors.red.50": {
    "value": "var(--bINrJX)",
    "variable": "var(--bINrJX)"
  },
  "colors.red.100": {
    "value": "var(--fKgVwH)",
    "variable": "var(--fKgVwH)"
  },
  "colors.red.200": {
    "value": "var(--bLdQLg)",
    "variable": "var(--bLdQLg)"
  },
  "colors.red.300": {
    "value": "var(--fMUQaR)",
    "variable": "var(--fMUQaR)"
  },
  "colors.red.400": {
    "value": "var(--hwCQam)",
    "variable": "var(--hwCQam)"
  },
  "colors.red.500": {
    "value": "var(--iYfRb)",
    "variable": "var(--iYfRb)"
  },
  "colors.red.600": {
    "value": "var(--hzqKEw)",
    "variable": "var(--hzqKEw)"
  },
  "colors.red.700": {
    "value": "var(--lMavl)",
    "variable": "var(--lMavl)"
  },
  "colors.red.800": {
    "value": "var(--bLDcWa)",
    "variable": "var(--bLDcWa)"
  },
  "colors.red.900": {
    "value": "var(--fNuclL)",
    "variable": "var(--fNuclL)"
  },
  "colors.red.950": {
    "value": "var(--jHDsLG)",
    "variable": "var(--jHDsLG)"
  },
  "colors.teal.50": {
    "value": "var(--jqQOis)",
    "variable": "var(--jqQOis)"
  },
  "colors.teal.100": {
    "value": "var(--hsCMHs)",
    "variable": "var(--hsCMHs)"
  },
  "colors.teal.200": {
    "value": "var(--jcJhxj)",
    "variable": "var(--jcJhxj)"
  },
  "colors.teal.300": {
    "value": "var(--czjDVi)",
    "variable": "var(--czjDVi)"
  },
  "colors.teal.400": {
    "value": "var(--kfgCt)",
    "variable": "var(--kfgCt)"
  },
  "colors.teal.500": {
    "value": "var(--eWbmzo)",
    "variable": "var(--eWbmzo)"
  },
  "colors.teal.600": {
    "value": "var(--gGhHpf)",
    "variable": "var(--gGhHpf)"
  },
  "colors.teal.700": {
    "value": "var(--cIdNe)",
    "variable": "var(--cIdNe)"
  },
  "colors.teal.800": {
    "value": "var(--catTvB)",
    "variable": "var(--catTvB)"
  },
  "colors.teal.900": {
    "value": "var(--gMpZsw)",
    "variable": "var(--gMpZsw)"
  },
  "colors.teal.950": {
    "value": "var(--bnTNlF)",
    "variable": "var(--bnTNlF)"
  },
  "colors.transparent.invisible": {
    "value": "var(--hULkOe)",
    "variable": "var(--hULkOe)"
  },
  "colors.transparent.black-0": {
    "value": "var(--dDQaeN)",
    "variable": "var(--dDQaeN)"
  },
  "colors.transparent.black-15": {
    "value": "var(--iGwhMB)",
    "variable": "var(--iGwhMB)"
  },
  "colors.transparent.black-20": {
    "value": "var(--fDSgRj)",
    "variable": "var(--fDSgRj)"
  },
  "colors.transparent.black-30": {
    "value": "var(--eDinTq)",
    "variable": "var(--eDinTq)"
  },
  "colors.transparent.black-60": {
    "value": "var(--YFCur)",
    "variable": "var(--YFCur)"
  },
  "colors.transparent.black-75": {
    "value": "var(--bWsqLb)",
    "variable": "var(--bWsqLb)"
  },
  "colors.transparent.white-0": {
    "value": "var(--iMRenZ)",
    "variable": "var(--iMRenZ)"
  },
  "colors.transparent.white-30": {
    "value": "var(--fTIDTW)",
    "variable": "var(--fTIDTW)"
  },
  "colors.transparent.white-40": {
    "value": "var(--crXcZh)",
    "variable": "var(--crXcZh)"
  },
  "colors.transparent.white-60": {
    "value": "var(--bMpXYj)",
    "variable": "var(--bMpXYj)"
  },
  "colors.transparent.white-80": {
    "value": "var(--kclypd)",
    "variable": "var(--kclypd)"
  },
  "colors.transparent.gray.50-0": {
    "value": "var(--dQAkQT)",
    "variable": "var(--dQAkQT)"
  },
  "colors.transparent.gray.100-0": {
    "value": "var(--diQjxL)",
    "variable": "var(--diQjxL)"
  },
  "colors.transparent.gray.200-0": {
    "value": "var(--hEUfIQ)",
    "variable": "var(--hEUfIQ)"
  },
  "colors.transparent.gray.300-0": {
    "value": "var(--beMgBh)",
    "variable": "var(--beMgBh)"
  },
  "colors.transparent.gray.400-0": {
    "value": "var(--fBtvnW)",
    "variable": "var(--fBtvnW)"
  },
  "colors.transparent.gray.400-20": {
    "value": "var(--iiJlk)",
    "variable": "var(--iiJlk)"
  },
  "colors.transparent.gray.400-30": {
    "value": "var(--bAxmdB)",
    "variable": "var(--bAxmdB)"
  },
  "colors.transparent.gray.500-0": {
    "value": "var(--eABFuL)",
    "variable": "var(--eABFuL)"
  },
  "colors.transparent.gray.500-20": {
    "value": "var(--eXwtCx)",
    "variable": "var(--eXwtCx)"
  },
  "colors.transparent.gray.500-30": {
    "value": "var(--dhhMXI)",
    "variable": "var(--dhhMXI)"
  },
  "colors.transparent.gray.600-0": {
    "value": "var(--iWFBFQ)",
    "variable": "var(--iWFBFQ)"
  },
  "colors.transparent.gray.600-20": {
    "value": "var(--icsmsm)",
    "variable": "var(--icsmsm)"
  },
  "colors.transparent.gray.600-30": {
    "value": "var(--juGPkD)",
    "variable": "var(--juGPkD)"
  },
  "colors.transparent.gray.600-40": {
    "value": "var(--gWLFzU)",
    "variable": "var(--gWLFzU)"
  },
  "colors.transparent.gray.600-60": {
    "value": "var(--hmpHia)",
    "variable": "var(--hmpHia)"
  },
  "colors.transparent.gray.700-0": {
    "value": "var(--cwxCyh)",
    "variable": "var(--cwxCyh)"
  },
  "colors.transparent.gray.700-80": {
    "value": "var(--fhTSjR)",
    "variable": "var(--fhTSjR)"
  },
  "colors.transparent.gray.800-0": {
    "value": "var(--jinnxS)",
    "variable": "var(--jinnxS)"
  },
  "colors.transparent.gray.900-0": {
    "value": "var(--ihvxEH)",
    "variable": "var(--ihvxEH)"
  },
  "colors.transparent.gray.900-80": {
    "value": "var(--VHlcz)",
    "variable": "var(--VHlcz)"
  },
  "colors.transparent.gray.950-20": {
    "value": "var(--jeRNVI)",
    "variable": "var(--jeRNVI)"
  },
  "colors.transparent.gray.950-30": {
    "value": "var(--OTFxd)",
    "variable": "var(--OTFxd)"
  },
  "colors.white": {
    "value": "var(--RiClf)",
    "variable": "var(--RiClf)"
  },
  "colors.yellow.50": {
    "value": "var(--cLFWMs)",
    "variable": "var(--cLFWMs)"
  },
  "colors.yellow.100": {
    "value": "var(--kxGpio)",
    "variable": "var(--kxGpio)"
  },
  "colors.yellow.200": {
    "value": "var(--cbZZGT)",
    "variable": "var(--cbZZGT)"
  },
  "colors.yellow.300": {
    "value": "var(--fwcFBW)",
    "variable": "var(--fwcFBW)"
  },
  "colors.yellow.400": {
    "value": "var(--hUTJsd)",
    "variable": "var(--hUTJsd)"
  },
  "colors.yellow.500": {
    "value": "var(--loWpng)",
    "variable": "var(--loWpng)"
  },
  "colors.yellow.600": {
    "value": "var(--cTpZLL)",
    "variable": "var(--cTpZLL)"
  },
  "colors.yellow.700": {
    "value": "var(--gnsFGO)",
    "variable": "var(--gnsFGO)"
  },
  "colors.yellow.800": {
    "value": "var(--ByZWN)",
    "variable": "var(--ByZWN)"
  },
  "colors.yellow.900": {
    "value": "var(--dVBFRQ)",
    "variable": "var(--dVBFRQ)"
  },
  "colors.yellow.950": {
    "value": "var(--iLqZUR)",
    "variable": "var(--iLqZUR)"
  },
  "borderWidths.25": {
    "value": "var(--cglXXs)",
    "variable": "var(--cglXXs)"
  },
  "borderWidths.50": {
    "value": "var(--heXhMm)",
    "variable": "var(--heXhMm)"
  },
  "borderWidths.100": {
    "value": "var(--eyojOW)",
    "variable": "var(--eyojOW)"
  },
  "borderWidths.150": {
    "value": "var(--eGyQvb)",
    "variable": "var(--eGyQvb)"
  },
  "borderWidths.zero": {
    "value": "var(--hHSOTV)",
    "variable": "var(--hHSOTV)"
  },
  "radii.50": {
    "value": "var(--cbuAfw)",
    "variable": "var(--cbuAfw)"
  },
  "radii.100": {
    "value": "var(--gDEwJY)",
    "variable": "var(--gDEwJY)"
  },
  "radii.150": {
    "value": "var(--jFCAyl)",
    "variable": "var(--jFCAyl)"
  },
  "radii.200": {
    "value": "var(--ksYUhH)",
    "variable": "var(--ksYUhH)"
  },
  "radii.300": {
    "value": "var(--ccPOou)",
    "variable": "var(--ccPOou)"
  },
  "radii.400": {
    "value": "var(--cgcEXx)",
    "variable": "var(--cgcEXx)"
  },
  "radii.500": {
    "value": "var(--ffpiDg)",
    "variable": "var(--ffpiDg)"
  },
  "radii.600": {
    "value": "var(--iUJGaP)",
    "variable": "var(--iUJGaP)"
  },
  "radii.700": {
    "value": "var(--EAAhC)",
    "variable": "var(--EAAhC)"
  },
  "radii.zero": {
    "value": "var(--gMOumn)",
    "variable": "var(--gMOumn)"
  },
  "radii.capsule": {
    "value": "var(--cmmfRw)",
    "variable": "var(--cmmfRw)"
  },
  "radii.ellipse": {
    "value": "var(--fKwbFz)",
    "variable": "var(--fKwbFz)"
  },
  "spacing.25": {
    "value": "var(--ieWSsg)",
    "variable": "var(--ieWSsg)"
  },
  "spacing.50": {
    "value": "var(--kKbbUK)",
    "variable": "var(--kKbbUK)"
  },
  "spacing.100": {
    "value": "var(--bIgSVm)",
    "variable": "var(--bIgSVm)"
  },
  "spacing.150": {
    "value": "var(--hmVCZH)",
    "variable": "var(--hmVCZH)"
  },
  "spacing.200": {
    "value": "var(--cJysOB)",
    "variable": "var(--cJysOB)"
  },
  "spacing.250": {
    "value": "var(--bIrbJs)",
    "variable": "var(--bIrbJs)"
  },
  "spacing.300": {
    "value": "var(--GHwVU)",
    "variable": "var(--GHwVU)"
  },
  "spacing.350": {
    "value": "var(--gmJDqV)",
    "variable": "var(--gmJDqV)"
  },
  "spacing.400": {
    "value": "var(--gqmheD)",
    "variable": "var(--gqmheD)"
  },
  "spacing.500": {
    "value": "var(--envllW)",
    "variable": "var(--envllW)"
  },
  "spacing.600": {
    "value": "var(--foMLfl)",
    "variable": "var(--foMLfl)"
  },
  "spacing.700": {
    "value": "var(--dlVPmE)",
    "variable": "var(--dlVPmE)"
  },
  "spacing.800": {
    "value": "var(--dUcYJv)",
    "variable": "var(--dUcYJv)"
  },
  "spacing.900": {
    "value": "var(--bRmcQO)",
    "variable": "var(--bRmcQO)"
  },
  "spacing.1000": {
    "value": "var(--iUTQca)",
    "variable": "var(--iUTQca)"
  },
  "spacing.1100": {
    "value": "var(--drMEwr)",
    "variable": "var(--drMEwr)"
  },
  "spacing.1200": {
    "value": "var(--bkFxjg)",
    "variable": "var(--bkFxjg)"
  },
  "spacing.1300": {
    "value": "var(--gWTVct)",
    "variable": "var(--gWTVct)"
  },
  "spacing.1400": {
    "value": "var(--iNucni)",
    "variable": "var(--iNucni)"
  },
  "spacing.1500": {
    "value": "var(--dkmQHz)",
    "variable": "var(--dkmQHz)"
  },
  "spacing.1600": {
    "value": "var(--bdfJuo)",
    "variable": "var(--bdfJuo)"
  },
  "spacing.1800": {
    "value": "var(--dofCJK)",
    "variable": "var(--dofCJK)"
  },
  "spacing.2400": {
    "value": "var(--jOLCgx)",
    "variable": "var(--jOLCgx)"
  },
  "spacing.negative-25": {
    "value": "var(--cKgcde)",
    "variable": "var(--cKgcde)"
  },
  "spacing.zero": {
    "value": "var(--LDKR)",
    "variable": "var(--LDKR)"
  },
  "sizes.25": {
    "value": "var(--eadANn)",
    "variable": "var(--eadANn)"
  },
  "sizes.50": {
    "value": "var(--ceVROR)",
    "variable": "var(--ceVROR)"
  },
  "sizes.75": {
    "value": "var(--dDrAge)",
    "variable": "var(--dDrAge)"
  },
  "sizes.100": {
    "value": "var(--gBYfPl)",
    "variable": "var(--gBYfPl)"
  },
  "sizes.150": {
    "value": "var(--jDUkyk)",
    "variable": "var(--jDUkyk)"
  },
  "sizes.200": {
    "value": "var(--krYoSC)",
    "variable": "var(--krYoSC)"
  },
  "sizes.250": {
    "value": "var(--gYOBBD)",
    "variable": "var(--gYOBBD)"
  },
  "sizes.300": {
    "value": "var(--cbPiZr)",
    "variable": "var(--cbPiZr)"
  },
  "sizes.350": {
    "value": "var(--fdLnIq)",
    "variable": "var(--fdLnIq)"
  },
  "sizes.400": {
    "value": "var(--ceuoXw)",
    "variable": "var(--ceuoXw)"
  },
  "sizes.500": {
    "value": "var(--fdGSDh)",
    "variable": "var(--fdGSDh)"
  },
  "sizes.600": {
    "value": "var(--iTHbGy)",
    "variable": "var(--iTHbGy)"
  },
  "sizes.700": {
    "value": "var(--DxVNn)",
    "variable": "var(--DxVNn)"
  },
  "sizes.750": {
    "value": "var(--gCcAUu)",
    "variable": "var(--gCcAUu)"
  },
  "sizes.800": {
    "value": "var(--gzqenc)",
    "variable": "var(--gzqenc)"
  },
  "sizes.900": {
    "value": "var(--jyCHSN)",
    "variable": "var(--jyCHSN)"
  },
  "sizes.1000": {
    "value": "var(--kKXdOV)",
    "variable": "var(--kKXdOV)"
  },
  "sizes.1100": {
    "value": "var(--jwTOvA)",
    "variable": "var(--jwTOvA)"
  },
  "sizes.1200": {
    "value": "var(--jsyCsv)",
    "variable": "var(--jsyCsv)"
  },
  "sizes.1300": {
    "value": "var(--ievmZa)",
    "variable": "var(--ievmZa)"
  },
  "sizes.1400": {
    "value": "var(--dLAOst)",
    "variable": "var(--dLAOst)"
  },
  "sizes.1500": {
    "value": "var(--cxxyYY)",
    "variable": "var(--cxxyYY)"
  },
  "sizes.1600": {
    "value": "var(--ctcmVT)",
    "variable": "var(--ctcmVT)"
  },
  "sizes.1700": {
    "value": "var(--beYXCy)",
    "variable": "var(--beYXCy)"
  },
  "sizes.1800": {
    "value": "var(--ceUrpB)",
    "variable": "var(--ceUrpB)"
  },
  "sizes.1900": {
    "value": "var(--QRbWg)",
    "variable": "var(--QRbWg)"
  },
  "sizes.2000": {
    "value": "var(--dlBDtq)",
    "variable": "var(--dlBDtq)"
  },
  "sizes.2100": {
    "value": "var(--gROfyT)",
    "variable": "var(--gROfyT)"
  },
  "sizes.2200": {
    "value": "var(--kfhgfA)",
    "variable": "var(--kfhgfA)"
  },
  "sizes.2300": {
    "value": "var(--cvXYMh)",
    "variable": "var(--cvXYMh)"
  },
  "sizes.2400": {
    "value": "var(--hBAXvK)",
    "variable": "var(--hBAXvK)"
  },
  "sizes.2500": {
    "value": "var(--lhNzBn)",
    "variable": "var(--lhNzBn)"
  },
  "sizes.2600": {
    "value": "var(--dfKQIY)",
    "variable": "var(--dfKQIY)"
  },
  "sizes.3600": {
    "value": "var(--gUyCVV)",
    "variable": "var(--gUyCVV)"
  },
  "sizes.4000": {
    "value": "var(--gntmXg)",
    "variable": "var(--gntmXg)"
  },
  "sizes.5000": {
    "value": "var(--jmFQCR)",
    "variable": "var(--jmFQCR)"
  },
  "sizes.zero": {
    "value": "var(--gPKapW)",
    "variable": "var(--gPKapW)"
  },
  "sizes.effect.blur.25": {
    "value": "var(--kPVzYV)",
    "variable": "var(--kPVzYV)"
  },
  "sizes.effect.blur.50": {
    "value": "var(--ecLvoD)",
    "variable": "var(--ecLvoD)"
  },
  "sizes.effect.blur.100": {
    "value": "var(--iBpESb)",
    "variable": "var(--iBpESb)"
  },
  "sizes.effect.blur.200": {
    "value": "var(--bkgKKc)",
    "variable": "var(--bkgKKc)"
  },
  "sizes.effect.blur.300": {
    "value": "var(--hByeKd)",
    "variable": "var(--hByeKd)"
  },
  "sizes.effect.blur.400": {
    "value": "var(--bjDpPq)",
    "variable": "var(--bjDpPq)"
  },
  "sizes.effect.blur.500": {
    "value": "var(--hAUJPr)",
    "variable": "var(--hAUJPr)"
  },
  "sizes.effect.blur.750": {
    "value": "var(--jivFhw)",
    "variable": "var(--jivFhw)"
  },
  "sizes.effect.offset.50": {
    "value": "var(--blFaXT)",
    "variable": "var(--blFaXT)"
  },
  "sizes.effect.offset.100": {
    "value": "var(--tfAVj)",
    "variable": "var(--tfAVj)"
  },
  "sizes.effect.offset.150": {
    "value": "var(--kglSMy)",
    "variable": "var(--kglSMy)"
  },
  "sizes.effect.offset.200": {
    "value": "var(--eLLTaM)",
    "variable": "var(--eLLTaM)"
  },
  "sizes.effect.offset.400": {
    "value": "var(--ktCmqW)",
    "variable": "var(--ktCmqW)"
  },
  "sizes.effect.offset.none": {
    "value": "var(--fmMddI)",
    "variable": "var(--fmMddI)"
  },
  "sizes.effect.spread.25": {
    "value": "var(--ewmNGV)",
    "variable": "var(--ewmNGV)"
  },
  "sizes.effect.spread.75": {
    "value": "var(--BEmzg)",
    "variable": "var(--BEmzg)"
  },
  "sizes.effect.spread.100": {
    "value": "var(--jeDcoX)",
    "variable": "var(--jeDcoX)"
  },
  "sizes.effect.spread.none": {
    "value": "var(--cbsCCc)",
    "variable": "var(--cbsCCc)"
  },
  "shadows.none": {
    "value": "var(--dkKAZB)",
    "variable": "var(--dkKAZB)"
  },
  "shadows.focus": {
    "value": "var(--daWseH)",
    "variable": "var(--daWseH)"
  },
  "shadows.sm": {
    "value": "var(--cDhNnp)",
    "variable": "var(--cDhNnp)"
  },
  "shadows.smHeavy": {
    "value": "var(--hvBWAy)",
    "variable": "var(--hvBWAy)"
  },
  "shadows.md": {
    "value": "var(--jMKUKK)",
    "variable": "var(--jMKUKK)"
  },
  "shadows.lg": {
    "value": "var(--kNVcRA)",
    "variable": "var(--kNVcRA)"
  },
  "opacity.8": {
    "value": "var(--gYXNUb)",
    "variable": "var(--gYXNUb)"
  },
  "opacity.10": {
    "value": "var(--fnEHeW)",
    "variable": "var(--fnEHeW)"
  },
  "opacity.12": {
    "value": "var(--mDXyI)",
    "variable": "var(--mDXyI)"
  },
  "opacity.15": {
    "value": "var(--cAPzRP)",
    "variable": "var(--cAPzRP)"
  },
  "opacity.20": {
    "value": "var(--fmanxx)",
    "variable": "var(--fmanxx)"
  },
  "opacity.30": {
    "value": "var(--ctIjcA)",
    "variable": "var(--ctIjcA)"
  },
  "opacity.32": {
    "value": "var(--kJOBwO)",
    "variable": "var(--kJOBwO)"
  },
  "opacity.40": {
    "value": "var(--cstQiv)",
    "variable": "var(--cstQiv)"
  },
  "opacity.50": {
    "value": "var(--kPxvmu)",
    "variable": "var(--kPxvmu)"
  },
  "opacity.60": {
    "value": "var(--kNTbEV)",
    "variable": "var(--kNTbEV)"
  },
  "opacity.70": {
    "value": "var(--hVAXjY)",
    "variable": "var(--hVAXjY)"
  },
  "opacity.75": {
    "value": "var(--ftiAQl)",
    "variable": "var(--ftiAQl)"
  },
  "opacity.80": {
    "value": "var(--eAwrXv)",
    "variable": "var(--eAwrXv)"
  },
  "opacity.100": {
    "value": "var(--gujXsi)",
    "variable": "var(--gujXsi)"
  },
  "opacity.zero": {
    "value": "var(--ksLLuZ)",
    "variable": "var(--ksLLuZ)"
  },
  "fonts.brand": {
    "value": "var(--khATbp)",
    "variable": "var(--khATbp)"
  },
  "fonts.ui": {
    "value": "var(--lcluZy)",
    "variable": "var(--lcluZy)"
  },
  "lineHeights.400": {
    "value": "var(--jDitYg)",
    "variable": "var(--jDitYg)"
  },
  "lineHeights.600": {
    "value": "var(--evCOgK)",
    "variable": "var(--evCOgK)"
  },
  "lineHeights.800": {
    "value": "var(--dbimSI)",
    "variable": "var(--dbimSI)"
  },
  "lineHeights.1000": {
    "value": "var(--Rnkil)",
    "variable": "var(--Rnkil)"
  },
  "lineHeights.1200": {
    "value": "var(--gXoecH)",
    "variable": "var(--gXoecH)"
  },
  "lineHeights.1400": {
    "value": "var(--jMbXuV)",
    "variable": "var(--jMbXuV)"
  },
  "lineHeights.1600": {
    "value": "var(--eCHhQv)",
    "variable": "var(--eCHhQv)"
  },
  "lineHeights.1800": {
    "value": "var(--dRwEut)",
    "variable": "var(--dRwEut)"
  },
  "fontWeights.regular": {
    "value": "var(--TgeWs)",
    "variable": "var(--TgeWs)"
  },
  "fontWeights.bold": {
    "value": "var(--ghWdwL)",
    "variable": "var(--ghWdwL)"
  },
  "fontWeights.heavy": {
    "value": "var(--fCTlhV)",
    "variable": "var(--fCTlhV)"
  },
  "fontWeights.heading": {
    "value": "var(--hntMky)",
    "variable": "var(--hntMky)"
  },
  "fontWeights.emphasis": {
    "value": "var(--jGnMpK)",
    "variable": "var(--jGnMpK)"
  },
  "fontWeights.default": {
    "value": "var(--AYfyZ)",
    "variable": "var(--AYfyZ)"
  },
  "fontWeights.responsive.default.mobile": {
    "value": "var(--kfkHTR)",
    "variable": "var(--kfkHTR)"
  },
  "fontWeights.responsive.default.tablet": {
    "value": "var(--iQPysT)",
    "variable": "var(--iQPysT)"
  },
  "fontWeights.responsive.default.desktop": {
    "value": "var(--bXmfwf)",
    "variable": "var(--bXmfwf)"
  },
  "fontWeights.responsive.emphasis.mobile": {
    "value": "var(--kropzO)",
    "variable": "var(--kropzO)"
  },
  "fontWeights.responsive.emphasis.tablet": {
    "value": "var(--fTcXDY)",
    "variable": "var(--fTcXDY)"
  },
  "fontWeights.responsive.emphasis.desktop": {
    "value": "var(--gqNCNs)",
    "variable": "var(--gqNCNs)"
  },
  "fontWeights.responsive.heading.mobile": {
    "value": "var(--lbYge)",
    "variable": "var(--lbYge)"
  },
  "fontWeights.responsive.heading.tablet": {
    "value": "var(--kNLDlk)",
    "variable": "var(--kNLDlk)"
  },
  "fontWeights.responsive.heading.desktop": {
    "value": "var(--gqJGiU)",
    "variable": "var(--gqJGiU)"
  },
  "fontSizes.250": {
    "value": "var(--rAUoI)",
    "variable": "var(--rAUoI)"
  },
  "fontSizes.300": {
    "value": "var(--dwPDDk)",
    "variable": "var(--dwPDDk)"
  },
  "fontSizes.350": {
    "value": "var(--hqmFgZ)",
    "variable": "var(--hqmFgZ)"
  },
  "fontSizes.400": {
    "value": "var(--MCGrf)",
    "variable": "var(--MCGrf)"
  },
  "fontSizes.450": {
    "value": "var(--kntzZW)",
    "variable": "var(--kntzZW)"
  },
  "fontSizes.500": {
    "value": "var(--gBaQWy)",
    "variable": "var(--gBaQWy)"
  },
  "fontSizes.600": {
    "value": "var(--fezXBV)",
    "variable": "var(--fezXBV)"
  },
  "fontSizes.700": {
    "value": "var(--kUlBrw)",
    "variable": "var(--kUlBrw)"
  },
  "fontSizes.800": {
    "value": "var(--lhvPTb)",
    "variable": "var(--lhvPTb)"
  },
  "fontSizes.900": {
    "value": "var(--fGyqZy)",
    "variable": "var(--fGyqZy)"
  },
  "fontSizes.1000": {
    "value": "var(--dAXelW)",
    "variable": "var(--dAXelW)"
  },
  "fontSizes.1100": {
    "value": "var(--hHbVzj)",
    "variable": "var(--hHbVzj)"
  },
  "fontSizes.1200": {
    "value": "var(--jAYdUM)",
    "variable": "var(--jAYdUM)"
  },
  "fontSizes.1500": {
    "value": "var(--huufPL)",
    "variable": "var(--huufPL)"
  },
  "letterSpacings.none": {
    "value": "var(--haSKcM)",
    "variable": "var(--haSKcM)"
  },
  "letterSpacings.default": {
    "value": "var(--jkEUmF)",
    "variable": "var(--jkEUmF)"
  },
  "zIndex.loadingMask": {
    "value": "var(--cQzMgg)",
    "variable": "var(--cQzMgg)"
  },
  "zIndex.combobox": {
    "value": "var(--elZHlj)",
    "variable": "var(--elZHlj)"
  },
  "zIndex.datePicker": {
    "value": "var(--jYDUSU)",
    "variable": "var(--jYDUSU)"
  },
  "zIndex.dropdown": {
    "value": "var(--TWcuN)",
    "variable": "var(--TWcuN)"
  },
  "zIndex.menu": {
    "value": "var(--eNmByV)",
    "variable": "var(--eNmByV)"
  },
  "zIndex.modal": {
    "value": "var(--dIktSh)",
    "variable": "var(--dIktSh)"
  },
  "zIndex.popover": {
    "value": "var(--beAiOT)",
    "variable": "var(--beAiOT)"
  },
  "zIndex.tooltip": {
    "value": "var(--hVmPBT)",
    "variable": "var(--hVmPBT)"
  },
  "zIndex.toast": {
    "value": "var(--BtcyX)",
    "variable": "var(--BtcyX)"
  },
  "colors.dataViz.sequential.insight.onA": {
    "value": "var(--fDmbgj)",
    "variable": "var(--fDmbgj)"
  },
  "colors.dataViz.sequential.insight.onB": {
    "value": "var(--dHrhUk)",
    "variable": "var(--dHrhUk)"
  },
  "colors.dataViz.sequential.insight.onC": {
    "value": "var(--ifYNAB)",
    "variable": "var(--ifYNAB)"
  },
  "colors.dataViz.sequential.insight.onD": {
    "value": "var(--bMjbCu)",
    "variable": "var(--bMjbCu)"
  },
  "colors.dataViz.sequential.insight.onE": {
    "value": "var(--elgqAn)",
    "variable": "var(--elgqAn)"
  },
  "colors.dataViz.sequential.insight.onF": {
    "value": "var(--cplxoo)",
    "variable": "var(--cplxoo)"
  },
  "colors.dataViz.sequential.insight.onG": {
    "value": "var(--gNTcUF)",
    "variable": "var(--gNTcUF)"
  },
  "colors.dataViz.sequential.insight.onH": {
    "value": "var(--iMHmQq)",
    "variable": "var(--iMHmQq)"
  },
  "colors.dataViz.sequential.insight.onI": {
    "value": "var(--llEBOj)",
    "variable": "var(--llEBOj)"
  },
  "colors.dataViz.sequential.insight.onJ": {
    "value": "var(--jpJICk)",
    "variable": "var(--jpJICk)"
  },
  "colors.dataViz.sequential.insight.onA-hero": {
    "value": "var(--ghqkiS)",
    "variable": "var(--ghqkiS)"
  },
  "colors.dataViz.sequential.insight.onB-hero": {
    "value": "var(--gfLedt)",
    "variable": "var(--gfLedt)"
  },
  "colors.dataViz.sequential.insight.onC-hero": {
    "value": "var(--dBAfNY)",
    "variable": "var(--dBAfNY)"
  },
  "colors.dataViz.sequential.insight.onD-hero": {
    "value": "var(--kdGTej)",
    "variable": "var(--kdGTej)"
  },
  "colors.dataViz.sequential.insight.onE-hero": {
    "value": "var(--hzvUOO)",
    "variable": "var(--hzvUOO)"
  },
  "colors.dataViz.sequential.insight.onF-hero": {
    "value": "var(--hxQOJp)",
    "variable": "var(--hxQOJp)"
  },
  "colors.dataViz.sequential.insight.onG-hero": {
    "value": "var(--eTFQtU)",
    "variable": "var(--eTFQtU)"
  },
  "colors.dataViz.sequential.insight.onH-hero": {
    "value": "var(--ddiHQn)",
    "variable": "var(--ddiHQn)"
  },
  "colors.dataViz.sequential.insight.onI-hero": {
    "value": "var(--yXJAS)",
    "variable": "var(--yXJAS)"
  },
  "colors.dataViz.sequential.insight.onJ-hero": {
    "value": "var(--xsDvt)",
    "variable": "var(--xsDvt)"
  },
  "colors.dataViz.sequential.insight.A": {
    "value": "var(--ivhYPC)",
    "variable": "var(--ivhYPC)"
  },
  "colors.dataViz.sequential.insight.B": {
    "value": "var(--laumlx)",
    "variable": "var(--laumlx)"
  },
  "colors.dataViz.sequential.insight.C": {
    "value": "var(--gcQGlw)",
    "variable": "var(--gcQGlw)"
  },
  "colors.dataViz.sequential.insight.D": {
    "value": "var(--fpEOGv)",
    "variable": "var(--fpEOGv)"
  },
  "colors.dataViz.sequential.insight.E": {
    "value": "var(--bYcQpO)",
    "variable": "var(--bYcQpO)"
  },
  "colors.dataViz.sequential.insight.F": {
    "value": "var(--eDpdLJ)",
    "variable": "var(--eDpdLJ)"
  },
  "colors.dataViz.sequential.insight.G": {
    "value": "var(--kVhhkE)",
    "variable": "var(--kVhhkE)"
  },
  "colors.dataViz.sequential.insight.H": {
    "value": "var(--fakaEb)",
    "variable": "var(--fakaEb)"
  },
  "colors.dataViz.sequential.insight.I": {
    "value": "var(--bIIcnu)",
    "variable": "var(--bIIcnu)"
  },
  "colors.dataViz.sequential.insight.J": {
    "value": "var(--enUpJp)",
    "variable": "var(--enUpJp)"
  },
  "colors.bg.accent.brand.hero": {
    "value": "var(--gDBYAt)",
    "variable": "var(--gDBYAt)"
  },
  "colors.bg.accent.brand.hero-fixed": {
    "value": "var(--dsaXGW)",
    "variable": "var(--dsaXGW)"
  },
  "colors.bg.accent.aqua.impact": {
    "value": "var(--lkGuVQ)",
    "variable": "var(--lkGuVQ)"
  },
  "colors.bg.accent.aqua.hero": {
    "value": "var(--dnncxy)",
    "variable": "var(--dnncxy)"
  },
  "colors.bg.accent.aqua.soft": {
    "value": "var(--fcFZWQ)",
    "variable": "var(--fcFZWQ)"
  },
  "colors.bg.accent.blue.impact": {
    "value": "var(--gPBAkK)",
    "variable": "var(--gPBAkK)"
  },
  "colors.bg.accent.blue.hero": {
    "value": "var(--kavidc)",
    "variable": "var(--kavidc)"
  },
  "colors.bg.accent.blue.soft": {
    "value": "var(--dfqUPS)",
    "variable": "var(--dfqUPS)"
  },
  "colors.bg.accent.gray.impact": {
    "value": "var(--kFXsVt)",
    "variable": "var(--kFXsVt)"
  },
  "colors.bg.accent.gray.hero": {
    "value": "var(--iRoujz)",
    "variable": "var(--iRoujz)"
  },
  "colors.bg.accent.gray.soft": {
    "value": "var(--kvAntN)",
    "variable": "var(--kvAntN)"
  },
  "colors.bg.accent.green.impact": {
    "value": "var(--stFxT)",
    "variable": "var(--stFxT)"
  },
  "colors.bg.accent.green.hero": {
    "value": "var(--JwkKR)",
    "variable": "var(--JwkKR)"
  },
  "colors.bg.accent.green.soft": {
    "value": "var(--eTgdAT)",
    "variable": "var(--eTgdAT)"
  },
  "colors.bg.accent.orange.impact": {
    "value": "var(--dlZzqY)",
    "variable": "var(--dlZzqY)"
  },
  "colors.bg.accent.orange.hero": {
    "value": "var(--ivYxzm)",
    "variable": "var(--ivYxzm)"
  },
  "colors.bg.accent.orange.soft": {
    "value": "var(--gdELHQ)",
    "variable": "var(--gdELHQ)"
  },
  "colors.bg.accent.purple.impact": {
    "value": "var(--cgfCyC)",
    "variable": "var(--cgfCyC)"
  },
  "colors.bg.accent.purple.hero": {
    "value": "var(--lkCvjk)",
    "variable": "var(--lkCvjk)"
  },
  "colors.bg.accent.purple.soft": {
    "value": "var(--bEFmea)",
    "variable": "var(--bEFmea)"
  },
  "colors.bg.accent.red.impact": {
    "value": "var(--grxhcP)",
    "variable": "var(--grxhcP)"
  },
  "colors.bg.accent.red.hero": {
    "value": "var(--hToBLF)",
    "variable": "var(--hToBLF)"
  },
  "colors.bg.accent.red.soft": {
    "value": "var(--jcFArz)",
    "variable": "var(--jcFArz)"
  },
  "colors.bg.accent.teal.impact": {
    "value": "var(--jDqrZI)",
    "variable": "var(--jDqrZI)"
  },
  "colors.bg.accent.teal.hero": {
    "value": "var(--bEdOXO)",
    "variable": "var(--bEdOXO)"
  },
  "colors.bg.accent.teal.soft": {
    "value": "var(--bzCNSc)",
    "variable": "var(--bzCNSc)"
  },
  "colors.bg.accent.yellow.impact": {
    "value": "var(--MasVk)",
    "variable": "var(--MasVk)"
  },
  "colors.bg.accent.yellow.hero": {
    "value": "var(--fLgwPW)",
    "variable": "var(--fLgwPW)"
  },
  "colors.bg.accent.yellow.soft": {
    "value": "var(--jagCMI)",
    "variable": "var(--jagCMI)"
  },
  "colors.bg.accent.yellow.soft-fixed": {
    "value": "var(--eTLBcP)",
    "variable": "var(--eTLBcP)"
  },
  "colors.bg.action.neutral.default": {
    "value": "var(--gCpeqo)",
    "variable": "var(--gCpeqo)"
  },
  "colors.bg.action.neutral.hover": {
    "value": "var(--euKceZ)",
    "variable": "var(--euKceZ)"
  },
  "colors.bg.action.neutral.pressed": {
    "value": "var(--kHimPp)",
    "variable": "var(--kHimPp)"
  },
  "colors.bg.action.neutral.selected.default": {
    "value": "var(--iCdqQI)",
    "variable": "var(--iCdqQI)"
  },
  "colors.bg.action.neutral.selected.hover": {
    "value": "var(--kNBsmx)",
    "variable": "var(--kNBsmx)"
  },
  "colors.bg.action.neutral.selected.pressed": {
    "value": "var(--daNAyN)",
    "variable": "var(--daNAyN)"
  },
  "colors.bg.action.neutral.alt.default": {
    "value": "var(--jaqcNU)",
    "variable": "var(--jaqcNU)"
  },
  "colors.bg.action.neutral.alt.hover": {
    "value": "var(--htSDcF)",
    "variable": "var(--htSDcF)"
  },
  "colors.bg.action.neutral.alt.pressed": {
    "value": "var(--hQFapl)",
    "variable": "var(--hQFapl)"
  },
  "colors.bg.action.neutral-fixed.default": {
    "value": "var(--iMmPfb)",
    "variable": "var(--iMmPfb)"
  },
  "colors.bg.action.neutral-fixed.hover": {
    "value": "var(--fccycq)",
    "variable": "var(--fccycq)"
  },
  "colors.bg.action.neutral-fixed.pressed": {
    "value": "var(--gPKDfK)",
    "variable": "var(--gPKDfK)"
  },
  "colors.bg.action.soft.default": {
    "value": "var(--fIeQrb)",
    "variable": "var(--fIeQrb)"
  },
  "colors.bg.action.soft.hover": {
    "value": "var(--iYEYga)",
    "variable": "var(--iYEYga)"
  },
  "colors.bg.action.soft.pressed": {
    "value": "var(--gFEzJS)",
    "variable": "var(--gFEzJS)"
  },
  "colors.bg.action.soft.selected.default": {
    "value": "var(--cGvlab)",
    "variable": "var(--cGvlab)"
  },
  "colors.bg.action.soft.selected.hover": {
    "value": "var(--kPNNlW)",
    "variable": "var(--kPNNlW)"
  },
  "colors.bg.action.soft.selected.pressed": {
    "value": "var(--boaiQu)",
    "variable": "var(--boaiQu)"
  },
  "colors.bg.action.hero.default": {
    "value": "var(--eBSYvh)",
    "variable": "var(--eBSYvh)"
  },
  "colors.bg.action.hero.hover": {
    "value": "var(--dZbANA)",
    "variable": "var(--dZbANA)"
  },
  "colors.bg.action.hero.pressed": {
    "value": "var(--bGbcrs)",
    "variable": "var(--bGbcrs)"
  },
  "colors.bg.action.hero.selected.default": {
    "value": "var(--iAEWsN)",
    "variable": "var(--iAEWsN)"
  },
  "colors.bg.action.hero.selected.hover": {
    "value": "var(--cnhQxw)",
    "variable": "var(--cnhQxw)"
  },
  "colors.bg.action.hero.selected.pressed": {
    "value": "var(--eaPVAQ)",
    "variable": "var(--eaPVAQ)"
  },
  "colors.bg.action.bare.neutral.default": {
    "value": "var(--fctnoV)",
    "variable": "var(--fctnoV)"
  },
  "colors.bg.action.bare.neutral.hover": {
    "value": "var(--jTivDM)",
    "variable": "var(--jTivDM)"
  },
  "colors.bg.action.bare.neutral.pressed": {
    "value": "var(--bKLPGk)",
    "variable": "var(--bKLPGk)"
  },
  "colors.bg.action.bare.neutral-fixed.default": {
    "value": "var(--hXIOdq)",
    "variable": "var(--hXIOdq)"
  },
  "colors.bg.action.bare.neutral-fixed.hover": {
    "value": "var(--ZieMP)",
    "variable": "var(--ZieMP)"
  },
  "colors.bg.action.bare.neutral-fixed.pressed": {
    "value": "var(--eFnnBv)",
    "variable": "var(--eFnnBv)"
  },
  "colors.bg.action.impact.neutral.default": {
    "value": "var(--kzOTWX)",
    "variable": "var(--kzOTWX)"
  },
  "colors.bg.action.impact.neutral.hover": {
    "value": "var(--jivfyC)",
    "variable": "var(--jivfyC)"
  },
  "colors.bg.action.impact.neutral.pressed": {
    "value": "var(--kRXVlG)",
    "variable": "var(--kRXVlG)"
  },
  "colors.bg.action.impact.soft.default": {
    "value": "var(--gFAQbM)",
    "variable": "var(--gFAQbM)"
  },
  "colors.bg.action.impact.soft.hover": {
    "value": "var(--fRgbwp)",
    "variable": "var(--fRgbwp)"
  },
  "colors.bg.action.impact.soft.pressed": {
    "value": "var(--gnSyIV)",
    "variable": "var(--gnSyIV)"
  },
  "colors.bg.action.impact.bare.default": {
    "value": "var(--jCDFWq)",
    "variable": "var(--jCDFWq)"
  },
  "colors.bg.action.impact.bare.hover": {
    "value": "var(--jjDyEv)",
    "variable": "var(--jjDyEv)"
  },
  "colors.bg.action.impact.bare.pressed": {
    "value": "var(--jGpVRb)",
    "variable": "var(--jGpVRb)"
  },
  "colors.bg.action.impact.bare.fixed.default": {
    "value": "var(--hnctYd)",
    "variable": "var(--hnctYd)"
  },
  "colors.bg.action.impact.bare.fixed.hover": {
    "value": "var(--kAjqUE)",
    "variable": "var(--kAjqUE)"
  },
  "colors.bg.action.impact.bare.fixed.pressed": {
    "value": "var(--dwdDnc)",
    "variable": "var(--dwdDnc)"
  },
  "colors.bg.action.critical.neutral.default": {
    "value": "var(--bEmNwG)",
    "variable": "var(--bEmNwG)"
  },
  "colors.bg.action.critical.neutral.hover": {
    "value": "var(--jyYqzX)",
    "variable": "var(--jyYqzX)"
  },
  "colors.bg.action.critical.neutral.pressed": {
    "value": "var(--bMkyMn)",
    "variable": "var(--bMkyMn)"
  },
  "colors.bg.action.critical.hero.default": {
    "value": "var(--fserrj)",
    "variable": "var(--fserrj)"
  },
  "colors.bg.action.critical.hero.hover": {
    "value": "var(--frMuLC)",
    "variable": "var(--frMuLC)"
  },
  "colors.bg.action.critical.hero.pressed": {
    "value": "var(--hfuzOW)",
    "variable": "var(--hfuzOW)"
  },
  "colors.bg.action.success.hero.default": {
    "value": "var(--eeUkOL)",
    "variable": "var(--eeUkOL)"
  },
  "colors.bg.action.success.hero.hover": {
    "value": "var(--dxqIMq)",
    "variable": "var(--dxqIMq)"
  },
  "colors.bg.action.success.hero.pressed": {
    "value": "var(--gEpMnK)",
    "variable": "var(--gEpMnK)"
  },
  "colors.bg.elevated.action.mediumShadow.default": {
    "value": "var(--khsNxh)",
    "variable": "var(--khsNxh)"
  },
  "colors.bg.elevated.action.mediumShadow.hover": {
    "value": "var(--iqGUcg)",
    "variable": "var(--iqGUcg)"
  },
  "colors.bg.elevated.action.mediumShadow.pressed": {
    "value": "var(--dksFAw)",
    "variable": "var(--dksFAw)"
  },
  "colors.bg.elevated.action.mediumShadow.selected.default": {
    "value": "var(--hZNQdl)",
    "variable": "var(--hZNQdl)"
  },
  "colors.bg.elevated.action.mediumShadow.selected.hover": {
    "value": "var(--jYRwDg)",
    "variable": "var(--jYRwDg)"
  },
  "colors.bg.elevated.action.mediumShadow.selected.pressed": {
    "value": "var(--fQZeyQ)",
    "variable": "var(--fQZeyQ)"
  },
  "colors.bg.elevated.action.smallShadow.default": {
    "value": "var(--iUEoSr)",
    "variable": "var(--iUEoSr)"
  },
  "colors.bg.elevated.action.smallShadow.hover": {
    "value": "var(--jfcaWS)",
    "variable": "var(--jfcaWS)"
  },
  "colors.bg.elevated.action.smallShadow.pressed": {
    "value": "var(--fSNPmS)",
    "variable": "var(--fSNPmS)"
  },
  "colors.bg.elevated.action.smallShadow.selected.default": {
    "value": "var(--fmSlsT)",
    "variable": "var(--fmSlsT)"
  },
  "colors.bg.elevated.action.smallShadow.selected.hover": {
    "value": "var(--eAZgka)",
    "variable": "var(--eAZgka)"
  },
  "colors.bg.elevated.action.smallShadow.selected.pressed": {
    "value": "var(--hyHGIa)",
    "variable": "var(--hyHGIa)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.default": {
    "value": "var(--iVOWHo)",
    "variable": "var(--iVOWHo)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.hover": {
    "value": "var(--icbOLR)",
    "variable": "var(--icbOLR)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.pressed": {
    "value": "var(--iGdoxJ)",
    "variable": "var(--iGdoxJ)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.selected.default": {
    "value": "var(--jfsvBA)",
    "variable": "var(--jfsvBA)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.selected.hover": {
    "value": "var(--jjDRdF)",
    "variable": "var(--jjDRdF)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.selected.pressed": {
    "value": "var(--MLSEt)",
    "variable": "var(--MLSEt)"
  },
  "colors.bg.elevated.sheet": {
    "value": "var(--uZSJM)",
    "variable": "var(--uZSJM)"
  },
  "colors.bg.elevated.mediumShadow": {
    "value": "var(--bUsszI)",
    "variable": "var(--bUsszI)"
  },
  "colors.bg.elevated.smallShadow": {
    "value": "var(--fbDFfG)",
    "variable": "var(--fbDFfG)"
  },
  "colors.bg.elevated.smallHeavyShadow": {
    "value": "var(--hShDcF)",
    "variable": "var(--hShDcF)"
  },
  "colors.bg.express.empower.impact": {
    "value": "var(--knzRmH)",
    "variable": "var(--knzRmH)"
  },
  "colors.bg.express.empower.hero": {
    "value": "var(--kfGjWd)",
    "variable": "var(--kfGjWd)"
  },
  "colors.bg.express.empower.soft": {
    "value": "var(--bqFisf)",
    "variable": "var(--bqFisf)"
  },
  "colors.bg.express.insight.impact": {
    "value": "var(--fGQKki)",
    "variable": "var(--fGQKki)"
  },
  "colors.bg.express.insight.hero": {
    "value": "var(--iWpLWY)",
    "variable": "var(--iWpLWY)"
  },
  "colors.bg.express.insight.soft": {
    "value": "var(--bGpRnO)",
    "variable": "var(--bGpRnO)"
  },
  "colors.bg.express.inspire.impact": {
    "value": "var(--jQitEK)",
    "variable": "var(--jQitEK)"
  },
  "colors.bg.express.inspire.hero": {
    "value": "var(--jMmLcg)",
    "variable": "var(--jMmLcg)"
  },
  "colors.bg.express.inspire.soft": {
    "value": "var(--muLci)",
    "variable": "var(--muLci)"
  },
  "colors.bg.express.trust.impact": {
    "value": "var(--hMjVIQ)",
    "variable": "var(--hMjVIQ)"
  },
  "colors.bg.express.trust.hero": {
    "value": "var(--iTUEsi)",
    "variable": "var(--iTUEsi)"
  },
  "colors.bg.express.trust.soft": {
    "value": "var(--kFmxVY)",
    "variable": "var(--kFmxVY)"
  },
  "colors.bg.feedback.critical.soft": {
    "value": "var(--jmFFQQ)",
    "variable": "var(--jmFFQQ)"
  },
  "colors.bg.feedback.critical.hero": {
    "value": "var(--fjjHVa)",
    "variable": "var(--fjjHVa)"
  },
  "colors.bg.feedback.critical.impact": {
    "value": "var(--KgkM)",
    "variable": "var(--KgkM)"
  },
  "colors.bg.feedback.info.soft": {
    "value": "var(--clPwKx)",
    "variable": "var(--clPwKx)"
  },
  "colors.bg.feedback.info.hero": {
    "value": "var(--hgBcBD)",
    "variable": "var(--hgBcBD)"
  },
  "colors.bg.feedback.info.impact": {
    "value": "var(--imCfjh)",
    "variable": "var(--imCfjh)"
  },
  "colors.bg.feedback.notify.impact": {
    "value": "var(--defGYE)",
    "variable": "var(--defGYE)"
  },
  "colors.bg.feedback.notify.hero": {
    "value": "var(--fJITIC)",
    "variable": "var(--fJITIC)"
  },
  "colors.bg.feedback.notify.hero-fixed": {
    "value": "var(--kOQPpZ)",
    "variable": "var(--kOQPpZ)"
  },
  "colors.bg.feedback.notify.soft": {
    "value": "var(--krkksI)",
    "variable": "var(--krkksI)"
  },
  "colors.bg.feedback.success.impact": {
    "value": "var(--caXmBQ)",
    "variable": "var(--caXmBQ)"
  },
  "colors.bg.feedback.success.hero": {
    "value": "var(--hzTwza)",
    "variable": "var(--hzTwza)"
  },
  "colors.bg.feedback.success.soft": {
    "value": "var(--chGNoc)",
    "variable": "var(--chGNoc)"
  },
  "colors.bg.feedback.warning.impact": {
    "value": "var(--dCuxpt)",
    "variable": "var(--dCuxpt)"
  },
  "colors.bg.feedback.warning.hero": {
    "value": "var(--eGOfbz)",
    "variable": "var(--eGOfbz)"
  },
  "colors.bg.feedback.warning.soft": {
    "value": "var(--inqYjV)",
    "variable": "var(--inqYjV)"
  },
  "colors.bg.invisible": {
    "value": "var(--lawEWN)",
    "variable": "var(--lawEWN)"
  },
  "colors.bg.impact": {
    "value": "var(--dUYSvi)",
    "variable": "var(--dUYSvi)"
  },
  "colors.bg.impact-fixed": {
    "value": "var(--bykxih)",
    "variable": "var(--bykxih)"
  },
  "colors.bg.impact-soft": {
    "value": "var(--pfyuF)",
    "variable": "var(--pfyuF)"
  },
  "colors.bg.impact-soft-fixed": {
    "value": "var(--fAfxbW)",
    "variable": "var(--fAfxbW)"
  },
  "colors.bg.impact-softer": {
    "value": "var(--ddWZne)",
    "variable": "var(--ddWZne)"
  },
  "colors.bg.impact-softest": {
    "value": "var(--eoTRNX)",
    "variable": "var(--eoTRNX)"
  },
  "colors.bg.neutral": {
    "value": "var(--euecPN)",
    "variable": "var(--euecPN)"
  },
  "colors.bg.neutral-fixed": {
    "value": "var(--kbSMSq)",
    "variable": "var(--kbSMSq)"
  },
  "colors.bg.soft": {
    "value": "var(--WbRFK)",
    "variable": "var(--WbRFK)"
  },
  "colors.bg.softer": {
    "value": "var(--lfQNoV)",
    "variable": "var(--lfQNoV)"
  },
  "colors.bg.softer-fixed": {
    "value": "var(--jWlrbO)",
    "variable": "var(--jWlrbO)"
  },
  "colors.bg.softest": {
    "value": "var(--dFJplw)",
    "variable": "var(--dFJplw)"
  },
  "colors.bg.softest-fixed": {
    "value": "var(--dLtdQb)",
    "variable": "var(--dLtdQb)"
  },
  "colors.bg.onElevated.softest": {
    "value": "var(--gCVIWa)",
    "variable": "var(--gCVIWa)"
  },
  "colors.bg.screen.neutral": {
    "value": "var(--dngnjw)",
    "variable": "var(--dngnjw)"
  },
  "colors.bg.screen.softest": {
    "value": "var(--keSXoB)",
    "variable": "var(--keSXoB)"
  },
  "colors.bg.screen.scrim": {
    "value": "var(--eAwCUX)",
    "variable": "var(--eAwCUX)"
  },
  "colors.bg.transparent.impact-fixed": {
    "value": "var(--bQxWIu)",
    "variable": "var(--bQxWIu)"
  },
  "colors.bg.transparent.impact-fixed-faint": {
    "value": "var(--eSOKiL)",
    "variable": "var(--eSOKiL)"
  },
  "colors.border.accent.brand.hero": {
    "value": "var(--entpEk)",
    "variable": "var(--entpEk)"
  },
  "colors.border.accent.brand.hero-fixed": {
    "value": "var(--hYTedn)",
    "variable": "var(--hYTedn)"
  },
  "colors.border.accent.aqua.strong": {
    "value": "var(--iyWRfA)",
    "variable": "var(--iyWRfA)"
  },
  "colors.border.accent.aqua.hero": {
    "value": "var(--kprtVr)",
    "variable": "var(--kprtVr)"
  },
  "colors.border.accent.blue.strong": {
    "value": "var(--cAWJGe)",
    "variable": "var(--cAWJGe)"
  },
  "colors.border.accent.blue.strong-fixed": {
    "value": "var(--gzxsZZ)",
    "variable": "var(--gzxsZZ)"
  },
  "colors.border.accent.blue.hero": {
    "value": "var(--kOqkNR)",
    "variable": "var(--kOqkNR)"
  },
  "colors.border.accent.gray.strong": {
    "value": "var(--QXvhl)",
    "variable": "var(--QXvhl)"
  },
  "colors.border.accent.gray.hero": {
    "value": "var(--bRvxSK)",
    "variable": "var(--bRvxSK)"
  },
  "colors.border.accent.green.strong": {
    "value": "var(--dzVYVL)",
    "variable": "var(--dzVYVL)"
  },
  "colors.border.accent.green.hero": {
    "value": "var(--pwSeI)",
    "variable": "var(--pwSeI)"
  },
  "colors.border.accent.orange.strong": {
    "value": "var(--gBmwfw)",
    "variable": "var(--gBmwfw)"
  },
  "colors.border.accent.orange.hero": {
    "value": "var(--bqlNiP)",
    "variable": "var(--bqlNiP)"
  },
  "colors.border.accent.purple.strong": {
    "value": "var(--kXTHme)",
    "variable": "var(--kXTHme)"
  },
  "colors.border.accent.purple.hero": {
    "value": "var(--ofHsp)",
    "variable": "var(--ofHsp)"
  },
  "colors.border.accent.red.strong": {
    "value": "var(--liuajf)",
    "variable": "var(--liuajf)"
  },
  "colors.border.accent.red.hero": {
    "value": "var(--eZFzkI)",
    "variable": "var(--eZFzkI)"
  },
  "colors.border.accent.teal.strong": {
    "value": "var(--dhuhdQ)",
    "variable": "var(--dhuhdQ)"
  },
  "colors.border.accent.teal.hero": {
    "value": "var(--fPCDWL)",
    "variable": "var(--fPCDWL)"
  },
  "colors.border.accent.yellow.strong": {
    "value": "var(--hYqfYw)",
    "variable": "var(--hYqfYw)"
  },
  "colors.border.accent.yellow.hero": {
    "value": "var(--tRymD)",
    "variable": "var(--tRymD)"
  },
  "colors.border.action.neutral.default": {
    "value": "var(--gMvPgF)",
    "variable": "var(--gMvPgF)"
  },
  "colors.border.action.neutral.hover": {
    "value": "var(--jFfgLM)",
    "variable": "var(--jFfgLM)"
  },
  "colors.border.action.neutral.pressed": {
    "value": "var(--kbRDYs)",
    "variable": "var(--kbRDYs)"
  },
  "colors.border.action.neutral-fixed.default": {
    "value": "var(--gplBby)",
    "variable": "var(--gplBby)"
  },
  "colors.border.action.neutral-fixed.hover": {
    "value": "var(--jxWVqH)",
    "variable": "var(--jxWVqH)"
  },
  "colors.border.action.neutral-fixed.pressed": {
    "value": "var(--ctRhJf)",
    "variable": "var(--ctRhJf)"
  },
  "colors.border.action.strong.default": {
    "value": "var(--ctRgCr)",
    "variable": "var(--ctRgCr)"
  },
  "colors.border.action.strong.hover": {
    "value": "var(--bCYtla)",
    "variable": "var(--bCYtla)"
  },
  "colors.border.action.strong.pressed": {
    "value": "var(--doIrvy)",
    "variable": "var(--doIrvy)"
  },
  "colors.border.action.hero.default": {
    "value": "var(--bfhuBg)",
    "variable": "var(--bfhuBg)"
  },
  "colors.border.action.hero.hover": {
    "value": "var(--ceVRjl)",
    "variable": "var(--ceVRjl)"
  },
  "colors.border.action.hero.pressed": {
    "value": "var(--eIOrEN)",
    "variable": "var(--eIOrEN)"
  },
  "colors.border.action.hero.selected.default": {
    "value": "var(--hpSeVA)",
    "variable": "var(--hpSeVA)"
  },
  "colors.border.action.hero.selected.hover": {
    "value": "var(--ISIId)",
    "variable": "var(--ISIId)"
  },
  "colors.border.action.hero.selected.pressed": {
    "value": "var(--eUiEzx)",
    "variable": "var(--eUiEzx)"
  },
  "colors.border.action.critical.strong.default": {
    "value": "var(--hFktpR)",
    "variable": "var(--hFktpR)"
  },
  "colors.border.action.critical.strong.hover": {
    "value": "var(--cHtOWk)",
    "variable": "var(--cHtOWk)"
  },
  "colors.border.action.critical.strong.pressed": {
    "value": "var(--jczBVo)",
    "variable": "var(--jczBVo)"
  },
  "colors.border.action.critical.hero.default": {
    "value": "var(--jNZtiu)",
    "variable": "var(--jNZtiu)"
  },
  "colors.border.action.critical.hero.hover": {
    "value": "var(--bFQgyj)",
    "variable": "var(--bFQgyj)"
  },
  "colors.border.action.critical.hero.pressed": {
    "value": "var(--fRgcpD)",
    "variable": "var(--fRgcpD)"
  },
  "colors.border.express.empower.strong": {
    "value": "var(--kvTyzL)",
    "variable": "var(--kvTyzL)"
  },
  "colors.border.express.empower.hero": {
    "value": "var(--eGrOHg)",
    "variable": "var(--eGrOHg)"
  },
  "colors.border.express.insight.strong": {
    "value": "var(--fUyxwa)",
    "variable": "var(--fUyxwa)"
  },
  "colors.border.express.insight.hero": {
    "value": "var(--bnMQMt)",
    "variable": "var(--bnMQMt)"
  },
  "colors.border.express.inspire.strong": {
    "value": "var(--eEqbOK)",
    "variable": "var(--eEqbOK)"
  },
  "colors.border.express.inspire.hero": {
    "value": "var(--fuubcF)",
    "variable": "var(--fuubcF)"
  },
  "colors.border.express.trust.strong": {
    "value": "var(--NifQI)",
    "variable": "var(--NifQI)"
  },
  "colors.border.express.trust.hero": {
    "value": "var(--kxCZYH)",
    "variable": "var(--kxCZYH)"
  },
  "colors.border.feedback.critical.strong": {
    "value": "var(--fNhnfI)",
    "variable": "var(--fNhnfI)"
  },
  "colors.border.feedback.critical.hero": {
    "value": "var(--hKUznb)",
    "variable": "var(--hKUznb)"
  },
  "colors.border.feedback.critical.hero-alt": {
    "value": "var(--bSLBar)",
    "variable": "var(--bSLBar)"
  },
  "colors.border.feedback.info.strong": {
    "value": "var(--hHkXzV)",
    "variable": "var(--hHkXzV)"
  },
  "colors.border.feedback.info.hero": {
    "value": "var(--hJHziG)",
    "variable": "var(--hJHziG)"
  },
  "colors.border.feedback.notify.strong": {
    "value": "var(--iSzGhs)",
    "variable": "var(--iSzGhs)"
  },
  "colors.border.feedback.notify.hero": {
    "value": "var(--yAgjj)",
    "variable": "var(--yAgjj)"
  },
  "colors.border.feedback.notify.hero-alt": {
    "value": "var(--gLuuiP)",
    "variable": "var(--gLuuiP)"
  },
  "colors.border.feedback.success.strong": {
    "value": "var(--loseyE)",
    "variable": "var(--loseyE)"
  },
  "colors.border.feedback.success.hero": {
    "value": "var(--jwnfpb)",
    "variable": "var(--jwnfpb)"
  },
  "colors.border.feedback.success.hero-alt": {
    "value": "var(--biprCP)",
    "variable": "var(--biprCP)"
  },
  "colors.border.feedback.warning.strong": {
    "value": "var(--liEMVR)",
    "variable": "var(--liEMVR)"
  },
  "colors.border.feedback.warning.hero": {
    "value": "var(--essVgm)",
    "variable": "var(--essVgm)"
  },
  "colors.border.invisible": {
    "value": "var(--kBABTA)",
    "variable": "var(--kBABTA)"
  },
  "colors.border.muted": {
    "value": "var(--hWIGgY)",
    "variable": "var(--hWIGgY)"
  },
  "colors.border.muted-alt": {
    "value": "var(--hLriMM)",
    "variable": "var(--hLriMM)"
  },
  "colors.border.neutral": {
    "value": "var(--jQCDo)",
    "variable": "var(--jQCDo)"
  },
  "colors.border.neutral-fixed": {
    "value": "var(--kKJPjL)",
    "variable": "var(--kKJPjL)"
  },
  "colors.border.subtle": {
    "value": "var(--jfPAjk)",
    "variable": "var(--jfPAjk)"
  },
  "colors.border.onHero.action.neutral.default": {
    "value": "var(--RBFdp)",
    "variable": "var(--RBFdp)"
  },
  "colors.border.onHero.action.neutral.hover": {
    "value": "var(--bViAso)",
    "variable": "var(--bViAso)"
  },
  "colors.border.onHero.action.neutral.pressed": {
    "value": "var(--fBnJgU)",
    "variable": "var(--fBnJgU)"
  },
  "colors.border.onHero.express.empower.hero": {
    "value": "var(--gGXYDI)",
    "variable": "var(--gGXYDI)"
  },
  "colors.border.onHero.express.insight.hero": {
    "value": "var(--eKqdjt)",
    "variable": "var(--eKqdjt)"
  },
  "colors.border.onHero.express.inspire.hero": {
    "value": "var(--kCVITN)",
    "variable": "var(--kCVITN)"
  },
  "colors.border.onHero.express.trust.hero": {
    "value": "var(--cmfRgD)",
    "variable": "var(--cmfRgD)"
  },
  "colors.border.onHero.neutral": {
    "value": "var(--eDnHZc)",
    "variable": "var(--eDnHZc)"
  },
  "colors.border.onHero.neutral-fixed": {
    "value": "var(--bfoauL)",
    "variable": "var(--bfoauL)"
  },
  "colors.border.onImpact.action.neutral.default": {
    "value": "var(--kXyzrf)",
    "variable": "var(--kXyzrf)"
  },
  "colors.border.onImpact.action.neutral.hover": {
    "value": "var(--iKiOGe)",
    "variable": "var(--iKiOGe)"
  },
  "colors.border.onImpact.action.neutral.pressed": {
    "value": "var(--fxUCWe)",
    "variable": "var(--fxUCWe)"
  },
  "colors.border.onImpact.action.hero.default": {
    "value": "var(--jlqQse)",
    "variable": "var(--jlqQse)"
  },
  "colors.border.onImpact.action.hero.hover": {
    "value": "var(--bpgCPn)",
    "variable": "var(--bpgCPn)"
  },
  "colors.border.onImpact.action.hero.pressed": {
    "value": "var(--fAwyGH)",
    "variable": "var(--fAwyGH)"
  },
  "colors.border.onImpact.action.critical.hero.default": {
    "value": "var(--loJQxE)",
    "variable": "var(--loJQxE)"
  },
  "colors.border.onImpact.action.critical.hero.hover": {
    "value": "var(--cvBzIV)",
    "variable": "var(--cvBzIV)"
  },
  "colors.border.onImpact.action.critical.hero.pressed": {
    "value": "var(--kjdhkV)",
    "variable": "var(--kjdhkV)"
  },
  "colors.border.onImpact.express.empower.hero": {
    "value": "var(--mKzEm)",
    "variable": "var(--mKzEm)"
  },
  "colors.border.onImpact.express.insight.hero": {
    "value": "var(--fLBwOf)",
    "variable": "var(--fLBwOf)"
  },
  "colors.border.onImpact.express.inspire.hero": {
    "value": "var(--tjKhn)",
    "variable": "var(--tjKhn)"
  },
  "colors.border.onImpact.express.trust.hero": {
    "value": "var(--gYUuPd)",
    "variable": "var(--gYUuPd)"
  },
  "colors.border.onImpact.feedback.critical.strong": {
    "value": "var(--eGWYFm)",
    "variable": "var(--eGWYFm)"
  },
  "colors.border.onImpact.feedback.critical.hero": {
    "value": "var(--iibPQd)",
    "variable": "var(--iibPQd)"
  },
  "colors.border.onImpact.feedback.critical.hero-alt": {
    "value": "var(--cRrGUx)",
    "variable": "var(--cRrGUx)"
  },
  "colors.border.onImpact.feedback.info.strong": {
    "value": "var(--fTzrWT)",
    "variable": "var(--fTzrWT)"
  },
  "colors.border.onImpact.feedback.info.hero": {
    "value": "var(--bdDAsw)",
    "variable": "var(--bdDAsw)"
  },
  "colors.border.onImpact.feedback.notify.strong": {
    "value": "var(--krjPGG)",
    "variable": "var(--krjPGG)"
  },
  "colors.border.onImpact.feedback.notify.hero": {
    "value": "var(--dfsssl)",
    "variable": "var(--dfsssl)"
  },
  "colors.border.onImpact.feedback.notify.hero-alt": {
    "value": "var(--kgbmEp)",
    "variable": "var(--kgbmEp)"
  },
  "colors.border.onImpact.feedback.success.strong": {
    "value": "var(--WzeKG)",
    "variable": "var(--WzeKG)"
  },
  "colors.border.onImpact.feedback.success.hero": {
    "value": "var(--dlMfUl)",
    "variable": "var(--dlMfUl)"
  },
  "colors.border.onImpact.feedback.success.hero-alt": {
    "value": "var(--iiLwLJ)",
    "variable": "var(--iiLwLJ)"
  },
  "colors.border.onImpact.feedback.warning.strong": {
    "value": "var(--kkgyhn)",
    "variable": "var(--kkgyhn)"
  },
  "colors.border.onImpact.feedback.warning.hero": {
    "value": "var(--denYxU)",
    "variable": "var(--denYxU)"
  },
  "colors.border.onImpact.neutral": {
    "value": "var(--idaNSC)",
    "variable": "var(--idaNSC)"
  },
  "colors.border.onImpact.neutral-fixed": {
    "value": "var(--bgwION)",
    "variable": "var(--bgwION)"
  },
  "colors.border.onImpact.subtle": {
    "value": "var(--kraPMO)",
    "variable": "var(--kraPMO)"
  },
  "colors.effect.elevation.sm": {
    "value": "var(--hlCWqO)",
    "variable": "var(--hlCWqO)"
  },
  "colors.effect.elevation.smHeavy": {
    "value": "var(--jiXVXh)",
    "variable": "var(--jiXVXh)"
  },
  "colors.effect.elevation.md": {
    "value": "var(--kGCNvR)",
    "variable": "var(--kGCNvR)"
  },
  "colors.effect.elevation.lg": {
    "value": "var(--escfUv)",
    "variable": "var(--escfUv)"
  },
  "colors.effect.elevation.invisible": {
    "value": "var(--eRFoKV)",
    "variable": "var(--eRFoKV)"
  },
  "colors.effect.elevation.focus-1": {
    "value": "var(--dmbpbc)",
    "variable": "var(--dmbpbc)"
  },
  "colors.effect.elevation.focus-2": {
    "value": "var(--Wiwvb)",
    "variable": "var(--Wiwvb)"
  },
  "colors.effect.elevation.focus-3": {
    "value": "var(--ivNzVi)",
    "variable": "var(--ivNzVi)"
  },
  "colors.icon.accent.brand.hero": {
    "value": "var(--JWxjX)",
    "variable": "var(--JWxjX)"
  },
  "colors.icon.accent.brand.hero-fixed": {
    "value": "var(--iYkOBs)",
    "variable": "var(--iYkOBs)"
  },
  "colors.icon.accent.aqua.strong": {
    "value": "var(--bOddUH)",
    "variable": "var(--bOddUH)"
  },
  "colors.icon.accent.aqua.hero": {
    "value": "var(--jTQoak)",
    "variable": "var(--jTQoak)"
  },
  "colors.icon.accent.blue.strong": {
    "value": "var(--grLsAR)",
    "variable": "var(--grLsAR)"
  },
  "colors.icon.accent.blue.strong-fixed": {
    "value": "var(--keUecG)",
    "variable": "var(--keUecG)"
  },
  "colors.icon.accent.blue.hero": {
    "value": "var(--XqODS)",
    "variable": "var(--XqODS)"
  },
  "colors.icon.accent.gray.strong": {
    "value": "var(--ecYupu)",
    "variable": "var(--ecYupu)"
  },
  "colors.icon.accent.gray.hero": {
    "value": "var(--ekAGth)",
    "variable": "var(--ekAGth)"
  },
  "colors.icon.accent.green.strong": {
    "value": "var(--ksyHyg)",
    "variable": "var(--ksyHyg)"
  },
  "colors.icon.accent.green.hero": {
    "value": "var(--gNEpUn)",
    "variable": "var(--gNEpUn)"
  },
  "colors.icon.accent.orange.strong": {
    "value": "var(--czjxKD)",
    "variable": "var(--czjxKD)"
  },
  "colors.icon.accent.orange.hero": {
    "value": "var(--dpYWqE)",
    "variable": "var(--dpYWqE)"
  },
  "colors.icon.accent.purple.strong": {
    "value": "var(--fNSIYB)",
    "variable": "var(--fNSIYB)"
  },
  "colors.icon.accent.purple.hero": {
    "value": "var(--fNXhGW)",
    "variable": "var(--fNXhGW)"
  },
  "colors.icon.accent.red.strong": {
    "value": "var(--DRmuU)",
    "variable": "var(--DRmuU)"
  },
  "colors.icon.accent.red.hero": {
    "value": "var(--gkNslb)",
    "variable": "var(--gkNslb)"
  },
  "colors.icon.accent.teal.strong": {
    "value": "var(--hqnRgP)",
    "variable": "var(--hqnRgP)"
  },
  "colors.icon.accent.teal.hero": {
    "value": "var(--kruCHE)",
    "variable": "var(--kruCHE)"
  },
  "colors.icon.accent.yellow.strong": {
    "value": "var(--iYUReP)",
    "variable": "var(--iYUReP)"
  },
  "colors.icon.accent.yellow.hero": {
    "value": "var(--hScRNo)",
    "variable": "var(--hScRNo)"
  },
  "colors.icon.action.neutral.default": {
    "value": "var(--ggvolK)",
    "variable": "var(--ggvolK)"
  },
  "colors.icon.action.neutral.hover": {
    "value": "var(--bzEJdH)",
    "variable": "var(--bzEJdH)"
  },
  "colors.icon.action.neutral.pressed": {
    "value": "var(--hsVItX)",
    "variable": "var(--hsVItX)"
  },
  "colors.icon.action.neutral-fixed.default": {
    "value": "var(--jmhMnx)",
    "variable": "var(--jmhMnx)"
  },
  "colors.icon.action.neutral-fixed.hover": {
    "value": "var(--gjotPY)",
    "variable": "var(--gjotPY)"
  },
  "colors.icon.action.neutral-fixed.pressed": {
    "value": "var(--fnyykU)",
    "variable": "var(--fnyykU)"
  },
  "colors.icon.action.hero.default": {
    "value": "var(--ecHnwD)",
    "variable": "var(--ecHnwD)"
  },
  "colors.icon.action.hero.hover": {
    "value": "var(--jHJVjK)",
    "variable": "var(--jHJVjK)"
  },
  "colors.icon.action.hero.pressed": {
    "value": "var(--jhVWAG)",
    "variable": "var(--jhVWAG)"
  },
  "colors.icon.action.hero.selected.default": {
    "value": "var(--hiQhhL)",
    "variable": "var(--hiQhhL)"
  },
  "colors.icon.action.hero.selected.hover": {
    "value": "var(--iMbHwK)",
    "variable": "var(--iMbHwK)"
  },
  "colors.icon.action.hero.selected.pressed": {
    "value": "var(--hQlLRG)",
    "variable": "var(--hQlLRG)"
  },
  "colors.icon.action.strong.default": {
    "value": "var(--bncwPs)",
    "variable": "var(--bncwPs)"
  },
  "colors.icon.action.strong.hover": {
    "value": "var(--lcLglV)",
    "variable": "var(--lcLglV)"
  },
  "colors.icon.action.strong.pressed": {
    "value": "var(--crhXiB)",
    "variable": "var(--crhXiB)"
  },
  "colors.icon.action.critical.strong.default": {
    "value": "var(--gLrAFu)",
    "variable": "var(--gLrAFu)"
  },
  "colors.icon.action.critical.strong.hover": {
    "value": "var(--gIWQtX)",
    "variable": "var(--gIWQtX)"
  },
  "colors.icon.action.critical.strong.pressed": {
    "value": "var(--kUmMlr)",
    "variable": "var(--kUmMlr)"
  },
  "colors.icon.action.critical.hero.default": {
    "value": "var(--hZvdxN)",
    "variable": "var(--hZvdxN)"
  },
  "colors.icon.action.critical.hero.hover": {
    "value": "var(--knpzog)",
    "variable": "var(--knpzog)"
  },
  "colors.icon.action.critical.hero.pressed": {
    "value": "var(--jrzDJc)",
    "variable": "var(--jrzDJc)"
  },
  "colors.icon.action.success.hero.default": {
    "value": "var(--bZqaTh)",
    "variable": "var(--bZqaTh)"
  },
  "colors.icon.action.success.hero.hover": {
    "value": "var(--gnCMCw)",
    "variable": "var(--gnCMCw)"
  },
  "colors.icon.action.success.hero.pressed": {
    "value": "var(--hXfCpA)",
    "variable": "var(--hXfCpA)"
  },
  "colors.icon.action.disabled": {
    "value": "var(--bItWqd)",
    "variable": "var(--bItWqd)"
  },
  "colors.icon.action.disabled-muted": {
    "value": "var(--gjpKVx)",
    "variable": "var(--gjpKVx)"
  },
  "colors.icon.action.disabled-alt": {
    "value": "var(--kMPCTt)",
    "variable": "var(--kMPCTt)"
  },
  "colors.icon.express.empower.strong": {
    "value": "var(--bYphio)",
    "variable": "var(--bYphio)"
  },
  "colors.icon.express.empower.hero": {
    "value": "var(--cEzlOn)",
    "variable": "var(--cEzlOn)"
  },
  "colors.icon.express.insight.strong": {
    "value": "var(--iqDbuV)",
    "variable": "var(--iqDbuV)"
  },
  "colors.icon.express.insight.hero": {
    "value": "var(--feJzSm)",
    "variable": "var(--feJzSm)"
  },
  "colors.icon.express.inspire.strong": {
    "value": "var(--dWAmQR)",
    "variable": "var(--dWAmQR)"
  },
  "colors.icon.express.inspire.hero": {
    "value": "var(--hLzlaa)",
    "variable": "var(--hLzlaa)"
  },
  "colors.icon.express.trust.strong": {
    "value": "var(--eboyBH)",
    "variable": "var(--eboyBH)"
  },
  "colors.icon.express.trust.hero": {
    "value": "var(--hqGIbk)",
    "variable": "var(--hqGIbk)"
  },
  "colors.icon.feedback.critical.strong": {
    "value": "var(--dUucpL)",
    "variable": "var(--dUucpL)"
  },
  "colors.icon.feedback.critical.hero": {
    "value": "var(--jbBerE)",
    "variable": "var(--jbBerE)"
  },
  "colors.icon.feedback.critical.hero-alt": {
    "value": "var(--htiptA)",
    "variable": "var(--htiptA)"
  },
  "colors.icon.feedback.info.strong": {
    "value": "var(--hkoYDW)",
    "variable": "var(--hkoYDW)"
  },
  "colors.icon.feedback.info.hero": {
    "value": "var(--dlLkYV)",
    "variable": "var(--dlLkYV)"
  },
  "colors.icon.feedback.notify.strong": {
    "value": "var(--dDDyIX)",
    "variable": "var(--dDDyIX)"
  },
  "colors.icon.feedback.notify.hero": {
    "value": "var(--jaWsXg)",
    "variable": "var(--jaWsXg)"
  },
  "colors.icon.feedback.notify.hero-alt": {
    "value": "var(--eSdHdc)",
    "variable": "var(--eSdHdc)"
  },
  "colors.icon.feedback.success.strong": {
    "value": "var(--bIYyej)",
    "variable": "var(--bIYyej)"
  },
  "colors.icon.feedback.success.hero": {
    "value": "var(--fNAGKQ)",
    "variable": "var(--fNAGKQ)"
  },
  "colors.icon.feedback.success.hero-alt": {
    "value": "var(--jCGIlY)",
    "variable": "var(--jCGIlY)"
  },
  "colors.icon.feedback.warning.strong": {
    "value": "var(--ivUSiq)",
    "variable": "var(--ivUSiq)"
  },
  "colors.icon.feedback.warning.hero": {
    "value": "var(--bRiyvp)",
    "variable": "var(--bRiyvp)"
  },
  "colors.icon.neutral": {
    "value": "var(--iyEiTX)",
    "variable": "var(--iyEiTX)"
  },
  "colors.icon.neutral-fixed": {
    "value": "var(--fwteVI)",
    "variable": "var(--fwteVI)"
  },
  "colors.icon.muted": {
    "value": "var(--dIqxun)",
    "variable": "var(--dIqxun)"
  },
  "colors.icon.subtle": {
    "value": "var(--crumIX)",
    "variable": "var(--crumIX)"
  },
  "colors.icon.invisible": {
    "value": "var(--cLqmYH)",
    "variable": "var(--cLqmYH)"
  },
  "colors.icon.link.default": {
    "value": "var(--kCzsJQ)",
    "variable": "var(--kCzsJQ)"
  },
  "colors.icon.link.hover": {
    "value": "var(--glnmMt)",
    "variable": "var(--glnmMt)"
  },
  "colors.icon.link.pressed": {
    "value": "var(--jiiXzN)",
    "variable": "var(--jiiXzN)"
  },
  "colors.icon.link.last-visited": {
    "value": "var(--bvwsAs)",
    "variable": "var(--bvwsAs)"
  },
  "colors.icon.transparent.neutral-fixed": {
    "value": "var(--iwiKYD)",
    "variable": "var(--iwiKYD)"
  },
  "colors.icon.transparent.neutral-fixed-faint": {
    "value": "var(--etVtaS)",
    "variable": "var(--etVtaS)"
  },
  "colors.icon.transparent.action.neutral-fixed.default": {
    "value": "var(--beanfC)",
    "variable": "var(--beanfC)"
  },
  "colors.icon.transparent.action.neutral-fixed.hover": {
    "value": "var(--iKjqlH)",
    "variable": "var(--iKjqlH)"
  },
  "colors.icon.transparent.action.neutral-fixed.pressed": {
    "value": "var(--eYgUYv)",
    "variable": "var(--eYgUYv)"
  },
  "colors.icon.transparent.onImpact.neutral-fixed": {
    "value": "var(--jdzHRF)",
    "variable": "var(--jdzHRF)"
  },
  "colors.icon.transparent.onInverse.neutral-fixed": {
    "value": "var(--jAFHIH)",
    "variable": "var(--jAFHIH)"
  },
  "colors.icon.onHero.action.neutral.default": {
    "value": "var(--kuWGla)",
    "variable": "var(--kuWGla)"
  },
  "colors.icon.onHero.action.neutral.hover": {
    "value": "var(--etQaqX)",
    "variable": "var(--etQaqX)"
  },
  "colors.icon.onHero.action.neutral.pressed": {
    "value": "var(--hWxScj)",
    "variable": "var(--hWxScj)"
  },
  "colors.icon.onHero.express.empower.hero": {
    "value": "var(--dHVNCH)",
    "variable": "var(--dHVNCH)"
  },
  "colors.icon.onHero.express.insight.hero": {
    "value": "var(--jTHMFe)",
    "variable": "var(--jTHMFe)"
  },
  "colors.icon.onHero.express.inspire.hero": {
    "value": "var(--eZEOSC)",
    "variable": "var(--eZEOSC)"
  },
  "colors.icon.onHero.express.trust.hero": {
    "value": "var(--jfgflw)",
    "variable": "var(--jfgflw)"
  },
  "colors.icon.onHero.neutral": {
    "value": "var(--etCEcb)",
    "variable": "var(--etCEcb)"
  },
  "colors.icon.onHero.neutral-fixed": {
    "value": "var(--jgdgjE)",
    "variable": "var(--jgdgjE)"
  },
  "colors.icon.onHero.link.default": {
    "value": "var(--fjgswc)",
    "variable": "var(--fjgswc)"
  },
  "colors.icon.onHero.link.hover": {
    "value": "var(--irCDll)",
    "variable": "var(--irCDll)"
  },
  "colors.icon.onHero.link.pressed": {
    "value": "var(--hROECh)",
    "variable": "var(--hROECh)"
  },
  "colors.icon.onImpact.action.neutral.default": {
    "value": "var(--dvpplc)",
    "variable": "var(--dvpplc)"
  },
  "colors.icon.onImpact.action.neutral.hover": {
    "value": "var(--bYDAYB)",
    "variable": "var(--bYDAYB)"
  },
  "colors.icon.onImpact.action.neutral.pressed": {
    "value": "var(--fEIJNh)",
    "variable": "var(--fEIJNh)"
  },
  "colors.icon.onImpact.action.neutral-fixed.default": {
    "value": "var(--fELNXX)",
    "variable": "var(--fELNXX)"
  },
  "colors.icon.onImpact.action.neutral-fixed.hover": {
    "value": "var(--eUzvdS)",
    "variable": "var(--eUzvdS)"
  },
  "colors.icon.onImpact.action.neutral-fixed.pressed": {
    "value": "var(--dkuEIq)",
    "variable": "var(--dkuEIq)"
  },
  "colors.icon.onImpact.action.neutral-fixed.selected.default": {
    "value": "var(--exZSKH)",
    "variable": "var(--exZSKH)"
  },
  "colors.icon.onImpact.action.neutral-fixed.selected.hover": {
    "value": "var(--gPbDcK)",
    "variable": "var(--gPbDcK)"
  },
  "colors.icon.onImpact.action.neutral-fixed.selected.pressed": {
    "value": "var(--bMBocu)",
    "variable": "var(--bMBocu)"
  },
  "colors.icon.onImpact.action.hero.default": {
    "value": "var(--huNuqR)",
    "variable": "var(--huNuqR)"
  },
  "colors.icon.onImpact.action.hero.hover": {
    "value": "var(--bGmbco)",
    "variable": "var(--bGmbco)"
  },
  "colors.icon.onImpact.action.hero.pressed": {
    "value": "var(--Kwfxk)",
    "variable": "var(--Kwfxk)"
  },
  "colors.icon.onImpact.action.critical.hero.default": {
    "value": "var(--gbJnlb)",
    "variable": "var(--gbJnlb)"
  },
  "colors.icon.onImpact.action.critical.hero.hover": {
    "value": "var(--bGOyYy)",
    "variable": "var(--bGOyYy)"
  },
  "colors.icon.onImpact.action.critical.hero.pressed": {
    "value": "var(--lmfsbS)",
    "variable": "var(--lmfsbS)"
  },
  "colors.icon.onImpact.express.empower.hero": {
    "value": "var(--cyvqQl)",
    "variable": "var(--cyvqQl)"
  },
  "colors.icon.onImpact.express.insight.hero": {
    "value": "var(--jccypw)",
    "variable": "var(--jccypw)"
  },
  "colors.icon.onImpact.express.inspire.hero": {
    "value": "var(--jxPQFY)",
    "variable": "var(--jxPQFY)"
  },
  "colors.icon.onImpact.express.trust.hero": {
    "value": "var(--hFeDfC)",
    "variable": "var(--hFeDfC)"
  },
  "colors.icon.onImpact.feedback.critical.strong": {
    "value": "var(--bXLNIh)",
    "variable": "var(--bXLNIh)"
  },
  "colors.icon.onImpact.feedback.critical.hero": {
    "value": "var(--lcjPtq)",
    "variable": "var(--lcjPtq)"
  },
  "colors.icon.onImpact.feedback.critical.hero-alt": {
    "value": "var(--jZjlpm)",
    "variable": "var(--jZjlpm)"
  },
  "colors.icon.onImpact.feedback.info.strong": {
    "value": "var(--buLCEc)",
    "variable": "var(--buLCEc)"
  },
  "colors.icon.onImpact.feedback.info.hero": {
    "value": "var(--knTXcb)",
    "variable": "var(--knTXcb)"
  },
  "colors.icon.onImpact.feedback.notify.strong": {
    "value": "var(--glWVEp)",
    "variable": "var(--glWVEp)"
  },
  "colors.icon.onImpact.feedback.notify.hero": {
    "value": "var(--hbwVWe)",
    "variable": "var(--hbwVWe)"
  },
  "colors.icon.onImpact.feedback.notify.hero-alt": {
    "value": "var(--jwfruG)",
    "variable": "var(--jwfruG)"
  },
  "colors.icon.onImpact.feedback.success.strong": {
    "value": "var(--aKRqN)",
    "variable": "var(--aKRqN)"
  },
  "colors.icon.onImpact.feedback.success.hero": {
    "value": "var(--SJPnG)",
    "variable": "var(--SJPnG)"
  },
  "colors.icon.onImpact.feedback.success.hero-alt": {
    "value": "var(--bHZsi)",
    "variable": "var(--bHZsi)"
  },
  "colors.icon.onImpact.feedback.warning.strong": {
    "value": "var(--cFLGVs)",
    "variable": "var(--cFLGVs)"
  },
  "colors.icon.onImpact.feedback.warning.hero": {
    "value": "var(--jLMDQf)",
    "variable": "var(--jLMDQf)"
  },
  "colors.icon.onImpact.neutral": {
    "value": "var(--gzDIbh)",
    "variable": "var(--gzDIbh)"
  },
  "colors.icon.onImpact.neutral-fixed": {
    "value": "var(--dnRqq)",
    "variable": "var(--dnRqq)"
  },
  "colors.icon.onImpact.subtle": {
    "value": "var(--kitEIp)",
    "variable": "var(--kitEIp)"
  },
  "colors.icon.onImpact.link.default": {
    "value": "var(--gDqdkq)",
    "variable": "var(--gDqdkq)"
  },
  "colors.icon.onImpact.link.hover": {
    "value": "var(--epLYMT)",
    "variable": "var(--epLYMT)"
  },
  "colors.icon.onImpact.link.pressed": {
    "value": "var(--gTEziv)",
    "variable": "var(--gTEziv)"
  },
  "colors.icon.onImpact.link.fixed.default": {
    "value": "var(--jBXjSZ)",
    "variable": "var(--jBXjSZ)"
  },
  "colors.icon.onImpact.link.fixed.hover": {
    "value": "var(--fsivlY)",
    "variable": "var(--fsivlY)"
  },
  "colors.icon.onImpact.link.fixed.pressed": {
    "value": "var(--hbLkZc)",
    "variable": "var(--hbLkZc)"
  },
  "colors.icon.onImpact.link.fixed.selected.default": {
    "value": "var(--kZhXCx)",
    "variable": "var(--kZhXCx)"
  },
  "colors.icon.onImpact.link.fixed.selected.hover": {
    "value": "var(--guYPUs)",
    "variable": "var(--guYPUs)"
  },
  "colors.icon.onImpact.link.fixed.selected.pressed": {
    "value": "var(--kxVALw)",
    "variable": "var(--kxVALw)"
  },
  "colors.text.onHero.action.neutral.default": {
    "value": "var(--fMTknM)",
    "variable": "var(--fMTknM)"
  },
  "colors.text.onHero.action.neutral.hover": {
    "value": "var(--kAwDNR)",
    "variable": "var(--kAwDNR)"
  },
  "colors.text.onHero.action.neutral.pressed": {
    "value": "var(--cNIMah)",
    "variable": "var(--cNIMah)"
  },
  "colors.text.onHero.express.empower.hero": {
    "value": "var(--iacqSN)",
    "variable": "var(--iacqSN)"
  },
  "colors.text.onHero.express.insight.hero": {
    "value": "var(--XGvGw)",
    "variable": "var(--XGvGw)"
  },
  "colors.text.onHero.express.inspire.hero": {
    "value": "var(--jSxcnw)",
    "variable": "var(--jSxcnw)"
  },
  "colors.text.onHero.express.trust.hero": {
    "value": "var(--ksPezG)",
    "variable": "var(--ksPezG)"
  },
  "colors.text.onHero.neutral": {
    "value": "var(--iiAkgh)",
    "variable": "var(--iiAkgh)"
  },
  "colors.text.onHero.neutral-fixed": {
    "value": "var(--SQwfG)",
    "variable": "var(--SQwfG)"
  },
  "colors.text.onHero.link.default": {
    "value": "var(--bziKxG)",
    "variable": "var(--bziKxG)"
  },
  "colors.text.onHero.link.hover": {
    "value": "var(--cQBuyH)",
    "variable": "var(--cQBuyH)"
  },
  "colors.text.onHero.link.pressed": {
    "value": "var(--cqNvPD)",
    "variable": "var(--cqNvPD)"
  },
  "colors.text.onHero.link.fixed.default": {
    "value": "var(--hRkCjJ)",
    "variable": "var(--hRkCjJ)"
  },
  "colors.text.onHero.link.fixed.hover": {
    "value": "var(--jxiuJE)",
    "variable": "var(--jxiuJE)"
  },
  "colors.text.onHero.link.fixed.pressed": {
    "value": "var(--boLOMc)",
    "variable": "var(--boLOMc)"
  },
  "colors.text.onImpact.action.neutral.default": {
    "value": "var(--iWWjAG)",
    "variable": "var(--iWWjAG)"
  },
  "colors.text.onImpact.action.neutral.hover": {
    "value": "var(--bzWyYn)",
    "variable": "var(--bzWyYn)"
  },
  "colors.text.onImpact.action.neutral.pressed": {
    "value": "var(--fgbHMT)",
    "variable": "var(--fgbHMT)"
  },
  "colors.text.onImpact.action.hero.default": {
    "value": "var(--fqKiUL)",
    "variable": "var(--fqKiUL)"
  },
  "colors.text.onImpact.action.hero.hover": {
    "value": "var(--fzGRjm)",
    "variable": "var(--fzGRjm)"
  },
  "colors.text.onImpact.action.hero.pressed": {
    "value": "var(--eDQVEi)",
    "variable": "var(--eDQVEi)"
  },
  "colors.text.onImpact.action.critical.hero.default": {
    "value": "var(--jixXXx)",
    "variable": "var(--jixXXx)"
  },
  "colors.text.onImpact.action.critical.hero.hover": {
    "value": "var(--cXESzc)",
    "variable": "var(--cXESzc)"
  },
  "colors.text.onImpact.action.critical.hero.pressed": {
    "value": "var(--bnAcdA)",
    "variable": "var(--bnAcdA)"
  },
  "colors.text.onImpact.express.energy.hero": {
    "value": "var(--fYPVEi)",
    "variable": "var(--fYPVEi)"
  },
  "colors.text.onImpact.express.insight.hero": {
    "value": "var(--kpLxDG)",
    "variable": "var(--kpLxDG)"
  },
  "colors.text.onImpact.express.inspire.hero": {
    "value": "var(--ewnPtC)",
    "variable": "var(--ewnPtC)"
  },
  "colors.text.onImpact.express.trust.hero": {
    "value": "var(--jYyVFQ)",
    "variable": "var(--jYyVFQ)"
  },
  "colors.text.onImpact.feedback.critical.strong": {
    "value": "var(--ZZHbf)",
    "variable": "var(--ZZHbf)"
  },
  "colors.text.onImpact.feedback.critical.hero": {
    "value": "var(--gugtwc)",
    "variable": "var(--gugtwc)"
  },
  "colors.text.onImpact.feedback.info.strong": {
    "value": "var(--jajEeC)",
    "variable": "var(--jajEeC)"
  },
  "colors.text.onImpact.feedback.info.hero": {
    "value": "var(--dPZSGV)",
    "variable": "var(--dPZSGV)"
  },
  "colors.text.onImpact.feedback.notify.strong": {
    "value": "var(--KVMRL)",
    "variable": "var(--KVMRL)"
  },
  "colors.text.onImpact.feedback.notify.hero": {
    "value": "var(--jfAhsk)",
    "variable": "var(--jfAhsk)"
  },
  "colors.text.onImpact.feedback.success.strong": {
    "value": "var(--gPfsdf)",
    "variable": "var(--gPfsdf)"
  },
  "colors.text.onImpact.feedback.success.hero": {
    "value": "var(--kYnXYk)",
    "variable": "var(--kYnXYk)"
  },
  "colors.text.onImpact.feedback.warning.strong": {
    "value": "var(--iTFphS)",
    "variable": "var(--iTFphS)"
  },
  "colors.text.onImpact.feedback.warning.hero": {
    "value": "var(--dKSZV)",
    "variable": "var(--dKSZV)"
  },
  "colors.text.onImpact.neutral": {
    "value": "var(--gkawLP)",
    "variable": "var(--gkawLP)"
  },
  "colors.text.onImpact.neutral-fixed": {
    "value": "var(--buekQU)",
    "variable": "var(--buekQU)"
  },
  "colors.text.onImpact.subtle": {
    "value": "var(--eHsvVL)",
    "variable": "var(--eHsvVL)"
  },
  "colors.text.onImpact.link.default": {
    "value": "var(--bhZPrA)",
    "variable": "var(--bhZPrA)"
  },
  "colors.text.onImpact.link.hover": {
    "value": "var(--cTlHtN)",
    "variable": "var(--cTlHtN)"
  },
  "colors.text.onImpact.link.pressed": {
    "value": "var(--fxehPp)",
    "variable": "var(--fxehPp)"
  },
  "colors.text.onImpact.link.last-visited": {
    "value": "var(--kKKuxw)",
    "variable": "var(--kKKuxw)"
  },
  "colors.text.onImpact.link.fixed.default": {
    "value": "var(--bvkknH)",
    "variable": "var(--bvkknH)"
  },
  "colors.text.onImpact.link.fixed.hover": {
    "value": "var(--jbCPkq)",
    "variable": "var(--jbCPkq)"
  },
  "colors.text.onImpact.link.fixed.pressed": {
    "value": "var(--kLfEXu)",
    "variable": "var(--kLfEXu)"
  },
  "colors.text.onImpact.link.fixed.last-visited": {
    "value": "var(--PCPOj)",
    "variable": "var(--PCPOj)"
  },
  "colors.text.accent.brand.hero": {
    "value": "var(--giufph)",
    "variable": "var(--giufph)"
  },
  "colors.text.accent.brand.hero-fixed": {
    "value": "var(--gfyXoW)",
    "variable": "var(--gfyXoW)"
  },
  "colors.text.accent.aqua.strong": {
    "value": "var(--cHXMbR)",
    "variable": "var(--cHXMbR)"
  },
  "colors.text.accent.aqua.hero": {
    "value": "var(--eOkuiC)",
    "variable": "var(--eOkuiC)"
  },
  "colors.text.accent.blue.strong": {
    "value": "var(--gFrexz)",
    "variable": "var(--gFrexz)"
  },
  "colors.text.accent.blue.strong-fixed": {
    "value": "var(--eJDQjQ)",
    "variable": "var(--eJDQjQ)"
  },
  "colors.text.accent.blue.hero": {
    "value": "var(--vIjhk)",
    "variable": "var(--vIjhk)"
  },
  "colors.text.accent.gray.strong": {
    "value": "var(--hVNyTs)",
    "variable": "var(--hVNyTs)"
  },
  "colors.text.accent.gray.hero": {
    "value": "var(--iSEcqv)",
    "variable": "var(--iSEcqv)"
  },
  "colors.text.accent.green.strong": {
    "value": "var(--jRvNEy)",
    "variable": "var(--jRvNEy)"
  },
  "colors.text.accent.green.hero": {
    "value": "var(--dRJmxx)",
    "variable": "var(--dRJmxx)"
  },
  "colors.text.accent.orange.strong": {
    "value": "var(--jnbvKR)",
    "variable": "var(--jnbvKR)"
  },
  "colors.text.accent.orange.hero": {
    "value": "var(--jDSEDe)",
    "variable": "var(--jDSEDe)"
  },
  "colors.text.accent.purple.strong": {
    "value": "var(--kvWeVP)",
    "variable": "var(--kvWeVP)"
  },
  "colors.text.accent.purple.hero": {
    "value": "var(--jGMmkU)",
    "variable": "var(--jGMmkU)"
  },
  "colors.text.accent.red.strong": {
    "value": "var(--enlGtm)",
    "variable": "var(--enlGtm)"
  },
  "colors.text.accent.red.hero": {
    "value": "var(--bJjGMt)",
    "variable": "var(--bJjGMt)"
  },
  "colors.text.accent.teal.strong": {
    "value": "var(--fcBJbJ)",
    "variable": "var(--fcBJbJ)"
  },
  "colors.text.accent.teal.hero": {
    "value": "var(--cehSDG)",
    "variable": "var(--cehSDG)"
  },
  "colors.text.accent.yellow.strong": {
    "value": "var(--eavyNt)",
    "variable": "var(--eavyNt)"
  },
  "colors.text.accent.yellow.hero": {
    "value": "var(--ctFjIe)",
    "variable": "var(--ctFjIe)"
  },
  "colors.text.action.disabled": {
    "value": "var(--jEsexP)",
    "variable": "var(--jEsexP)"
  },
  "colors.text.action.disabled-alt": {
    "value": "var(--igETxL)",
    "variable": "var(--igETxL)"
  },
  "colors.text.action.neutral.default": {
    "value": "var(--hehuSM)",
    "variable": "var(--hehuSM)"
  },
  "colors.text.action.neutral.hover": {
    "value": "var(--bLqvTh)",
    "variable": "var(--bLqvTh)"
  },
  "colors.text.action.neutral.pressed": {
    "value": "var(--hEHvjx)",
    "variable": "var(--hEHvjx)"
  },
  "colors.text.action.neutral-fixed.default": {
    "value": "var(--cNGQQL)",
    "variable": "var(--cNGQQL)"
  },
  "colors.text.action.neutral-fixed.hover": {
    "value": "var(--fptLIO)",
    "variable": "var(--fptLIO)"
  },
  "colors.text.action.neutral-fixed.pressed": {
    "value": "var(--etDQdK)",
    "variable": "var(--etDQdK)"
  },
  "colors.text.action.hero.default": {
    "value": "var(--fifHgR)",
    "variable": "var(--fifHgR)"
  },
  "colors.text.action.hero.hover": {
    "value": "var(--hhkgHQ)",
    "variable": "var(--hhkgHQ)"
  },
  "colors.text.action.hero.pressed": {
    "value": "var(--gHwhYM)",
    "variable": "var(--gHwhYM)"
  },
  "colors.text.action.hero.selected.default": {
    "value": "var(--lBaYV)",
    "variable": "var(--lBaYV)"
  },
  "colors.text.action.hero.selected.hover": {
    "value": "var(--fkBjpE)",
    "variable": "var(--fkBjpE)"
  },
  "colors.text.action.hero.selected.pressed": {
    "value": "var(--eoLnKA)",
    "variable": "var(--eoLnKA)"
  },
  "colors.text.action.strong.default": {
    "value": "var(--exbPaa)",
    "variable": "var(--exbPaa)"
  },
  "colors.text.action.strong.hover": {
    "value": "var(--XgXBr)",
    "variable": "var(--XgXBr)"
  },
  "colors.text.action.strong.pressed": {
    "value": "var(--dAZxWT)",
    "variable": "var(--dAZxWT)"
  },
  "colors.text.action.critical.strong.default": {
    "value": "var(--ichUfY)",
    "variable": "var(--ichUfY)"
  },
  "colors.text.action.critical.strong.hover": {
    "value": "var(--bcoCKR)",
    "variable": "var(--bcoCKR)"
  },
  "colors.text.action.critical.strong.pressed": {
    "value": "var(--fnEyCl)",
    "variable": "var(--fnEyCl)"
  },
  "colors.text.action.critical.hero.default": {
    "value": "var(--jMvByf)",
    "variable": "var(--jMvByf)"
  },
  "colors.text.action.critical.hero.hover": {
    "value": "var(--egIVRm)",
    "variable": "var(--egIVRm)"
  },
  "colors.text.action.critical.hero.pressed": {
    "value": "var(--dkTami)",
    "variable": "var(--dkTami)"
  },
  "colors.text.express.empower.strong": {
    "value": "var(--imiPuO)",
    "variable": "var(--imiPuO)"
  },
  "colors.text.express.empower.hero": {
    "value": "var(--jsrjOB)",
    "variable": "var(--jsrjOB)"
  },
  "colors.text.express.insight.strong": {
    "value": "var(--iSlGRD)",
    "variable": "var(--iSlGRD)"
  },
  "colors.text.express.insight.hero": {
    "value": "var(--kqGagI)",
    "variable": "var(--kqGagI)"
  },
  "colors.text.express.inspire.strong": {
    "value": "var(--hfiWKv)",
    "variable": "var(--hfiWKv)"
  },
  "colors.text.express.inspire.hero": {
    "value": "var(--keTDAo)",
    "variable": "var(--keTDAo)"
  },
  "colors.text.express.trust.strong": {
    "value": "var(--kPgwBV)",
    "variable": "var(--kPgwBV)"
  },
  "colors.text.express.trust.hero": {
    "value": "var(--cpeGOO)",
    "variable": "var(--cpeGOO)"
  },
  "colors.text.feedback.critical.strong": {
    "value": "var(--bGHUkF)",
    "variable": "var(--bGHUkF)"
  },
  "colors.text.feedback.critical.hero": {
    "value": "var(--OounG)",
    "variable": "var(--OounG)"
  },
  "colors.text.feedback.info.strong": {
    "value": "var(--joskac)",
    "variable": "var(--joskac)"
  },
  "colors.text.feedback.info.hero": {
    "value": "var(--FABDn)",
    "variable": "var(--FABDn)"
  },
  "colors.text.feedback.notify.strong": {
    "value": "var(--fTgsJt)",
    "variable": "var(--fTgsJt)"
  },
  "colors.text.feedback.notify.hero": {
    "value": "var(--fqYKYK)",
    "variable": "var(--fqYKYK)"
  },
  "colors.text.feedback.success.strong": {
    "value": "var(--dYBseF)",
    "variable": "var(--dYBseF)"
  },
  "colors.text.feedback.success.hero": {
    "value": "var(--kxVKou)",
    "variable": "var(--kxVKou)"
  },
  "colors.text.feedback.warning.strong": {
    "value": "var(--kPpkIE)",
    "variable": "var(--kPpkIE)"
  },
  "colors.text.feedback.warning.hero": {
    "value": "var(--ceOkrX)",
    "variable": "var(--ceOkrX)"
  },
  "colors.text.neutral": {
    "value": "var(--fCJfxh)",
    "variable": "var(--fCJfxh)"
  },
  "colors.text.neutral-fixed": {
    "value": "var(--kFikXK)",
    "variable": "var(--kFikXK)"
  },
  "colors.text.subtle": {
    "value": "var(--eGXgJt)",
    "variable": "var(--eGXgJt)"
  },
  "colors.text.invisible": {
    "value": "var(--rqiVt)",
    "variable": "var(--rqiVt)"
  },
  "colors.text.link.default": {
    "value": "var(--lhZwGq)",
    "variable": "var(--lhZwGq)"
  },
  "colors.text.link.hover": {
    "value": "var(--bmhdtr)",
    "variable": "var(--bmhdtr)"
  },
  "colors.text.link.pressed": {
    "value": "var(--ejcOgL)",
    "variable": "var(--ejcOgL)"
  },
  "colors.text.link.last-visited": {
    "value": "var(--gfRwdW)",
    "variable": "var(--gfRwdW)"
  },
  "colors.Accordion.bg.default": {
    "value": "var(--gcTHu)",
    "variable": "var(--gcTHu)"
  },
  "colors.Accordion.bg.hover": {
    "value": "var(--HdMfX)",
    "variable": "var(--HdMfX)"
  },
  "colors.Accordion.bg.pressed": {
    "value": "var(--cLtNVz)",
    "variable": "var(--cLtNVz)"
  },
  "colors.Accordion.bg.selectedPressed": {
    "value": "var(--dRfpSC)",
    "variable": "var(--dRfpSC)"
  },
  "colors.Accordion.border.default": {
    "value": "var(--hRHzOb)",
    "variable": "var(--hRHzOb)"
  },
  "colors.Accordion.Header.bg.default": {
    "value": "var(--fLvQqk)",
    "variable": "var(--fLvQqk)"
  },
  "colors.Accordion.Header.bg.hover": {
    "value": "var(--OmrYp)",
    "variable": "var(--OmrYp)"
  },
  "colors.Accordion.Header.bg.pressed": {
    "value": "var(--gHDroF)",
    "variable": "var(--gHDroF)"
  },
  "colors.Accordion.Header.bg.selected": {
    "value": "var(--cibXqy)",
    "variable": "var(--cibXqy)"
  },
  "colors.Accordion.Header.bg.selectedHover": {
    "value": "var(--lesKkg)",
    "variable": "var(--lesKkg)"
  },
  "colors.Accordion.Header.bg.selectedPressed": {
    "value": "var(--eamWCE)",
    "variable": "var(--eamWCE)"
  },
  "colors.Accordion.Header.border.default": {
    "value": "var(--cMcptx)",
    "variable": "var(--cMcptx)"
  },
  "colors.Accordion.Header.icon.leading": {
    "value": "var(--cIhoBh)",
    "variable": "var(--cIhoBh)"
  },
  "colors.Accordion.Header.icon.trailing": {
    "value": "var(--fkOgCD)",
    "variable": "var(--fkOgCD)"
  },
  "colors.Accordion.Header.label.default": {
    "value": "var(--dSTRFn)",
    "variable": "var(--dSTRFn)"
  },
  "colors.Accordion.Header.label.trailing": {
    "value": "var(--jeKvWq)",
    "variable": "var(--jeKvWq)"
  },
  "colors.Accordion.Panel.bg": {
    "value": "var(--kUEYev)",
    "variable": "var(--kUEYev)"
  },
  "colors.Accordion.Panel.border": {
    "value": "var(--QZFbi)",
    "variable": "var(--QZFbi)"
  },
  "colors.AdornedInput.Adornment.default": {
    "value": "var(--xlGOO)",
    "variable": "var(--xlGOO)"
  },
  "colors.AdornedInput.Input.placeholder": {
    "value": "var(--oRAqY)",
    "variable": "var(--oRAqY)"
  },
  "colors.AdornedInput.Input.populated": {
    "value": "var(--oCsJx)",
    "variable": "var(--oCsJx)"
  },
  "colors.AdornedInput.bg.active": {
    "value": "var(--jgfCFI)",
    "variable": "var(--jgfCFI)"
  },
  "colors.AdornedInput.bg.activeHover": {
    "value": "var(--WooBS)",
    "variable": "var(--WooBS)"
  },
  "colors.AdornedInput.bg.autofill": {
    "value": "var(--gAYaFw)",
    "variable": "var(--gAYaFw)"
  },
  "colors.AdornedInput.bg.default": {
    "value": "var(--fuiwTL)",
    "variable": "var(--fuiwTL)"
  },
  "colors.AdornedInput.bg.error": {
    "value": "var(--fGtyCk)",
    "variable": "var(--fGtyCk)"
  },
  "colors.AdornedInput.bg.errorActive": {
    "value": "var(--ihhXDc)",
    "variable": "var(--ihhXDc)"
  },
  "colors.AdornedInput.bg.errorHover": {
    "value": "var(--fMGHQe)",
    "variable": "var(--fMGHQe)"
  },
  "colors.AdornedInput.bg.hover": {
    "value": "var(--dZtKoS)",
    "variable": "var(--dZtKoS)"
  },
  "colors.AdornedInput.bg.readOnly": {
    "value": "var(--nenQm)",
    "variable": "var(--nenQm)"
  },
  "colors.AdornedInput.border.active": {
    "value": "var(--epWDXJ)",
    "variable": "var(--epWDXJ)"
  },
  "colors.AdornedInput.border.activeHover": {
    "value": "var(--biHFnT)",
    "variable": "var(--biHFnT)"
  },
  "colors.AdornedInput.border.default": {
    "value": "var(--dLwete)",
    "variable": "var(--dLwete)"
  },
  "colors.AdornedInput.border.error": {
    "value": "var(--crPzmZ)",
    "variable": "var(--crPzmZ)"
  },
  "colors.AdornedInput.border.errorActive": {
    "value": "var(--gnHCTB)",
    "variable": "var(--gnHCTB)"
  },
  "colors.AdornedInput.border.errorHover": {
    "value": "var(--jnXmrH)",
    "variable": "var(--jnXmrH)"
  },
  "colors.AdornedInput.border.hover": {
    "value": "var(--gsPCwv)",
    "variable": "var(--gsPCwv)"
  },
  "colors.Alert.critical.bg": {
    "value": "var(--jViHSg)",
    "variable": "var(--jViHSg)"
  },
  "colors.Alert.critical.border": {
    "value": "var(--gtWZJd)",
    "variable": "var(--gtWZJd)"
  },
  "colors.Alert.critical.icon": {
    "value": "var(--eYWXyy)",
    "variable": "var(--eYWXyy)"
  },
  "colors.Alert.critical.text": {
    "value": "var(--jCOuwM)",
    "variable": "var(--jCOuwM)"
  },
  "colors.Alert.info.bg": {
    "value": "var(--jVIgXp)",
    "variable": "var(--jVIgXp)"
  },
  "colors.Alert.info.border": {
    "value": "var(--dgLYfg)",
    "variable": "var(--dgLYfg)"
  },
  "colors.Alert.info.icon": {
    "value": "var(--bLMieD)",
    "variable": "var(--bLMieD)"
  },
  "colors.Alert.info.text": {
    "value": "var(--irTiml)",
    "variable": "var(--irTiml)"
  },
  "colors.Alert.notify.bg": {
    "value": "var(--dmSKTQ)",
    "variable": "var(--dmSKTQ)"
  },
  "colors.Alert.notify.border": {
    "value": "var(--qhqBl)",
    "variable": "var(--qhqBl)"
  },
  "colors.Alert.notify.icon": {
    "value": "var(--haTnAO)",
    "variable": "var(--haTnAO)"
  },
  "colors.Alert.notify.text": {
    "value": "var(--ivwXRk)",
    "variable": "var(--ivwXRk)"
  },
  "colors.Alert.success.bg": {
    "value": "var(--gqFZQw)",
    "variable": "var(--gqFZQw)"
  },
  "colors.Alert.success.border": {
    "value": "var(--ZMrIV)",
    "variable": "var(--ZMrIV)"
  },
  "colors.Alert.success.icon": {
    "value": "var(--kZYdSG)",
    "variable": "var(--kZYdSG)"
  },
  "colors.Alert.success.text": {
    "value": "var(--iXwSwE)",
    "variable": "var(--iXwSwE)"
  },
  "colors.Alert.warning.bg": {
    "value": "var(--lbQiBR)",
    "variable": "var(--lbQiBR)"
  },
  "colors.Alert.warning.border": {
    "value": "var(--btoIIg)",
    "variable": "var(--btoIIg)"
  },
  "colors.Alert.warning.icon": {
    "value": "var(--eUoqvL)",
    "variable": "var(--eUoqvL)"
  },
  "colors.Alert.warning.text": {
    "value": "var(--OjIup)",
    "variable": "var(--OjIup)"
  },
  "colors.Anchor.default": {
    "value": "var(--laZBDf)",
    "variable": "var(--laZBDf)"
  },
  "colors.Anchor.focus": {
    "value": "var(--gPHmlI)",
    "variable": "var(--gPHmlI)"
  },
  "colors.Anchor.visited": {
    "value": "var(--dopKes)",
    "variable": "var(--dopKes)"
  },
  "colors.Anchor.hover": {
    "value": "var(--fsTohi)",
    "variable": "var(--fsTohi)"
  },
  "colors.Anchor.pressed": {
    "value": "var(--ilxPCu)",
    "variable": "var(--ilxPCu)"
  },
  "colors.Anchor.onImpact.default": {
    "value": "var(--cUEUZB)",
    "variable": "var(--cUEUZB)"
  },
  "colors.Anchor.onImpact.hover": {
    "value": "var(--iemxtU)",
    "variable": "var(--iemxtU)"
  },
  "colors.Anchor.onImpact.focus": {
    "value": "var(--fPJfvC)",
    "variable": "var(--fPJfvC)"
  },
  "colors.Anchor.onImpact.visited": {
    "value": "var(--dFQrBa)",
    "variable": "var(--dFQrBa)"
  },
  "colors.Anchor.onImpact.pressed": {
    "value": "var(--jeSLJo)",
    "variable": "var(--jeSLJo)"
  },
  "colors.Avatar.Badge.hero.bg": {
    "value": "var(--dFrHCk)",
    "variable": "var(--dFrHCk)"
  },
  "colors.Avatar.Badge.hero.border": {
    "value": "var(--cwHdJx)",
    "variable": "var(--cwHdJx)"
  },
  "colors.Avatar.Badge.hero.icon": {
    "value": "var(--gmCadO)",
    "variable": "var(--gmCadO)"
  },
  "colors.Avatar.Badge.impact.bg": {
    "value": "var(--jOonmy)",
    "variable": "var(--jOonmy)"
  },
  "colors.Avatar.Badge.impact.border": {
    "value": "var(--dTYvdf)",
    "variable": "var(--dTYvdf)"
  },
  "colors.Avatar.Badge.impact.icon": {
    "value": "var(--eRnVFA)",
    "variable": "var(--eRnVFA)"
  },
  "colors.Avatar.Icon.default": {
    "value": "var(--ibxgjd)",
    "variable": "var(--ibxgjd)"
  },
  "colors.Avatar.Icon.brand.hero": {
    "value": "var(--dlYjg)",
    "variable": "var(--dlYjg)"
  },
  "colors.Avatar.Icon.accent-1": {
    "value": "var(--cdJkAw)",
    "variable": "var(--cdJkAw)"
  },
  "colors.Avatar.Icon.accent-2": {
    "value": "var(--leGzuD)",
    "variable": "var(--leGzuD)"
  },
  "colors.Avatar.Icon.accent-3": {
    "value": "var(--gNTLTi)",
    "variable": "var(--gNTLTi)"
  },
  "colors.Avatar.Icon.accent-4": {
    "value": "var(--cVsueR)",
    "variable": "var(--cVsueR)"
  },
  "colors.Avatar.Root.bg": {
    "value": "var(--gpSJkC)",
    "variable": "var(--gpSJkC)"
  },
  "colors.Avatar.Root.border": {
    "value": "var(--jyDjOn)",
    "variable": "var(--jyDjOn)"
  },
  "colors.Avatar.Root.text": {
    "value": "var(--jiCIKC)",
    "variable": "var(--jiCIKC)"
  },
  "colors.Avatar.Root.brand.hero.bg": {
    "value": "var(--gOOzfR)",
    "variable": "var(--gOOzfR)"
  },
  "colors.Avatar.Root.brand.hero.border": {
    "value": "var(--iyBEU)",
    "variable": "var(--iyBEU)"
  },
  "colors.Avatar.Root.brand.hero.text": {
    "value": "var(--hXSgjZ)",
    "variable": "var(--hXSgjZ)"
  },
  "colors.Avatar.Root.accent.1.bg": {
    "value": "var(--iuGDFF)",
    "variable": "var(--iuGDFF)"
  },
  "colors.Avatar.Root.accent.1.border": {
    "value": "var(--dtJGaY)",
    "variable": "var(--dtJGaY)"
  },
  "colors.Avatar.Root.accent.1.text": {
    "value": "var(--beyMjV)",
    "variable": "var(--beyMjV)"
  },
  "colors.Avatar.Root.accent.2.bg": {
    "value": "var(--inJMVm)",
    "variable": "var(--inJMVm)"
  },
  "colors.Avatar.Root.accent.2.border": {
    "value": "var(--igLAkj)",
    "variable": "var(--igLAkj)"
  },
  "colors.Avatar.Root.accent.2.text": {
    "value": "var(--hrKEcy)",
    "variable": "var(--hrKEcy)"
  },
  "colors.Avatar.Root.accent.3.bg": {
    "value": "var(--gAVKCj)",
    "variable": "var(--gAVKCj)"
  },
  "colors.Avatar.Root.accent.3.border": {
    "value": "var(--jmZuoy)",
    "variable": "var(--jmZuoy)"
  },
  "colors.Avatar.Root.accent.3.text": {
    "value": "var(--glwJYj)",
    "variable": "var(--glwJYj)"
  },
  "colors.Avatar.Root.accent.4.bg": {
    "value": "var(--bZxfpI)",
    "variable": "var(--bZxfpI)"
  },
  "colors.Avatar.Root.accent.4.border": {
    "value": "var(--fuTUMF)",
    "variable": "var(--fuTUMF)"
  },
  "colors.Avatar.Root.accent.4.text": {
    "value": "var(--dTBifI)",
    "variable": "var(--dTBifI)"
  },
  "colors.Banner.critical.bg": {
    "value": "var(--hRlntq)",
    "variable": "var(--hRlntq)"
  },
  "colors.Banner.critical.icon": {
    "value": "var(--iXmYpg)",
    "variable": "var(--iXmYpg)"
  },
  "colors.Banner.critical.text": {
    "value": "var(--fhuGBO)",
    "variable": "var(--fhuGBO)"
  },
  "colors.Banner.info.bg": {
    "value": "var(--copSbf)",
    "variable": "var(--copSbf)"
  },
  "colors.Banner.info.icon": {
    "value": "var(--hDAnfJ)",
    "variable": "var(--hDAnfJ)"
  },
  "colors.Banner.info.text": {
    "value": "var(--gGdZeH)",
    "variable": "var(--gGdZeH)"
  },
  "colors.Banner.success.bg": {
    "value": "var(--gXNTUm)",
    "variable": "var(--gXNTUm)"
  },
  "colors.Banner.success.icon": {
    "value": "var(--gzfxgs)",
    "variable": "var(--gzfxgs)"
  },
  "colors.Banner.success.text": {
    "value": "var(--dpBQFa)",
    "variable": "var(--dpBQFa)"
  },
  "colors.Banner.warning.bg": {
    "value": "var(--gzNdDP)",
    "variable": "var(--gzNdDP)"
  },
  "colors.Banner.warning.icon": {
    "value": "var(--kcdTFx)",
    "variable": "var(--kcdTFx)"
  },
  "colors.Banner.warning.text": {
    "value": "var(--eIltpP)",
    "variable": "var(--eIltpP)"
  },
  "colors.Button.filled.brand.bg.default": {
    "value": "var(--csZcJV)",
    "variable": "var(--csZcJV)"
  },
  "colors.Button.filled.brand.bg.hover": {
    "value": "var(--dbuMiM)",
    "variable": "var(--dbuMiM)"
  },
  "colors.Button.filled.brand.bg.pressed": {
    "value": "var(--gitPKg)",
    "variable": "var(--gitPKg)"
  },
  "colors.Button.filled.brand.label.default": {
    "value": "var(--cgQrHK)",
    "variable": "var(--cgQrHK)"
  },
  "colors.Button.filled.brand.label.hover": {
    "value": "var(--juPnJz)",
    "variable": "var(--juPnJz)"
  },
  "colors.Button.filled.brand.label.pressed": {
    "value": "var(--iyZsev)",
    "variable": "var(--iyZsev)"
  },
  "colors.Button.filled.brand.border.default": {
    "value": "var(--hnUeUQ)",
    "variable": "var(--hnUeUQ)"
  },
  "colors.Button.filled.brand.border.hover": {
    "value": "var(--ebkjcx)",
    "variable": "var(--ebkjcx)"
  },
  "colors.Button.filled.brand.border.pressed": {
    "value": "var(--hDSaNJ)",
    "variable": "var(--hDSaNJ)"
  },
  "colors.Button.filled.brand.icon.default": {
    "value": "var(--erNwTH)",
    "variable": "var(--erNwTH)"
  },
  "colors.Button.filled.brand.icon.hover": {
    "value": "var(--xZsfe)",
    "variable": "var(--xZsfe)"
  },
  "colors.Button.filled.brand.icon.pressed": {
    "value": "var(--chChSi)",
    "variable": "var(--chChSi)"
  },
  "colors.Button.filled.critical.bg.default": {
    "value": "var(--dapIPN)",
    "variable": "var(--dapIPN)"
  },
  "colors.Button.filled.critical.bg.hover": {
    "value": "var(--jCuYnY)",
    "variable": "var(--jCuYnY)"
  },
  "colors.Button.filled.critical.bg.pressed": {
    "value": "var(--iGFcIU)",
    "variable": "var(--iGFcIU)"
  },
  "colors.Button.filled.critical.label.default": {
    "value": "var(--gprdLe)",
    "variable": "var(--gprdLe)"
  },
  "colors.Button.filled.critical.label.hover": {
    "value": "var(--bcaAgD)",
    "variable": "var(--bcaAgD)"
  },
  "colors.Button.filled.critical.label.pressed": {
    "value": "var(--eIfIVj)",
    "variable": "var(--eIfIVj)"
  },
  "colors.Button.filled.critical.icon.default": {
    "value": "var(--hyRvsD)",
    "variable": "var(--hyRvsD)"
  },
  "colors.Button.filled.critical.icon.hover": {
    "value": "var(--hDfkLu)",
    "variable": "var(--hDfkLu)"
  },
  "colors.Button.filled.critical.icon.pressed": {
    "value": "var(--yZxdS)",
    "variable": "var(--yZxdS)"
  },
  "colors.Button.filled.critical.border.default": {
    "value": "var(--eRKUck)",
    "variable": "var(--eRKUck)"
  },
  "colors.Button.filled.critical.border.hover": {
    "value": "var(--hMvzLR)",
    "variable": "var(--hMvzLR)"
  },
  "colors.Button.filled.critical.border.pressed": {
    "value": "var(--cSfDlZ)",
    "variable": "var(--cSfDlZ)"
  },
  "colors.Button.outlined.brand.bg.default": {
    "value": "var(--iSbkuX)",
    "variable": "var(--iSbkuX)"
  },
  "colors.Button.outlined.brand.bg.hover": {
    "value": "var(--fvIkmC)",
    "variable": "var(--fvIkmC)"
  },
  "colors.Button.outlined.brand.bg.pressed": {
    "value": "var(--hfkZZG)",
    "variable": "var(--hfkZZG)"
  },
  "colors.Button.outlined.brand.label.default": {
    "value": "var(--jRqqWI)",
    "variable": "var(--jRqqWI)"
  },
  "colors.Button.outlined.brand.label.hover": {
    "value": "var(--kVwbEN)",
    "variable": "var(--kVwbEN)"
  },
  "colors.Button.outlined.brand.label.pressed": {
    "value": "var(--dRqnXl)",
    "variable": "var(--dRqnXl)"
  },
  "colors.Button.outlined.brand.icon.default": {
    "value": "var(--jyoMpd)",
    "variable": "var(--jyoMpd)"
  },
  "colors.Button.outlined.brand.icon.hover": {
    "value": "var(--klfERg)",
    "variable": "var(--klfERg)"
  },
  "colors.Button.outlined.brand.icon.pressed": {
    "value": "var(--cyrNdw)",
    "variable": "var(--cyrNdw)"
  },
  "colors.Button.outlined.brand.border.default": {
    "value": "var(--kMVDCi)",
    "variable": "var(--kMVDCi)"
  },
  "colors.Button.outlined.brand.border.hover": {
    "value": "var(--ezTEjr)",
    "variable": "var(--ezTEjr)"
  },
  "colors.Button.outlined.brand.border.pressed": {
    "value": "var(--ifYMXX)",
    "variable": "var(--ifYMXX)"
  },
  "colors.Button.outlined.neutral.bg.default": {
    "value": "var(--feWlDB)",
    "variable": "var(--feWlDB)"
  },
  "colors.Button.outlined.neutral.bg.hover": {
    "value": "var(--gPOpLU)",
    "variable": "var(--gPOpLU)"
  },
  "colors.Button.outlined.neutral.bg.pressed": {
    "value": "var(--kswhxg)",
    "variable": "var(--kswhxg)"
  },
  "colors.Button.outlined.neutral.bg.selected": {
    "value": "var(--fLhZeT)",
    "variable": "var(--fLhZeT)"
  },
  "colors.Button.outlined.neutral.bg.selectedHover": {
    "value": "var(--iLcScJ)",
    "variable": "var(--iLcScJ)"
  },
  "colors.Button.outlined.neutral.bg.selectedPressed": {
    "value": "var(--haYbHh)",
    "variable": "var(--haYbHh)"
  },
  "colors.Button.outlined.neutral.label.default": {
    "value": "var(--dHMpeS)",
    "variable": "var(--dHMpeS)"
  },
  "colors.Button.outlined.neutral.label.hover": {
    "value": "var(--cDaOlf)",
    "variable": "var(--cDaOlf)"
  },
  "colors.Button.outlined.neutral.label.pressed": {
    "value": "var(--iYgBkj)",
    "variable": "var(--iYgBkj)"
  },
  "colors.Button.outlined.neutral.label.selected": {
    "value": "var(--jgUmE)",
    "variable": "var(--jgUmE)"
  },
  "colors.Button.outlined.neutral.label.selectedHover": {
    "value": "var(--hEmUlS)",
    "variable": "var(--hEmUlS)"
  },
  "colors.Button.outlined.neutral.label.selectedPressed": {
    "value": "var(--dSkyYG)",
    "variable": "var(--dSkyYG)"
  },
  "colors.Button.outlined.neutral.icon.default": {
    "value": "var(--cJofkj)",
    "variable": "var(--cJofkj)"
  },
  "colors.Button.outlined.neutral.icon.hover": {
    "value": "var(--kCatq)",
    "variable": "var(--kCatq)"
  },
  "colors.Button.outlined.neutral.icon.pressed": {
    "value": "var(--dQHjhW)",
    "variable": "var(--dQHjhW)"
  },
  "colors.Button.outlined.neutral.icon.selected": {
    "value": "var(--kXaizp)",
    "variable": "var(--kXaizp)"
  },
  "colors.Button.outlined.neutral.icon.selectedHover": {
    "value": "var(--dUsSHr)",
    "variable": "var(--dUsSHr)"
  },
  "colors.Button.outlined.neutral.icon.selectedPressed": {
    "value": "var(--syQKv)",
    "variable": "var(--syQKv)"
  },
  "colors.Button.outlined.neutral.border.default": {
    "value": "var(--iDtpaw)",
    "variable": "var(--iDtpaw)"
  },
  "colors.Button.outlined.neutral.border.hover": {
    "value": "var(--hVFZVp)",
    "variable": "var(--hVFZVp)"
  },
  "colors.Button.outlined.neutral.border.pressed": {
    "value": "var(--eJrOlp)",
    "variable": "var(--eJrOlp)"
  },
  "colors.Button.outlined.neutral.border.selected": {
    "value": "var(--grUkDa)",
    "variable": "var(--grUkDa)"
  },
  "colors.Button.outlined.neutral.border.selectedHover": {
    "value": "var(--bbKAWc)",
    "variable": "var(--bbKAWc)"
  },
  "colors.Button.outlined.neutral.border.selectedPressed": {
    "value": "var(--chNBPE)",
    "variable": "var(--chNBPE)"
  },
  "colors.Button.outlined.neutral-fixed.bg.default": {
    "value": "var(--dhLDEm)",
    "variable": "var(--dhLDEm)"
  },
  "colors.Button.outlined.neutral-fixed.bg.hover": {
    "value": "var(--iBMWgb)",
    "variable": "var(--iBMWgb)"
  },
  "colors.Button.outlined.neutral-fixed.bg.pressed": {
    "value": "var(--iZWWMb)",
    "variable": "var(--iZWWMb)"
  },
  "colors.Button.outlined.neutral-fixed.label.default": {
    "value": "var(--etgKHd)",
    "variable": "var(--etgKHd)"
  },
  "colors.Button.outlined.neutral-fixed.label.hover": {
    "value": "var(--enFnxE)",
    "variable": "var(--enFnxE)"
  },
  "colors.Button.outlined.neutral-fixed.label.pressed": {
    "value": "var(--eRGNjw)",
    "variable": "var(--eRGNjw)"
  },
  "colors.Button.outlined.neutral-fixed.icon.default": {
    "value": "var(--kyjerg)",
    "variable": "var(--kyjerg)"
  },
  "colors.Button.outlined.neutral-fixed.icon.hover": {
    "value": "var(--ftbcft)",
    "variable": "var(--ftbcft)"
  },
  "colors.Button.outlined.neutral-fixed.icon.pressed": {
    "value": "var(--dIWlJR)",
    "variable": "var(--dIWlJR)"
  },
  "colors.Button.outlined.neutral-fixed.border.default": {
    "value": "var(--gZTPZX)",
    "variable": "var(--gZTPZX)"
  },
  "colors.Button.outlined.neutral-fixed.border.hover": {
    "value": "var(--iHMJHS)",
    "variable": "var(--iHMJHS)"
  },
  "colors.Button.outlined.neutral-fixed.border.pressed": {
    "value": "var(--ffSHKW)",
    "variable": "var(--ffSHKW)"
  },
  "colors.Button.outlined.critical.bg.default": {
    "value": "var(--grptCX)",
    "variable": "var(--grptCX)"
  },
  "colors.Button.outlined.critical.bg.hover": {
    "value": "var(--eEuYAu)",
    "variable": "var(--eEuYAu)"
  },
  "colors.Button.outlined.critical.bg.pressed": {
    "value": "var(--iPKUrO)",
    "variable": "var(--iPKUrO)"
  },
  "colors.Button.outlined.critical.label.default": {
    "value": "var(--kYZswA)",
    "variable": "var(--kYZswA)"
  },
  "colors.Button.outlined.critical.label.hover": {
    "value": "var(--bIzkhZ)",
    "variable": "var(--bIzkhZ)"
  },
  "colors.Button.outlined.critical.label.pressed": {
    "value": "var(--jLGHWV)",
    "variable": "var(--jLGHWV)"
  },
  "colors.Button.outlined.critical.icon.default": {
    "value": "var(--egEwIx)",
    "variable": "var(--egEwIx)"
  },
  "colors.Button.outlined.critical.icon.hover": {
    "value": "var(--klGRuY)",
    "variable": "var(--klGRuY)"
  },
  "colors.Button.outlined.critical.icon.pressed": {
    "value": "var(--frqUVg)",
    "variable": "var(--frqUVg)"
  },
  "colors.Button.outlined.critical.border.default": {
    "value": "var(--ivJpii)",
    "variable": "var(--ivJpii)"
  },
  "colors.Button.outlined.critical.border.hover": {
    "value": "var(--bfRzTb)",
    "variable": "var(--bfRzTb)"
  },
  "colors.Button.outlined.critical.border.pressed": {
    "value": "var(--hoYUQn)",
    "variable": "var(--hoYUQn)"
  },
  "colors.Button.onImpact.filled.brand.bg.default": {
    "value": "var(--gSDSGf)",
    "variable": "var(--gSDSGf)"
  },
  "colors.Button.onImpact.filled.brand.bg.hover": {
    "value": "var(--dmmoqi)",
    "variable": "var(--dmmoqi)"
  },
  "colors.Button.onImpact.filled.brand.bg.pressed": {
    "value": "var(--jvtJnu)",
    "variable": "var(--jvtJnu)"
  },
  "colors.Button.onImpact.filled.brand.label.default": {
    "value": "var(--ieRrKg)",
    "variable": "var(--ieRrKg)"
  },
  "colors.Button.onImpact.filled.brand.label.hover": {
    "value": "var(--bYxucd)",
    "variable": "var(--bYxucd)"
  },
  "colors.Button.onImpact.filled.brand.label.pressed": {
    "value": "var(--osDGB)",
    "variable": "var(--osDGB)"
  },
  "colors.Button.onImpact.filled.brand.icon.default": {
    "value": "var(--flZSfh)",
    "variable": "var(--flZSfh)"
  },
  "colors.Button.onImpact.filled.brand.icon.hover": {
    "value": "var(--gNkFns)",
    "variable": "var(--gNkFns)"
  },
  "colors.Button.onImpact.filled.brand.icon.pressed": {
    "value": "var(--kQhqew)",
    "variable": "var(--kQhqew)"
  },
  "colors.Button.onImpact.filled.brand.border.default": {
    "value": "var(--kkwmQe)",
    "variable": "var(--kkwmQe)"
  },
  "colors.Button.onImpact.filled.brand.border.hover": {
    "value": "var(--dWtuZf)",
    "variable": "var(--dWtuZf)"
  },
  "colors.Button.onImpact.filled.brand.border.pressed": {
    "value": "var(--eAuUKX)",
    "variable": "var(--eAuUKX)"
  },
  "colors.Button.onImpact.filled.neutral-fixed.bg.default": {
    "value": "var(--SfcMy)",
    "variable": "var(--SfcMy)"
  },
  "colors.Button.onImpact.filled.neutral-fixed.bg.hover": {
    "value": "var(--hKfZpH)",
    "variable": "var(--hKfZpH)"
  },
  "colors.Button.onImpact.filled.neutral-fixed.bg.pressed": {
    "value": "var(--kHOzNH)",
    "variable": "var(--kHOzNH)"
  },
  "colors.Button.onImpact.filled.neutral-fixed.label.default": {
    "value": "var(--iQlAdx)",
    "variable": "var(--iQlAdx)"
  },
  "colors.Button.onImpact.filled.neutral-fixed.label.hover": {
    "value": "var(--vIthc)",
    "variable": "var(--vIthc)"
  },
  "colors.Button.onImpact.filled.neutral-fixed.label.pressed": {
    "value": "var(--jSgogg)",
    "variable": "var(--jSgogg)"
  },
  "colors.Button.onImpact.filled.neutral-fixed.icon.default": {
    "value": "var(--lczfGU)",
    "variable": "var(--lczfGU)"
  },
  "colors.Button.onImpact.filled.neutral-fixed.icon.hover": {
    "value": "var(--fqZyHF)",
    "variable": "var(--fqZyHF)"
  },
  "colors.Button.onImpact.filled.neutral-fixed.icon.pressed": {
    "value": "var(--dUSjIB)",
    "variable": "var(--dUSjIB)"
  },
  "colors.Button.onImpact.filled.neutral-fixed.border.default": {
    "value": "var(--cLTXZn)",
    "variable": "var(--cLTXZn)"
  },
  "colors.Button.onImpact.filled.neutral-fixed.border.hover": {
    "value": "var(--ibmfzW)",
    "variable": "var(--ibmfzW)"
  },
  "colors.Button.onImpact.filled.neutral-fixed.border.pressed": {
    "value": "var(--cYLQzG)",
    "variable": "var(--cYLQzG)"
  },
  "colors.Button.onImpact.filled.critical.bg.default": {
    "value": "var(--hLYMD)",
    "variable": "var(--hLYMD)"
  },
  "colors.Button.onImpact.filled.critical.bg.hover": {
    "value": "var(--fYegQq)",
    "variable": "var(--fYegQq)"
  },
  "colors.Button.onImpact.filled.critical.bg.pressed": {
    "value": "var(--enZquO)",
    "variable": "var(--enZquO)"
  },
  "colors.Button.onImpact.filled.critical.label.default": {
    "value": "var(--ghvdbs)",
    "variable": "var(--ghvdbs)"
  },
  "colors.Button.onImpact.filled.critical.label.hover": {
    "value": "var(--fpfZTh)",
    "variable": "var(--fpfZTh)"
  },
  "colors.Button.onImpact.filled.critical.label.pressed": {
    "value": "var(--bDdEFV)",
    "variable": "var(--bDdEFV)"
  },
  "colors.Button.onImpact.filled.critical.icon.default": {
    "value": "var(--eAtmKR)",
    "variable": "var(--eAtmKR)"
  },
  "colors.Button.onImpact.filled.critical.icon.hover": {
    "value": "var(--iuNtdQ)",
    "variable": "var(--iuNtdQ)"
  },
  "colors.Button.onImpact.filled.critical.icon.pressed": {
    "value": "var(--eSTrgU)",
    "variable": "var(--eSTrgU)"
  },
  "colors.Button.onImpact.filled.critical.border.default": {
    "value": "var(--kJWUXi)",
    "variable": "var(--kJWUXi)"
  },
  "colors.Button.onImpact.filled.critical.border.hover": {
    "value": "var(--ePprZL)",
    "variable": "var(--ePprZL)"
  },
  "colors.Button.onImpact.filled.critical.border.pressed": {
    "value": "var(--fVssTn)",
    "variable": "var(--fVssTn)"
  },
  "colors.Button.onImpact.outlined.brand.bg.default": {
    "value": "var(--dlaXTB)",
    "variable": "var(--dlaXTB)"
  },
  "colors.Button.onImpact.outlined.brand.bg.hover": {
    "value": "var(--aerlw)",
    "variable": "var(--aerlw)"
  },
  "colors.Button.onImpact.outlined.brand.bg.pressed": {
    "value": "var(--fdbccA)",
    "variable": "var(--fdbccA)"
  },
  "colors.Button.onImpact.outlined.brand.label.default": {
    "value": "var(--cuArUe)",
    "variable": "var(--cuArUe)"
  },
  "colors.Button.onImpact.outlined.brand.label.hover": {
    "value": "var(--eDYaEj)",
    "variable": "var(--eDYaEj)"
  },
  "colors.Button.onImpact.outlined.brand.label.pressed": {
    "value": "var(--bcdYHn)",
    "variable": "var(--bcdYHn)"
  },
  "colors.Button.onImpact.outlined.brand.icon.default": {
    "value": "var(--ghMWuX)",
    "variable": "var(--ghMWuX)"
  },
  "colors.Button.onImpact.outlined.brand.icon.hover": {
    "value": "var(--bwItTy)",
    "variable": "var(--bwItTy)"
  },
  "colors.Button.onImpact.outlined.brand.icon.pressed": {
    "value": "var(--caJTFq)",
    "variable": "var(--caJTFq)"
  },
  "colors.Button.onImpact.outlined.brand.border.default": {
    "value": "var(--bKOGcE)",
    "variable": "var(--bKOGcE)"
  },
  "colors.Button.onImpact.outlined.brand.border.hover": {
    "value": "var(--bvEltF)",
    "variable": "var(--bvEltF)"
  },
  "colors.Button.onImpact.outlined.brand.border.pressed": {
    "value": "var(--iYXzFp)",
    "variable": "var(--iYXzFp)"
  },
  "colors.Button.onImpact.outlined.neutral.bg.default": {
    "value": "var(--ktdrD)",
    "variable": "var(--ktdrD)"
  },
  "colors.Button.onImpact.outlined.neutral.bg.hover": {
    "value": "var(--hLtotW)",
    "variable": "var(--hLtotW)"
  },
  "colors.Button.onImpact.outlined.neutral.bg.pressed": {
    "value": "var(--ipuOfO)",
    "variable": "var(--ipuOfO)"
  },
  "colors.Button.onImpact.outlined.neutral.label.default": {
    "value": "var(--dAGrU)",
    "variable": "var(--dAGrU)"
  },
  "colors.Button.onImpact.outlined.neutral.label.hover": {
    "value": "var(--ekJCAN)",
    "variable": "var(--ekJCAN)"
  },
  "colors.Button.onImpact.outlined.neutral.label.pressed": {
    "value": "var(--fqMDup)",
    "variable": "var(--fqMDup)"
  },
  "colors.Button.onImpact.outlined.neutral.icon.default": {
    "value": "var(--fEVbsx)",
    "variable": "var(--fEVbsx)"
  },
  "colors.Button.onImpact.outlined.neutral.icon.hover": {
    "value": "var(--gNGLbE)",
    "variable": "var(--gNGLbE)"
  },
  "colors.Button.onImpact.outlined.neutral.icon.pressed": {
    "value": "var(--dbEpOs)",
    "variable": "var(--dbEpOs)"
  },
  "colors.Button.onImpact.outlined.neutral.border.default": {
    "value": "var(--cJJfMa)",
    "variable": "var(--cJJfMa)"
  },
  "colors.Button.onImpact.outlined.neutral.border.hover": {
    "value": "var(--edvlrb)",
    "variable": "var(--edvlrb)"
  },
  "colors.Button.onImpact.outlined.neutral.border.pressed": {
    "value": "var(--hbdLPb)",
    "variable": "var(--hbdLPb)"
  },
  "colors.Button.onImpact.outlined.neutral-fixed.bg.default": {
    "value": "var(--bKnvDg)",
    "variable": "var(--bKnvDg)"
  },
  "colors.Button.onImpact.outlined.neutral-fixed.bg.hover": {
    "value": "var(--dCBJHZ)",
    "variable": "var(--dCBJHZ)"
  },
  "colors.Button.onImpact.outlined.neutral-fixed.bg.pressed": {
    "value": "var(--cguuIV)",
    "variable": "var(--cguuIV)"
  },
  "colors.Button.onImpact.outlined.neutral-fixed.label.default": {
    "value": "var(--leytBT)",
    "variable": "var(--leytBT)"
  },
  "colors.Button.onImpact.outlined.neutral-fixed.label.hover": {
    "value": "var(--fSBFaK)",
    "variable": "var(--fSBFaK)"
  },
  "colors.Button.onImpact.outlined.neutral-fixed.label.pressed": {
    "value": "var(--iLfqau)",
    "variable": "var(--iLfqau)"
  },
  "colors.Button.onImpact.outlined.neutral-fixed.icon.default": {
    "value": "var(--ejdpYC)",
    "variable": "var(--ejdpYC)"
  },
  "colors.Button.onImpact.outlined.neutral-fixed.icon.hover": {
    "value": "var(--okEH)",
    "variable": "var(--okEH)"
  },
  "colors.Button.onImpact.outlined.neutral-fixed.icon.pressed": {
    "value": "var(--gnjFdn)",
    "variable": "var(--gnjFdn)"
  },
  "colors.Button.onImpact.outlined.neutral-fixed.border.default": {
    "value": "var(--eYhipN)",
    "variable": "var(--eYhipN)"
  },
  "colors.Button.onImpact.outlined.neutral-fixed.border.hover": {
    "value": "var(--ibtvls)",
    "variable": "var(--ibtvls)"
  },
  "colors.Button.onImpact.outlined.neutral-fixed.border.pressed": {
    "value": "var(--HyMKU)",
    "variable": "var(--HyMKU)"
  },
  "colors.Button.onImpact.outlined.critical.bg.default": {
    "value": "var(--kXtAkx)",
    "variable": "var(--kXtAkx)"
  },
  "colors.Button.onImpact.outlined.critical.bg.hover": {
    "value": "var(--jgnYAk)",
    "variable": "var(--jgnYAk)"
  },
  "colors.Button.onImpact.outlined.critical.bg.pressed": {
    "value": "var(--fEtWDo)",
    "variable": "var(--fEtWDo)"
  },
  "colors.Button.onImpact.outlined.critical.label.default": {
    "value": "var(--kARALy)",
    "variable": "var(--kARALy)"
  },
  "colors.Button.onImpact.outlined.critical.label.hover": {
    "value": "var(--VjXGb)",
    "variable": "var(--VjXGb)"
  },
  "colors.Button.onImpact.outlined.critical.label.pressed": {
    "value": "var(--dSSyeb)",
    "variable": "var(--dSSyeb)"
  },
  "colors.Button.onImpact.outlined.critical.icon.default": {
    "value": "var(--ijIvjn)",
    "variable": "var(--ijIvjn)"
  },
  "colors.Button.onImpact.outlined.critical.icon.hover": {
    "value": "var(--fAsROS)",
    "variable": "var(--fAsROS)"
  },
  "colors.Button.onImpact.outlined.critical.icon.pressed": {
    "value": "var(--gGvSIu)",
    "variable": "var(--gGvSIu)"
  },
  "colors.Button.onImpact.outlined.critical.border.default": {
    "value": "var(--cpESgE)",
    "variable": "var(--cpESgE)"
  },
  "colors.Button.onImpact.outlined.critical.border.hover": {
    "value": "var(--kSyTCB)",
    "variable": "var(--kSyTCB)"
  },
  "colors.Button.onImpact.outlined.critical.border.pressed": {
    "value": "var(--gKGByl)",
    "variable": "var(--gKGByl)"
  },
  "colors.Calendar.ControlButton.bg.default": {
    "value": "var(--bYHIlk)",
    "variable": "var(--bYHIlk)"
  },
  "colors.Calendar.ControlButton.bg.hover": {
    "value": "var(--cuwt)",
    "variable": "var(--cuwt)"
  },
  "colors.Calendar.ControlButton.bg.pressed": {
    "value": "var(--ktIiql)",
    "variable": "var(--ktIiql)"
  },
  "colors.Calendar.ControlButton.icon.default": {
    "value": "var(--jplnkq)",
    "variable": "var(--jplnkq)"
  },
  "colors.Calendar.DayOfWeek.border.default": {
    "value": "var(--JDmYp)",
    "variable": "var(--JDmYp)"
  },
  "colors.Calendar.Day.bg.default": {
    "value": "var(--jDMlaB)",
    "variable": "var(--jDMlaB)"
  },
  "colors.Calendar.Day.bg.hover": {
    "value": "var(--kiucvc)",
    "variable": "var(--kiucvc)"
  },
  "colors.Calendar.Day.bg.pressed": {
    "value": "var(--ljaqKw)",
    "variable": "var(--ljaqKw)"
  },
  "colors.Calendar.Day.bg.selected": {
    "value": "var(--loHGLf)",
    "variable": "var(--loHGLf)"
  },
  "colors.Calendar.Day.bg.selectedHover": {
    "value": "var(--ipWezB)",
    "variable": "var(--ipWezB)"
  },
  "colors.Calendar.Day.bg.selectedPressed": {
    "value": "var(--kdEjCV)",
    "variable": "var(--kdEjCV)"
  },
  "colors.Calendar.Day.border.default": {
    "value": "var(--jbfrQQ)",
    "variable": "var(--jbfrQQ)"
  },
  "colors.Calendar.Day.border.hover": {
    "value": "var(--dPTOeF)",
    "variable": "var(--dPTOeF)"
  },
  "colors.Calendar.Day.border.pressed": {
    "value": "var(--jJkNuV)",
    "variable": "var(--jJkNuV)"
  },
  "colors.Calendar.Day.border.selected": {
    "value": "var(--hXlhbC)",
    "variable": "var(--hXlhbC)"
  },
  "colors.Calendar.Day.border.selectedHover": {
    "value": "var(--iRcPpk)",
    "variable": "var(--iRcPpk)"
  },
  "colors.Calendar.Day.border.selectedPressed": {
    "value": "var(--bMXbHI)",
    "variable": "var(--bMXbHI)"
  },
  "colors.Calendar.Day.border.today.default": {
    "value": "var(--fZzUYG)",
    "variable": "var(--fZzUYG)"
  },
  "colors.Calendar.Day.border.today.hover": {
    "value": "var(--dhJpSL)",
    "variable": "var(--dhJpSL)"
  },
  "colors.Calendar.Day.border.today.pressed": {
    "value": "var(--clTunH)",
    "variable": "var(--clTunH)"
  },
  "colors.Calendar.Day.border.today.selected": {
    "value": "var(--mCqos)",
    "variable": "var(--mCqos)"
  },
  "colors.Calendar.Day.border.today.selectedHover": {
    "value": "var(--clqEJq)",
    "variable": "var(--clqEJq)"
  },
  "colors.Calendar.Day.border.today.selectedPressed": {
    "value": "var(--gonpAu)",
    "variable": "var(--gonpAu)"
  },
  "colors.Calendar.Day.label.default": {
    "value": "var(--glFqii)",
    "variable": "var(--glFqii)"
  },
  "colors.Calendar.Day.label.hover": {
    "value": "var(--iVTzef)",
    "variable": "var(--iVTzef)"
  },
  "colors.Calendar.Day.label.pressed": {
    "value": "var(--kqqaL)",
    "variable": "var(--kqqaL)"
  },
  "colors.Calendar.Day.label.selected": {
    "value": "var(--enOFzM)",
    "variable": "var(--enOFzM)"
  },
  "colors.Calendar.Day.label.selectedHover": {
    "value": "var(--eXTRgK)",
    "variable": "var(--eXTRgK)"
  },
  "colors.Calendar.Day.label.selectedPressed": {
    "value": "var(--iABIRW)",
    "variable": "var(--iABIRW)"
  },
  "colors.Calendar.Root.bg.default": {
    "value": "var(--hzPDdL)",
    "variable": "var(--hzPDdL)"
  },
  "colors.Calendar.YearSelect.bg.default": {
    "value": "var(--gLLMKa)",
    "variable": "var(--gLLMKa)"
  },
  "colors.Calendar.YearSelect.bg.hover": {
    "value": "var(--fYzUen)",
    "variable": "var(--fYzUen)"
  },
  "colors.Calendar.YearSelect.bg.pressed": {
    "value": "var(--jfyXFH)",
    "variable": "var(--jfyXFH)"
  },
  "colors.Calendar.YearSelect.icon.default": {
    "value": "var(--dWojzA)",
    "variable": "var(--dWojzA)"
  },
  "colors.Calendar.YearSelect.icon.hover": {
    "value": "var(--hZOjut)",
    "variable": "var(--hZOjut)"
  },
  "colors.Calendar.YearSelect.icon.pressed": {
    "value": "var(--jJqZhx)",
    "variable": "var(--jJqZhx)"
  },
  "colors.Card.Footer.border": {
    "value": "var(--ghmjQJ)",
    "variable": "var(--ghmjQJ)"
  },
  "colors.Card.Header.border": {
    "value": "var(--jkOoIz)",
    "variable": "var(--jkOoIz)"
  },
  "colors.Card.Root.neutral.bg": {
    "value": "var(--eYnSsb)",
    "variable": "var(--eYnSsb)"
  },
  "colors.Card.Root.neutral.border": {
    "value": "var(--fSBtrC)",
    "variable": "var(--fSBtrC)"
  },
  "colors.Card.Root.neutral.elevated.bg": {
    "value": "var(--fYYnRE)",
    "variable": "var(--fYYnRE)"
  },
  "colors.Card.Root.soft.bg": {
    "value": "var(--iHCyis)",
    "variable": "var(--iHCyis)"
  },
  "colors.Card.Root.soft.border": {
    "value": "var(--koJkul)",
    "variable": "var(--koJkul)"
  },
  "colors.Card.Root.interactive.neutral.bg.default": {
    "value": "var(--bmjcIc)",
    "variable": "var(--bmjcIc)"
  },
  "colors.Card.Root.interactive.neutral.bg.hover": {
    "value": "var(--gTZytR)",
    "variable": "var(--gTZytR)"
  },
  "colors.Card.Root.interactive.neutral.bg.pressed": {
    "value": "var(--hsjyZR)",
    "variable": "var(--hsjyZR)"
  },
  "colors.Card.Root.interactive.neutral.border.default": {
    "value": "var(--jXfJsl)",
    "variable": "var(--jXfJsl)"
  },
  "colors.Card.Root.interactive.neutral.border.hover": {
    "value": "var(--erwEmE)",
    "variable": "var(--erwEmE)"
  },
  "colors.Card.Root.interactive.neutral.border.pressed": {
    "value": "var(--PCCpI)",
    "variable": "var(--PCCpI)"
  },
  "colors.Card.Root.interactive.neutral.elevated.bg.default": {
    "value": "var(--fymRSP)",
    "variable": "var(--fymRSP)"
  },
  "colors.Card.Root.interactive.neutral.elevated.bg.hover": {
    "value": "var(--gjlYDG)",
    "variable": "var(--gjlYDG)"
  },
  "colors.Card.Root.interactive.neutral.elevated.bg.pressed": {
    "value": "var(--eNeJEC)",
    "variable": "var(--eNeJEC)"
  },
  "colors.Card.Root.interactive.soft.bg.default": {
    "value": "var(--eTTvRf)",
    "variable": "var(--eTTvRf)"
  },
  "colors.Card.Root.interactive.soft.bg.hover": {
    "value": "var(--eJqHtq)",
    "variable": "var(--eJqHtq)"
  },
  "colors.Card.Root.interactive.soft.bg.pressed": {
    "value": "var(--lewusu)",
    "variable": "var(--lewusu)"
  },
  "colors.Card.Root.interactive.soft.border.default": {
    "value": "var(--bhjXHu)",
    "variable": "var(--bhjXHu)"
  },
  "colors.Card.Root.interactive.soft.border.hover": {
    "value": "var(--djKeUD)",
    "variable": "var(--djKeUD)"
  },
  "colors.Card.Root.interactive.soft.border.pressed": {
    "value": "var(--hmGPLH)",
    "variable": "var(--hmGPLH)"
  },
  "colors.Card.Root.interactive.soft.elevated.bg.default": {
    "value": "var(--byKiVM)",
    "variable": "var(--byKiVM)"
  },
  "colors.Card.Root.interactive.soft.elevated.bg.hover": {
    "value": "var(--cdXJXB)",
    "variable": "var(--cdXJXB)"
  },
  "colors.Card.Root.interactive.soft.elevated.bg.pressed": {
    "value": "var(--dkaKRd)",
    "variable": "var(--dkaKRd)"
  },
  "colors.Card.text.heading": {
    "value": "var(--hKjQbZ)",
    "variable": "var(--hKjQbZ)"
  },
  "colors.Card.text.description": {
    "value": "var(--bzUfIX)",
    "variable": "var(--bzUfIX)"
  },
  "colors.Carousel.SkipLink.bg": {
    "value": "var(--dfeUec)",
    "variable": "var(--dfeUec)"
  },
  "colors.Checkbox.bg.default": {
    "value": "var(--bonkpp)",
    "variable": "var(--bonkpp)"
  },
  "colors.Checkbox.bg.hover": {
    "value": "var(--kQtYjI)",
    "variable": "var(--kQtYjI)"
  },
  "colors.Checkbox.bg.pressed": {
    "value": "var(--fdcYTs)",
    "variable": "var(--fdcYTs)"
  },
  "colors.Checkbox.bg.indeterminate": {
    "value": "var(--dbMdSV)",
    "variable": "var(--dbMdSV)"
  },
  "colors.Checkbox.bg.indeterminateHover": {
    "value": "var(--iGfBbf)",
    "variable": "var(--iGfBbf)"
  },
  "colors.Checkbox.bg.indeterminatePressed": {
    "value": "var(--kpIqOj)",
    "variable": "var(--kpIqOj)"
  },
  "colors.Checkbox.bg.selected": {
    "value": "var(--jWKLfL)",
    "variable": "var(--jWKLfL)"
  },
  "colors.Checkbox.bg.selectedHover": {
    "value": "var(--gabERd)",
    "variable": "var(--gabERd)"
  },
  "colors.Checkbox.bg.selectedPressed": {
    "value": "var(--DWUIx)",
    "variable": "var(--DWUIx)"
  },
  "colors.Checkbox.border.default": {
    "value": "var(--cRmraI)",
    "variable": "var(--cRmraI)"
  },
  "colors.Checkbox.border.hover": {
    "value": "var(--htrHRt)",
    "variable": "var(--htrHRt)"
  },
  "colors.Checkbox.border.pressed": {
    "value": "var(--itXWgN)",
    "variable": "var(--itXWgN)"
  },
  "colors.Checkbox.border.indeterminate": {
    "value": "var(--spPJA)",
    "variable": "var(--spPJA)"
  },
  "colors.Checkbox.border.indeterminateHover": {
    "value": "var(--bIgZCa)",
    "variable": "var(--bIgZCa)"
  },
  "colors.Checkbox.border.indeterminatePressed": {
    "value": "var(--fomiqG)",
    "variable": "var(--fomiqG)"
  },
  "colors.Checkbox.border.selected": {
    "value": "var(--blWjky)",
    "variable": "var(--blWjky)"
  },
  "colors.Checkbox.border.selectedHover": {
    "value": "var(--edYozI)",
    "variable": "var(--edYozI)"
  },
  "colors.Checkbox.border.selectedPressed": {
    "value": "var(--fRGtDc)",
    "variable": "var(--fRGtDc)"
  },
  "colors.Checkbox.icon.default": {
    "value": "var(--kREInX)",
    "variable": "var(--kREInX)"
  },
  "colors.Checkbox.icon.indeterminate": {
    "value": "var(--fRiWxv)",
    "variable": "var(--fRiWxv)"
  },
  "colors.Checkbox.icon.indeterminateHover": {
    "value": "var(--jsYbBB)",
    "variable": "var(--jsYbBB)"
  },
  "colors.Checkbox.icon.indeterminatePressed": {
    "value": "var(--bGkjNR)",
    "variable": "var(--bGkjNR)"
  },
  "colors.Checkbox.icon.selected": {
    "value": "var(--kICtgp)",
    "variable": "var(--kICtgp)"
  },
  "colors.Checkbox.icon.selectedHover": {
    "value": "var(--cPsqiX)",
    "variable": "var(--cPsqiX)"
  },
  "colors.Checkbox.icon.selectedPressed": {
    "value": "var(--dmeNvD)",
    "variable": "var(--dmeNvD)"
  },
  "colors.Chip.bg.default": {
    "value": "var(--bUVIpo)",
    "variable": "var(--bUVIpo)"
  },
  "colors.Chip.bg.hover": {
    "value": "var(--ddAMrd)",
    "variable": "var(--ddAMrd)"
  },
  "colors.Chip.bg.pressed": {
    "value": "var(--gZCIYp)",
    "variable": "var(--gZCIYp)"
  },
  "colors.Chip.bg.selected": {
    "value": "var(--jRJHne)",
    "variable": "var(--jRJHne)"
  },
  "colors.Chip.bg.selectedHover": {
    "value": "var(--hAMSkw)",
    "variable": "var(--hAMSkw)"
  },
  "colors.Chip.bg.selectedPressed": {
    "value": "var(--iBtgzQ)",
    "variable": "var(--iBtgzQ)"
  },
  "colors.Chip.bg.elevated.default": {
    "value": "var(--dPnoCP)",
    "variable": "var(--dPnoCP)"
  },
  "colors.Chip.bg.elevated.hover": {
    "value": "var(--jpfpRi)",
    "variable": "var(--jpfpRi)"
  },
  "colors.Chip.bg.elevated.pressed": {
    "value": "var(--iPrrie)",
    "variable": "var(--iPrrie)"
  },
  "colors.Chip.bg.elevated.selected": {
    "value": "var(--fgJfpF)",
    "variable": "var(--fgJfpF)"
  },
  "colors.Chip.bg.elevated.selectedHover": {
    "value": "var(--mOmRH)",
    "variable": "var(--mOmRH)"
  },
  "colors.Chip.bg.elevated.selectedPressed": {
    "value": "var(--bWrcEL)",
    "variable": "var(--bWrcEL)"
  },
  "colors.Chip.label.default": {
    "value": "var(--jJbpsb)",
    "variable": "var(--jJbpsb)"
  },
  "colors.Chip.label.hover": {
    "value": "var(--bNEafq)",
    "variable": "var(--bNEafq)"
  },
  "colors.Chip.label.pressed": {
    "value": "var(--iwATnG)",
    "variable": "var(--iwATnG)"
  },
  "colors.Chip.label.selected": {
    "value": "var(--ezSSYZ)",
    "variable": "var(--ezSSYZ)"
  },
  "colors.Chip.label.selectedHover": {
    "value": "var(--kmpewf)",
    "variable": "var(--kmpewf)"
  },
  "colors.Chip.label.selectedPressed": {
    "value": "var(--bALVsL)",
    "variable": "var(--bALVsL)"
  },
  "colors.Chip.icon.default": {
    "value": "var(--dEMmJy)",
    "variable": "var(--dEMmJy)"
  },
  "colors.Chip.icon.hover": {
    "value": "var(--gVNGBD)",
    "variable": "var(--gVNGBD)"
  },
  "colors.Chip.icon.pressed": {
    "value": "var(--jSJroX)",
    "variable": "var(--jSJroX)"
  },
  "colors.Chip.icon.selected": {
    "value": "var(--bTLWQU)",
    "variable": "var(--bTLWQU)"
  },
  "colors.Chip.icon.selectedHover": {
    "value": "var(--bVOkzC)",
    "variable": "var(--bVOkzC)"
  },
  "colors.Chip.icon.selectedPressed": {
    "value": "var(--iimvjS)",
    "variable": "var(--iimvjS)"
  },
  "colors.Chip.border.default": {
    "value": "var(--djLGcl)",
    "variable": "var(--djLGcl)"
  },
  "colors.Chip.border.hover": {
    "value": "var(--gDyIeU)",
    "variable": "var(--gDyIeU)"
  },
  "colors.Chip.border.pressed": {
    "value": "var(--QhIOE)",
    "variable": "var(--QhIOE)"
  },
  "colors.Chip.border.selected": {
    "value": "var(--iLrWtv)",
    "variable": "var(--iLrWtv)"
  },
  "colors.Chip.border.selectedHover": {
    "value": "var(--jDISsV)",
    "variable": "var(--jDISsV)"
  },
  "colors.Chip.border.selectedPressed": {
    "value": "var(--ehEikp)",
    "variable": "var(--ehEikp)"
  },
  "colors.CloseButton.bg.default": {
    "value": "var(--ldRIwW)",
    "variable": "var(--ldRIwW)"
  },
  "colors.CloseButton.bg.hover": {
    "value": "var(--kmXlhP)",
    "variable": "var(--kmXlhP)"
  },
  "colors.CloseButton.bg.pressed": {
    "value": "var(--hTWMLH)",
    "variable": "var(--hTWMLH)"
  },
  "colors.CloseButton.bg.onImpact.default": {
    "value": "var(--kUwdTY)",
    "variable": "var(--kUwdTY)"
  },
  "colors.CloseButton.bg.onImpact.hover": {
    "value": "var(--hWVUIJ)",
    "variable": "var(--hWVUIJ)"
  },
  "colors.CloseButton.bg.onImpact.pressed": {
    "value": "var(--jKDZMd)",
    "variable": "var(--jKDZMd)"
  },
  "colors.CloseButton.border.default": {
    "value": "var(--jeIWMP)",
    "variable": "var(--jeIWMP)"
  },
  "colors.CloseButton.border.hover": {
    "value": "var(--hAjNtG)",
    "variable": "var(--hAjNtG)"
  },
  "colors.CloseButton.border.pressed": {
    "value": "var(--kecnPi)",
    "variable": "var(--kecnPi)"
  },
  "colors.CloseButton.border.onImpact.default": {
    "value": "var(--cUHcwx)",
    "variable": "var(--cUHcwx)"
  },
  "colors.CloseButton.border.onImpact.hover": {
    "value": "var(--jIGbEA)",
    "variable": "var(--jIGbEA)"
  },
  "colors.CloseButton.border.onImpact.pressed": {
    "value": "var(--cEAnWY)",
    "variable": "var(--cEAnWY)"
  },
  "colors.CloseButton.icon.default": {
    "value": "var(--gMNcFA)",
    "variable": "var(--gMNcFA)"
  },
  "colors.CloseButton.icon.hover": {
    "value": "var(--jGXZYZ)",
    "variable": "var(--jGXZYZ)"
  },
  "colors.CloseButton.icon.pressed": {
    "value": "var(--jhkbpV)",
    "variable": "var(--jhkbpV)"
  },
  "colors.CloseButton.icon.onImpact.default": {
    "value": "var(--ewCsYa)",
    "variable": "var(--ewCsYa)"
  },
  "colors.CloseButton.icon.onImpact.hover": {
    "value": "var(--hTkEcD)",
    "variable": "var(--hTkEcD)"
  },
  "colors.CloseButton.icon.onImpact.pressed": {
    "value": "var(--gXuIxz)",
    "variable": "var(--gXuIxz)"
  },
  "colors.Combobox.Heading.bg": {
    "value": "var(--iLZmvU)",
    "variable": "var(--iLZmvU)"
  },
  "colors.Combobox.Heading.icon": {
    "value": "var(--MrtXy)",
    "variable": "var(--MrtXy)"
  },
  "colors.Combobox.Heading.label": {
    "value": "var(--hKkkjD)",
    "variable": "var(--hKkkjD)"
  },
  "colors.Combobox.Adornment.icon.trailing.default": {
    "value": "var(--edsAHL)",
    "variable": "var(--edsAHL)"
  },
  "colors.Combobox.ChipsOverflow.text.default": {
    "value": "var(--Ltgvv)",
    "variable": "var(--Ltgvv)"
  },
  "colors.Combobox.bg.default": {
    "value": "var(--cLeLKr)",
    "variable": "var(--cLeLKr)"
  },
  "colors.Combobox.bg.hover": {
    "value": "var(--dqaFJq)",
    "variable": "var(--dqaFJq)"
  },
  "colors.Combobox.bg.active": {
    "value": "var(--fEEjwU)",
    "variable": "var(--fEEjwU)"
  },
  "colors.Combobox.bg.activeHover": {
    "value": "var(--cFDPJK)",
    "variable": "var(--cFDPJK)"
  },
  "colors.Combobox.bg.error": {
    "value": "var(--jpBRQQ)",
    "variable": "var(--jpBRQQ)"
  },
  "colors.Combobox.bg.errorHover": {
    "value": "var(--cWUpLq)",
    "variable": "var(--cWUpLq)"
  },
  "colors.Combobox.bg.errorActive": {
    "value": "var(--jGPFpY)",
    "variable": "var(--jGPFpY)"
  },
  "colors.Combobox.bg.readOnly": {
    "value": "var(--cUtHAK)",
    "variable": "var(--cUtHAK)"
  },
  "colors.Combobox.border.default": {
    "value": "var(--cCzWOy)",
    "variable": "var(--cCzWOy)"
  },
  "colors.Combobox.border.hover": {
    "value": "var(--cLrKTX)",
    "variable": "var(--cLrKTX)"
  },
  "colors.Combobox.border.active": {
    "value": "var(--RBKoN)",
    "variable": "var(--RBKoN)"
  },
  "colors.Combobox.border.activeHover": {
    "value": "var(--AdoOz)",
    "variable": "var(--AdoOz)"
  },
  "colors.Combobox.border.error": {
    "value": "var(--fAzCFF)",
    "variable": "var(--fAzCFF)"
  },
  "colors.Combobox.border.errorHover": {
    "value": "var(--hCmKLj)",
    "variable": "var(--hCmKLj)"
  },
  "colors.Combobox.border.errorActive": {
    "value": "var(--hHrxZB)",
    "variable": "var(--hHrxZB)"
  },
  "colors.Combobox.icon.clearButton.default": {
    "value": "var(--coFeJH)",
    "variable": "var(--coFeJH)"
  },
  "colors.Combobox.icon.clearButton.hover": {
    "value": "var(--glyjrm)",
    "variable": "var(--glyjrm)"
  },
  "colors.Combobox.icon.clearButton.pressed": {
    "value": "var(--fpInMi)",
    "variable": "var(--fpInMi)"
  },
  "colors.Combobox.icon.trailing.default": {
    "value": "var(--knvkTm)",
    "variable": "var(--knvkTm)"
  },
  "colors.Combobox.icon.trailing.readOnly": {
    "value": "var(--bfJDin)",
    "variable": "var(--bfJDin)"
  },
  "colors.Combobox.text.populated": {
    "value": "var(--etNBsO)",
    "variable": "var(--etNBsO)"
  },
  "colors.Combobox.text.placeholder": {
    "value": "var(--lkxWWH)",
    "variable": "var(--lkxWWH)"
  },
  "colors.Combobox.text.readOnly": {
    "value": "var(--gGQhhi)",
    "variable": "var(--gGQhhi)"
  },
  "colors.Combobox.Content.bg": {
    "value": "var(--jMynJh)",
    "variable": "var(--jMynJh)"
  },
  "colors.Combobox.Group.border": {
    "value": "var(--hpAlFW)",
    "variable": "var(--hpAlFW)"
  },
  "colors.Combobox.Input.text.populated": {
    "value": "var(--bKnYPh)",
    "variable": "var(--bKnYPh)"
  },
  "colors.Combobox.Input.text.placeholder": {
    "value": "var(--iKFxsc)",
    "variable": "var(--iKFxsc)"
  },
  "colors.Combobox.OptionLabel.text.label.default": {
    "value": "var(--eehrfw)",
    "variable": "var(--eehrfw)"
  },
  "colors.Combobox.OptionLabel.text.label.hover": {
    "value": "var(--hGWwgV)",
    "variable": "var(--hGWwgV)"
  },
  "colors.Combobox.OptionLabel.text.label.pressed": {
    "value": "var(--cAIhFl)",
    "variable": "var(--cAIhFl)"
  },
  "colors.Combobox.OptionLabel.text.label.selected": {
    "value": "var(--EMFFS)",
    "variable": "var(--EMFFS)"
  },
  "colors.Combobox.OptionMedia.icon.default": {
    "value": "var(--cpkIBz)",
    "variable": "var(--cpkIBz)"
  },
  "colors.Combobox.OptionMedia.icon.hover": {
    "value": "var(--jrMttm)",
    "variable": "var(--jrMttm)"
  },
  "colors.Combobox.OptionMedia.icon.pressed": {
    "value": "var(--ivWxOi)",
    "variable": "var(--ivWxOi)"
  },
  "colors.Combobox.OptionMedia.icon.selected": {
    "value": "var(--cDaPdl)",
    "variable": "var(--cDaPdl)"
  },
  "colors.Combobox.OptionMeta.text.meta.default": {
    "value": "var(--iGctVo)",
    "variable": "var(--iGctVo)"
  },
  "colors.Combobox.OptionMeta.text.meta.hover": {
    "value": "var(--efYcll)",
    "variable": "var(--efYcll)"
  },
  "colors.Combobox.OptionMeta.text.meta.pressed": {
    "value": "var(--kBdPkp)",
    "variable": "var(--kBdPkp)"
  },
  "colors.Combobox.OptionMeta.text.meta.selected": {
    "value": "var(--eKvpGy)",
    "variable": "var(--eKvpGy)"
  },
  "colors.Combobox.Option.bg.default": {
    "value": "var(--OPYnB)",
    "variable": "var(--OPYnB)"
  },
  "colors.Combobox.Option.bg.hover": {
    "value": "var(--iuwZFw)",
    "variable": "var(--iuwZFw)"
  },
  "colors.Combobox.Option.bg.pressed": {
    "value": "var(--kYpAaY)",
    "variable": "var(--kYpAaY)"
  },
  "colors.Combobox.Option.bg.selected": {
    "value": "var(--hHwnLj)",
    "variable": "var(--hHwnLj)"
  },
  "colors.Combobox.Trigger.bg.default": {
    "value": "var(--fRzRnq)",
    "variable": "var(--fRzRnq)"
  },
  "colors.Combobox.Trigger.bg.hover": {
    "value": "var(--jhZCZT)",
    "variable": "var(--jhZCZT)"
  },
  "colors.Combobox.Trigger.bg.active": {
    "value": "var(--iLxuAB)",
    "variable": "var(--iLxuAB)"
  },
  "colors.Combobox.Trigger.bg.activeHover": {
    "value": "var(--QOlRz)",
    "variable": "var(--QOlRz)"
  },
  "colors.Combobox.Trigger.bg.error": {
    "value": "var(--ikxSvZ)",
    "variable": "var(--ikxSvZ)"
  },
  "colors.Combobox.Trigger.bg.errorHover": {
    "value": "var(--tRmcP)",
    "variable": "var(--tRmcP)"
  },
  "colors.Combobox.Trigger.bg.errorActive": {
    "value": "var(--ikxUaB)",
    "variable": "var(--ikxUaB)"
  },
  "colors.Combobox.Trigger.border.default": {
    "value": "var(--kJWqVH)",
    "variable": "var(--kJWqVH)"
  },
  "colors.Combobox.Trigger.border.hover": {
    "value": "var(--iCjWbm)",
    "variable": "var(--iCjWbm)"
  },
  "colors.Combobox.Trigger.border.active": {
    "value": "var(--jWrkXw)",
    "variable": "var(--jWrkXw)"
  },
  "colors.Combobox.Trigger.border.activeHover": {
    "value": "var(--llJdfy)",
    "variable": "var(--llJdfy)"
  },
  "colors.Combobox.Trigger.border.error": {
    "value": "var(--lfpNiU)",
    "variable": "var(--lfpNiU)"
  },
  "colors.Combobox.Trigger.border.errorHover": {
    "value": "var(--dkCEiy)",
    "variable": "var(--dkCEiy)"
  },
  "colors.Combobox.Trigger.border.errorActive": {
    "value": "var(--Ivdgk)",
    "variable": "var(--Ivdgk)"
  },
  "colors.DateInput.bg.active": {
    "value": "var(--gXMiSD)",
    "variable": "var(--gXMiSD)"
  },
  "colors.DateInput.bg.activeHover": {
    "value": "var(--eGYxst)",
    "variable": "var(--eGYxst)"
  },
  "colors.DateInput.bg.autofill": {
    "value": "var(--gegLQP)",
    "variable": "var(--gegLQP)"
  },
  "colors.DateInput.bg.default": {
    "value": "var(--jcIbIY)",
    "variable": "var(--jcIbIY)"
  },
  "colors.DateInput.bg.error": {
    "value": "var(--BMXkb)",
    "variable": "var(--BMXkb)"
  },
  "colors.DateInput.bg.errorActive": {
    "value": "var(--iUPXrr)",
    "variable": "var(--iUPXrr)"
  },
  "colors.DateInput.bg.errorHover": {
    "value": "var(--gDYjJt)",
    "variable": "var(--gDYjJt)"
  },
  "colors.DateInput.bg.hover": {
    "value": "var(--jboeex)",
    "variable": "var(--jboeex)"
  },
  "colors.DateInput.bg.readOnly": {
    "value": "var(--iefCTJ)",
    "variable": "var(--iefCTJ)"
  },
  "colors.DateInput.border.active": {
    "value": "var(--kkuJKK)",
    "variable": "var(--kkuJKK)"
  },
  "colors.DateInput.border.activeHover": {
    "value": "var(--ezZFcQ)",
    "variable": "var(--ezZFcQ)"
  },
  "colors.DateInput.border.default": {
    "value": "var(--gyPiYB)",
    "variable": "var(--gyPiYB)"
  },
  "colors.DateInput.border.error": {
    "value": "var(--bGoLHS)",
    "variable": "var(--bGoLHS)"
  },
  "colors.DateInput.border.errorActive": {
    "value": "var(--gwiJnO)",
    "variable": "var(--gwiJnO)"
  },
  "colors.DateInput.border.errorHover": {
    "value": "var(--bVieIU)",
    "variable": "var(--bVieIU)"
  },
  "colors.DateInput.border.hover": {
    "value": "var(--bEvXcw)",
    "variable": "var(--bEvXcw)"
  },
  "colors.DateInput.border.readOnly": {
    "value": "var(--itTucg)",
    "variable": "var(--itTucg)"
  },
  "colors.DateInput.icon.leading.default": {
    "value": "var(--cWdCRP)",
    "variable": "var(--cWdCRP)"
  },
  "colors.DateInput.icon.leading.readOnly": {
    "value": "var(--ffJoMW)",
    "variable": "var(--ffJoMW)"
  },
  "colors.DateInput.icon.trailing.default": {
    "value": "var(--iErTSR)",
    "variable": "var(--iErTSR)"
  },
  "colors.DateInput.icon.trailing.readOnly": {
    "value": "var(--fiCJKM)",
    "variable": "var(--fiCJKM)"
  },
  "colors.DateInput.text.adornment.default": {
    "value": "var(--dNEjEt)",
    "variable": "var(--dNEjEt)"
  },
  "colors.DateInput.text.adornment.readOnly": {
    "value": "var(--byInPY)",
    "variable": "var(--byInPY)"
  },
  "colors.DateInput.text.placeholder": {
    "value": "var(--fCWOTw)",
    "variable": "var(--fCWOTw)"
  },
  "colors.DateInput.text.populated": {
    "value": "var(--gyndSB)",
    "variable": "var(--gyndSB)"
  },
  "colors.DateInput.text.readOnly": {
    "value": "var(--hyOrrB)",
    "variable": "var(--hyOrrB)"
  },
  "colors.DateInput.HelperArea.icon.default": {
    "value": "var(--hLrgQW)",
    "variable": "var(--hLrgQW)"
  },
  "colors.DateInput.HelperArea.icon.error": {
    "value": "var(--qHEeB)",
    "variable": "var(--qHEeB)"
  },
  "colors.DateInput.HelperArea.icon.readOnly": {
    "value": "var(--jYGEbb)",
    "variable": "var(--jYGEbb)"
  },
  "colors.DateInput.HelperArea.text.default": {
    "value": "var(--bRPSDQ)",
    "variable": "var(--bRPSDQ)"
  },
  "colors.DateInput.HelperArea.text.error": {
    "value": "var(--gdobgv)",
    "variable": "var(--gdobgv)"
  },
  "colors.DateInput.HelperArea.text.readOnly": {
    "value": "var(--hyHDsl)",
    "variable": "var(--hyHDsl)"
  },
  "colors.DateInput.LabelArea.indicator.optional": {
    "value": "var(--fvZCkp)",
    "variable": "var(--fvZCkp)"
  },
  "colors.DateInput.LabelArea.indicator.readOnly": {
    "value": "var(--dUXOhZ)",
    "variable": "var(--dUXOhZ)"
  },
  "colors.DateInput.LabelArea.indicator.required": {
    "value": "var(--iKSAuG)",
    "variable": "var(--iKSAuG)"
  },
  "colors.DateInput.LabelArea.label.default": {
    "value": "var(--jfGFAD)",
    "variable": "var(--jfGFAD)"
  },
  "colors.DateInput.LabelArea.label.readOnly": {
    "value": "var(--frXoVS)",
    "variable": "var(--frXoVS)"
  },
  "colors.DatePicker.Backdrop.bg": {
    "value": "var(--gETnzp)",
    "variable": "var(--gETnzp)"
  },
  "colors.DatePicker.Content.bg": {
    "value": "var(--hRnwkW)",
    "variable": "var(--hRnwkW)"
  },
  "colors.DatePicker.InputGroup.bg.default": {
    "value": "var(--eaGyWE)",
    "variable": "var(--eaGyWE)"
  },
  "colors.DatePicker.InputGroup.bg.hover": {
    "value": "var(--krZAKJ)",
    "variable": "var(--krZAKJ)"
  },
  "colors.DatePicker.InputGroup.bg.active": {
    "value": "var(--kKozQH)",
    "variable": "var(--kKozQH)"
  },
  "colors.DatePicker.InputGroup.bg.activeHover": {
    "value": "var(--hNnMdJ)",
    "variable": "var(--hNnMdJ)"
  },
  "colors.DatePicker.InputGroup.bg.error": {
    "value": "var(--gTIain)",
    "variable": "var(--gTIain)"
  },
  "colors.DatePicker.InputGroup.bg.errorActive": {
    "value": "var(--QbUCr)",
    "variable": "var(--QbUCr)"
  },
  "colors.DatePicker.InputGroup.bg.errorHover": {
    "value": "var(--bthYot)",
    "variable": "var(--bthYot)"
  },
  "colors.DatePicker.InputGroup.bg.readOnly": {
    "value": "var(--jWsfEl)",
    "variable": "var(--jWsfEl)"
  },
  "colors.DatePicker.InputGroup.border.default": {
    "value": "var(--lfPrjt)",
    "variable": "var(--lfPrjt)"
  },
  "colors.DatePicker.InputGroup.border.hover": {
    "value": "var(--hWbFiQ)",
    "variable": "var(--hWbFiQ)"
  },
  "colors.DatePicker.InputGroup.border.active": {
    "value": "var(--exdLzS)",
    "variable": "var(--exdLzS)"
  },
  "colors.DatePicker.InputGroup.border.activeHover": {
    "value": "var(--iRjjGM)",
    "variable": "var(--iRjjGM)"
  },
  "colors.DatePicker.InputGroup.border.error": {
    "value": "var(--hrBSzW)",
    "variable": "var(--hrBSzW)"
  },
  "colors.DatePicker.InputGroup.border.errorActive": {
    "value": "var(--brSBPe)",
    "variable": "var(--brSBPe)"
  },
  "colors.DatePicker.InputGroup.border.errorHover": {
    "value": "var(--clgTwA)",
    "variable": "var(--clgTwA)"
  },
  "colors.DatePicker.InputGroup.border.readOnly": {
    "value": "var(--kIuvWk)",
    "variable": "var(--kIuvWk)"
  },
  "colors.DatePicker.InputGroup.text.placeholder": {
    "value": "var(--ldKtNY)",
    "variable": "var(--ldKtNY)"
  },
  "colors.DatePicker.InputGroup.text.populated": {
    "value": "var(--gqfagx)",
    "variable": "var(--gqfagx)"
  },
  "colors.DatePicker.InputGroup.text.readOnly": {
    "value": "var(--fZNfSR)",
    "variable": "var(--fZNfSR)"
  },
  "colors.DatePicker.Trigger.border.default": {
    "value": "var(--fgFqzY)",
    "variable": "var(--fgFqzY)"
  },
  "colors.DatePicker.Trigger.border.active": {
    "value": "var(--hdclAj)",
    "variable": "var(--hdclAj)"
  },
  "colors.DatePicker.Trigger.border.error": {
    "value": "var(--iLvohj)",
    "variable": "var(--iLvohj)"
  },
  "colors.Divider.muted.bg": {
    "value": "var(--eTqrmV)",
    "variable": "var(--eTqrmV)"
  },
  "colors.Divider.muted-alt.bg": {
    "value": "var(--kNpejh)",
    "variable": "var(--kNpejh)"
  },
  "colors.Divider.emphasized.bg": {
    "value": "var(--loSvXo)",
    "variable": "var(--loSvXo)"
  },
  "colors.Dropdown.Content.bg": {
    "value": "var(--jYAGkP)",
    "variable": "var(--jYAGkP)"
  },
  "colors.Dropdown.Heading.bg": {
    "value": "var(--fDaqpK)",
    "variable": "var(--fDaqpK)"
  },
  "colors.Dropdown.Heading.icon": {
    "value": "var(--cmKxxI)",
    "variable": "var(--cmKxxI)"
  },
  "colors.Dropdown.Heading.text": {
    "value": "var(--jLBDKi)",
    "variable": "var(--jLBDKi)"
  },
  "colors.DuoColorIcon.trust.default.bg": {
    "value": "var(--kIGqgH)",
    "variable": "var(--kIGqgH)"
  },
  "colors.DuoColorIcon.trust.default.icon": {
    "value": "var(--kcQFtl)",
    "variable": "var(--kcQFtl)"
  },
  "colors.DuoColorIcon.trust.onHero.bg": {
    "value": "var(--irxqOd)",
    "variable": "var(--irxqOd)"
  },
  "colors.DuoColorIcon.trust.onHero.icon": {
    "value": "var(--jPTIiT)",
    "variable": "var(--jPTIiT)"
  },
  "colors.DuoColorIcon.trust.onImpact.bg": {
    "value": "var(--jhBaDn)",
    "variable": "var(--jhBaDn)"
  },
  "colors.DuoColorIcon.trust.onImpact.icon": {
    "value": "var(--iDJJfl)",
    "variable": "var(--iDJJfl)"
  },
  "colors.DuoColorIcon.insight.default.bg": {
    "value": "var(--cGydzh)",
    "variable": "var(--cGydzh)"
  },
  "colors.DuoColorIcon.insight.default.icon": {
    "value": "var(--kVqyET)",
    "variable": "var(--kVqyET)"
  },
  "colors.DuoColorIcon.insight.onHero.bg": {
    "value": "var(--kXjvyb)",
    "variable": "var(--kXjvyb)"
  },
  "colors.DuoColorIcon.insight.onHero.icon": {
    "value": "var(--jQBLpJ)",
    "variable": "var(--jQBLpJ)"
  },
  "colors.DuoColorIcon.insight.onImpact.bg": {
    "value": "var(--iEwNxh)",
    "variable": "var(--iEwNxh)"
  },
  "colors.DuoColorIcon.insight.onImpact.icon": {
    "value": "var(--knhYBr)",
    "variable": "var(--knhYBr)"
  },
  "colors.DuoColorIcon.inspire.default.bg": {
    "value": "var(--bguzJ)",
    "variable": "var(--bguzJ)"
  },
  "colors.DuoColorIcon.inspire.default.icon": {
    "value": "var(--iCIkqz)",
    "variable": "var(--iCIkqz)"
  },
  "colors.DuoColorIcon.inspire.onHero.bg": {
    "value": "var(--fXpYYf)",
    "variable": "var(--fXpYYf)"
  },
  "colors.DuoColorIcon.inspire.onHero.icon": {
    "value": "var(--CECIB)",
    "variable": "var(--CECIB)"
  },
  "colors.DuoColorIcon.inspire.onImpact.bg": {
    "value": "var(--eKAZLR)",
    "variable": "var(--eKAZLR)"
  },
  "colors.DuoColorIcon.inspire.onImpact.icon": {
    "value": "var(--iAEqNL)",
    "variable": "var(--iAEqNL)"
  },
  "colors.DuoColorIcon.empower.default.bg": {
    "value": "var(--fsejRo)",
    "variable": "var(--fsejRo)"
  },
  "colors.DuoColorIcon.empower.default.icon": {
    "value": "var(--wwaYS)",
    "variable": "var(--wwaYS)"
  },
  "colors.DuoColorIcon.empower.onHero.bg": {
    "value": "var(--idINNe)",
    "variable": "var(--idINNe)"
  },
  "colors.DuoColorIcon.empower.onHero.icon": {
    "value": "var(--ihYfog)",
    "variable": "var(--ihYfog)"
  },
  "colors.DuoColorIcon.empower.onImpact.bg": {
    "value": "var(--cIhSOs)",
    "variable": "var(--cIhSOs)"
  },
  "colors.DuoColorIcon.empower.onImpact.icon": {
    "value": "var(--gFeUEe)",
    "variable": "var(--gFeUEe)"
  },
  "colors.DuoColorIcon.info.default.bg": {
    "value": "var(--jrbbit)",
    "variable": "var(--jrbbit)"
  },
  "colors.DuoColorIcon.info.default.icon": {
    "value": "var(--eaEkBX)",
    "variable": "var(--eaEkBX)"
  },
  "colors.DuoColorIcon.info.onHero.bg": {
    "value": "var(--eXqxCz)",
    "variable": "var(--eXqxCz)"
  },
  "colors.DuoColorIcon.info.onHero.icon": {
    "value": "var(--eurwXJ)",
    "variable": "var(--eurwXJ)"
  },
  "colors.DuoColorIcon.info.onImpact.bg": {
    "value": "var(--egHbCR)",
    "variable": "var(--egHbCR)"
  },
  "colors.DuoColorIcon.info.onImpact.icon": {
    "value": "var(--dhYwxz)",
    "variable": "var(--dhYwxz)"
  },
  "colors.DuoColorIcon.success.default.bg": {
    "value": "var(--fsDVUg)",
    "variable": "var(--fsDVUg)"
  },
  "colors.DuoColorIcon.success.default.icon": {
    "value": "var(--kHBhxK)",
    "variable": "var(--kHBhxK)"
  },
  "colors.DuoColorIcon.success.onHero.bg": {
    "value": "var(--frFfVy)",
    "variable": "var(--frFfVy)"
  },
  "colors.DuoColorIcon.success.onHero.icon": {
    "value": "var(--dkVOJE)",
    "variable": "var(--dkVOJE)"
  },
  "colors.DuoColorIcon.success.onImpact.bg": {
    "value": "var(--arXDY)",
    "variable": "var(--arXDY)"
  },
  "colors.DuoColorIcon.success.onImpact.icon": {
    "value": "var(--bWEsSy)",
    "variable": "var(--bWEsSy)"
  },
  "colors.DuoColorIcon.critical.default.bg": {
    "value": "var(--jIjiiM)",
    "variable": "var(--jIjiiM)"
  },
  "colors.DuoColorIcon.critical.default.icon": {
    "value": "var(--dzCsVC)",
    "variable": "var(--dzCsVC)"
  },
  "colors.DuoColorIcon.critical.onHero.bg": {
    "value": "var(--iswUMK)",
    "variable": "var(--iswUMK)"
  },
  "colors.DuoColorIcon.critical.onHero.icon": {
    "value": "var(--eITldM)",
    "variable": "var(--eITldM)"
  },
  "colors.DuoColorIcon.critical.onImpact.bg": {
    "value": "var(--emueWU)",
    "variable": "var(--emueWU)"
  },
  "colors.DuoColorIcon.critical.onImpact.icon": {
    "value": "var(--jEYNCa)",
    "variable": "var(--jEYNCa)"
  },
  "colors.DuoColorIcon.warning.default.bg": {
    "value": "var(--gudAyh)",
    "variable": "var(--gudAyh)"
  },
  "colors.DuoColorIcon.warning.default.icon": {
    "value": "var(--iZMcOj)",
    "variable": "var(--iZMcOj)"
  },
  "colors.DuoColorIcon.warning.onHero.bg": {
    "value": "var(--jublZX)",
    "variable": "var(--jublZX)"
  },
  "colors.DuoColorIcon.warning.onHero.icon": {
    "value": "var(--htTUph)",
    "variable": "var(--htTUph)"
  },
  "colors.DuoColorIcon.warning.onImpact.bg": {
    "value": "var(--hkbHtd)",
    "variable": "var(--hkbHtd)"
  },
  "colors.DuoColorIcon.warning.onImpact.icon": {
    "value": "var(--hssOlL)",
    "variable": "var(--hssOlL)"
  },
  "colors.DuoColorIcon.notify.default.bg": {
    "value": "var(--kFiRjk)",
    "variable": "var(--kFiRjk)"
  },
  "colors.DuoColorIcon.notify.default.icon": {
    "value": "var(--hgknoy)",
    "variable": "var(--hgknoy)"
  },
  "colors.DuoColorIcon.notify.onHero.bg": {
    "value": "var(--drsJfa)",
    "variable": "var(--drsJfa)"
  },
  "colors.DuoColorIcon.notify.onHero.icon": {
    "value": "var(--kddxSA)",
    "variable": "var(--kddxSA)"
  },
  "colors.DuoColorIcon.notify.onImpact.bg": {
    "value": "var(--hFpfug)",
    "variable": "var(--hFpfug)"
  },
  "colors.DuoColorIcon.notify.onImpact.icon": {
    "value": "var(--jNzQAa)",
    "variable": "var(--jNzQAa)"
  },
  "colors.FieldSet.HelperArea.icon.default": {
    "value": "var(--hrqSrg)",
    "variable": "var(--hrqSrg)"
  },
  "colors.FieldSet.HelperArea.icon.error": {
    "value": "var(--eghtvv)",
    "variable": "var(--eghtvv)"
  },
  "colors.FieldSet.HelperArea.text.default": {
    "value": "var(--isXJdG)",
    "variable": "var(--isXJdG)"
  },
  "colors.FieldSet.HelperArea.text.error": {
    "value": "var(--bFFtWV)",
    "variable": "var(--bFFtWV)"
  },
  "colors.FieldSet.LabelArea.indicator.optional": {
    "value": "var(--odPXr)",
    "variable": "var(--odPXr)"
  },
  "colors.FieldSet.LabelArea.indicator.required": {
    "value": "var(--fnBrAA)",
    "variable": "var(--fnBrAA)"
  },
  "colors.FieldSet.LabelArea.label.default": {
    "value": "var(--GxeCN)",
    "variable": "var(--GxeCN)"
  },
  "colors.FormField.HelperArea.icon.default": {
    "value": "var(--hfgYkM)",
    "variable": "var(--hfgYkM)"
  },
  "colors.FormField.HelperArea.icon.error": {
    "value": "var(--hlarSD)",
    "variable": "var(--hlarSD)"
  },
  "colors.FormField.HelperArea.icon.readOnly": {
    "value": "var(--hHkgaJ)",
    "variable": "var(--hHkgaJ)"
  },
  "colors.FormField.HelperArea.text.default": {
    "value": "var(--fSBGKi)",
    "variable": "var(--fSBGKi)"
  },
  "colors.FormField.HelperArea.text.error": {
    "value": "var(--enGqvh)",
    "variable": "var(--enGqvh)"
  },
  "colors.FormField.HelperArea.text.readOnly": {
    "value": "var(--kFGivr)",
    "variable": "var(--kFGivr)"
  },
  "colors.FormField.LabelArea.indicator.optional": {
    "value": "var(--cnDdSH)",
    "variable": "var(--cnDdSH)"
  },
  "colors.FormField.LabelArea.indicator.readOnly": {
    "value": "var(--kEMtcX)",
    "variable": "var(--kEMtcX)"
  },
  "colors.FormField.LabelArea.indicator.required": {
    "value": "var(--boSLPI)",
    "variable": "var(--boSLPI)"
  },
  "colors.FormField.LabelArea.label.default": {
    "value": "var(--AjoQB)",
    "variable": "var(--AjoQB)"
  },
  "colors.FormField.LabelArea.label.readOnly": {
    "value": "var(--eLNgpI)",
    "variable": "var(--eLNgpI)"
  },
  "colors.Gleam.bg": {
    "value": "var(--bZNMQe)",
    "variable": "var(--bZNMQe)"
  },
  "colors.Gleam.text": {
    "value": "var(--coCPeu)",
    "variable": "var(--coCPeu)"
  },
  "colors.Gleam.info.bg": {
    "value": "var(--iAKbnB)",
    "variable": "var(--iAKbnB)"
  },
  "colors.Gleam.info.text": {
    "value": "var(--ekaIcp)",
    "variable": "var(--ekaIcp)"
  },
  "colors.Gleam.new.bg": {
    "value": "var(--bGRRQL)",
    "variable": "var(--bGRRQL)"
  },
  "colors.Gleam.new.text": {
    "value": "var(--bGGMHX)",
    "variable": "var(--bGGMHX)"
  },
  "colors.Gleam.onImpact.info.bg": {
    "value": "var(--kgpduH)",
    "variable": "var(--kgpduH)"
  },
  "colors.Gleam.onImpact.info.text": {
    "value": "var(--kwPshT)",
    "variable": "var(--kwPshT)"
  },
  "colors.Gleam.onImpact.new.bg": {
    "value": "var(--iRcscR)",
    "variable": "var(--iRcscR)"
  },
  "colors.Gleam.onImpact.new.text": {
    "value": "var(--jOmhyB)",
    "variable": "var(--jOmhyB)"
  },
  "colors.IconButton.filled.brand.bg.default": {
    "value": "var(--dvJySq)",
    "variable": "var(--dvJySq)"
  },
  "colors.IconButton.filled.brand.bg.hover": {
    "value": "var(--ezxfBb)",
    "variable": "var(--ezxfBb)"
  },
  "colors.IconButton.filled.brand.bg.pressed": {
    "value": "var(--iceXmn)",
    "variable": "var(--iceXmn)"
  },
  "colors.IconButton.filled.brand.border.default": {
    "value": "var(--bmyxNn)",
    "variable": "var(--bmyxNn)"
  },
  "colors.IconButton.filled.brand.border.hover": {
    "value": "var(--iYdCom)",
    "variable": "var(--iYdCom)"
  },
  "colors.IconButton.filled.brand.border.pressed": {
    "value": "var(--fLPqEm)",
    "variable": "var(--fLPqEm)"
  },
  "colors.IconButton.filled.brand.icon.default": {
    "value": "var(--clNfwg)",
    "variable": "var(--clNfwg)"
  },
  "colors.IconButton.filled.brand.icon.hover": {
    "value": "var(--dcTRHF)",
    "variable": "var(--dcTRHF)"
  },
  "colors.IconButton.filled.brand.icon.pressed": {
    "value": "var(--gIZawl)",
    "variable": "var(--gIZawl)"
  },
  "colors.IconButton.filled.critical.bg.default": {
    "value": "var(--iOHmnm)",
    "variable": "var(--iOHmnm)"
  },
  "colors.IconButton.filled.critical.bg.hover": {
    "value": "var(--icsJsf)",
    "variable": "var(--icsJsf)"
  },
  "colors.IconButton.filled.critical.bg.pressed": {
    "value": "var(--dicMSn)",
    "variable": "var(--dicMSn)"
  },
  "colors.IconButton.filled.critical.icon.default": {
    "value": "var(--dhgNY)",
    "variable": "var(--dhgNY)"
  },
  "colors.IconButton.filled.critical.icon.hover": {
    "value": "var(--laQAGZ)",
    "variable": "var(--laQAGZ)"
  },
  "colors.IconButton.filled.critical.icon.pressed": {
    "value": "var(--fUCmfp)",
    "variable": "var(--fUCmfp)"
  },
  "colors.IconButton.filled.critical.border.default": {
    "value": "var(--YGdJT)",
    "variable": "var(--YGdJT)"
  },
  "colors.IconButton.filled.critical.border.hover": {
    "value": "var(--gEiDxy)",
    "variable": "var(--gEiDxy)"
  },
  "colors.IconButton.filled.critical.border.pressed": {
    "value": "var(--kHfooC)",
    "variable": "var(--kHfooC)"
  },
  "colors.IconButton.outlined.brand.bg.default": {
    "value": "var(--jqepgI)",
    "variable": "var(--jqepgI)"
  },
  "colors.IconButton.outlined.brand.bg.hover": {
    "value": "var(--cnXmNB)",
    "variable": "var(--cnXmNB)"
  },
  "colors.IconButton.outlined.brand.bg.pressed": {
    "value": "var(--fUcvCh)",
    "variable": "var(--fUcvCh)"
  },
  "colors.IconButton.outlined.brand.icon.default": {
    "value": "var(--cuWtPa)",
    "variable": "var(--cuWtPa)"
  },
  "colors.IconButton.outlined.brand.icon.hover": {
    "value": "var(--bfEQij)",
    "variable": "var(--bfEQij)"
  },
  "colors.IconButton.outlined.brand.icon.pressed": {
    "value": "var(--jiMnXf)",
    "variable": "var(--jiMnXf)"
  },
  "colors.IconButton.outlined.brand.border.default": {
    "value": "var(--hqQnNN)",
    "variable": "var(--hqQnNN)"
  },
  "colors.IconButton.outlined.brand.border.hover": {
    "value": "var(--fWObKo)",
    "variable": "var(--fWObKo)"
  },
  "colors.IconButton.outlined.brand.border.pressed": {
    "value": "var(--guYcqo)",
    "variable": "var(--guYcqo)"
  },
  "colors.IconButton.outlined.neutral.bg.default": {
    "value": "var(--deHLOu)",
    "variable": "var(--deHLOu)"
  },
  "colors.IconButton.outlined.neutral.bg.hover": {
    "value": "var(--jnHXJD)",
    "variable": "var(--jnHXJD)"
  },
  "colors.IconButton.outlined.neutral.bg.pressed": {
    "value": "var(--gbtLZD)",
    "variable": "var(--gbtLZD)"
  },
  "colors.IconButton.outlined.neutral.bg.selected": {
    "value": "var(--nVvAU)",
    "variable": "var(--nVvAU)"
  },
  "colors.IconButton.outlined.neutral.bg.selectedHover": {
    "value": "var(--kRYTbC)",
    "variable": "var(--kRYTbC)"
  },
  "colors.IconButton.outlined.neutral.bg.selectedPressed": {
    "value": "var(--IGkwi)",
    "variable": "var(--IGkwi)"
  },
  "colors.IconButton.outlined.neutral.icon.default": {
    "value": "var(--fWxUgY)",
    "variable": "var(--fWxUgY)"
  },
  "colors.IconButton.outlined.neutral.icon.hover": {
    "value": "var(--entDuN)",
    "variable": "var(--entDuN)"
  },
  "colors.IconButton.outlined.neutral.icon.pressed": {
    "value": "var(--eLDEaN)",
    "variable": "var(--eLDEaN)"
  },
  "colors.IconButton.outlined.neutral.icon.selected": {
    "value": "var(--ccDoBS)",
    "variable": "var(--ccDoBS)"
  },
  "colors.IconButton.outlined.neutral.icon.selectedHover": {
    "value": "var(--kRrYLk)",
    "variable": "var(--kRrYLk)"
  },
  "colors.IconButton.outlined.neutral.icon.selectedPressed": {
    "value": "var(--gJzGGU)",
    "variable": "var(--gJzGGU)"
  },
  "colors.IconButton.outlined.neutral.border.default": {
    "value": "var(--fQVMxH)",
    "variable": "var(--fQVMxH)"
  },
  "colors.IconButton.outlined.neutral.border.hover": {
    "value": "var(--yJGGG)",
    "variable": "var(--yJGGG)"
  },
  "colors.IconButton.outlined.neutral.border.pressed": {
    "value": "var(--keazKa)",
    "variable": "var(--keazKa)"
  },
  "colors.IconButton.outlined.neutral.border.selected": {
    "value": "var(--kTWKIh)",
    "variable": "var(--kTWKIh)"
  },
  "colors.IconButton.outlined.neutral.border.selectedHover": {
    "value": "var(--jAqoUr)",
    "variable": "var(--jAqoUr)"
  },
  "colors.IconButton.outlined.neutral.border.selectedPressed": {
    "value": "var(--hHsAuz)",
    "variable": "var(--hHsAuz)"
  },
  "colors.IconButton.outlined.neutral-fixed.bg.default": {
    "value": "var(--eKcMJJ)",
    "variable": "var(--eKcMJJ)"
  },
  "colors.IconButton.outlined.neutral-fixed.bg.hover": {
    "value": "var(--fyrHms)",
    "variable": "var(--fyrHms)"
  },
  "colors.IconButton.outlined.neutral-fixed.bg.pressed": {
    "value": "var(--bWxFpw)",
    "variable": "var(--bWxFpw)"
  },
  "colors.IconButton.outlined.neutral-fixed.icon.default": {
    "value": "var(--jwfEQP)",
    "variable": "var(--jwfEQP)"
  },
  "colors.IconButton.outlined.neutral-fixed.icon.hover": {
    "value": "var(--iilEIu)",
    "variable": "var(--iilEIu)"
  },
  "colors.IconButton.outlined.neutral-fixed.icon.pressed": {
    "value": "var(--jooFBW)",
    "variable": "var(--jooFBW)"
  },
  "colors.IconButton.outlined.neutral-fixed.border.default": {
    "value": "var(--eEFeso)",
    "variable": "var(--eEFeso)"
  },
  "colors.IconButton.outlined.neutral-fixed.border.hover": {
    "value": "var(--dDfkJ)",
    "variable": "var(--dDfkJ)"
  },
  "colors.IconButton.outlined.neutral-fixed.border.pressed": {
    "value": "var(--hlgwFp)",
    "variable": "var(--hlgwFp)"
  },
  "colors.IconButton.outlined.critical.bg.default": {
    "value": "var(--dHFBbw)",
    "variable": "var(--dHFBbw)"
  },
  "colors.IconButton.outlined.critical.bg.hover": {
    "value": "var(--csBkUF)",
    "variable": "var(--csBkUF)"
  },
  "colors.IconButton.outlined.critical.bg.pressed": {
    "value": "var(--iBIFRR)",
    "variable": "var(--iBIFRR)"
  },
  "colors.IconButton.outlined.critical.icon.default": {
    "value": "var(--fjrRsC)",
    "variable": "var(--fjrRsC)"
  },
  "colors.IconButton.outlined.critical.icon.hover": {
    "value": "var(--eGyCQr)",
    "variable": "var(--eGyCQr)"
  },
  "colors.IconButton.outlined.critical.icon.pressed": {
    "value": "var(--iJvnHv)",
    "variable": "var(--iJvnHv)"
  },
  "colors.IconButton.outlined.critical.border.default": {
    "value": "var(--kczgAl)",
    "variable": "var(--kczgAl)"
  },
  "colors.IconButton.outlined.critical.border.hover": {
    "value": "var(--fNXTDQ)",
    "variable": "var(--fNXTDQ)"
  },
  "colors.IconButton.outlined.critical.border.pressed": {
    "value": "var(--grZtpI)",
    "variable": "var(--grZtpI)"
  },
  "colors.IconButton.bare.brand.bg.default": {
    "value": "var(--ljGzUs)",
    "variable": "var(--ljGzUs)"
  },
  "colors.IconButton.bare.brand.bg.hover": {
    "value": "var(--fNSXd)",
    "variable": "var(--fNSXd)"
  },
  "colors.IconButton.bare.brand.bg.pressed": {
    "value": "var(--bPqIKh)",
    "variable": "var(--bPqIKh)"
  },
  "colors.IconButton.bare.brand.icon.default": {
    "value": "var(--cdjYsS)",
    "variable": "var(--cdjYsS)"
  },
  "colors.IconButton.bare.brand.icon.hover": {
    "value": "var(--fYdFBn)",
    "variable": "var(--fYdFBn)"
  },
  "colors.IconButton.bare.brand.icon.pressed": {
    "value": "var(--jALxmz)",
    "variable": "var(--jALxmz)"
  },
  "colors.IconButton.bare.neutral.bg.default": {
    "value": "var(--gskhNy)",
    "variable": "var(--gskhNy)"
  },
  "colors.IconButton.bare.neutral.bg.hover": {
    "value": "var(--hjDEob)",
    "variable": "var(--hjDEob)"
  },
  "colors.IconButton.bare.neutral.bg.pressed": {
    "value": "var(--kMlvZn)",
    "variable": "var(--kMlvZn)"
  },
  "colors.IconButton.bare.neutral.icon.default": {
    "value": "var(--Cvsvw)",
    "variable": "var(--Cvsvw)"
  },
  "colors.IconButton.bare.neutral.icon.hover": {
    "value": "var(--iINgrJ)",
    "variable": "var(--iINgrJ)"
  },
  "colors.IconButton.bare.neutral.icon.pressed": {
    "value": "var(--ZwFHt)",
    "variable": "var(--ZwFHt)"
  },
  "colors.IconButton.bare.neutral-fixed.bg.default": {
    "value": "var(--kXIgrB)",
    "variable": "var(--kXIgrB)"
  },
  "colors.IconButton.bare.neutral-fixed.bg.hover": {
    "value": "var(--cGQDpg)",
    "variable": "var(--cGQDpg)"
  },
  "colors.IconButton.bare.neutral-fixed.bg.pressed": {
    "value": "var(--dfaDVg)",
    "variable": "var(--dfaDVg)"
  },
  "colors.IconButton.bare.neutral-fixed.icon.default": {
    "value": "var(--jobgjT)",
    "variable": "var(--jobgjT)"
  },
  "colors.IconButton.bare.neutral-fixed.icon.hover": {
    "value": "var(--ldNilW)",
    "variable": "var(--ldNilW)"
  },
  "colors.IconButton.bare.neutral-fixed.icon.pressed": {
    "value": "var(--jtIrQu)",
    "variable": "var(--jtIrQu)"
  },
  "colors.IconButton.bare.critical.bg.default": {
    "value": "var(--cpGQaQ)",
    "variable": "var(--cpGQaQ)"
  },
  "colors.IconButton.bare.critical.bg.hover": {
    "value": "var(--ejSaTd)",
    "variable": "var(--ejSaTd)"
  },
  "colors.IconButton.bare.critical.bg.pressed": {
    "value": "var(--ivhWKx)",
    "variable": "var(--ivhWKx)"
  },
  "colors.IconButton.bare.critical.icon.default": {
    "value": "var(--jqqqe)",
    "variable": "var(--jqqqe)"
  },
  "colors.IconButton.bare.critical.icon.hover": {
    "value": "var(--ivmxYr)",
    "variable": "var(--ivmxYr)"
  },
  "colors.IconButton.bare.critical.icon.pressed": {
    "value": "var(--dAWByz)",
    "variable": "var(--dAWByz)"
  },
  "colors.IconButton.onImpact.filled.brand.bg.default": {
    "value": "var(--hqPSqU)",
    "variable": "var(--hqPSqU)"
  },
  "colors.IconButton.onImpact.filled.brand.bg.hover": {
    "value": "var(--hktgUl)",
    "variable": "var(--hktgUl)"
  },
  "colors.IconButton.onImpact.filled.brand.bg.pressed": {
    "value": "var(--hOuGGd)",
    "variable": "var(--hOuGGd)"
  },
  "colors.IconButton.onImpact.filled.brand.icon.default": {
    "value": "var(--dvWigO)",
    "variable": "var(--dvWigO)"
  },
  "colors.IconButton.onImpact.filled.brand.icon.hover": {
    "value": "var(--gOIoYf)",
    "variable": "var(--gOIoYf)"
  },
  "colors.IconButton.onImpact.filled.brand.icon.pressed": {
    "value": "var(--dcFTKT)",
    "variable": "var(--dcFTKT)"
  },
  "colors.IconButton.onImpact.filled.brand.border.default": {
    "value": "var(--ipdIyN)",
    "variable": "var(--ipdIyN)"
  },
  "colors.IconButton.onImpact.filled.brand.border.hover": {
    "value": "var(--cXWEuA)",
    "variable": "var(--cXWEuA)"
  },
  "colors.IconButton.onImpact.filled.brand.border.pressed": {
    "value": "var(--fVFeSA)",
    "variable": "var(--fVFeSA)"
  },
  "colors.IconButton.onImpact.filled.neutral-fixed.bg.default": {
    "value": "var(--djOBKB)",
    "variable": "var(--djOBKB)"
  },
  "colors.IconButton.onImpact.filled.neutral-fixed.bg.hover": {
    "value": "var(--bZEnXY)",
    "variable": "var(--bZEnXY)"
  },
  "colors.IconButton.onImpact.filled.neutral-fixed.bg.pressed": {
    "value": "var(--imzIwE)",
    "variable": "var(--imzIwE)"
  },
  "colors.IconButton.onImpact.filled.neutral-fixed.icon.default": {
    "value": "var(--hvGkSf)",
    "variable": "var(--hvGkSf)"
  },
  "colors.IconButton.onImpact.filled.neutral-fixed.icon.hover": {
    "value": "var(--gXydMq)",
    "variable": "var(--gXydMq)"
  },
  "colors.IconButton.onImpact.filled.neutral-fixed.icon.pressed": {
    "value": "var(--kSZeKO)",
    "variable": "var(--kSZeKO)"
  },
  "colors.IconButton.onImpact.filled.neutral-fixed.border.default": {
    "value": "var(--hbJClw)",
    "variable": "var(--hbJClw)"
  },
  "colors.IconButton.onImpact.filled.neutral-fixed.border.hover": {
    "value": "var(--iyKEZd)",
    "variable": "var(--iyKEZd)"
  },
  "colors.IconButton.onImpact.filled.neutral-fixed.border.pressed": {
    "value": "var(--DWaEN)",
    "variable": "var(--DWaEN)"
  },
  "colors.IconButton.onImpact.filled.critical.bg.default": {
    "value": "var(--kqegKU)",
    "variable": "var(--kqegKU)"
  },
  "colors.IconButton.onImpact.filled.critical.bg.hover": {
    "value": "var(--hDTWat)",
    "variable": "var(--hDTWat)"
  },
  "colors.IconButton.onImpact.filled.critical.bg.pressed": {
    "value": "var(--iJWWTV)",
    "variable": "var(--iJWWTV)"
  },
  "colors.IconButton.onImpact.filled.critical.icon.default": {
    "value": "var(--hAUECa)",
    "variable": "var(--hAUECa)"
  },
  "colors.IconButton.onImpact.filled.critical.icon.hover": {
    "value": "var(--euBmwL)",
    "variable": "var(--euBmwL)"
  },
  "colors.IconButton.onImpact.filled.critical.icon.pressed": {
    "value": "var(--mIUsv)",
    "variable": "var(--mIUsv)"
  },
  "colors.IconButton.onImpact.filled.critical.border.pressed": {
    "value": "var(--DqBhE)",
    "variable": "var(--DqBhE)"
  },
  "colors.IconButton.onImpact.outlined.brand.bg.default": {
    "value": "var(--dnOeDa)",
    "variable": "var(--dnOeDa)"
  },
  "colors.IconButton.onImpact.outlined.brand.bg.hover": {
    "value": "var(--dQtJvv)",
    "variable": "var(--dQtJvv)"
  },
  "colors.IconButton.onImpact.outlined.brand.bg.pressed": {
    "value": "var(--eroij)",
    "variable": "var(--eroij)"
  },
  "colors.IconButton.onImpact.outlined.brand.icon.default": {
    "value": "var(--eMqANE)",
    "variable": "var(--eMqANE)"
  },
  "colors.IconButton.onImpact.outlined.brand.icon.hover": {
    "value": "var(--jyCcdl)",
    "variable": "var(--jyCcdl)"
  },
  "colors.IconButton.onImpact.outlined.brand.icon.pressed": {
    "value": "var(--bgOTcp)",
    "variable": "var(--bgOTcp)"
  },
  "colors.IconButton.onImpact.outlined.brand.border.default": {
    "value": "var(--FnGeD)",
    "variable": "var(--FnGeD)"
  },
  "colors.IconButton.onImpact.outlined.brand.border.hover": {
    "value": "var(--hiBLpK)",
    "variable": "var(--hiBLpK)"
  },
  "colors.IconButton.onImpact.outlined.brand.border.pressed": {
    "value": "var(--fMuwqG)",
    "variable": "var(--fMuwqG)"
  },
  "colors.IconButton.onImpact.outlined.neutral.bg.default": {
    "value": "var(--eKdskc)",
    "variable": "var(--eKdskc)"
  },
  "colors.IconButton.onImpact.outlined.neutral.bg.hover": {
    "value": "var(--jymxuh)",
    "variable": "var(--jymxuh)"
  },
  "colors.IconButton.onImpact.outlined.neutral.bg.pressed": {
    "value": "var(--bgzotl)",
    "variable": "var(--bgzotl)"
  },
  "colors.IconButton.onImpact.outlined.neutral.icon.default": {
    "value": "var(--ekTlty)",
    "variable": "var(--ekTlty)"
  },
  "colors.IconButton.onImpact.outlined.neutral.icon.hover": {
    "value": "var(--epfGxD)",
    "variable": "var(--epfGxD)"
  },
  "colors.IconButton.onImpact.outlined.neutral.icon.pressed": {
    "value": "var(--cSYryz)",
    "variable": "var(--cSYryz)"
  },
  "colors.IconButton.onImpact.outlined.neutral.border.default": {
    "value": "var(--hwCIbp)",
    "variable": "var(--hwCIbp)"
  },
  "colors.IconButton.onImpact.outlined.neutral.border.hover": {
    "value": "var(--fDoyZY)",
    "variable": "var(--fDoyZY)"
  },
  "colors.IconButton.onImpact.outlined.neutral.border.pressed": {
    "value": "var(--AOjZI)",
    "variable": "var(--AOjZI)"
  },
  "colors.IconButton.onImpact.outlined.neutral-fixed.bg.default": {
    "value": "var(--dMqSDT)",
    "variable": "var(--dMqSDT)"
  },
  "colors.IconButton.onImpact.outlined.neutral-fixed.bg.hover": {
    "value": "var(--cWEgoe)",
    "variable": "var(--cWEgoe)"
  },
  "colors.IconButton.onImpact.outlined.neutral-fixed.bg.pressed": {
    "value": "var(--gSfhmC)",
    "variable": "var(--gSfhmC)"
  },
  "colors.IconButton.onImpact.outlined.neutral-fixed.icon.default": {
    "value": "var(--jFHxQN)",
    "variable": "var(--jFHxQN)"
  },
  "colors.IconButton.onImpact.outlined.neutral-fixed.icon.hover": {
    "value": "var(--egDNXo)",
    "variable": "var(--egDNXo)"
  },
  "colors.IconButton.onImpact.outlined.neutral-fixed.icon.pressed": {
    "value": "var(--hBkTbU)",
    "variable": "var(--hBkTbU)"
  },
  "colors.IconButton.onImpact.outlined.neutral-fixed.border.default": {
    "value": "var(--dbwvlm)",
    "variable": "var(--dbwvlm)"
  },
  "colors.IconButton.onImpact.outlined.neutral-fixed.border.hover": {
    "value": "var(--fZYKnr)",
    "variable": "var(--fZYKnr)"
  },
  "colors.IconButton.onImpact.outlined.neutral-fixed.border.pressed": {
    "value": "var(--llOijH)",
    "variable": "var(--llOijH)"
  },
  "colors.IconButton.onImpact.outlined.critical.bg.default": {
    "value": "var(--dolgAS)",
    "variable": "var(--dolgAS)"
  },
  "colors.IconButton.onImpact.outlined.critical.bg.hover": {
    "value": "var(--kYducX)",
    "variable": "var(--kYducX)"
  },
  "colors.IconButton.onImpact.outlined.critical.bg.pressed": {
    "value": "var(--gQlbYH)",
    "variable": "var(--gQlbYH)"
  },
  "colors.IconButton.onImpact.outlined.critical.icon.default": {
    "value": "var(--bEmATw)",
    "variable": "var(--bEmATw)"
  },
  "colors.IconButton.onImpact.outlined.critical.icon.hover": {
    "value": "var(--fLdOXJ)",
    "variable": "var(--fLdOXJ)"
  },
  "colors.IconButton.onImpact.outlined.critical.icon.pressed": {
    "value": "var(--dSgaxR)",
    "variable": "var(--dSgaxR)"
  },
  "colors.IconButton.onImpact.outlined.critical.border.default": {
    "value": "var(--gIbRnP)",
    "variable": "var(--gIbRnP)"
  },
  "colors.IconButton.onImpact.outlined.critical.border.hover": {
    "value": "var(--kJJWsi)",
    "variable": "var(--kJJWsi)"
  },
  "colors.IconButton.onImpact.outlined.critical.border.pressed": {
    "value": "var(--cmRXSW)",
    "variable": "var(--cmRXSW)"
  },
  "colors.IconButton.onImpact.bare.brand.bg.default": {
    "value": "var(--eWoEFO)",
    "variable": "var(--eWoEFO)"
  },
  "colors.IconButton.onImpact.bare.brand.bg.hover": {
    "value": "var(--bIFjZn)",
    "variable": "var(--bIFjZn)"
  },
  "colors.IconButton.onImpact.bare.brand.bg.pressed": {
    "value": "var(--fLBUQr)",
    "variable": "var(--fLBUQr)"
  },
  "colors.IconButton.onImpact.bare.brand.icon.default": {
    "value": "var(--GqVFE)",
    "variable": "var(--GqVFE)"
  },
  "colors.IconButton.onImpact.bare.brand.icon.hover": {
    "value": "var(--dxZSYp)",
    "variable": "var(--dxZSYp)"
  },
  "colors.IconButton.onImpact.bare.brand.icon.pressed": {
    "value": "var(--ecbsKh)",
    "variable": "var(--ecbsKh)"
  },
  "colors.IconButton.onImpact.bare.neutral.bg.default": {
    "value": "var(--gnOZlU)",
    "variable": "var(--gnOZlU)"
  },
  "colors.IconButton.onImpact.bare.neutral.bg.hover": {
    "value": "var(--emtoAp)",
    "variable": "var(--emtoAp)"
  },
  "colors.IconButton.onImpact.bare.neutral.bg.pressed": {
    "value": "var(--eQuOmh)",
    "variable": "var(--eQuOmh)"
  },
  "colors.IconButton.onImpact.bare.neutral.icon.default": {
    "value": "var(--kTXJaK)",
    "variable": "var(--kTXJaK)"
  },
  "colors.IconButton.onImpact.bare.neutral.icon.hover": {
    "value": "var(--hmeSxn)",
    "variable": "var(--hmeSxn)"
  },
  "colors.IconButton.onImpact.bare.neutral.icon.pressed": {
    "value": "var(--dAcxkb)",
    "variable": "var(--dAcxkb)"
  },
  "colors.IconButton.onImpact.bare.neutral-fixed.bg.default": {
    "value": "var(--hiyBtv)",
    "variable": "var(--hiyBtv)"
  },
  "colors.IconButton.onImpact.bare.neutral-fixed.bg.hover": {
    "value": "var(--dIdlqC)",
    "variable": "var(--dIdlqC)"
  },
  "colors.IconButton.onImpact.bare.neutral-fixed.bg.pressed": {
    "value": "var(--clVWry)",
    "variable": "var(--clVWry)"
  },
  "colors.IconButton.onImpact.bare.neutral-fixed.icon.default": {
    "value": "var(--eEIJZJ)",
    "variable": "var(--eEIJZJ)"
  },
  "colors.IconButton.onImpact.bare.neutral-fixed.icon.hover": {
    "value": "var(--kDYgqI)",
    "variable": "var(--kDYgqI)"
  },
  "colors.IconButton.onImpact.bare.neutral-fixed.icon.pressed": {
    "value": "var(--fBxRqs)",
    "variable": "var(--fBxRqs)"
  },
  "colors.IconButton.onImpact.bare.critical.bg.default": {
    "value": "var(--jUsqrW)",
    "variable": "var(--jUsqrW)"
  },
  "colors.IconButton.onImpact.bare.critical.bg.hover": {
    "value": "var(--fCasiP)",
    "variable": "var(--fCasiP)"
  },
  "colors.IconButton.onImpact.bare.critical.bg.pressed": {
    "value": "var(--cagqlT)",
    "variable": "var(--cagqlT)"
  },
  "colors.IconButton.onImpact.bare.critical.icon.default": {
    "value": "var(--knibKk)",
    "variable": "var(--knibKk)"
  },
  "colors.IconButton.onImpact.bare.critical.icon.hover": {
    "value": "var(--dyYDgF)",
    "variable": "var(--dyYDgF)"
  },
  "colors.IconButton.onImpact.bare.critical.icon.pressed": {
    "value": "var(--eFbEah)",
    "variable": "var(--eFbEah)"
  },
  "colors.InlineFeedback.critical.icon": {
    "value": "var(--bxPeZQ)",
    "variable": "var(--bxPeZQ)"
  },
  "colors.InlineFeedback.critical.text": {
    "value": "var(--fwPeNK)",
    "variable": "var(--fwPeNK)"
  },
  "colors.InlineFeedback.info.icon": {
    "value": "var(--ieWlTV)",
    "variable": "var(--ieWlTV)"
  },
  "colors.InlineFeedback.info.text": {
    "value": "var(--gagxnb)",
    "variable": "var(--gagxnb)"
  },
  "colors.InlineFeedback.success.icon": {
    "value": "var(--cgweLk)",
    "variable": "var(--cgweLk)"
  },
  "colors.InlineFeedback.success.text": {
    "value": "var(--ezjNlS)",
    "variable": "var(--ezjNlS)"
  },
  "colors.InlineFeedback.transient.icon": {
    "value": "var(--YUNLn)",
    "variable": "var(--YUNLn)"
  },
  "colors.InlineFeedback.transient.text": {
    "value": "var(--fjExqN)",
    "variable": "var(--fjExqN)"
  },
  "colors.InlineFeedback.warning.icon": {
    "value": "var(--gqOPtB)",
    "variable": "var(--gqOPtB)"
  },
  "colors.InlineFeedback.warning.text": {
    "value": "var(--dRsCDT)",
    "variable": "var(--dRsCDT)"
  },
  "colors.Input.HelperArea.icon.default": {
    "value": "var(--bQcTpq)",
    "variable": "var(--bQcTpq)"
  },
  "colors.Input.HelperArea.icon.error": {
    "value": "var(--eLgmMh)",
    "variable": "var(--eLgmMh)"
  },
  "colors.Input.HelperArea.icon.readOnly": {
    "value": "var(--docmQz)",
    "variable": "var(--docmQz)"
  },
  "colors.Input.HelperArea.text.default": {
    "value": "var(--dAigKk)",
    "variable": "var(--dAigKk)"
  },
  "colors.Input.HelperArea.text.error": {
    "value": "var(--fOqIyP)",
    "variable": "var(--fOqIyP)"
  },
  "colors.Input.HelperArea.text.readOnly": {
    "value": "var(--goMhnJ)",
    "variable": "var(--goMhnJ)"
  },
  "colors.Input.bg.active": {
    "value": "var(--hglhTL)",
    "variable": "var(--hglhTL)"
  },
  "colors.Input.bg.activeHover": {
    "value": "var(--fjalzB)",
    "variable": "var(--fjalzB)"
  },
  "colors.Input.bg.autofill": {
    "value": "var(--eokPZj)",
    "variable": "var(--eokPZj)"
  },
  "colors.Input.bg.default": {
    "value": "var(--OCtIg)",
    "variable": "var(--OCtIg)"
  },
  "colors.Input.bg.error": {
    "value": "var(--kwaLaD)",
    "variable": "var(--kwaLaD)"
  },
  "colors.Input.bg.errorActive": {
    "value": "var(--hgBcTD)",
    "variable": "var(--hgBcTD)"
  },
  "colors.Input.bg.errorHover": {
    "value": "var(--PzODN)",
    "variable": "var(--PzODN)"
  },
  "colors.Input.bg.hover": {
    "value": "var(--brKooB)",
    "variable": "var(--brKooB)"
  },
  "colors.Input.bg.readOnly": {
    "value": "var(--igEWCd)",
    "variable": "var(--igEWCd)"
  },
  "colors.Input.border.active": {
    "value": "var(--bMchXS)",
    "variable": "var(--bMchXS)"
  },
  "colors.Input.border.activeHover": {
    "value": "var(--kBNGQU)",
    "variable": "var(--kBNGQU)"
  },
  "colors.Input.border.default": {
    "value": "var(--lhtgsV)",
    "variable": "var(--lhtgsV)"
  },
  "colors.Input.border.error": {
    "value": "var(--oKXSe)",
    "variable": "var(--oKXSe)"
  },
  "colors.Input.border.errorActive": {
    "value": "var(--kUoYOi)",
    "variable": "var(--kUoYOi)"
  },
  "colors.Input.border.errorHover": {
    "value": "var(--iEVrhM)",
    "variable": "var(--iEVrhM)"
  },
  "colors.Input.border.hover": {
    "value": "var(--jqYOeQ)",
    "variable": "var(--jqYOeQ)"
  },
  "colors.Input.icon.leading.default": {
    "value": "var(--kKBDKX)",
    "variable": "var(--kKBDKX)"
  },
  "colors.Input.icon.leading.readOnly": {
    "value": "var(--ffTBdW)",
    "variable": "var(--ffTBdW)"
  },
  "colors.Input.icon.trailing.default": {
    "value": "var(--jwgxPB)",
    "variable": "var(--jwgxPB)"
  },
  "colors.Input.icon.trailing.readOnly": {
    "value": "var(--inIHms)",
    "variable": "var(--inIHms)"
  },
  "colors.Input.text.adornment.default": {
    "value": "var(--eIYqTR)",
    "variable": "var(--eIYqTR)"
  },
  "colors.Input.text.adornment.readOnly": {
    "value": "var(--fKzadg)",
    "variable": "var(--fKzadg)"
  },
  "colors.Input.text.placeholder": {
    "value": "var(--eaVZGE)",
    "variable": "var(--eaVZGE)"
  },
  "colors.Input.text.populated": {
    "value": "var(--cwElbR)",
    "variable": "var(--cwElbR)"
  },
  "colors.Input.text.readOnly": {
    "value": "var(--kmMtHh)",
    "variable": "var(--kmMtHh)"
  },
  "colors.Input.LabelArea.indicator.optional": {
    "value": "var(--hiANNh)",
    "variable": "var(--hiANNh)"
  },
  "colors.Input.LabelArea.indicator.readOnly": {
    "value": "var(--kHUmId)",
    "variable": "var(--kHUmId)"
  },
  "colors.Input.LabelArea.indicator.required": {
    "value": "var(--cpUVhi)",
    "variable": "var(--cpUVhi)"
  },
  "colors.Input.LabelArea.label.default": {
    "value": "var(--kUQiGH)",
    "variable": "var(--kUQiGH)"
  },
  "colors.Input.LabelArea.label.readOnly": {
    "value": "var(--irSslq)",
    "variable": "var(--irSslq)"
  },
  "colors.Label.text.default": {
    "value": "var(--ejjrXY)",
    "variable": "var(--ejjrXY)"
  },
  "colors.Label.text.hover": {
    "value": "var(--irsPAJ)",
    "variable": "var(--irsPAJ)"
  },
  "colors.Label.text.pressed": {
    "value": "var(--dKTZkd)",
    "variable": "var(--dKTZkd)"
  },
  "colors.Label.text.selected": {
    "value": "var(--dJZdCu)",
    "variable": "var(--dJZdCu)"
  },
  "colors.Label.text.selectedHover": {
    "value": "var(--fasyDU)",
    "variable": "var(--fasyDU)"
  },
  "colors.Label.text.selectedPressed": {
    "value": "var(--hEkYZw)",
    "variable": "var(--hEkYZw)"
  },
  "colors.Label.indicator.required": {
    "value": "var(--jllKtm)",
    "variable": "var(--jllKtm)"
  },
  "colors.Label.indicator.optional": {
    "value": "var(--kARPKp)",
    "variable": "var(--kARPKp)"
  },
  "colors.Label.indicator.readOnly": {
    "value": "var(--Jwwmx)",
    "variable": "var(--Jwwmx)"
  },
  "colors.LabeledControl.label.default": {
    "value": "var(--frNFoJ)",
    "variable": "var(--frNFoJ)"
  },
  "colors.LabeledControl.label.hover": {
    "value": "var(--eIYgjY)",
    "variable": "var(--eIYgjY)"
  },
  "colors.LabeledControl.label.pressed": {
    "value": "var(--guIeuw)",
    "variable": "var(--guIeuw)"
  },
  "colors.LabeledControl.label.selected": {
    "value": "var(--XUBbf)",
    "variable": "var(--XUBbf)"
  },
  "colors.LabeledControl.label.selectedHover": {
    "value": "var(--fBAdlJ)",
    "variable": "var(--fBAdlJ)"
  },
  "colors.LabeledControl.label.selectedPressed": {
    "value": "var(--jhFmap)",
    "variable": "var(--jhFmap)"
  },
  "colors.Layout.Content.bg": {
    "value": "var(--AxtEO)",
    "variable": "var(--AxtEO)"
  },
  "colors.Legend.text.default": {
    "value": "var(--FCmqr)",
    "variable": "var(--FCmqr)"
  },
  "colors.Legend.indicator.required": {
    "value": "var(--nzWVd)",
    "variable": "var(--nzWVd)"
  },
  "colors.Legend.indicator.optional": {
    "value": "var(--bYyCdm)",
    "variable": "var(--bYyCdm)"
  },
  "colors.List.label": {
    "value": "var(--eTaCRt)",
    "variable": "var(--eTaCRt)"
  },
  "colors.List.ol-decorator": {
    "value": "var(--gcBTte)",
    "variable": "var(--gcBTte)"
  },
  "colors.List.ul-decorator": {
    "value": "var(--jiGTNU)",
    "variable": "var(--jiGTNU)"
  },
  "colors.LoadingMask.bg.default": {
    "value": "var(--jEWLRU)",
    "variable": "var(--jEWLRU)"
  },
  "colors.LoadingMask.bg.onImpact": {
    "value": "var(--gqpYUA)",
    "variable": "var(--gqpYUA)"
  },
  "colors.Menu.Heading.bg": {
    "value": "var(--dVaeXK)",
    "variable": "var(--dVaeXK)"
  },
  "colors.Menu.Heading.icon": {
    "value": "var(--hYEgmg)",
    "variable": "var(--hYEgmg)"
  },
  "colors.Menu.Heading.label": {
    "value": "var(--fnZllp)",
    "variable": "var(--fnZllp)"
  },
  "colors.Menu.Content.bg": {
    "value": "var(--fCimob)",
    "variable": "var(--fCimob)"
  },
  "colors.Menu.Group.border": {
    "value": "var(--bOHJQo)",
    "variable": "var(--bOHJQo)"
  },
  "colors.Menu.ItemIcon.icon.default": {
    "value": "var(--jXwSRQ)",
    "variable": "var(--jXwSRQ)"
  },
  "colors.Menu.ItemIcon.icon.hover": {
    "value": "var(--gDBLzh)",
    "variable": "var(--gDBLzh)"
  },
  "colors.Menu.ItemIcon.icon.pressed": {
    "value": "var(--jhulUJ)",
    "variable": "var(--jhulUJ)"
  },
  "colors.Menu.ItemIcon.anchor.icon.default": {
    "value": "var(--kewUUA)",
    "variable": "var(--kewUUA)"
  },
  "colors.Menu.ItemIcon.anchor.icon.hover": {
    "value": "var(--fOrRXB)",
    "variable": "var(--fOrRXB)"
  },
  "colors.Menu.ItemIcon.anchor.icon.pressed": {
    "value": "var(--eSBWsx)",
    "variable": "var(--eSBWsx)"
  },
  "colors.Menu.ItemLabel.text.label.default": {
    "value": "var(--dDcNRQ)",
    "variable": "var(--dDcNRQ)"
  },
  "colors.Menu.ItemLabel.text.label.hover": {
    "value": "var(--hqaqSl)",
    "variable": "var(--hqaqSl)"
  },
  "colors.Menu.ItemLabel.text.label.pressed": {
    "value": "var(--gukvnh)",
    "variable": "var(--gukvnh)"
  },
  "colors.Menu.ItemLabel.text.anchor.label.default": {
    "value": "var(--lnlXTo)",
    "variable": "var(--lnlXTo)"
  },
  "colors.Menu.ItemLabel.text.anchor.label.hover": {
    "value": "var(--jakmyV)",
    "variable": "var(--jakmyV)"
  },
  "colors.Menu.ItemLabel.text.anchor.label.pressed": {
    "value": "var(--jyuneV)",
    "variable": "var(--jyuneV)"
  },
  "colors.Menu.ItemMeta.text.meta.default": {
    "value": "var(--jfkfvI)",
    "variable": "var(--jfkfvI)"
  },
  "colors.Menu.ItemMeta.text.meta.hover": {
    "value": "var(--guyXhF)",
    "variable": "var(--guyXhF)"
  },
  "colors.Menu.ItemMeta.text.meta.pressed": {
    "value": "var(--iihckZ)",
    "variable": "var(--iihckZ)"
  },
  "colors.Menu.Item.bg.default": {
    "value": "var(--cyZqlN)",
    "variable": "var(--cyZqlN)"
  },
  "colors.Menu.Item.bg.hover": {
    "value": "var(--kyfLFs)",
    "variable": "var(--kyfLFs)"
  },
  "colors.Menu.Item.bg.pressed": {
    "value": "var(--bnadVY)",
    "variable": "var(--bnadVY)"
  },
  "colors.Modal.Backdrop.bg": {
    "value": "var(--gOqurw)",
    "variable": "var(--gOqurw)"
  },
  "colors.Modal.Content.bg": {
    "value": "var(--fsalfn)",
    "variable": "var(--fsalfn)"
  },
  "colors.Modal.Header.text": {
    "value": "var(--gXdrTB)",
    "variable": "var(--gXdrTB)"
  },
  "colors.NumberRating.icon": {
    "value": "var(--lbooXq)",
    "variable": "var(--lbooXq)"
  },
  "colors.NumberRating.text": {
    "value": "var(--kYSWaY)",
    "variable": "var(--kYSWaY)"
  },
  "colors.Page.bg": {
    "value": "var(--bLpYgL)",
    "variable": "var(--bLpYgL)"
  },
  "colors.Pagination.PageButton.bg.default": {
    "value": "var(--byynGC)",
    "variable": "var(--byynGC)"
  },
  "colors.Pagination.PageButton.bg.hover": {
    "value": "var(--bTCfar)",
    "variable": "var(--bTCfar)"
  },
  "colors.Pagination.PageButton.bg.pressed": {
    "value": "var(--dDeUNv)",
    "variable": "var(--dDeUNv)"
  },
  "colors.Pagination.PageButton.bg.active": {
    "value": "var(--jBtvNp)",
    "variable": "var(--jBtvNp)"
  },
  "colors.Pagination.PageButton.border.active": {
    "value": "var(--sMWCY)",
    "variable": "var(--sMWCY)"
  },
  "colors.Pagination.PageButton.label.default": {
    "value": "var(--jjDytt)",
    "variable": "var(--jjDytt)"
  },
  "colors.Pagination.PageButton.label.hover": {
    "value": "var(--bmisHU)",
    "variable": "var(--bmisHU)"
  },
  "colors.Pagination.PageButton.label.pressed": {
    "value": "var(--fxyozo)",
    "variable": "var(--fxyozo)"
  },
  "colors.Pagination.PageButton.label.active": {
    "value": "var(--dfrBCi)",
    "variable": "var(--dfrBCi)"
  },
  "colors.Pagination.Readout.colors": {
    "value": "var(--fKrcjK)",
    "variable": "var(--fKrcjK)"
  },
  "colors.PhotoCarousel.Dot.active": {
    "value": "var(--gosXxn)",
    "variable": "var(--gosXxn)"
  },
  "colors.PhotoCarousel.Dot.inactive": {
    "value": "var(--dGHQTQ)",
    "variable": "var(--dGHQTQ)"
  },
  "colors.PhotoCarousel.Dots.bg.default": {
    "value": "var(--hqfquf)",
    "variable": "var(--hqfquf)"
  },
  "colors.PhotoCarousel.Dots.bg.focus": {
    "value": "var(--esrlYA)",
    "variable": "var(--esrlYA)"
  },
  "colors.PhotoCarousel.NavControls.icon.default": {
    "value": "var(--jQIeLw)",
    "variable": "var(--jQIeLw)"
  },
  "colors.Popover.Backdrop.bg": {
    "value": "var(--dwpLua)",
    "variable": "var(--dwpLua)"
  },
  "colors.Popover.Content.bg": {
    "value": "var(--dKyFml)",
    "variable": "var(--dKyFml)"
  },
  "colors.Popover.Divider.bg.default": {
    "value": "var(--jNHZef)",
    "variable": "var(--jNHZef)"
  },
  "colors.Popover.Divider.bg.critical": {
    "value": "var(--fNFbav)",
    "variable": "var(--fNFbav)"
  },
  "colors.Popover.Divider.bg.success": {
    "value": "var(--jzzSFH)",
    "variable": "var(--jzzSFH)"
  },
  "colors.Popover.Divider.bg.info": {
    "value": "var(--dlWraq)",
    "variable": "var(--dlWraq)"
  },
  "colors.Popover.Divider.bg.warning": {
    "value": "var(--kKLPcS)",
    "variable": "var(--kKLPcS)"
  },
  "colors.Popover.Header.bg.default": {
    "value": "var(--OQusZ)",
    "variable": "var(--OQusZ)"
  },
  "colors.Popover.Header.bg.critical": {
    "value": "var(--ftBzOl)",
    "variable": "var(--ftBzOl)"
  },
  "colors.Popover.Header.bg.success": {
    "value": "var(--kUfKmd)",
    "variable": "var(--kUfKmd)"
  },
  "colors.Popover.Header.bg.info": {
    "value": "var(--jgRbQg)",
    "variable": "var(--jgRbQg)"
  },
  "colors.Popover.Header.bg.warning": {
    "value": "var(--buTRwY)",
    "variable": "var(--buTRwY)"
  },
  "colors.Popover.Header.text": {
    "value": "var(--fkhPFj)",
    "variable": "var(--fkhPFj)"
  },
  "colors.Popover.Header.icon.critical": {
    "value": "var(--gGRhYD)",
    "variable": "var(--gGRhYD)"
  },
  "colors.Popover.Header.icon.success": {
    "value": "var(--eoxbnj)",
    "variable": "var(--eoxbnj)"
  },
  "colors.Popover.Header.icon.info": {
    "value": "var(--kCvFVu)",
    "variable": "var(--kCvFVu)"
  },
  "colors.Popover.Header.icon.warning": {
    "value": "var(--hUbaAm)",
    "variable": "var(--hUbaAm)"
  },
  "colors.ProgressIndicator.spinner.icon.default": {
    "value": "var(--eahMfM)",
    "variable": "var(--eahMfM)"
  },
  "colors.ProgressIndicator.spinner.icon.onImpact": {
    "value": "var(--kaThJw)",
    "variable": "var(--kaThJw)"
  },
  "colors.ProgressIndicator.bar.track.bg.default": {
    "value": "var(--iziakc)",
    "variable": "var(--iziakc)"
  },
  "colors.ProgressIndicator.bar.track.bg.active": {
    "value": "var(--gdzTkv)",
    "variable": "var(--gdzTkv)"
  },
  "colors.ProgressIndicator.bar.track.bg.complete": {
    "value": "var(--iuvRUG)",
    "variable": "var(--iuvRUG)"
  },
  "colors.ProgressIndicator.bar.text.helper": {
    "value": "var(--WEOcv)",
    "variable": "var(--WEOcv)"
  },
  "colors.ProgressIndicator.bar.text.label": {
    "value": "var(--imFlTj)",
    "variable": "var(--imFlTj)"
  },
  "colors.ProgressMeter.Label.metaText": {
    "value": "var(--gNzIug)",
    "variable": "var(--gNzIug)"
  },
  "colors.ProgressMeter.Label.interactive.default": {
    "value": "var(--bwBHRm)",
    "variable": "var(--bwBHRm)"
  },
  "colors.ProgressMeter.Label.interactive.hover": {
    "value": "var(--ldySyv)",
    "variable": "var(--ldySyv)"
  },
  "colors.ProgressMeter.Label.interactive.pressed": {
    "value": "var(--fXkDWL)",
    "variable": "var(--fXkDWL)"
  },
  "colors.ProgressMeter.Label.interactive.activeDefault": {
    "value": "var(--epZlgS)",
    "variable": "var(--epZlgS)"
  },
  "colors.ProgressMeter.Label.interactive.activeHover": {
    "value": "var(--bLMUqz)",
    "variable": "var(--bLMUqz)"
  },
  "colors.ProgressMeter.Label.interactive.activePressed": {
    "value": "var(--jpgiCj)",
    "variable": "var(--jpgiCj)"
  },
  "colors.ProgressMeter.Label.static.active": {
    "value": "var(--fpzHSp)",
    "variable": "var(--fpzHSp)"
  },
  "colors.ProgressMeter.Label.static.complete": {
    "value": "var(--cvwRaA)",
    "variable": "var(--cvwRaA)"
  },
  "colors.ProgressMeter.Label.static.error": {
    "value": "var(--eRYGqB)",
    "variable": "var(--eRYGqB)"
  },
  "colors.ProgressMeter.Label.static.incomplete": {
    "value": "var(--ijLAvP)",
    "variable": "var(--ijLAvP)"
  },
  "colors.ProgressMeter.Label.static.notStarted": {
    "value": "var(--hhnuTt)",
    "variable": "var(--hhnuTt)"
  },
  "colors.ProgressMeter.Label.static.success": {
    "value": "var(--deZCtK)",
    "variable": "var(--deZCtK)"
  },
  "colors.ProgressMeter.Label.static.warning": {
    "value": "var(--xXLdD)",
    "variable": "var(--xXLdD)"
  },
  "colors.ProgressMeter.Node.active.bg": {
    "value": "var(--idPRUS)",
    "variable": "var(--idPRUS)"
  },
  "colors.ProgressMeter.Node.active.border": {
    "value": "var(--iPtMCn)",
    "variable": "var(--iPtMCn)"
  },
  "colors.ProgressMeter.Node.active.icon": {
    "value": "var(--jWvxhE)",
    "variable": "var(--jWvxhE)"
  },
  "colors.ProgressMeter.Node.complete.bg": {
    "value": "var(--dggYXD)",
    "variable": "var(--dggYXD)"
  },
  "colors.ProgressMeter.Node.complete.icon": {
    "value": "var(--CYCzR)",
    "variable": "var(--CYCzR)"
  },
  "colors.ProgressMeter.Node.error.bg": {
    "value": "var(--eOwDcO)",
    "variable": "var(--eOwDcO)"
  },
  "colors.ProgressMeter.Node.error.icon": {
    "value": "var(--jmuxoM)",
    "variable": "var(--jmuxoM)"
  },
  "colors.ProgressMeter.Node.focusRing.bg": {
    "value": "var(--YEhbc)",
    "variable": "var(--YEhbc)"
  },
  "colors.ProgressMeter.Node.inactive.icon": {
    "value": "var(--iKRdfj)",
    "variable": "var(--iKRdfj)"
  },
  "colors.ProgressMeter.Node.incomplete.bg": {
    "value": "var(--HNqYo)",
    "variable": "var(--HNqYo)"
  },
  "colors.ProgressMeter.Node.incomplete.icon": {
    "value": "var(--bySdUW)",
    "variable": "var(--bySdUW)"
  },
  "colors.ProgressMeter.Node.success.bg": {
    "value": "var(--kLaSgd)",
    "variable": "var(--kLaSgd)"
  },
  "colors.ProgressMeter.Node.success.icon": {
    "value": "var(--hUdLtj)",
    "variable": "var(--hUdLtj)"
  },
  "colors.ProgressMeter.Node.warning.bg": {
    "value": "var(--jHVPEk)",
    "variable": "var(--jHVPEk)"
  },
  "colors.ProgressMeter.Node.warning.icon": {
    "value": "var(--bFEMLy)",
    "variable": "var(--bFEMLy)"
  },
  "colors.ProgressMeter.Track.active": {
    "value": "var(--ffwZid)",
    "variable": "var(--ffwZid)"
  },
  "colors.ProgressMeter.Track.default": {
    "value": "var(--cPPYJy)",
    "variable": "var(--cPPYJy)"
  },
  "colors.PropertyCard.PhotoFallback.bg": {
    "value": "var(--dOLVEi)",
    "variable": "var(--dOLVEi)"
  },
  "colors.PropertyCard.PhotoFallback.icon": {
    "value": "var(--gaMBEw)",
    "variable": "var(--gaMBEw)"
  },
  "colors.PropertyCard.Badge.brand.bg": {
    "value": "var(--hQYIOJ)",
    "variable": "var(--hQYIOJ)"
  },
  "colors.PropertyCard.Badge.brand.icon": {
    "value": "var(--kwovaD)",
    "variable": "var(--kwovaD)"
  },
  "colors.PropertyCard.Badge.brand.label": {
    "value": "var(--irfhmG)",
    "variable": "var(--irfhmG)"
  },
  "colors.PropertyCard.Badge.flex.bg": {
    "value": "var(--jJqWpJ)",
    "variable": "var(--jJqWpJ)"
  },
  "colors.PropertyCard.Badge.flex.icon": {
    "value": "var(--eQFzmH)",
    "variable": "var(--eQFzmH)"
  },
  "colors.PropertyCard.Badge.flex.label": {
    "value": "var(--dkeHCS)",
    "variable": "var(--dkeHCS)"
  },
  "colors.PropertyCard.Badge.neutral.bg": {
    "value": "var(--lnQnen)",
    "variable": "var(--lnQnen)"
  },
  "colors.PropertyCard.Badge.neutral.icon": {
    "value": "var(--gHDeVx)",
    "variable": "var(--gHDeVx)"
  },
  "colors.PropertyCard.Badge.neutral.label": {
    "value": "var(--qxIzA)",
    "variable": "var(--qxIzA)"
  },
  "colors.PropertyCard.Badge.notify.bg": {
    "value": "var(--NiAbh)",
    "variable": "var(--NiAbh)"
  },
  "colors.PropertyCard.Badge.notify.icon": {
    "value": "var(--ZzKav)",
    "variable": "var(--ZzKav)"
  },
  "colors.PropertyCard.Badge.notify.label": {
    "value": "var(--gceEyy)",
    "variable": "var(--gceEyy)"
  },
  "colors.PropertyCard.Badge.buyAbility.bg": {
    "value": "var(--caSNtO)",
    "variable": "var(--caSNtO)"
  },
  "colors.PropertyCard.Badge.buyAbility.icon": {
    "value": "var(--CXik)",
    "variable": "var(--CXik)"
  },
  "colors.PropertyCard.Badge.buyAbility.label": {
    "value": "var(--gAvhZR)",
    "variable": "var(--gAvhZR)"
  },
  "colors.PropertyCard.Body.bg.default": {
    "value": "var(--dlguJk)",
    "variable": "var(--dlguJk)"
  },
  "colors.PropertyCard.Body.bg.hover": {
    "value": "var(--ftLLQt)",
    "variable": "var(--ftLLQt)"
  },
  "colors.PropertyCard.Body.bg.pressed": {
    "value": "var(--hfvKaR)",
    "variable": "var(--hfvKaR)"
  },
  "colors.PropertyCard.DataArea.text.info": {
    "value": "var(--eACQe)",
    "variable": "var(--eACQe)"
  },
  "colors.PropertyCard.DataArea.text.fineprint": {
    "value": "var(--ckIMFl)",
    "variable": "var(--ckIMFl)"
  },
  "colors.PropertyCard.DataArea.text.dataDivider": {
    "value": "var(--iIKSDp)",
    "variable": "var(--iIKSDp)"
  },
  "colors.PropertyCard.Root.loading.bg": {
    "value": "var(--cYujwv)",
    "variable": "var(--cYujwv)"
  },
  "colors.PropertyCard.Root.loading.shimmer": {
    "value": "var(--gaLJCD)",
    "variable": "var(--gaLJCD)"
  },
  "colors.PropertyCard.SaveButton.bg.default": {
    "value": "var(--jcFxUz)",
    "variable": "var(--jcFxUz)"
  },
  "colors.PropertyCard.SaveButton.bg.hover": {
    "value": "var(--bQcuou)",
    "variable": "var(--bQcuou)"
  },
  "colors.PropertyCard.SaveButton.bg.pressed": {
    "value": "var(--fsKlZG)",
    "variable": "var(--fsKlZG)"
  },
  "colors.PropertyCard.SaveButton.bg.selected": {
    "value": "var(--hjtqZ)",
    "variable": "var(--hjtqZ)"
  },
  "colors.PropertyCard.SaveButton.bg.selectedHover": {
    "value": "var(--dLzLeL)",
    "variable": "var(--dLzLeL)"
  },
  "colors.PropertyCard.SaveButton.bg.selectedPressed": {
    "value": "var(--cbuUJj)",
    "variable": "var(--cbuUJj)"
  },
  "colors.PropertyCard.SaveButton.border.default": {
    "value": "var(--gRyfsq)",
    "variable": "var(--gRyfsq)"
  },
  "colors.PropertyCard.SaveButton.border.hover": {
    "value": "var(--lfmYif)",
    "variable": "var(--lfmYif)"
  },
  "colors.PropertyCard.SaveButton.border.pressed": {
    "value": "var(--hSYMyf)",
    "variable": "var(--hSYMyf)"
  },
  "colors.PropertyCard.SaveButton.border.selected": {
    "value": "var(--bQYAkI)",
    "variable": "var(--bQYAkI)"
  },
  "colors.PropertyCard.SaveButton.border.selectedHover": {
    "value": "var(--cVTNuS)",
    "variable": "var(--cVTNuS)"
  },
  "colors.PropertyCard.SaveButton.border.selectedPressed": {
    "value": "var(--ebWOou)",
    "variable": "var(--ebWOou)"
  },
  "colors.Radio.bg.default": {
    "value": "var(--kcCIgb)",
    "variable": "var(--kcCIgb)"
  },
  "colors.Radio.bg.hover": {
    "value": "var(--hXKYyu)",
    "variable": "var(--hXKYyu)"
  },
  "colors.Radio.bg.pressed": {
    "value": "var(--bTWHPW)",
    "variable": "var(--bTWHPW)"
  },
  "colors.Radio.bg.selected": {
    "value": "var(--AKQDx)",
    "variable": "var(--AKQDx)"
  },
  "colors.Radio.bg.selectedHover": {
    "value": "var(--epJcXP)",
    "variable": "var(--epJcXP)"
  },
  "colors.Radio.bg.selectedPressed": {
    "value": "var(--dPVeoL)",
    "variable": "var(--dPVeoL)"
  },
  "colors.Radio.border.default": {
    "value": "var(--ihVSEy)",
    "variable": "var(--ihVSEy)"
  },
  "colors.Radio.border.hover": {
    "value": "var(--btPnnj)",
    "variable": "var(--btPnnj)"
  },
  "colors.Radio.border.pressed": {
    "value": "var(--dyfpcL)",
    "variable": "var(--dyfpcL)"
  },
  "colors.Radio.border.selected": {
    "value": "var(--ktfHVw)",
    "variable": "var(--ktfHVw)"
  },
  "colors.Radio.border.selectedHover": {
    "value": "var(--jRrxXW)",
    "variable": "var(--jRrxXW)"
  },
  "colors.Radio.border.selectedPressed": {
    "value": "var(--nFMJy)",
    "variable": "var(--nFMJy)"
  },
  "colors.Range.Track.bg.default": {
    "value": "var(--CZXqL)",
    "variable": "var(--CZXqL)"
  },
  "colors.Range.Handle.bg.default": {
    "value": "var(--fGIQNK)",
    "variable": "var(--fGIQNK)"
  },
  "colors.Range.Handle.bg.hover": {
    "value": "var(--dbcdzz)",
    "variable": "var(--dbcdzz)"
  },
  "colors.Range.Handle.bg.pressed": {
    "value": "var(--ebIrOT)",
    "variable": "var(--ebIrOT)"
  },
  "colors.Range.Handle.bg.active": {
    "value": "var(--cbJvih)",
    "variable": "var(--cbJvih)"
  },
  "colors.Range.Handle.bg.activeHover": {
    "value": "var(--biVlqH)",
    "variable": "var(--biVlqH)"
  },
  "colors.Range.Handle.border.default": {
    "value": "var(--dtBogH)",
    "variable": "var(--dtBogH)"
  },
  "colors.Range.Handle.border.hover": {
    "value": "var(--brVsnq)",
    "variable": "var(--brVsnq)"
  },
  "colors.Range.Handle.border.active": {
    "value": "var(--aRoRI)",
    "variable": "var(--aRoRI)"
  },
  "colors.Range.Handle.border.pressed": {
    "value": "var(--hlmrDG)",
    "variable": "var(--hlmrDG)"
  },
  "colors.Range.Handle.border.activeHover": {
    "value": "var(--kusmi)",
    "variable": "var(--kusmi)"
  },
  "colors.RatingStars.icon.empty": {
    "value": "var(--dHeuIW)",
    "variable": "var(--dHeuIW)"
  },
  "colors.RatingStars.icon.filled": {
    "value": "var(--hOmYdh)",
    "variable": "var(--hOmYdh)"
  },
  "colors.RatingStars.text.empty": {
    "value": "var(--cvBUio)",
    "variable": "var(--cvBUio)"
  },
  "colors.RatingStars.text.filled": {
    "value": "var(--gppfqf)",
    "variable": "var(--gppfqf)"
  },
  "colors.ShowHide.icon.default": {
    "value": "var(--emNfDr)",
    "variable": "var(--emNfDr)"
  },
  "colors.ShowHide.icon.hover": {
    "value": "var(--eiIJzK)",
    "variable": "var(--eiIJzK)"
  },
  "colors.ShowHide.icon.pressed": {
    "value": "var(--fgrLYW)",
    "variable": "var(--fgrLYW)"
  },
  "colors.ShowHide.label.default": {
    "value": "var(--bisxIq)",
    "variable": "var(--bisxIq)"
  },
  "colors.ShowHide.label.hover": {
    "value": "var(--jDTjpj)",
    "variable": "var(--jDTjpj)"
  },
  "colors.ShowHide.label.pressed": {
    "value": "var(--hkSKTb)",
    "variable": "var(--hkSKTb)"
  },
  "colors.Slider.Track.bg.default": {
    "value": "var(--cozwVd)",
    "variable": "var(--cozwVd)"
  },
  "colors.Slider.Track.bg.active": {
    "value": "var(--XCtzK)",
    "variable": "var(--XCtzK)"
  },
  "colors.Slider.Handle.bg.default": {
    "value": "var(--bYfyAc)",
    "variable": "var(--bYfyAc)"
  },
  "colors.Slider.Handle.bg.hover": {
    "value": "var(--kMPiCx)",
    "variable": "var(--kMPiCx)"
  },
  "colors.Slider.Handle.bg.pressed": {
    "value": "var(--knbjTt)",
    "variable": "var(--knbjTt)"
  },
  "colors.Slider.Handle.bg.active": {
    "value": "var(--cXQhSn)",
    "variable": "var(--cXQhSn)"
  },
  "colors.Slider.Handle.bg.activeHover": {
    "value": "var(--fwPveR)",
    "variable": "var(--fwPveR)"
  },
  "colors.Slider.Handle.bg.activePressed": {
    "value": "var(--iDOyGl)",
    "variable": "var(--iDOyGl)"
  },
  "colors.Slider.Handle.border.default": {
    "value": "var(--hZmgtN)",
    "variable": "var(--hZmgtN)"
  },
  "colors.Slider.Handle.border.hover": {
    "value": "var(--dmGSPA)",
    "variable": "var(--dmGSPA)"
  },
  "colors.Slider.Handle.border.active": {
    "value": "var(--hNBNly)",
    "variable": "var(--hNBNly)"
  },
  "colors.Slider.Handle.border.pressed": {
    "value": "var(--eYqQZY)",
    "variable": "var(--eYqQZY)"
  },
  "colors.Slider.Handle.border.activeHover": {
    "value": "var(--dqAxTo)",
    "variable": "var(--dqAxTo)"
  },
  "colors.Slider.Handle.border.activePressed": {
    "value": "var(--gTipEA)",
    "variable": "var(--gTipEA)"
  },
  "colors.Switch.Track.bg.default": {
    "value": "var(--dIODgW)",
    "variable": "var(--dIODgW)"
  },
  "colors.Switch.Track.bg.hover": {
    "value": "var(--gqdWqv)",
    "variable": "var(--gqdWqv)"
  },
  "colors.Switch.Track.bg.pressed": {
    "value": "var(--hqKkFP)",
    "variable": "var(--hqKkFP)"
  },
  "colors.Switch.Track.bg.selected": {
    "value": "var(--eqZAUc)",
    "variable": "var(--eqZAUc)"
  },
  "colors.Switch.Track.bg.selectedHover": {
    "value": "var(--lckCXO)",
    "variable": "var(--lckCXO)"
  },
  "colors.Switch.Track.bg.selectedPressed": {
    "value": "var(--bAwYCm)",
    "variable": "var(--bAwYCm)"
  },
  "colors.Switch.Handle.default": {
    "value": "var(--kkhxuv)",
    "variable": "var(--kkhxuv)"
  },
  "colors.Switch.Handle.hover": {
    "value": "var(--gyUBqi)",
    "variable": "var(--gyUBqi)"
  },
  "colors.Switch.Handle.pressed": {
    "value": "var(--hwDDPu)",
    "variable": "var(--hwDDPu)"
  },
  "colors.Switch.Handle.selected": {
    "value": "var(--cepvqh)",
    "variable": "var(--cepvqh)"
  },
  "colors.Switch.Handle.selectedHover": {
    "value": "var(--jHRAub)",
    "variable": "var(--jHRAub)"
  },
  "colors.Switch.Handle.selectedPressed": {
    "value": "var(--keDXGH)",
    "variable": "var(--keDXGH)"
  },
  "colors.Table.Cell.border": {
    "value": "var(--YQfPo)",
    "variable": "var(--YQfPo)"
  },
  "colors.Table.Cell.bg.default": {
    "value": "var(--kAMrxH)",
    "variable": "var(--kAMrxH)"
  },
  "colors.Table.Cell.bg.hover": {
    "value": "var(--hsXNmq)",
    "variable": "var(--hsXNmq)"
  },
  "colors.Table.Cell.bg.pressed": {
    "value": "var(--iqGPLC)",
    "variable": "var(--iqGPLC)"
  },
  "colors.Table.Cell.bg.selected": {
    "value": "var(--dwWytd)",
    "variable": "var(--dwWytd)"
  },
  "colors.Table.Cell.bg.zebra": {
    "value": "var(--eCSyFm)",
    "variable": "var(--eCSyFm)"
  },
  "colors.Table.Cell.text.default": {
    "value": "var(--iqetxP)",
    "variable": "var(--iqetxP)"
  },
  "colors.Table.Cell.text.hover": {
    "value": "var(--jEhwqi)",
    "variable": "var(--jEhwqi)"
  },
  "colors.Table.Cell.text.pressed": {
    "value": "var(--kENKFC)",
    "variable": "var(--kENKFC)"
  },
  "colors.Table.Cell.text.selected": {
    "value": "var(--iEspVl)",
    "variable": "var(--iEspVl)"
  },
  "colors.Table.SortIcon.icon.default": {
    "value": "var(--hmwOGK)",
    "variable": "var(--hmwOGK)"
  },
  "colors.Table.SortIcon.icon.hover": {
    "value": "var(--eNISnL)",
    "variable": "var(--eNISnL)"
  },
  "colors.Table.SortIcon.icon.pressed": {
    "value": "var(--kGZREb)",
    "variable": "var(--kGZREb)"
  },
  "colors.Table.SortIcon.icon.selected": {
    "value": "var(--kBYAhA)",
    "variable": "var(--kBYAhA)"
  },
  "colors.Tabs.default.bg.tab.default": {
    "value": "var(--gmLwi)",
    "variable": "var(--gmLwi)"
  },
  "colors.Tabs.default.bg.tab.hover": {
    "value": "var(--kFnXEv)",
    "variable": "var(--kFnXEv)"
  },
  "colors.Tabs.default.bg.tab.pressed": {
    "value": "var(--fjjnvP)",
    "variable": "var(--fjjnvP)"
  },
  "colors.Tabs.default.bg.tab.active": {
    "value": "var(--epUbPZ)",
    "variable": "var(--epUbPZ)"
  },
  "colors.Tabs.default.bg.indicator.default": {
    "value": "var(--gFySIE)",
    "variable": "var(--gFySIE)"
  },
  "colors.Tabs.default.bg.indicator.hover": {
    "value": "var(--gOGsWl)",
    "variable": "var(--gOGsWl)"
  },
  "colors.Tabs.default.bg.indicator.pressed": {
    "value": "var(--fSQxrh)",
    "variable": "var(--fSQxrh)"
  },
  "colors.Tabs.default.bg.indicator.active": {
    "value": "var(--ivAAWH)",
    "variable": "var(--ivAAWH)"
  },
  "colors.Tabs.default.bg.panel": {
    "value": "var(--bSfFfd)",
    "variable": "var(--bSfFfd)"
  },
  "colors.Tabs.default.label.default": {
    "value": "var(--hkiWDf)",
    "variable": "var(--hkiWDf)"
  },
  "colors.Tabs.default.label.hover": {
    "value": "var(--jlNpkS)",
    "variable": "var(--jlNpkS)"
  },
  "colors.Tabs.default.label.pressed": {
    "value": "var(--Akghy)",
    "variable": "var(--Akghy)"
  },
  "colors.Tabs.default.label.active": {
    "value": "var(--kQrTNs)",
    "variable": "var(--kQrTNs)"
  },
  "colors.Tabs.default.label.selected.default": {
    "value": "var(--hgLeLj)",
    "variable": "var(--hgLeLj)"
  },
  "colors.Tabs.default.label.selected.pressed": {
    "value": "var(--iRGRma)",
    "variable": "var(--iRGRma)"
  },
  "colors.Tabs.default.border.track": {
    "value": "var(--jyckBl)",
    "variable": "var(--jyckBl)"
  },
  "colors.Tabs.default.border.tab.default": {
    "value": "var(--jFYiWz)",
    "variable": "var(--jFYiWz)"
  },
  "colors.Tabs.default.border.tab.hover": {
    "value": "var(--cjoAPa)",
    "variable": "var(--cjoAPa)"
  },
  "colors.Tabs.default.border.tab.pressed": {
    "value": "var(--dWWFSu)",
    "variable": "var(--dWWFSu)"
  },
  "colors.Tabs.default.border.tab.active": {
    "value": "var(--emyaSU)",
    "variable": "var(--emyaSU)"
  },
  "colors.Tabs.default.icon.default": {
    "value": "var(--hDKOWe)",
    "variable": "var(--hDKOWe)"
  },
  "colors.Tabs.default.icon.hover": {
    "value": "var(--DQBJD)",
    "variable": "var(--DQBJD)"
  },
  "colors.Tabs.default.icon.pressed": {
    "value": "var(--gQoMtT)",
    "variable": "var(--gQoMtT)"
  },
  "colors.Tabs.default.icon.active": {
    "value": "var(--kJYkMR)",
    "variable": "var(--kJYkMR)"
  },
  "colors.Tabs.file.bg.tab.default": {
    "value": "var(--bvDSpr)",
    "variable": "var(--bvDSpr)"
  },
  "colors.Tabs.file.bg.tab.hover": {
    "value": "var(--cpjktu)",
    "variable": "var(--cpjktu)"
  },
  "colors.Tabs.file.bg.tab.pressed": {
    "value": "var(--bPvlKq)",
    "variable": "var(--bPvlKq)"
  },
  "colors.Tabs.file.bg.tab.active": {
    "value": "var(--hlLEWA)",
    "variable": "var(--hlLEWA)"
  },
  "colors.Tabs.file.bg.indicator.default": {
    "value": "var(--iAxkUt)",
    "variable": "var(--iAxkUt)"
  },
  "colors.Tabs.file.bg.indicator.hover": {
    "value": "var(--jWFQrY)",
    "variable": "var(--jWFQrY)"
  },
  "colors.Tabs.file.bg.indicator.pressed": {
    "value": "var(--bOjkuw)",
    "variable": "var(--bOjkuw)"
  },
  "colors.Tabs.file.bg.indicator.active": {
    "value": "var(--hQMOOm)",
    "variable": "var(--hQMOOm)"
  },
  "colors.Tabs.file.bg.panel": {
    "value": "var(--jKFcSk)",
    "variable": "var(--jKFcSk)"
  },
  "colors.Tabs.file.border.default": {
    "value": "var(--iKmBKU)",
    "variable": "var(--iKmBKU)"
  },
  "colors.Tabs.file.border.hover": {
    "value": "var(--kRgUzV)",
    "variable": "var(--kRgUzV)"
  },
  "colors.Tabs.file.border.pressed": {
    "value": "var(--krsVQR)",
    "variable": "var(--krsVQR)"
  },
  "colors.Tabs.file.border.active": {
    "value": "var(--gRHAIb)",
    "variable": "var(--gRHAIb)"
  },
  "colors.Tabs.file.label.default": {
    "value": "var(--hgFjme)",
    "variable": "var(--hgFjme)"
  },
  "colors.Tag.aqua.bg": {
    "value": "var(--hnnCdz)",
    "variable": "var(--hnnCdz)"
  },
  "colors.Tag.aqua.icon": {
    "value": "var(--hRsOVV)",
    "variable": "var(--hRsOVV)"
  },
  "colors.Tag.aqua.text": {
    "value": "var(--eAKXPj)",
    "variable": "var(--eAKXPj)"
  },
  "colors.Tag.blue.bg": {
    "value": "var(--jrQwZt)",
    "variable": "var(--jrQwZt)"
  },
  "colors.Tag.blue.icon": {
    "value": "var(--iAwazT)",
    "variable": "var(--iAwazT)"
  },
  "colors.Tag.blue.text": {
    "value": "var(--iZtlwV)",
    "variable": "var(--iZtlwV)"
  },
  "colors.Tag.critical.bg": {
    "value": "var(--ikkSwc)",
    "variable": "var(--ikkSwc)"
  },
  "colors.Tag.critical.icon": {
    "value": "var(--gbVYqu)",
    "variable": "var(--gbVYqu)"
  },
  "colors.Tag.critical.text": {
    "value": "var(--evgaKs)",
    "variable": "var(--evgaKs)"
  },
  "colors.Tag.gray.bg": {
    "value": "var(--dFfUFq)",
    "variable": "var(--dFfUFq)"
  },
  "colors.Tag.gray.icon": {
    "value": "var(--imrcQk)",
    "variable": "var(--imrcQk)"
  },
  "colors.Tag.gray.text": {
    "value": "var(--hERBxi)",
    "variable": "var(--hERBxi)"
  },
  "colors.Tag.green.bg": {
    "value": "var(--hyJtjM)",
    "variable": "var(--hyJtjM)"
  },
  "colors.Tag.green.icon": {
    "value": "var(--ccVHPa)",
    "variable": "var(--ccVHPa)"
  },
  "colors.Tag.green.text": {
    "value": "var(--dIsPLE)",
    "variable": "var(--dIsPLE)"
  },
  "colors.Tag.info.bg": {
    "value": "var(--cNhqNZ)",
    "variable": "var(--cNhqNZ)"
  },
  "colors.Tag.info.icon": {
    "value": "var(--hztXIz)",
    "variable": "var(--hztXIz)"
  },
  "colors.Tag.info.text": {
    "value": "var(--idlwjt)",
    "variable": "var(--idlwjt)"
  },
  "colors.Tag.orange.bg": {
    "value": "var(--ihHImX)",
    "variable": "var(--ihHImX)"
  },
  "colors.Tag.orange.icon": {
    "value": "var(--moeFd)",
    "variable": "var(--moeFd)"
  },
  "colors.Tag.orange.text": {
    "value": "var(--cwOdQH)",
    "variable": "var(--cwOdQH)"
  },
  "colors.Tag.purple.bg": {
    "value": "var(--fEbJMx)",
    "variable": "var(--fEbJMx)"
  },
  "colors.Tag.purple.icon": {
    "value": "var(--gNmDRL)",
    "variable": "var(--gNmDRL)"
  },
  "colors.Tag.purple.text": {
    "value": "var(--iQLDqx)",
    "variable": "var(--iQLDqx)"
  },
  "colors.Tag.red.bg": {
    "value": "var(--hZjEGc)",
    "variable": "var(--hZjEGc)"
  },
  "colors.Tag.red.icon": {
    "value": "var(--gukCaS)",
    "variable": "var(--gukCaS)"
  },
  "colors.Tag.red.text": {
    "value": "var(--csoOKQ)",
    "variable": "var(--csoOKQ)"
  },
  "colors.Tag.success.bg": {
    "value": "var(--bHzDGI)",
    "variable": "var(--bHzDGI)"
  },
  "colors.Tag.success.icon": {
    "value": "var(--fVboRG)",
    "variable": "var(--fVboRG)"
  },
  "colors.Tag.success.text": {
    "value": "var(--fxkLrM)",
    "variable": "var(--fxkLrM)"
  },
  "colors.Tag.teal.bg": {
    "value": "var(--cjucin)",
    "variable": "var(--cjucin)"
  },
  "colors.Tag.teal.icon": {
    "value": "var(--QQoZh)",
    "variable": "var(--QQoZh)"
  },
  "colors.Tag.teal.text": {
    "value": "var(--hovNHX)",
    "variable": "var(--hovNHX)"
  },
  "colors.Tag.warning.bg": {
    "value": "var(--jiQjkd)",
    "variable": "var(--jiQjkd)"
  },
  "colors.Tag.warning.icon": {
    "value": "var(--hYiJVz)",
    "variable": "var(--hYiJVz)"
  },
  "colors.Tag.warning.text": {
    "value": "var(--ftPdTV)",
    "variable": "var(--ftPdTV)"
  },
  "colors.Tag.yellow.bg": {
    "value": "var(--gPJyOv)",
    "variable": "var(--gPJyOv)"
  },
  "colors.Tag.yellow.icon": {
    "value": "var(--hDhRDN)",
    "variable": "var(--hDhRDN)"
  },
  "colors.Tag.yellow.text": {
    "value": "var(--cycoFb)",
    "variable": "var(--cycoFb)"
  },
  "colors.Tag.transparent.bg": {
    "value": "var(--hoQbbZ)",
    "variable": "var(--hoQbbZ)"
  },
  "colors.Tag.transparent.icon": {
    "value": "var(--iLiUPf)",
    "variable": "var(--iLiUPf)"
  },
  "colors.Tag.transparent.text": {
    "value": "var(--kKyWzB)",
    "variable": "var(--kKyWzB)"
  },
  "colors.TextButton.brand.label.default": {
    "value": "var(--iomHnc)",
    "variable": "var(--iomHnc)"
  },
  "colors.TextButton.brand.label.hover": {
    "value": "var(--iLtNoZ)",
    "variable": "var(--iLtNoZ)"
  },
  "colors.TextButton.brand.label.pressed": {
    "value": "var(--CXhrx)",
    "variable": "var(--CXhrx)"
  },
  "colors.TextButton.brand.icon.default": {
    "value": "var(--lnEPEZ)",
    "variable": "var(--lnEPEZ)"
  },
  "colors.TextButton.brand.icon.hover": {
    "value": "var(--goXzWM)",
    "variable": "var(--goXzWM)"
  },
  "colors.TextButton.brand.icon.pressed": {
    "value": "var(--gLJXjs)",
    "variable": "var(--gLJXjs)"
  },
  "colors.TextButton.neutral.label.default": {
    "value": "var(--XrjpC)",
    "variable": "var(--XrjpC)"
  },
  "colors.TextButton.neutral.label.hover": {
    "value": "var(--gyabjr)",
    "variable": "var(--gyabjr)"
  },
  "colors.TextButton.neutral.label.pressed": {
    "value": "var(--ihCQWv)",
    "variable": "var(--ihCQWv)"
  },
  "colors.TextButton.neutral.icon.default": {
    "value": "var(--jottkD)",
    "variable": "var(--jottkD)"
  },
  "colors.TextButton.neutral.icon.hover": {
    "value": "var(--gLqaPK)",
    "variable": "var(--gLqaPK)"
  },
  "colors.TextButton.neutral.icon.pressed": {
    "value": "var(--iyYfTe)",
    "variable": "var(--iyYfTe)"
  },
  "colors.TextButton.neutral-fixed.label.default": {
    "value": "var(--eRMcGJ)",
    "variable": "var(--eRMcGJ)"
  },
  "colors.TextButton.neutral-fixed.label.hover": {
    "value": "var(--fbGXmo)",
    "variable": "var(--fbGXmo)"
  },
  "colors.TextButton.neutral-fixed.label.pressed": {
    "value": "var(--bPsLCo)",
    "variable": "var(--bPsLCo)"
  },
  "colors.TextButton.neutral-fixed.icon.default": {
    "value": "var(--coFPbQ)",
    "variable": "var(--coFPbQ)"
  },
  "colors.TextButton.neutral-fixed.icon.hover": {
    "value": "var(--eetBFh)",
    "variable": "var(--eetBFh)"
  },
  "colors.TextButton.neutral-fixed.icon.pressed": {
    "value": "var(--kzzoEl)",
    "variable": "var(--kzzoEl)"
  },
  "colors.TextButton.subtle.label.default": {
    "value": "var(--iEoPmu)",
    "variable": "var(--iEoPmu)"
  },
  "colors.TextButton.subtle.label.hover": {
    "value": "var(--cqOgaz)",
    "variable": "var(--cqOgaz)"
  },
  "colors.TextButton.subtle.label.pressed": {
    "value": "var(--eewldT)",
    "variable": "var(--eewldT)"
  },
  "colors.TextButton.subtle.icon.default": {
    "value": "var(--kdnKxT)",
    "variable": "var(--kdnKxT)"
  },
  "colors.TextButton.subtle.icon.hover": {
    "value": "var(--kQjmNO)",
    "variable": "var(--kQjmNO)"
  },
  "colors.TextButton.subtle.icon.pressed": {
    "value": "var(--cHMGQm)",
    "variable": "var(--cHMGQm)"
  },
  "colors.TextButton.critical.label.default": {
    "value": "var(--kpMiVA)",
    "variable": "var(--kpMiVA)"
  },
  "colors.TextButton.critical.label.hover": {
    "value": "var(--kRGzpV)",
    "variable": "var(--kRGzpV)"
  },
  "colors.TextButton.critical.label.pressed": {
    "value": "var(--jVQDKR)",
    "variable": "var(--jVQDKR)"
  },
  "colors.TextButton.critical.icon.default": {
    "value": "var(--elhLGB)",
    "variable": "var(--elhLGB)"
  },
  "colors.TextButton.critical.icon.hover": {
    "value": "var(--iGVjsU)",
    "variable": "var(--iGVjsU)"
  },
  "colors.TextButton.critical.icon.pressed": {
    "value": "var(--kqxZfY)",
    "variable": "var(--kqxZfY)"
  },
  "colors.TextButton.onImpact.brand.label.default": {
    "value": "var(--bYFcyy)",
    "variable": "var(--bYFcyy)"
  },
  "colors.TextButton.onImpact.brand.label.hover": {
    "value": "var(--htwabb)",
    "variable": "var(--htwabb)"
  },
  "colors.TextButton.onImpact.brand.label.pressed": {
    "value": "var(--cnhLzr)",
    "variable": "var(--cnhLzr)"
  },
  "colors.TextButton.onImpact.brand.icon.default": {
    "value": "var(--eGSYCf)",
    "variable": "var(--eGSYCf)"
  },
  "colors.TextButton.onImpact.brand.icon.hover": {
    "value": "var(--kUeWWy)",
    "variable": "var(--kUeWWy)"
  },
  "colors.TextButton.onImpact.brand.icon.pressed": {
    "value": "var(--hHQLmy)",
    "variable": "var(--hHQLmy)"
  },
  "colors.TextButton.onImpact.neutral.label.default": {
    "value": "var(--gbYWlA)",
    "variable": "var(--gbYWlA)"
  },
  "colors.TextButton.onImpact.neutral.label.hover": {
    "value": "var(--iaUuwd)",
    "variable": "var(--iaUuwd)"
  },
  "colors.TextButton.onImpact.neutral.label.pressed": {
    "value": "var(--OvvOl)",
    "variable": "var(--OvvOl)"
  },
  "colors.TextButton.onImpact.neutral.icon.default": {
    "value": "var(--kvxeqB)",
    "variable": "var(--kvxeqB)"
  },
  "colors.TextButton.onImpact.neutral.icon.hover": {
    "value": "var(--jedSgE)",
    "variable": "var(--jedSgE)"
  },
  "colors.TextButton.onImpact.neutral.icon.pressed": {
    "value": "var(--jCnSME)",
    "variable": "var(--jCnSME)"
  },
  "colors.TextButton.onImpact.neutral-fixed.label.default": {
    "value": "var(--gWANCT)",
    "variable": "var(--gWANCT)"
  },
  "colors.TextButton.onImpact.neutral-fixed.label.hover": {
    "value": "var(--hdUGky)",
    "variable": "var(--hdUGky)"
  },
  "colors.TextButton.onImpact.neutral-fixed.label.pressed": {
    "value": "var(--kbDgIy)",
    "variable": "var(--kbDgIy)"
  },
  "colors.TextButton.onImpact.neutral-fixed.icon.default": {
    "value": "var(--hQZcRK)",
    "variable": "var(--hQZcRK)"
  },
  "colors.TextButton.onImpact.neutral-fixed.icon.hover": {
    "value": "var(--bWceGn)",
    "variable": "var(--bWceGn)"
  },
  "colors.TextButton.onImpact.neutral-fixed.icon.pressed": {
    "value": "var(--dcffzP)",
    "variable": "var(--dcffzP)"
  },
  "colors.TextButton.onImpact.critical.label.default": {
    "value": "var(--fQMcne)",
    "variable": "var(--fQMcne)"
  },
  "colors.TextButton.onImpact.critical.label.hover": {
    "value": "var(--dvVLdz)",
    "variable": "var(--dvVLdz)"
  },
  "colors.TextButton.onImpact.critical.label.pressed": {
    "value": "var(--bLQUHX)",
    "variable": "var(--bLQUHX)"
  },
  "colors.TextButton.onImpact.critical.icon.default": {
    "value": "var(--bIIRrb)",
    "variable": "var(--bIIRrb)"
  },
  "colors.TextButton.onImpact.critical.icon.hover": {
    "value": "var(--ezfpQq)",
    "variable": "var(--ezfpQq)"
  },
  "colors.TextButton.onImpact.critical.icon.pressed": {
    "value": "var(--iCcaHu)",
    "variable": "var(--iCcaHu)"
  },
  "colors.Toast.critical.bg": {
    "value": "var(--iLaoqv)",
    "variable": "var(--iLaoqv)"
  },
  "colors.Toast.critical.icon-leading": {
    "value": "var(--kMQaCQ)",
    "variable": "var(--kMQaCQ)"
  },
  "colors.Toast.critical.icon-trailing": {
    "value": "var(--dfTJgS)",
    "variable": "var(--dfTJgS)"
  },
  "colors.Toast.critical.text": {
    "value": "var(--kzFoWn)",
    "variable": "var(--kzFoWn)"
  },
  "colors.Toast.info.bg": {
    "value": "var(--cTJZoi)",
    "variable": "var(--cTJZoi)"
  },
  "colors.Toast.info.icon-leading": {
    "value": "var(--lgxNGp)",
    "variable": "var(--lgxNGp)"
  },
  "colors.Toast.info.icon-trailing": {
    "value": "var(--jGhJiH)",
    "variable": "var(--jGhJiH)"
  },
  "colors.Toast.info.text": {
    "value": "var(--kwWEsa)",
    "variable": "var(--kwWEsa)"
  },
  "colors.Toast.notify.bg": {
    "value": "var(--ccKrsf)",
    "variable": "var(--ccKrsf)"
  },
  "colors.Toast.notify.icon-leading": {
    "value": "var(--bfVZRM)",
    "variable": "var(--bfVZRM)"
  },
  "colors.Toast.notify.icon-trailing": {
    "value": "var(--gykuaC)",
    "variable": "var(--gykuaC)"
  },
  "colors.Toast.notify.text": {
    "value": "var(--jsnSqL)",
    "variable": "var(--jsnSqL)"
  },
  "colors.Toast.success.bg": {
    "value": "var(--fgxGoL)",
    "variable": "var(--fgxGoL)"
  },
  "colors.Toast.success.icon-leading": {
    "value": "var(--gUkKUA)",
    "variable": "var(--gUkKUA)"
  },
  "colors.Toast.success.icon-trailing": {
    "value": "var(--kLUezO)",
    "variable": "var(--kLUezO)"
  },
  "colors.Toast.success.text": {
    "value": "var(--jUnMWf)",
    "variable": "var(--jUnMWf)"
  },
  "colors.Toast.warning.bg": {
    "value": "var(--ecsEdy)",
    "variable": "var(--ecsEdy)"
  },
  "colors.Toast.warning.icon-leading": {
    "value": "var(--iJBzoZ)",
    "variable": "var(--iJBzoZ)"
  },
  "colors.Toast.warning.icon-trailing": {
    "value": "var(--gudBVz)",
    "variable": "var(--gudBVz)"
  },
  "colors.Toast.warning.text": {
    "value": "var(--hZLdRG)",
    "variable": "var(--hZLdRG)"
  },
  "colors.ToggleButton.bg.default": {
    "value": "var(--hAksLO)",
    "variable": "var(--hAksLO)"
  },
  "colors.ToggleButton.bg.hover": {
    "value": "var(--dycSbT)",
    "variable": "var(--dycSbT)"
  },
  "colors.ToggleButton.bg.pressed": {
    "value": "var(--eyJgrn)",
    "variable": "var(--eyJgrn)"
  },
  "colors.ToggleButton.bg.selected": {
    "value": "var(--eXkbzQ)",
    "variable": "var(--eXkbzQ)"
  },
  "colors.ToggleButton.bg.selectedHover": {
    "value": "var(--dHuPbK)",
    "variable": "var(--dHuPbK)"
  },
  "colors.ToggleButton.bg.selectedPressed": {
    "value": "var(--fvcUfe)",
    "variable": "var(--fvcUfe)"
  },
  "colors.ToggleButton.label.default": {
    "value": "var(--bsiikN)",
    "variable": "var(--bsiikN)"
  },
  "colors.ToggleButton.label.hover": {
    "value": "var(--bqGDgA)",
    "variable": "var(--bqGDgA)"
  },
  "colors.ToggleButton.label.pressed": {
    "value": "var(--dUzdCc)",
    "variable": "var(--dUzdCc)"
  },
  "colors.ToggleButton.label.selected": {
    "value": "var(--bGARnz)",
    "variable": "var(--bGARnz)"
  },
  "colors.ToggleButton.label.selectedHover": {
    "value": "var(--gbltzh)",
    "variable": "var(--gbltzh)"
  },
  "colors.ToggleButton.label.selectedPressed": {
    "value": "var(--jDTlkt)",
    "variable": "var(--jDTlkt)"
  },
  "colors.ToggleButton.icon.default": {
    "value": "var(--lbSpgA)",
    "variable": "var(--lbSpgA)"
  },
  "colors.ToggleButton.icon.hover": {
    "value": "var(--gblwQh)",
    "variable": "var(--gblwQh)"
  },
  "colors.ToggleButton.icon.pressed": {
    "value": "var(--YnYbB)",
    "variable": "var(--YnYbB)"
  },
  "colors.ToggleButton.icon.selected": {
    "value": "var(--iRHIjm)",
    "variable": "var(--iRHIjm)"
  },
  "colors.ToggleButton.icon.selectedHover": {
    "value": "var(--hkpjI)",
    "variable": "var(--hkpjI)"
  },
  "colors.ToggleButton.icon.selectedPressed": {
    "value": "var(--kAQddA)",
    "variable": "var(--kAQddA)"
  },
  "colors.ToggleButton.border.default": {
    "value": "var(--dEqUyf)",
    "variable": "var(--dEqUyf)"
  },
  "colors.ToggleButton.border.hover": {
    "value": "var(--TgSMW)",
    "variable": "var(--TgSMW)"
  },
  "colors.ToggleButton.border.pressed": {
    "value": "var(--gMxSdm)",
    "variable": "var(--gMxSdm)"
  },
  "colors.ToggleButton.border.selected": {
    "value": "var(--beFnYp)",
    "variable": "var(--beFnYp)"
  },
  "colors.ToggleButton.border.selectedHover": {
    "value": "var(--dabetf)",
    "variable": "var(--dabetf)"
  },
  "colors.ToggleButton.border.selectedPressed": {
    "value": "var(--hlrakz)",
    "variable": "var(--hlrakz)"
  },
  "colors.ToggleCard.Footer.border": {
    "value": "var(--ddLdHf)",
    "variable": "var(--ddLdHf)"
  },
  "colors.ToggleCard.Header.border": {
    "value": "var(--cbsYHF)",
    "variable": "var(--cbsYHF)"
  },
  "colors.ToggleCard.Root.neutral.bg.default": {
    "value": "var(--fAVrCD)",
    "variable": "var(--fAVrCD)"
  },
  "colors.ToggleCard.Root.neutral.bg.hover": {
    "value": "var(--eZLdEi)",
    "variable": "var(--eZLdEi)"
  },
  "colors.ToggleCard.Root.neutral.bg.pressed": {
    "value": "var(--iCsVpu)",
    "variable": "var(--iCsVpu)"
  },
  "colors.ToggleCard.Root.neutral.bg.selected.default": {
    "value": "var(--eWqipT)",
    "variable": "var(--eWqipT)"
  },
  "colors.ToggleCard.Root.neutral.bg.selected.hover": {
    "value": "var(--wPAXa)",
    "variable": "var(--wPAXa)"
  },
  "colors.ToggleCard.Root.neutral.bg.selected.pressed": {
    "value": "var(--aRaIS)",
    "variable": "var(--aRaIS)"
  },
  "colors.ToggleCard.Root.neutral.border.default": {
    "value": "var(--jOfbHW)",
    "variable": "var(--jOfbHW)"
  },
  "colors.ToggleCard.Root.neutral.border.hover": {
    "value": "var(--cBrLRT)",
    "variable": "var(--cBrLRT)"
  },
  "colors.ToggleCard.Root.neutral.border.pressed": {
    "value": "var(--kEzjGP)",
    "variable": "var(--kEzjGP)"
  },
  "colors.ToggleCard.Root.neutral.border.selected.default": {
    "value": "var(--dIxeFe)",
    "variable": "var(--dIxeFe)"
  },
  "colors.ToggleCard.Root.neutral.border.selected.hover": {
    "value": "var(--dwaoof)",
    "variable": "var(--dwaoof)"
  },
  "colors.ToggleCard.Root.neutral.border.selected.pressed": {
    "value": "var(--gtIOMf)",
    "variable": "var(--gtIOMf)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.default": {
    "value": "var(--fNshEw)",
    "variable": "var(--fNshEw)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.hover": {
    "value": "var(--gLquJ)",
    "variable": "var(--gLquJ)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.pressed": {
    "value": "var(--KMQgB)",
    "variable": "var(--KMQgB)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.selected.default": {
    "value": "var(--gtOKOA)",
    "variable": "var(--gtOKOA)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.selected.hover": {
    "value": "var(--dsLJRl)",
    "variable": "var(--dsLJRl)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.selected.pressed": {
    "value": "var(--glpuQV)",
    "variable": "var(--glpuQV)"
  },
  "colors.ToggleCard.Root.soft.bg.default": {
    "value": "var(--tBVjc)",
    "variable": "var(--tBVjc)"
  },
  "colors.ToggleCard.Root.soft.bg.hover": {
    "value": "var(--ijWbPh)",
    "variable": "var(--ijWbPh)"
  },
  "colors.ToggleCard.Root.soft.bg.pressed": {
    "value": "var(--jXEgSB)",
    "variable": "var(--jXEgSB)"
  },
  "colors.ToggleCard.Root.soft.bg.selected.default": {
    "value": "var(--fYtbIQ)",
    "variable": "var(--fYtbIQ)"
  },
  "colors.ToggleCard.Root.soft.bg.selected.hover": {
    "value": "var(--cHZAAh)",
    "variable": "var(--cHZAAh)"
  },
  "colors.ToggleCard.Root.soft.bg.selected.pressed": {
    "value": "var(--dgjBgh)",
    "variable": "var(--dgjBgh)"
  },
  "colors.ToggleCard.Root.soft.border.default": {
    "value": "var(--gOncWV)",
    "variable": "var(--gOncWV)"
  },
  "colors.ToggleCard.Root.soft.border.hover": {
    "value": "var(--cOpwXo)",
    "variable": "var(--cOpwXo)"
  },
  "colors.ToggleCard.Root.soft.border.pressed": {
    "value": "var(--gZFsOI)",
    "variable": "var(--gZFsOI)"
  },
  "colors.ToggleCard.Root.soft.border.selected.default": {
    "value": "var(--ccfaFF)",
    "variable": "var(--ccfaFF)"
  },
  "colors.ToggleCard.Root.soft.border.selected.hover": {
    "value": "var(--hrHnvs)",
    "variable": "var(--hrHnvs)"
  },
  "colors.ToggleCard.Root.soft.border.selected.pressed": {
    "value": "var(--dPNlyw)",
    "variable": "var(--dPNlyw)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.default": {
    "value": "var(--djnNhj)",
    "variable": "var(--djnNhj)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.hover": {
    "value": "var(--hRspre)",
    "variable": "var(--hRspre)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.pressed": {
    "value": "var(--ipCpXe)",
    "variable": "var(--ipCpXe)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.selected.default": {
    "value": "var(--dwYnDn)",
    "variable": "var(--dwYnDn)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.selected.hover": {
    "value": "var(--CSbzi)",
    "variable": "var(--CSbzi)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.selected.pressed": {
    "value": "var(--kwgvZa)",
    "variable": "var(--kwgvZa)"
  },
  "colors.Tooltip.neutral.bg": {
    "value": "var(--fDpiyJ)",
    "variable": "var(--fDpiyJ)"
  },
  "colors.Tooltip.neutral.text": {
    "value": "var(--fkIySR)",
    "variable": "var(--fkIySR)"
  },
  "colors.Tooltip.impact.bg": {
    "value": "var(--ewVNiK)",
    "variable": "var(--ewVNiK)"
  },
  "colors.Tooltip.impact.text": {
    "value": "var(--TGzBG)",
    "variable": "var(--TGzBG)"
  },
  "colors.TriggerButton.bg.default": {
    "value": "var(--fOqcdQ)",
    "variable": "var(--fOqcdQ)"
  },
  "colors.TriggerButton.bg.hover": {
    "value": "var(--fEGeId)",
    "variable": "var(--fEGeId)"
  },
  "colors.TriggerButton.bg.pressed": {
    "value": "var(--feSfYZ)",
    "variable": "var(--feSfYZ)"
  },
  "colors.TriggerButton.border.default": {
    "value": "var(--ivbxbR)",
    "variable": "var(--ivbxbR)"
  },
  "colors.TriggerButton.border.pressed": {
    "value": "var(--hKsGac)",
    "variable": "var(--hKsGac)"
  },
  "colors.TriggerButton.text": {
    "value": "var(--kXVIkW)",
    "variable": "var(--kXVIkW)"
  },
  "colors.TriggerText.border.default": {
    "value": "var(--kulyzW)",
    "variable": "var(--kulyzW)"
  },
  "colors.TriggerText.border.hover": {
    "value": "var(--liMlvv)",
    "variable": "var(--liMlvv)"
  },
  "colors.TriggerText.border.pressed": {
    "value": "var(--cxjcsb)",
    "variable": "var(--cxjcsb)"
  },
  "colors.UpsellBanner.Body.hero.text": {
    "value": "var(--ecAQFL)",
    "variable": "var(--ecAQFL)"
  },
  "colors.UpsellBanner.Body.impact.text": {
    "value": "var(--chPwbV)",
    "variable": "var(--chPwbV)"
  },
  "colors.UpsellBanner.Body.neutral.text": {
    "value": "var(--gIkQnW)",
    "variable": "var(--gIkQnW)"
  },
  "colors.UpsellBanner.Body.soft.text": {
    "value": "var(--iMoIN)",
    "variable": "var(--iMoIN)"
  },
  "colors.UpsellBanner.Header.hero.text": {
    "value": "var(--bLKLkM)",
    "variable": "var(--bLKLkM)"
  },
  "colors.UpsellBanner.Header.impact.text": {
    "value": "var(--bgOxFW)",
    "variable": "var(--bgOxFW)"
  },
  "colors.UpsellBanner.Header.neutral.text": {
    "value": "var(--dIqLsJ)",
    "variable": "var(--dIqLsJ)"
  },
  "colors.UpsellBanner.Header.soft.text": {
    "value": "var(--fKtQKq)",
    "variable": "var(--fKtQKq)"
  },
  "colors.UpsellBanner.Media.hero.icon": {
    "value": "var(--hufJtN)",
    "variable": "var(--hufJtN)"
  },
  "colors.UpsellBanner.Media.impact.icon": {
    "value": "var(--dhmCFv)",
    "variable": "var(--dhmCFv)"
  },
  "colors.UpsellBanner.Media.neutral.icon": {
    "value": "var(--egGtTI)",
    "variable": "var(--egGtTI)"
  },
  "colors.UpsellBanner.Media.soft.icon": {
    "value": "var(--ecmaMv)",
    "variable": "var(--ecmaMv)"
  },
  "colors.UpsellBanner.Root.hero.bg": {
    "value": "var(--dVEyiF)",
    "variable": "var(--dVEyiF)"
  },
  "colors.UpsellBanner.Root.impact.bg": {
    "value": "var(--jCiDWD)",
    "variable": "var(--jCiDWD)"
  },
  "colors.UpsellBanner.Root.neutral.bg.default": {
    "value": "var(--fvezO)",
    "variable": "var(--fvezO)"
  },
  "colors.UpsellBanner.Root.soft.bg": {
    "value": "var(--kOgulf)",
    "variable": "var(--kOgulf)"
  },
  "colors.Upsell.Body.hero.text": {
    "value": "var(--csRIWL)",
    "variable": "var(--csRIWL)"
  },
  "colors.Upsell.Body.impact.text": {
    "value": "var(--jLuJnd)",
    "variable": "var(--jLuJnd)"
  },
  "colors.Upsell.Body.neutral.text": {
    "value": "var(--hxLPwy)",
    "variable": "var(--hxLPwy)"
  },
  "colors.Upsell.Body.soft.text": {
    "value": "var(--cnSdRp)",
    "variable": "var(--cnSdRp)"
  },
  "colors.Upsell.Header.hero.text": {
    "value": "var(--bpRquA)",
    "variable": "var(--bpRquA)"
  },
  "colors.Upsell.Header.impact.text": {
    "value": "var(--fGaMEa)",
    "variable": "var(--fGaMEa)"
  },
  "colors.Upsell.Header.neutral.text": {
    "value": "var(--bYMSBt)",
    "variable": "var(--bYMSBt)"
  },
  "colors.Upsell.Header.soft.text": {
    "value": "var(--cCiykm)",
    "variable": "var(--cCiykm)"
  },
  "colors.Upsell.Legal.hero.text-legal": {
    "value": "var(--bwTwdC)",
    "variable": "var(--bwTwdC)"
  },
  "colors.Upsell.Legal.impact.text-legal": {
    "value": "var(--jiHvUI)",
    "variable": "var(--jiHvUI)"
  },
  "colors.Upsell.Legal.neutral.text-legal": {
    "value": "var(--bWGDbz)",
    "variable": "var(--bWGDbz)"
  },
  "colors.Upsell.Legal.soft.text-legal": {
    "value": "var(--cfCSfI)",
    "variable": "var(--cfCSfI)"
  },
  "colors.Upsell.Media.hero.icon": {
    "value": "var(--jgWcsF)",
    "variable": "var(--jgWcsF)"
  },
  "colors.Upsell.Media.impact.icon": {
    "value": "var(--hRyuXb)",
    "variable": "var(--hRyuXb)"
  },
  "colors.Upsell.Media.neutral.icon": {
    "value": "var(--fpkbxM)",
    "variable": "var(--fpkbxM)"
  },
  "colors.Upsell.Media.soft.icon": {
    "value": "var(--bRTojL)",
    "variable": "var(--bRTojL)"
  },
  "colors.Upsell.Root.hero.bg": {
    "value": "var(--cyfnkt)",
    "variable": "var(--cyfnkt)"
  },
  "colors.Upsell.Root.hero.border": {
    "value": "var(--ifxGY)",
    "variable": "var(--ifxGY)"
  },
  "colors.Upsell.Root.impact.bg": {
    "value": "var(--ezxAob)",
    "variable": "var(--ezxAob)"
  },
  "colors.Upsell.Root.impact.border": {
    "value": "var(--bgYDLC)",
    "variable": "var(--bgYDLC)"
  },
  "colors.Upsell.Root.neutral.bg": {
    "value": "var(--cXiXUM)",
    "variable": "var(--cXiXUM)"
  },
  "colors.Upsell.Root.neutral.border": {
    "value": "var(--eMjaex)",
    "variable": "var(--eMjaex)"
  },
  "colors.Upsell.Root.neutral.elevated.bg": {
    "value": "var(--kSfVEf)",
    "variable": "var(--kSfVEf)"
  },
  "colors.Upsell.Root.neutral.elevated.border": {
    "value": "var(--iZlxau)",
    "variable": "var(--iZlxau)"
  },
  "colors.Upsell.Root.soft.bg": {
    "value": "var(--eSVKlz)",
    "variable": "var(--eSVKlz)"
  },
  "colors.Upsell.Root.soft.border": {
    "value": "var(--cbohIe)",
    "variable": "var(--cbohIe)"
  },
  "colors.VerticalNav.Heading": {
    "value": "var(--hllRSi)",
    "variable": "var(--hllRSi)"
  },
  "colors.VerticalNav.Item.brand.bg.default": {
    "value": "var(--eUinpX)",
    "variable": "var(--eUinpX)"
  },
  "colors.VerticalNav.Item.brand.bg.hover": {
    "value": "var(--etuIcy)",
    "variable": "var(--etuIcy)"
  },
  "colors.VerticalNav.Item.brand.bg.active": {
    "value": "var(--diilaA)",
    "variable": "var(--diilaA)"
  },
  "colors.VerticalNav.Item.brand.bg.pressed": {
    "value": "var(--dxEMxu)",
    "variable": "var(--dxEMxu)"
  },
  "colors.VerticalNav.Item.brand.icon.default": {
    "value": "var(--jscAWJ)",
    "variable": "var(--jscAWJ)"
  },
  "colors.VerticalNav.Item.brand.icon.hover": {
    "value": "var(--khOvtc)",
    "variable": "var(--khOvtc)"
  },
  "colors.VerticalNav.Item.brand.icon.active": {
    "value": "var(--iUtsDa)",
    "variable": "var(--iUtsDa)"
  },
  "colors.VerticalNav.Item.brand.icon.pressed": {
    "value": "var(--ddIHLA)",
    "variable": "var(--ddIHLA)"
  },
  "colors.VerticalNav.Item.brand.label.default": {
    "value": "var(--iUaosM)",
    "variable": "var(--iUaosM)"
  },
  "colors.VerticalNav.Item.brand.label.hover": {
    "value": "var(--jmyzXF)",
    "variable": "var(--jmyzXF)"
  },
  "colors.VerticalNav.Item.brand.label.active": {
    "value": "var(--gkYwKz)",
    "variable": "var(--gkYwKz)"
  },
  "colors.VerticalNav.Item.brand.label.pressed": {
    "value": "var(--bDhZnp)",
    "variable": "var(--bDhZnp)"
  },
  "colors.VerticalNav.Item.neutral.bg.default": {
    "value": "var(--jWYISZ)",
    "variable": "var(--jWYISZ)"
  },
  "colors.VerticalNav.Item.neutral.bg.hover": {
    "value": "var(--dZIvkw)",
    "variable": "var(--dZIvkw)"
  },
  "colors.VerticalNav.Item.neutral.bg.active": {
    "value": "var(--gjOHKK)",
    "variable": "var(--gjOHKK)"
  },
  "colors.VerticalNav.Item.neutral.bg.pressed": {
    "value": "var(--ikYrbQ)",
    "variable": "var(--ikYrbQ)"
  },
  "colors.VerticalNav.Item.neutral.icon.default": {
    "value": "var(--jbCVxX)",
    "variable": "var(--jbCVxX)"
  },
  "colors.VerticalNav.Item.neutral.icon.hover": {
    "value": "var(--kWgxNe)",
    "variable": "var(--kWgxNe)"
  },
  "colors.VerticalNav.Item.neutral.icon.active": {
    "value": "var(--kYUOLg)",
    "variable": "var(--kYUOLg)"
  },
  "colors.VerticalNav.Item.neutral.icon.pressed": {
    "value": "var(--gbQBnm)",
    "variable": "var(--gbQBnm)"
  },
  "colors.VerticalNav.Item.neutral.label.default": {
    "value": "var(--udppK)",
    "variable": "var(--udppK)"
  },
  "colors.VerticalNav.Item.neutral.label.hover": {
    "value": "var(--fcGHxX)",
    "variable": "var(--fcGHxX)"
  },
  "colors.VerticalNav.Item.neutral.label.active": {
    "value": "var(--etseMp)",
    "variable": "var(--etseMp)"
  },
  "colors.VerticalNav.Item.neutral.label.pressed": {
    "value": "var(--bQsvNX)",
    "variable": "var(--bQsvNX)"
  },
  "colors.VerticalNav.Root.bg": {
    "value": "var(--glhEao)",
    "variable": "var(--glhEao)"
  },
  "colors.VerticalNav.Root.bg-elevated": {
    "value": "var(--kZVFTz)",
    "variable": "var(--kZVFTz)"
  },
  "colors.VerticalNav.Root.border": {
    "value": "var(--cxsGaN)",
    "variable": "var(--cxsGaN)"
  },
  "colors.ZillowLogo.brand-mark": {
    "value": "var(--kstXgG)",
    "variable": "var(--kstXgG)"
  },
  "colors.ZillowLogo.brand-text": {
    "value": "var(--irhiCq)",
    "variable": "var(--irhiCq)"
  },
  "colors.ZillowLogo.onImpact.brand-mark": {
    "value": "var(--kyjzjc)",
    "variable": "var(--kyjzjc)"
  },
  "colors.ZillowLogo.onImpact.brand-text": {
    "value": "var(--ZmWQg)",
    "variable": "var(--ZmWQg)"
  },
  "colors.ZillowLogo.legacy.brand-mark": {
    "value": "var(--jcQeUy)",
    "variable": "var(--jcQeUy)"
  },
  "colors.ZillowLogo.legacy.brand-text": {
    "value": "var(--bfTMzK)",
    "variable": "var(--bfTMzK)"
  },
  "colors.ZillowLogo.legacy.onImpact.brand-mark": {
    "value": "var(--brYIbQ)",
    "variable": "var(--brYIbQ)"
  },
  "colors.ZillowLogo.legacy.onImpact.brand-text": {
    "value": "var(--exftig)",
    "variable": "var(--exftig)"
  },
  "colors.transparent": {
    "value": "var(--edNtiq)",
    "variable": "var(--edNtiq)"
  },
  "colors.brand": {
    "value": "var(--hiaXtX)",
    "variable": "var(--hiaXtX)"
  },
  "colors.brandSecondary": {
    "value": "var(--hmKHmN)",
    "variable": "var(--hmKHmN)"
  },
  "colors.backgroundBrand": {
    "value": "var(--kldixN)",
    "variable": "var(--kldixN)"
  },
  "colors.textWhite": {
    "value": "var(--knlIAu)",
    "variable": "var(--knlIAu)"
  },
  "colors.textLight": {
    "value": "var(--fjTYzX)",
    "variable": "var(--fjTYzX)"
  },
  "colors.textMedium": {
    "value": "var(--fQDgBQ)",
    "variable": "var(--fQDgBQ)"
  },
  "colors.textDark": {
    "value": "var(--dHjKfd)",
    "variable": "var(--dHjKfd)"
  },
  "colors.link": {
    "value": "var(--fYfGw)",
    "variable": "var(--fYfGw)"
  },
  "colors.linkFocus": {
    "value": "var(--gBpyMs)",
    "variable": "var(--gBpyMs)"
  },
  "colors.linkInverse": {
    "value": "var(--iUVNvI)",
    "variable": "var(--iUVNvI)"
  },
  "colors.linkVisited": {
    "value": "var(--cYNNEU)",
    "variable": "var(--cYNNEU)"
  },
  "colors.linkHover": {
    "value": "var(--eKipSG)",
    "variable": "var(--eKipSG)"
  },
  "colors.linkActive": {
    "value": "var(--cPTyAI)",
    "variable": "var(--cPTyAI)"
  },
  "colors.backgroundAqua": {
    "value": "var(--cxnbem)",
    "variable": "var(--cxnbem)"
  },
  "colors.backgroundBlue": {
    "value": "var(--ibbYAU)",
    "variable": "var(--ibbYAU)"
  },
  "colors.backgroundGreen": {
    "value": "var(--jkGXUl)",
    "variable": "var(--jkGXUl)"
  },
  "colors.backgroundOrange": {
    "value": "var(--fflzqi)",
    "variable": "var(--fflzqi)"
  },
  "colors.backgroundOrangeRed": {
    "value": "var(--fKHctV)",
    "variable": "var(--fKHctV)"
  },
  "colors.backgroundPurple": {
    "value": "var(--iGoLvs)",
    "variable": "var(--iGoLvs)"
  },
  "colors.backgroundRed": {
    "value": "var(--hMmWiB)",
    "variable": "var(--hMmWiB)"
  },
  "colors.backgroundYellow": {
    "value": "var(--btfngK)",
    "variable": "var(--btfngK)"
  },
  "colors.backgroundDarkAqua": {
    "value": "var(--iRnQOq)",
    "variable": "var(--iRnQOq)"
  },
  "colors.backgroundDarkBlue": {
    "value": "var(--ldLWfM)",
    "variable": "var(--ldLWfM)"
  },
  "colors.backgroundDarkGreen": {
    "value": "var(--hempVt)",
    "variable": "var(--hempVt)"
  },
  "colors.backgroundDarkOrange": {
    "value": "var(--klIFOu)",
    "variable": "var(--klIFOu)"
  },
  "colors.backgroundDarkOrangeRed": {
    "value": "var(--glwVVB)",
    "variable": "var(--glwVVB)"
  },
  "colors.backgroundDarkPurple": {
    "value": "var(--iKaMpU)",
    "variable": "var(--iKaMpU)"
  },
  "colors.backgroundDarkRed": {
    "value": "var(--cHtJAp)",
    "variable": "var(--cHtJAp)"
  },
  "colors.backgroundDarkYellow": {
    "value": "var(--etCcJu)",
    "variable": "var(--etCcJu)"
  },
  "colors.backgroundWhite": {
    "value": "var(--hAUCbB)",
    "variable": "var(--hAUCbB)"
  },
  "colors.backgroundLight": {
    "value": "var(--kpIPsE)",
    "variable": "var(--kpIPsE)"
  },
  "colors.backgroundDark": {
    "value": "var(--frUaVO)",
    "variable": "var(--frUaVO)"
  },
  "colors.borderAqua": {
    "value": "var(--fEVneo)",
    "variable": "var(--fEVneo)"
  },
  "colors.borderBlue": {
    "value": "var(--bbPXxy)",
    "variable": "var(--bbPXxy)"
  },
  "colors.borderGreen": {
    "value": "var(--eZuzBL)",
    "variable": "var(--eZuzBL)"
  },
  "colors.borderOrange": {
    "value": "var(--jTvAKQ)",
    "variable": "var(--jTvAKQ)"
  },
  "colors.borderOrangeRed": {
    "value": "var(--iHVNKP)",
    "variable": "var(--iHVNKP)"
  },
  "colors.borderPurple": {
    "value": "var(--cBAHFi)",
    "variable": "var(--cBAHFi)"
  },
  "colors.borderRed": {
    "value": "var(--chxKZD)",
    "variable": "var(--chxKZD)"
  },
  "colors.borderYellow": {
    "value": "var(--httwpc)",
    "variable": "var(--httwpc)"
  },
  "colors.borderLight": {
    "value": "var(--dImOBy)",
    "variable": "var(--dImOBy)"
  },
  "colors.borderDark": {
    "value": "var(--ifVnKw)",
    "variable": "var(--ifVnKw)"
  },
  "colors.error.background": {
    "value": "var(--hFjlAf)",
    "variable": "var(--hFjlAf)"
  },
  "colors.error.border": {
    "value": "var(--jadEjl)",
    "variable": "var(--jadEjl)"
  },
  "colors.error.foreground": {
    "value": "var(--fKPBwG)",
    "variable": "var(--fKPBwG)"
  },
  "colors.error.fontColor": {
    "value": "var(--fhxUNr)",
    "variable": "var(--fhxUNr)"
  },
  "colors.error.darkBackground": {
    "value": "var(--kLqJsP)",
    "variable": "var(--kLqJsP)"
  },
  "colors.info.background": {
    "value": "var(--buksQJ)",
    "variable": "var(--buksQJ)"
  },
  "colors.info.border": {
    "value": "var(--gXApob)",
    "variable": "var(--gXApob)"
  },
  "colors.info.foreground": {
    "value": "var(--kByfIM)",
    "variable": "var(--kByfIM)"
  },
  "colors.info.fontColor": {
    "value": "var(--cFJHkt)",
    "variable": "var(--cFJHkt)"
  },
  "colors.info.darkBackground": {
    "value": "var(--dsqZqh)",
    "variable": "var(--dsqZqh)"
  },
  "colors.success.background": {
    "value": "var(--hWSJgE)",
    "variable": "var(--hWSJgE)"
  },
  "colors.success.border": {
    "value": "var(--byEAfG)",
    "variable": "var(--byEAfG)"
  },
  "colors.success.foreground": {
    "value": "var(--iWSXLF)",
    "variable": "var(--iWSXLF)"
  },
  "colors.success.fontColor": {
    "value": "var(--gubvTY)",
    "variable": "var(--gubvTY)"
  },
  "colors.success.darkBackground": {
    "value": "var(--guTiiA)",
    "variable": "var(--guTiiA)"
  },
  "colors.warning.background": {
    "value": "var(--hexVsx)",
    "variable": "var(--hexVsx)"
  },
  "colors.warning.border": {
    "value": "var(--jLpRzP)",
    "variable": "var(--jLpRzP)"
  },
  "colors.warning.foreground": {
    "value": "var(--bfegDw)",
    "variable": "var(--bfegDw)"
  },
  "colors.warning.fontColor": {
    "value": "var(--eNKoDl)",
    "variable": "var(--eNKoDl)"
  },
  "colors.warning.darkBackground": {
    "value": "var(--gXAwyt)",
    "variable": "var(--gXAwyt)"
  },
  "colors.transient.foreground": {
    "value": "var(--ikWdeC)",
    "variable": "var(--ikWdeC)"
  },
  "borderWidths.Accordion.default": {
    "value": "var(--gqaReN)",
    "variable": "var(--gqaReN)"
  },
  "borderWidths.AdornedInput.active": {
    "value": "var(--cnDAyX)",
    "variable": "var(--cnDAyX)"
  },
  "borderWidths.AdornedInput.default": {
    "value": "var(--wSTsE)",
    "variable": "var(--wSTsE)"
  },
  "borderWidths.Alert": {
    "value": "var(--ggeEep)",
    "variable": "var(--ggeEep)"
  },
  "borderWidths.Avatar.Badge.sm": {
    "value": "var(--fKyWxV)",
    "variable": "var(--fKyWxV)"
  },
  "borderWidths.Avatar.Badge.md": {
    "value": "var(--bHNICC)",
    "variable": "var(--bHNICC)"
  },
  "borderWidths.Avatar.Badge.lg": {
    "value": "var(--fviAxc)",
    "variable": "var(--fviAxc)"
  },
  "borderWidths.Avatar.Image.default": {
    "value": "var(--iyDnSS)",
    "variable": "var(--iyDnSS)"
  },
  "borderWidths.Avatar.Root.default": {
    "value": "var(--fhFAcf)",
    "variable": "var(--fhFAcf)"
  },
  "borderWidths.Button.default": {
    "value": "var(--bTsbwz)",
    "variable": "var(--bTsbwz)"
  },
  "borderWidths.Button.selected": {
    "value": "var(--YswNx)",
    "variable": "var(--YswNx)"
  },
  "borderWidths.Calendar.DayOfWeek.default": {
    "value": "var(--jHAqKX)",
    "variable": "var(--jHAqKX)"
  },
  "borderWidths.Calendar.Day.default": {
    "value": "var(--exgJOK)",
    "variable": "var(--exgJOK)"
  },
  "borderWidths.Calendar.Day.selected": {
    "value": "var(--iZMnHY)",
    "variable": "var(--iZMnHY)"
  },
  "borderWidths.Card.Footer": {
    "value": "var(--dKwehb)",
    "variable": "var(--dKwehb)"
  },
  "borderWidths.Card.Header": {
    "value": "var(--ksadHt)",
    "variable": "var(--ksadHt)"
  },
  "borderWidths.Card.Root": {
    "value": "var(--bbAMgw)",
    "variable": "var(--bbAMgw)"
  },
  "borderWidths.Checkbox.box": {
    "value": "var(--cZzhws)",
    "variable": "var(--cZzhws)"
  },
  "borderWidths.Chip.default": {
    "value": "var(--aLCbr)",
    "variable": "var(--aLCbr)"
  },
  "borderWidths.Chip.selected": {
    "value": "var(--hRsQWN)",
    "variable": "var(--hRsQWN)"
  },
  "borderWidths.Combobox.Group": {
    "value": "var(--fDLqk)",
    "variable": "var(--fDLqk)"
  },
  "borderWidths.Combobox.Trigger": {
    "value": "var(--gerPAL)",
    "variable": "var(--gerPAL)"
  },
  "borderWidths.DateInput.active": {
    "value": "var(--fLlmLo)",
    "variable": "var(--fLlmLo)"
  },
  "borderWidths.DateInput.default": {
    "value": "var(--gDbHOL)",
    "variable": "var(--gDbHOL)"
  },
  "borderWidths.DatePicker.InputGroup.active": {
    "value": "var(--kyfKFA)",
    "variable": "var(--kyfKFA)"
  },
  "borderWidths.DatePicker.InputGroup.default": {
    "value": "var(--iYpnOX)",
    "variable": "var(--iYpnOX)"
  },
  "borderWidths.DatePicker.Trigger.default": {
    "value": "var(--euYSLS)",
    "variable": "var(--euYSLS)"
  },
  "borderWidths.IconButton.default": {
    "value": "var(--eOvPkY)",
    "variable": "var(--eOvPkY)"
  },
  "borderWidths.IconButton.selected": {
    "value": "var(--loaQLK)",
    "variable": "var(--loaQLK)"
  },
  "borderWidths.Input.active": {
    "value": "var(--kaSSkE)",
    "variable": "var(--kaSSkE)"
  },
  "borderWidths.Input.default": {
    "value": "var(--kEPqMP)",
    "variable": "var(--kEPqMP)"
  },
  "borderWidths.Menu.Group": {
    "value": "var(--eXcNRe)",
    "variable": "var(--eXcNRe)"
  },
  "borderWidths.ProgressMeter.Node.active": {
    "value": "var(--knPyrx)",
    "variable": "var(--knPyrx)"
  },
  "borderWidths.Radio.ring.default": {
    "value": "var(--eQWHaP)",
    "variable": "var(--eQWHaP)"
  },
  "borderWidths.Radio.ring.selected": {
    "value": "var(--gVTeNp)",
    "variable": "var(--gVTeNp)"
  },
  "borderWidths.Range.Handle": {
    "value": "var(--cfgqVD)",
    "variable": "var(--cfgqVD)"
  },
  "borderWidths.Slider.Handle": {
    "value": "var(--cteWqt)",
    "variable": "var(--cteWqt)"
  },
  "borderWidths.Table.Cell": {
    "value": "var(--hHUEQC)",
    "variable": "var(--hHUEQC)"
  },
  "borderWidths.Tabs.default": {
    "value": "var(--hLpFwR)",
    "variable": "var(--hLpFwR)"
  },
  "borderWidths.ToggleButton.default": {
    "value": "var(--hYqyWZ)",
    "variable": "var(--hYqyWZ)"
  },
  "borderWidths.ToggleButton.selected": {
    "value": "var(--jVyeWX)",
    "variable": "var(--jVyeWX)"
  },
  "borderWidths.ToggleCard.Footer": {
    "value": "var(--jMXXTl)",
    "variable": "var(--jMXXTl)"
  },
  "borderWidths.ToggleCard.Header": {
    "value": "var(--gPSiOf)",
    "variable": "var(--gPSiOf)"
  },
  "borderWidths.ToggleCard.Root.default": {
    "value": "var(--bgTVAI)",
    "variable": "var(--bgTVAI)"
  },
  "borderWidths.ToggleCard.Root.selected": {
    "value": "var(--ktUXXu)",
    "variable": "var(--ktUXXu)"
  },
  "borderWidths.TriggerText": {
    "value": "var(--ctukPa)",
    "variable": "var(--ctukPa)"
  },
  "borderWidths.Upsell.Root": {
    "value": "var(--gzvMGP)",
    "variable": "var(--gzvMGP)"
  },
  "borderWidths.VerticalNav.Item.indicator": {
    "value": "var(--eJOnJc)",
    "variable": "var(--eJOnJc)"
  },
  "borderWidths.VerticalNav.Root": {
    "value": "var(--cjrsVL)",
    "variable": "var(--cjrsVL)"
  },
  "borderWidths.control.selected": {
    "value": "var(--kbWFes)",
    "variable": "var(--kbWFes)"
  },
  "borderWidths.default": {
    "value": "var(--lpfEoc)",
    "variable": "var(--lpfEoc)"
  },
  "borderWidths.none": {
    "value": "var(--dsAOAt)",
    "variable": "var(--dsAOAt)"
  },
  "borderWidths.thick": {
    "value": "var(--hiYFxW)",
    "variable": "var(--hiYFxW)"
  },
  "borderWidths.thicker": {
    "value": "var(--kXAhp)",
    "variable": "var(--kXAhp)"
  },
  "borderWidths.selected": {
    "value": "var(--eiLDDe)",
    "variable": "var(--eiLDDe)"
  },
  "borderWidths.xs": {
    "value": "var(--kYFOek)",
    "variable": "var(--kYFOek)"
  },
  "borderWidths.sm": {
    "value": "var(--cjTwZZ)",
    "variable": "var(--cjTwZZ)"
  },
  "borderWidths.md": {
    "value": "var(--dvTIcW)",
    "variable": "var(--dvTIcW)"
  },
  "borderWidths.lg": {
    "value": "var(--jBUvqk)",
    "variable": "var(--jBUvqk)"
  },
  "borderWidths.xl": {
    "value": "var(--hRTFLr)",
    "variable": "var(--hRTFLr)"
  },
  "radii.Accordion.default": {
    "value": "var(--daWZT)",
    "variable": "var(--daWZT)"
  },
  "radii.Accordion.fullWidth": {
    "value": "var(--lgsvnd)",
    "variable": "var(--lgsvnd)"
  },
  "radii.Accordion.conjoined": {
    "value": "var(--cozgIB)",
    "variable": "var(--cozgIB)"
  },
  "radii.AdornedInput.sm": {
    "value": "var(--kqwzZH)",
    "variable": "var(--kqwzZH)"
  },
  "radii.AdornedInput.md.default": {
    "value": "var(--jzRRFa)",
    "variable": "var(--jzRRFa)"
  },
  "radii.AdornedInput.md.messaging": {
    "value": "var(--fTGSrL)",
    "variable": "var(--fTGSrL)"
  },
  "radii.AdornedInput.lg.default": {
    "value": "var(--eaJiRI)",
    "variable": "var(--eaJiRI)"
  },
  "radii.AdornedInput.lg.messaging": {
    "value": "var(--jSbJBp)",
    "variable": "var(--jSbJBp)"
  },
  "radii.Alert": {
    "value": "var(--cBNBOb)",
    "variable": "var(--cBNBOb)"
  },
  "radii.Avatar.Badge.sm": {
    "value": "var(--cprPKv)",
    "variable": "var(--cprPKv)"
  },
  "radii.Avatar.Badge.md": {
    "value": "var(--kFXYBg)",
    "variable": "var(--kFXYBg)"
  },
  "radii.Avatar.Badge.lg": {
    "value": "var(--zicia)",
    "variable": "var(--zicia)"
  },
  "radii.Avatar.Image.default": {
    "value": "var(--fBgdsk)",
    "variable": "var(--fBgdsk)"
  },
  "radii.Avatar.Root.default": {
    "value": "var(--enAIOJ)",
    "variable": "var(--enAIOJ)"
  },
  "radii.Badge": {
    "value": "var(--lgCrOQ)",
    "variable": "var(--lgCrOQ)"
  },
  "radii.Banner": {
    "value": "var(--cNLpSl)",
    "variable": "var(--cNLpSl)"
  },
  "radii.ButtonGroup.conjoined": {
    "value": "var(--itipNE)",
    "variable": "var(--itipNE)"
  },
  "radii.Button.sm": {
    "value": "var(--jxkpDg)",
    "variable": "var(--jxkpDg)"
  },
  "radii.Button.md": {
    "value": "var(--etEJwL)",
    "variable": "var(--etEJwL)"
  },
  "radii.Button.lg": {
    "value": "var(--eXGfBJ)",
    "variable": "var(--eXGfBJ)"
  },
  "radii.Calendar.ControlButton": {
    "value": "var(--ehiqFf)",
    "variable": "var(--ehiqFf)"
  },
  "radii.Calendar.Day": {
    "value": "var(--cqrXvi)",
    "variable": "var(--cqrXvi)"
  },
  "radii.Calendar.YearSelect.button": {
    "value": "var(--ekvguS)",
    "variable": "var(--ekvguS)"
  },
  "radii.Card.Root": {
    "value": "var(--inZPRu)",
    "variable": "var(--inZPRu)"
  },
  "radii.Checkbox.box": {
    "value": "var(--jalZgm)",
    "variable": "var(--jalZgm)"
  },
  "radii.Chip": {
    "value": "var(--hgMsPz)",
    "variable": "var(--hgMsPz)"
  },
  "radii.CloseButton": {
    "value": "var(--cnWuV)",
    "variable": "var(--cnWuV)"
  },
  "radii.Combobox.Content": {
    "value": "var(--fTwtnU)",
    "variable": "var(--fTwtnU)"
  },
  "radii.Combobox.Trigger.sm": {
    "value": "var(--hkIVaW)",
    "variable": "var(--hkIVaW)"
  },
  "radii.Combobox.Trigger.md": {
    "value": "var(--dqYHex)",
    "variable": "var(--dqYHex)"
  },
  "radii.Combobox.Trigger.lg": {
    "value": "var(--gJdArb)",
    "variable": "var(--gJdArb)"
  },
  "radii.DateInput.sm": {
    "value": "var(--esUlfA)",
    "variable": "var(--esUlfA)"
  },
  "radii.DateInput.md.default": {
    "value": "var(--kWuOEh)",
    "variable": "var(--kWuOEh)"
  },
  "radii.DateInput.lg.default": {
    "value": "var(--jgwsqD)",
    "variable": "var(--jgwsqD)"
  },
  "radii.DatePicker.Content": {
    "value": "var(--hFbmj)",
    "variable": "var(--hFbmj)"
  },
  "radii.DatePicker.InputGroup.sm": {
    "value": "var(--iMFOZE)",
    "variable": "var(--iMFOZE)"
  },
  "radii.DatePicker.InputGroup.md": {
    "value": "var(--kDUYQL)",
    "variable": "var(--kDUYQL)"
  },
  "radii.DatePicker.InputGroup.lg": {
    "value": "var(--izBNcx)",
    "variable": "var(--izBNcx)"
  },
  "radii.DatePicker.Trigger.sm.topRight": {
    "value": "var(--bfRDGD)",
    "variable": "var(--bfRDGD)"
  },
  "radii.DatePicker.Trigger.sm.bottomRight": {
    "value": "var(--cruLwb)",
    "variable": "var(--cruLwb)"
  },
  "radii.DatePicker.Trigger.sm.topLeft": {
    "value": "var(--fwCmKg)",
    "variable": "var(--fwCmKg)"
  },
  "radii.DatePicker.Trigger.sm.bottomLeft": {
    "value": "var(--cIpcWY)",
    "variable": "var(--cIpcWY)"
  },
  "radii.DatePicker.Trigger.md.topRight": {
    "value": "var(--bYeZak)",
    "variable": "var(--bYeZak)"
  },
  "radii.DatePicker.Trigger.md.bottomRight": {
    "value": "var(--bDOYTA)",
    "variable": "var(--bDOYTA)"
  },
  "radii.DatePicker.Trigger.md.topLeft": {
    "value": "var(--ejfTcj)",
    "variable": "var(--ejfTcj)"
  },
  "radii.DatePicker.Trigger.md.bottomLeft": {
    "value": "var(--bRgVHH)",
    "variable": "var(--bRgVHH)"
  },
  "radii.DatePicker.Trigger.lg.topRight": {
    "value": "var(--cqNyVm)",
    "variable": "var(--cqNyVm)"
  },
  "radii.DatePicker.Trigger.lg.bottomRight": {
    "value": "var(--fqwcRG)",
    "variable": "var(--fqwcRG)"
  },
  "radii.DatePicker.Trigger.lg.topLeft": {
    "value": "var(--VWSaJ)",
    "variable": "var(--VWSaJ)"
  },
  "radii.DatePicker.Trigger.lg.bottomLeft": {
    "value": "var(--fMgBIp)",
    "variable": "var(--fMgBIp)"
  },
  "radii.Divider": {
    "value": "var(--dnilFc)",
    "variable": "var(--dnilFc)"
  },
  "radii.Dropdown.Content": {
    "value": "var(--lfhcaG)",
    "variable": "var(--lfhcaG)"
  },
  "radii.DuoColorIcon.Root.borderRadius": {
    "value": "var(--bmGhDr)",
    "variable": "var(--bmGhDr)"
  },
  "radii.Gleam.default": {
    "value": "var(--gogxqR)",
    "variable": "var(--gogxqR)"
  },
  "radii.IconButton.circle": {
    "value": "var(--gbMJKD)",
    "variable": "var(--gbMJKD)"
  },
  "radii.IconButton.square": {
    "value": "var(--gSqvUg)",
    "variable": "var(--gSqvUg)"
  },
  "radii.Input.sm": {
    "value": "var(--jACzYc)",
    "variable": "var(--jACzYc)"
  },
  "radii.Input.md.default": {
    "value": "var(--eMhmRV)",
    "variable": "var(--eMhmRV)"
  },
  "radii.Input.md.messaging": {
    "value": "var(--eGquJs)",
    "variable": "var(--eGquJs)"
  },
  "radii.Input.lg.default": {
    "value": "var(--bosUQH)",
    "variable": "var(--bosUQH)"
  },
  "radii.Input.lg.messaging": {
    "value": "var(--kIfwaS)",
    "variable": "var(--kIfwaS)"
  },
  "radii.Layout.Content": {
    "value": "var(--cBeWMP)",
    "variable": "var(--cBeWMP)"
  },
  "radii.Menu.Content": {
    "value": "var(--lojJOy)",
    "variable": "var(--lojJOy)"
  },
  "radii.Modal.Content.default": {
    "value": "var(--kmQtMU)",
    "variable": "var(--kmQtMU)"
  },
  "radii.Modal.Content.fullscreen": {
    "value": "var(--hGBbfo)",
    "variable": "var(--hGBbfo)"
  },
  "radii.Pagination.PageButton.default": {
    "value": "var(--GVupX)",
    "variable": "var(--GVupX)"
  },
  "radii.PhotoCarousel.Dot": {
    "value": "var(--gbaoSH)",
    "variable": "var(--gbaoSH)"
  },
  "radii.PhotoCarousel.Dots": {
    "value": "var(--jFurtw)",
    "variable": "var(--jFurtw)"
  },
  "radii.Popover.Content": {
    "value": "var(--kavgho)",
    "variable": "var(--kavgho)"
  },
  "radii.ProgressIndicator.bar.sm": {
    "value": "var(--jJQaGS)",
    "variable": "var(--jJQaGS)"
  },
  "radii.ProgressIndicator.bar.md": {
    "value": "var(--eaEtgZ)",
    "variable": "var(--eaEtgZ)"
  },
  "radii.ProgressMeter.Node.default": {
    "value": "var(--gjDZIk)",
    "variable": "var(--gjDZIk)"
  },
  "radii.ProgressMeter.Track.default": {
    "value": "var(--iacYJr)",
    "variable": "var(--iacYJr)"
  },
  "radii.PropertyCard.Badge": {
    "value": "var(--ewUfWu)",
    "variable": "var(--ewUfWu)"
  },
  "radii.PropertyCard.Body": {
    "value": "var(--vaYyr)",
    "variable": "var(--vaYyr)"
  },
  "radii.Radio": {
    "value": "var(--iczdps)",
    "variable": "var(--iczdps)"
  },
  "radii.Range.Handle": {
    "value": "var(--FzQWN)",
    "variable": "var(--FzQWN)"
  },
  "radii.Range.Track": {
    "value": "var(--fjlSyc)",
    "variable": "var(--fjlSyc)"
  },
  "radii.Slider.Handle": {
    "value": "var(--JOiHj)",
    "variable": "var(--JOiHj)"
  },
  "radii.Slider.Track": {
    "value": "var(--iykrJm)",
    "variable": "var(--iykrJm)"
  },
  "radii.Switch.Track.md": {
    "value": "var(--fndhMd)",
    "variable": "var(--fndhMd)"
  },
  "radii.Switch.Track.lg": {
    "value": "var(--bEoCaj)",
    "variable": "var(--bEoCaj)"
  },
  "radii.Switch.Handle.md": {
    "value": "var(--eEIxBc)",
    "variable": "var(--eEIxBc)"
  },
  "radii.Switch.Handle.lg": {
    "value": "var(--gFeSDO)",
    "variable": "var(--gFeSDO)"
  },
  "radii.Table.Cell": {
    "value": "var(--fTPUQI)",
    "variable": "var(--fTPUQI)"
  },
  "radii.Tabs.tab": {
    "value": "var(--hcMtrD)",
    "variable": "var(--hcMtrD)"
  },
  "radii.Tabs.indicator": {
    "value": "var(--ccRGcV)",
    "variable": "var(--ccRGcV)"
  },
  "radii.Tabs.panel": {
    "value": "var(--dfndQi)",
    "variable": "var(--dfndQi)"
  },
  "radii.Tag.sm": {
    "value": "var(--jmyGEM)",
    "variable": "var(--jmyGEM)"
  },
  "radii.Tag.md": {
    "value": "var(--fSJOMr)",
    "variable": "var(--fSJOMr)"
  },
  "radii.Textarea": {
    "value": "var(--hNRFkD)",
    "variable": "var(--hNRFkD)"
  },
  "radii.Toast": {
    "value": "var(--kGNBKc)",
    "variable": "var(--kGNBKc)"
  },
  "radii.ToggleButton.sm": {
    "value": "var(--crnoWO)",
    "variable": "var(--crnoWO)"
  },
  "radii.ToggleButton.md": {
    "value": "var(--duUgPR)",
    "variable": "var(--duUgPR)"
  },
  "radii.ToggleButton.lg": {
    "value": "var(--gXfHlX)",
    "variable": "var(--gXfHlX)"
  },
  "radii.ToggleCard.Root": {
    "value": "var(--fLDmuI)",
    "variable": "var(--fLDmuI)"
  },
  "radii.Tooltip": {
    "value": "var(--jtueqk)",
    "variable": "var(--jtueqk)"
  },
  "radii.TriggerButton": {
    "value": "var(--fdMDIz)",
    "variable": "var(--fdMDIz)"
  },
  "radii.UpsellBanner.Root": {
    "value": "var(--jUeRgl)",
    "variable": "var(--jUeRgl)"
  },
  "radii.Upsell.Root": {
    "value": "var(--ivwxcp)",
    "variable": "var(--ivwxcp)"
  },
  "radii.VerticalNav.Item": {
    "value": "var(--dwSuxa)",
    "variable": "var(--dwSuxa)"
  },
  "radii.VerticalNav.Root": {
    "value": "var(--iAgybl)",
    "variable": "var(--iAgybl)"
  },
  "radii.none": {
    "value": "var(--dbrZvb)",
    "variable": "var(--dbrZvb)"
  },
  "radii.obj.sharp": {
    "value": "var(--fpBHJH)",
    "variable": "var(--fpBHJH)"
  },
  "radii.obj.default": {
    "value": "var(--jHyVPA)",
    "variable": "var(--jHyVPA)"
  },
  "radii.obj.soft": {
    "value": "var(--fCmAMJ)",
    "variable": "var(--fCmAMJ)"
  },
  "radii.obj.fullWidth": {
    "value": "var(--gZLdZu)",
    "variable": "var(--gZLdZu)"
  },
  "radii.obj.conjoined": {
    "value": "var(--cwEiYm)",
    "variable": "var(--cwEiYm)"
  },
  "radii.shape.capsule": {
    "value": "var(--dQcoKq)",
    "variable": "var(--dQcoKq)"
  },
  "radii.shape.ellipse": {
    "value": "var(--jrpiuh)",
    "variable": "var(--jrpiuh)"
  },
  "radii.shape.flexCapsule.md": {
    "value": "var(--WBpth)",
    "variable": "var(--WBpth)"
  },
  "radii.shape.flexCapsule.lg": {
    "value": "var(--esHWWX)",
    "variable": "var(--esHWWX)"
  },
  "radii.sheets.sharp": {
    "value": "var(--cvwjjs)",
    "variable": "var(--cvwjjs)"
  },
  "radii.sheets.default": {
    "value": "var(--fbfnkT)",
    "variable": "var(--fbfnkT)"
  },
  "radii.sm": {
    "value": "var(--bewZvn)",
    "variable": "var(--bewZvn)"
  },
  "radii.md": {
    "value": "var(--kLOfAE)",
    "variable": "var(--kLOfAE)"
  },
  "radii.lg": {
    "value": "var(--dxfumK)",
    "variable": "var(--dxfumK)"
  },
  "radii.pill": {
    "value": "var(--SqnIo)",
    "variable": "var(--SqnIo)"
  },
  "spacing.Accordion.gap.header-toPanel": {
    "value": "var(--bNqZoO)",
    "variable": "var(--bNqZoO)"
  },
  "spacing.Accordion.gap.betweenAccordions": {
    "value": "var(--ffvvjI)",
    "variable": "var(--ffvvjI)"
  },
  "spacing.Accordion.Header.gap.leading": {
    "value": "var(--bwpRTD)",
    "variable": "var(--bwpRTD)"
  },
  "spacing.Accordion.Header.gap.trailing": {
    "value": "var(--dZFXRZ)",
    "variable": "var(--dZFXRZ)"
  },
  "spacing.Accordion.Header.gap.trailingLabel-toIcon": {
    "value": "var(--eLQeLG)",
    "variable": "var(--eLQeLG)"
  },
  "spacing.Accordion.Header.padding.horz": {
    "value": "var(--iuySXb)",
    "variable": "var(--iuySXb)"
  },
  "spacing.Accordion.Header.padding.vert": {
    "value": "var(--eyrvPl)",
    "variable": "var(--eyrvPl)"
  },
  "spacing.Accordion.Panel.padding.horz": {
    "value": "var(--hlrcK)",
    "variable": "var(--hlrcK)"
  },
  "spacing.Accordion.Panel.padding.top": {
    "value": "var(--bZoLmy)",
    "variable": "var(--bZoLmy)"
  },
  "spacing.Accordion.Panel.padding.bottom": {
    "value": "var(--eJStZW)",
    "variable": "var(--eJStZW)"
  },
  "spacing.AdornedInput.sm.gap.input-toAdornment": {
    "value": "var(--giWyZn)",
    "variable": "var(--giWyZn)"
  },
  "spacing.AdornedInput.sm.padding.horz": {
    "value": "var(--cktADH)",
    "variable": "var(--cktADH)"
  },
  "spacing.AdornedInput.sm.padding.horz-readOnly": {
    "value": "var(--jcghdc)",
    "variable": "var(--jcghdc)"
  },
  "spacing.AdornedInput.sm.padding.vert": {
    "value": "var(--kwodqp)",
    "variable": "var(--kwodqp)"
  },
  "spacing.AdornedInput.md.gap.input-toAdornment": {
    "value": "var(--KPzA)",
    "variable": "var(--KPzA)"
  },
  "spacing.AdornedInput.md.padding.horz": {
    "value": "var(--jSyZtM)",
    "variable": "var(--jSyZtM)"
  },
  "spacing.AdornedInput.md.padding.horz-readOnly": {
    "value": "var(--iBRrrv)",
    "variable": "var(--iBRrrv)"
  },
  "spacing.AdornedInput.md.padding.vert": {
    "value": "var(--hZgzVm)",
    "variable": "var(--hZgzVm)"
  },
  "spacing.AdornedInput.lg.gap.input-toAdornment": {
    "value": "var(--duzHvi)",
    "variable": "var(--duzHvi)"
  },
  "spacing.AdornedInput.lg.padding.horz": {
    "value": "var(--bWShQy)",
    "variable": "var(--bWShQy)"
  },
  "spacing.AdornedInput.lg.padding.horz-readOnly": {
    "value": "var(--bSfKZF)",
    "variable": "var(--bSfKZF)"
  },
  "spacing.AdornedInput.lg.padding.vert": {
    "value": "var(--eQVQQI)",
    "variable": "var(--eQVQQI)"
  },
  "spacing.Alert.gap.content-toActions": {
    "value": "var(--eGWKPV)",
    "variable": "var(--eGWKPV)"
  },
  "spacing.Alert.gap.leading": {
    "value": "var(--gXuGeT)",
    "variable": "var(--gXuGeT)"
  },
  "spacing.Alert.gap.trailing": {
    "value": "var(--irgxnF)",
    "variable": "var(--irgxnF)"
  },
  "spacing.Alert.gap.message.toFlexArea": {
    "value": "var(--cLyUkK)",
    "variable": "var(--cLyUkK)"
  },
  "spacing.Alert.padding.horz": {
    "value": "var(--iqzGnv)",
    "variable": "var(--iqzGnv)"
  },
  "spacing.Alert.padding.vert": {
    "value": "var(--qtDOZ)",
    "variable": "var(--qtDOZ)"
  },
  "spacing.Alert.CloseButton.margin.top": {
    "value": "var(--gmvJmF)",
    "variable": "var(--gmvJmF)"
  },
  "spacing.Alert.CloseButton.margin.right": {
    "value": "var(--hCMzIC)",
    "variable": "var(--hCMzIC)"
  },
  "spacing.Anchor.icon-toLabel": {
    "value": "var(--kkfdlA)",
    "variable": "var(--kkfdlA)"
  },
  "spacing.Avatar.Badge.padding.sm.default": {
    "value": "var(--iDvLBT)",
    "variable": "var(--iDvLBT)"
  },
  "spacing.Avatar.Badge.padding.sm.bare": {
    "value": "var(--jQETGw)",
    "variable": "var(--jQETGw)"
  },
  "spacing.Avatar.Badge.padding.md.default": {
    "value": "var(--gSeFVY)",
    "variable": "var(--gSeFVY)"
  },
  "spacing.Avatar.Badge.padding.md.bare": {
    "value": "var(--koIlbn)",
    "variable": "var(--koIlbn)"
  },
  "spacing.Avatar.Badge.padding.lg.default": {
    "value": "var(--vMQFG)",
    "variable": "var(--vMQFG)"
  },
  "spacing.Avatar.Badge.padding.lg.bare": {
    "value": "var(--KhwPF)",
    "variable": "var(--KhwPF)"
  },
  "spacing.Avatar.Badge.offset.sm.horz": {
    "value": "var(--kUuDvn)",
    "variable": "var(--kUuDvn)"
  },
  "spacing.Avatar.Badge.offset.sm.vert": {
    "value": "var(--dOQuzN)",
    "variable": "var(--dOQuzN)"
  },
  "spacing.Avatar.Badge.offset.md.horz": {
    "value": "var(--fdERLI)",
    "variable": "var(--fdERLI)"
  },
  "spacing.Avatar.Badge.offset.md.vert": {
    "value": "var(--fslsBW)",
    "variable": "var(--fslsBW)"
  },
  "spacing.Avatar.Badge.offset.lg.horz": {
    "value": "var(--rVvfG)",
    "variable": "var(--rVvfG)"
  },
  "spacing.Avatar.Badge.offset.lg.vert": {
    "value": "var(--eURnlI)",
    "variable": "var(--eURnlI)"
  },
  "spacing.Badge.gap.label-toIcon": {
    "value": "var(--cwZWSr)",
    "variable": "var(--cwZWSr)"
  },
  "spacing.Badge.padding.horz": {
    "value": "var(--hfSeCc)",
    "variable": "var(--hfSeCc)"
  },
  "spacing.Badge.padding.vert": {
    "value": "var(--heXOQG)",
    "variable": "var(--heXOQG)"
  },
  "spacing.Banner.gap.leading": {
    "value": "var(--hGxWwp)",
    "variable": "var(--hGxWwp)"
  },
  "spacing.Banner.gap.trailing": {
    "value": "var(--dQDpNT)",
    "variable": "var(--dQDpNT)"
  },
  "spacing.Banner.gap.text-toActions.horz": {
    "value": "var(--kkQFep)",
    "variable": "var(--kkQFep)"
  },
  "spacing.Banner.gap.text-toActions.vert": {
    "value": "var(--cDzzfb)",
    "variable": "var(--cDzzfb)"
  },
  "spacing.Banner.padding.horz": {
    "value": "var(--koEjuJ)",
    "variable": "var(--koEjuJ)"
  },
  "spacing.Banner.padding.vert": {
    "value": "var(--grHYuP)",
    "variable": "var(--grHYuP)"
  },
  "spacing.Banner.CloseButton.margin.top": {
    "value": "var(--SaYWL)",
    "variable": "var(--SaYWL)"
  },
  "spacing.Banner.CloseButton.margin.right": {
    "value": "var(--hsjrNs)",
    "variable": "var(--hsjrNs)"
  },
  "spacing.ButtonGroup.gap.horz": {
    "value": "var(--kEzFgX)",
    "variable": "var(--kEzFgX)"
  },
  "spacing.ButtonGroup.gap.vert": {
    "value": "var(--hdUbmd)",
    "variable": "var(--hdUbmd)"
  },
  "spacing.ButtonGroup.conjoined.gap.default": {
    "value": "var(--wXnJf)",
    "variable": "var(--wXnJf)"
  },
  "spacing.ButtonGroup.conjoined.gap.offsetBorder": {
    "value": "var(--jOoSsZ)",
    "variable": "var(--jOoSsZ)"
  },
  "spacing.ButtonGroup.bare.gap.horz": {
    "value": "var(--Oqoky)",
    "variable": "var(--Oqoky)"
  },
  "spacing.ButtonGroup.bare.gap.vert": {
    "value": "var(--kQreUc)",
    "variable": "var(--kQreUc)"
  },
  "spacing.ButtonGroup.textButton.padding.padding.horz": {
    "value": "var(--XtnQS)",
    "variable": "var(--XtnQS)"
  },
  "spacing.ButtonGroup.textButton.padding.padding.vert": {
    "value": "var(--chjxts)",
    "variable": "var(--chjxts)"
  },
  "spacing.Button.xs.gap.label-toIcon": {
    "value": "var(--eABAkm)",
    "variable": "var(--eABAkm)"
  },
  "spacing.Button.xs.padding.horz": {
    "value": "var(--evDSnJ)",
    "variable": "var(--evDSnJ)"
  },
  "spacing.Button.xs.padding.vert": {
    "value": "var(--krIemT)",
    "variable": "var(--krIemT)"
  },
  "spacing.Button.sm.gap.label-toIcon": {
    "value": "var(--hbtXPD)",
    "variable": "var(--hbtXPD)"
  },
  "spacing.Button.sm.padding.bare.horz": {
    "value": "var(--ldipmR)",
    "variable": "var(--ldipmR)"
  },
  "spacing.Button.sm.padding.horz": {
    "value": "var(--hbHbQA)",
    "variable": "var(--hbHbQA)"
  },
  "spacing.Button.sm.padding.vert": {
    "value": "var(--eoWFjK)",
    "variable": "var(--eoWFjK)"
  },
  "spacing.Button.md.gap.label-toIcon": {
    "value": "var(--iaPdzs)",
    "variable": "var(--iaPdzs)"
  },
  "spacing.Button.md.padding.bare.horz": {
    "value": "var(--hHWvke)",
    "variable": "var(--hHWvke)"
  },
  "spacing.Button.md.padding.horz": {
    "value": "var(--jpBmpz)",
    "variable": "var(--jpBmpz)"
  },
  "spacing.Button.md.padding.vert": {
    "value": "var(--hUZAHR)",
    "variable": "var(--hUZAHR)"
  },
  "spacing.Button.lg.gap.label-toIcon": {
    "value": "var(--ZFidy)",
    "variable": "var(--ZFidy)"
  },
  "spacing.Button.lg.padding.bare.horz": {
    "value": "var(--kxVnxc)",
    "variable": "var(--kxVnxc)"
  },
  "spacing.Button.lg.padding.horz": {
    "value": "var(--koxNQp)",
    "variable": "var(--koxNQp)"
  },
  "spacing.Button.lg.padding.vert": {
    "value": "var(--gQLMgf)",
    "variable": "var(--gQLMgf)"
  },
  "spacing.Calendar.Body.gap.header-toDays": {
    "value": "var(--dFyAoE)",
    "variable": "var(--dFyAoE)"
  },
  "spacing.Calendar.Body.padding.horz": {
    "value": "var(--hUveGy)",
    "variable": "var(--hUveGy)"
  },
  "spacing.Calendar.Controls.gap": {
    "value": "var(--daEYjf)",
    "variable": "var(--daEYjf)"
  },
  "spacing.Calendar.Controls.padding.horz": {
    "value": "var(--pnGHi)",
    "variable": "var(--pnGHi)"
  },
  "spacing.Calendar.DayOfWeek.padding.bottom": {
    "value": "var(--bqRvuH)",
    "variable": "var(--bqRvuH)"
  },
  "spacing.Calendar.Day.margin.horz": {
    "value": "var(--cgwSnx)",
    "variable": "var(--cgwSnx)"
  },
  "spacing.Calendar.Day.margin.vert": {
    "value": "var(--hslhYj)",
    "variable": "var(--hslhYj)"
  },
  "spacing.Calendar.Root.gap.controls-toBody": {
    "value": "var(--eLFqsS)",
    "variable": "var(--eLFqsS)"
  },
  "spacing.Calendar.YearSelect.padding.left": {
    "value": "var(--hWiArN)",
    "variable": "var(--hWiArN)"
  },
  "spacing.Calendar.YearSelect.gap.select-toButton": {
    "value": "var(--bvJrtJ)",
    "variable": "var(--bvJrtJ)"
  },
  "spacing.Card.Footer.margin.to-Body": {
    "value": "var(--bOnbxr)",
    "variable": "var(--bOnbxr)"
  },
  "spacing.Card.Footer.padding.from-Footer": {
    "value": "var(--kNYjsI)",
    "variable": "var(--kNYjsI)"
  },
  "spacing.Card.Header.margin.to-Body": {
    "value": "var(--dwuSMF)",
    "variable": "var(--dwuSMF)"
  },
  "spacing.Card.Header.padding.from-Header": {
    "value": "var(--dcHlDg)",
    "variable": "var(--dcHlDg)"
  },
  "spacing.Card.Root.padding": {
    "value": "var(--ByWEY)",
    "variable": "var(--ByWEY)"
  },
  "spacing.Carousel.Heading.gap.heading-toNav": {
    "value": "var(--cODAIL)",
    "variable": "var(--cODAIL)"
  },
  "spacing.Carousel.Heading.gap.heading-toDescription": {
    "value": "var(--hqSTyc)",
    "variable": "var(--hqSTyc)"
  },
  "spacing.Carousel.Heading.gap.betweenNav": {
    "value": "var(--brfXwr)",
    "variable": "var(--brfXwr)"
  },
  "spacing.Carousel.Heading.padding.headingArea-toSlideArray": {
    "value": "var(--gpBTCQ)",
    "variable": "var(--gpBTCQ)"
  },
  "spacing.Carousel.Root.gap-carousel-toButton": {
    "value": "var(--brfroS)",
    "variable": "var(--brfroS)"
  },
  "spacing.Carousel.SkipLink.margin": {
    "value": "var(--eICkag)",
    "variable": "var(--eICkag)"
  },
  "spacing.Carousel.SlideArray.padding.top": {
    "value": "var(--gtcYMO)",
    "variable": "var(--gtcYMO)"
  },
  "spacing.Carousel.SlideArray.padding.bottom": {
    "value": "var(--hqSBIm)",
    "variable": "var(--hqSBIm)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.none.padding-horz": {
    "value": "var(--fpHVeU)",
    "variable": "var(--fpHVeU)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.xs.padding-horz": {
    "value": "var(--jQCgnR)",
    "variable": "var(--jQCgnR)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.sm.padding-horz": {
    "value": "var(--jHHxTg)",
    "variable": "var(--jHHxTg)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.md.padding-horz": {
    "value": "var(--gnccdr)",
    "variable": "var(--gnccdr)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.lg.padding-horz": {
    "value": "var(--fxDmsh)",
    "variable": "var(--fxDmsh)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.xl.padding-horz": {
    "value": "var(--iygrpu)",
    "variable": "var(--iygrpu)"
  },
  "spacing.Carousel.SlideArray.slideGap.xxs": {
    "value": "var(--bMeelm)",
    "variable": "var(--bMeelm)"
  },
  "spacing.Carousel.SlideArray.slideGap.xs": {
    "value": "var(--iEOVPS)",
    "variable": "var(--iEOVPS)"
  },
  "spacing.Carousel.SlideArray.slideGap.sm": {
    "value": "var(--leIUvH)",
    "variable": "var(--leIUvH)"
  },
  "spacing.Carousel.SlideArray.slideGap.md": {
    "value": "var(--cFfLhw)",
    "variable": "var(--cFfLhw)"
  },
  "spacing.Carousel.SlideArray.slideGap.lg": {
    "value": "var(--cgzvKq)",
    "variable": "var(--cgzvKq)"
  },
  "spacing.Carousel.SlideArray.slideGap.xl": {
    "value": "var(--gRNUmF)",
    "variable": "var(--gRNUmF)"
  },
  "spacing.ChipGroup.gap.horz": {
    "value": "var(--bpFLBX)",
    "variable": "var(--bpFLBX)"
  },
  "spacing.ChipGroup.gap.vert.default": {
    "value": "var(--bASdGr)",
    "variable": "var(--bASdGr)"
  },
  "spacing.ChipGroup.gap.vert.tighter": {
    "value": "var(--hhEQiB)",
    "variable": "var(--hhEQiB)"
  },
  "spacing.ChipGroup.padding.horz": {
    "value": "var(--fgUYoc)",
    "variable": "var(--fgUYoc)"
  },
  "spacing.ChipGroup.padding.vert": {
    "value": "var(--dfzGia)",
    "variable": "var(--dfzGia)"
  },
  "spacing.ChipGroup.padding.screen.leading": {
    "value": "var(--fePwvu)",
    "variable": "var(--fePwvu)"
  },
  "spacing.ChipGroup.padding.screen.trailing": {
    "value": "var(--dGbdfc)",
    "variable": "var(--dGbdfc)"
  },
  "spacing.Chip.padding.horz": {
    "value": "var(--fTmwWf)",
    "variable": "var(--fTmwWf)"
  },
  "spacing.Chip.padding.vert": {
    "value": "var(--dgnWVZ)",
    "variable": "var(--dgnWVZ)"
  },
  "spacing.Chip.gap.leading": {
    "value": "var(--iyFPiX)",
    "variable": "var(--iyFPiX)"
  },
  "spacing.Chip.gap.trailing": {
    "value": "var(--hXVhUN)",
    "variable": "var(--hXVhUN)"
  },
  "spacing.Chip.gap.inputChip-trailing": {
    "value": "var(--dLTNDs)",
    "variable": "var(--dLTNDs)"
  },
  "spacing.Chip.Close.margin.left": {
    "value": "var(--haKccD)",
    "variable": "var(--haKccD)"
  },
  "spacing.Chip.Close.padding": {
    "value": "var(--jdixam)",
    "variable": "var(--jdixam)"
  },
  "spacing.CloseButton.padding": {
    "value": "var(--hIkYOv)",
    "variable": "var(--hIkYOv)"
  },
  "spacing.CloseButton.margin": {
    "value": "var(--ioAyOA)",
    "variable": "var(--ioAyOA)"
  },
  "spacing.Combobox.ChipsOverflow.trailingTextArea.gap.limitNumber-toText": {
    "value": "var(--evRaQM)",
    "variable": "var(--evRaQM)"
  },
  "spacing.Combobox.Clear.margin.horz": {
    "value": "var(--uyWED)",
    "variable": "var(--uyWED)"
  },
  "spacing.Combobox.Heading.gap.leading": {
    "value": "var(--OuZxZ)",
    "variable": "var(--OuZxZ)"
  },
  "spacing.Combobox.Heading.padding.horz": {
    "value": "var(--gEWQAJ)",
    "variable": "var(--gEWQAJ)"
  },
  "spacing.Combobox.Heading.padding.vert": {
    "value": "var(--kGSZib)",
    "variable": "var(--kGSZib)"
  },
  "spacing.Combobox.Option.gap.leading": {
    "value": "var(--efUQli)",
    "variable": "var(--efUQli)"
  },
  "spacing.Combobox.Option.padding.horz": {
    "value": "var(--cEmPgy)",
    "variable": "var(--cEmPgy)"
  },
  "spacing.Combobox.Option.padding.vert": {
    "value": "var(--eAPILw)",
    "variable": "var(--eAPILw)"
  },
  "spacing.Combobox.Trigger.sm.gap.close-toSelect": {
    "value": "var(--cLDufK)",
    "variable": "var(--cLDufK)"
  },
  "spacing.Combobox.Trigger.sm.gap.default": {
    "value": "var(--hKxeuB)",
    "variable": "var(--hKxeuB)"
  },
  "spacing.Combobox.Trigger.sm.gap.trailing": {
    "value": "var(--hyUpmI)",
    "variable": "var(--hyUpmI)"
  },
  "spacing.Combobox.Trigger.sm.padding.horz": {
    "value": "var(--hXvBKi)",
    "variable": "var(--hXvBKi)"
  },
  "spacing.Combobox.Trigger.sm.padding.vert": {
    "value": "var(--EazRg)",
    "variable": "var(--EazRg)"
  },
  "spacing.Combobox.Trigger.md.gap.close-toSelect": {
    "value": "var(--iHLLR)",
    "variable": "var(--iHLLR)"
  },
  "spacing.Combobox.Trigger.md.gap.default": {
    "value": "var(--ZyjuC)",
    "variable": "var(--ZyjuC)"
  },
  "spacing.Combobox.Trigger.md.gap.trailing": {
    "value": "var(--loeztP)",
    "variable": "var(--loeztP)"
  },
  "spacing.Combobox.Trigger.md.padding.horz": {
    "value": "var(--cZhzap)",
    "variable": "var(--cZhzap)"
  },
  "spacing.Combobox.Trigger.md.padding.vert": {
    "value": "var(--dfvEuv)",
    "variable": "var(--dfvEuv)"
  },
  "spacing.Combobox.Trigger.lg.gap.close-toSelect": {
    "value": "var(--ilLOgL)",
    "variable": "var(--ilLOgL)"
  },
  "spacing.Combobox.Trigger.lg.gap.default": {
    "value": "var(--fQJoMg)",
    "variable": "var(--fQJoMg)"
  },
  "spacing.Combobox.Trigger.lg.gap.trailing": {
    "value": "var(--dZTStB)",
    "variable": "var(--dZTStB)"
  },
  "spacing.Combobox.Trigger.lg.padding.horz": {
    "value": "var(--iFxhSD)",
    "variable": "var(--iFxhSD)"
  },
  "spacing.Combobox.Trigger.lg.padding.vert": {
    "value": "var(--iTUIcF)",
    "variable": "var(--iTUIcF)"
  },
  "spacing.DateInput.sm.gap.input-toAdornment": {
    "value": "var(--jOTGFE)",
    "variable": "var(--jOTGFE)"
  },
  "spacing.DateInput.sm.gap.leading": {
    "value": "var(--iFUAoQ)",
    "variable": "var(--iFUAoQ)"
  },
  "spacing.DateInput.sm.gap.trailing": {
    "value": "var(--fYwVCm)",
    "variable": "var(--fYwVCm)"
  },
  "spacing.DateInput.sm.padding.horz": {
    "value": "var(--khbGKw)",
    "variable": "var(--khbGKw)"
  },
  "spacing.DateInput.sm.padding.horz-readOnly": {
    "value": "var(--gITNIv)",
    "variable": "var(--gITNIv)"
  },
  "spacing.DateInput.sm.padding.vert": {
    "value": "var(--eiKHUu)",
    "variable": "var(--eiKHUu)"
  },
  "spacing.DateInput.md.gap.input-toAdornment": {
    "value": "var(--dZYgxr)",
    "variable": "var(--dZYgxr)"
  },
  "spacing.DateInput.md.gap.leading": {
    "value": "var(--kPRNlP)",
    "variable": "var(--kPRNlP)"
  },
  "spacing.DateInput.md.gap.trailing": {
    "value": "var(--kquzZV)",
    "variable": "var(--kquzZV)"
  },
  "spacing.DateInput.md.padding.horz": {
    "value": "var(--cFsqub)",
    "variable": "var(--cFsqub)"
  },
  "spacing.DateInput.md.padding.horz-readOnly": {
    "value": "var(--bDBNVE)",
    "variable": "var(--bDBNVE)"
  },
  "spacing.DateInput.md.padding.vert": {
    "value": "var(--iTcIJp)",
    "variable": "var(--iTcIJp)"
  },
  "spacing.DateInput.lg.gap.input-toAdornment": {
    "value": "var(--fcTFFd)",
    "variable": "var(--fcTFFd)"
  },
  "spacing.DateInput.lg.gap.leading": {
    "value": "var(--DrCUF)",
    "variable": "var(--DrCUF)"
  },
  "spacing.DateInput.lg.gap.trailing": {
    "value": "var(--hCcRnL)",
    "variable": "var(--hCcRnL)"
  },
  "spacing.DateInput.lg.padding.horz": {
    "value": "var(--dInPBN)",
    "variable": "var(--dInPBN)"
  },
  "spacing.DateInput.lg.padding.horz-readOnly": {
    "value": "var(--jyuhfe)",
    "variable": "var(--jyuhfe)"
  },
  "spacing.DateInput.lg.padding.vert": {
    "value": "var(--lefWKz)",
    "variable": "var(--lefWKz)"
  },
  "spacing.DateInput.HelperArea.gap.icon-toText": {
    "value": "var(--dPCHNL)",
    "variable": "var(--dPCHNL)"
  },
  "spacing.DatePicker.Backdrop.padding.default.horz": {
    "value": "var(--eQOwou)",
    "variable": "var(--eQOwou)"
  },
  "spacing.DatePicker.Backdrop.padding.default.vert": {
    "value": "var(--jqWtrY)",
    "variable": "var(--jqWtrY)"
  },
  "spacing.DatePicker.Content.padding.vert": {
    "value": "var(--cggrVF)",
    "variable": "var(--cggrVF)"
  },
  "spacing.DatePicker.Content.padding.horz": {
    "value": "var(--brmcbn)",
    "variable": "var(--brmcbn)"
  },
  "spacing.DatePicker.Footer.padding.gap-toContent": {
    "value": "var(--krUHMJ)",
    "variable": "var(--krUHMJ)"
  },
  "spacing.DatePicker.Trigger.padding.sm.horz": {
    "value": "var(--bDkaGd)",
    "variable": "var(--bDkaGd)"
  },
  "spacing.DatePicker.Trigger.padding.md.horz": {
    "value": "var(--coGlie)",
    "variable": "var(--coGlie)"
  },
  "spacing.DatePicker.Trigger.padding.lg.horz": {
    "value": "var(--htEqIo)",
    "variable": "var(--htEqIo)"
  },
  "spacing.DateTimeBlock.Root.gap.toLabel": {
    "value": "var(--hRGpWX)",
    "variable": "var(--hRGpWX)"
  },
  "spacing.DateTimeBlock.Root.gap.toTime": {
    "value": "var(--fIYUhg)",
    "variable": "var(--fIYUhg)"
  },
  "spacing.DateTimeBlock.Dates.gap.toCard": {
    "value": "var(--dssjqc)",
    "variable": "var(--dssjqc)"
  },
  "spacing.DateTimeBlock.Dates.gap.toNav": {
    "value": "var(--joEzQh)",
    "variable": "var(--joEzQh)"
  },
  "spacing.DateTimeBlock.Day.padding.horz": {
    "value": "var(--jTsPvA)",
    "variable": "var(--jTsPvA)"
  },
  "spacing.DateTimeBlock.Day.padding.vert": {
    "value": "var(--boTXJi)",
    "variable": "var(--boTXJi)"
  },
  "spacing.DateTimeBlock.Wrap.padding.horz.outer": {
    "value": "var(--bPNWc)",
    "variable": "var(--bPNWc)"
  },
  "spacing.DateTimeBlock.Wrap.padding.horz.inner": {
    "value": "var(--buLcuL)",
    "variable": "var(--buLcuL)"
  },
  "spacing.Dropdown.Body.padding.horz": {
    "value": "var(--iDpjzn)",
    "variable": "var(--iDpjzn)"
  },
  "spacing.Dropdown.Body.padding.vert": {
    "value": "var(--TEkWl)",
    "variable": "var(--TEkWl)"
  },
  "spacing.Dropdown.Footer.padding.horz": {
    "value": "var(--exdgGe)",
    "variable": "var(--exdgGe)"
  },
  "spacing.Dropdown.Footer.padding.vert": {
    "value": "var(--jwpFXA)",
    "variable": "var(--jwpFXA)"
  },
  "spacing.Dropdown.Heading.gap.leading": {
    "value": "var(--limXIv)",
    "variable": "var(--limXIv)"
  },
  "spacing.Dropdown.Heading.padding.horz": {
    "value": "var(--liLbbf)",
    "variable": "var(--liLbbf)"
  },
  "spacing.Dropdown.Heading.padding.vert": {
    "value": "var(--gcxASd)",
    "variable": "var(--gcxASd)"
  },
  "spacing.FieldSet.gap.controls-toHelperArea": {
    "value": "var(--bMcHtG)",
    "variable": "var(--bMcHtG)"
  },
  "spacing.FieldSet.gap.controls-toLegendArea": {
    "value": "var(--dzLmtp)",
    "variable": "var(--dzLmtp)"
  },
  "spacing.FieldSet.helperArea.gap.text-toIcon": {
    "value": "var(--fLvtit)",
    "variable": "var(--fLvtit)"
  },
  "spacing.FieldSet.labelArea.gap.legend-toRequred": {
    "value": "var(--dnHVom)",
    "variable": "var(--dnHVom)"
  },
  "spacing.FieldSet.labelArea.gap.legend-toOptional": {
    "value": "var(--UZRKA)",
    "variable": "var(--UZRKA)"
  },
  "spacing.FieldSet.labeledControlArea.gap.vert": {
    "value": "var(--dTkVJe)",
    "variable": "var(--dTkVJe)"
  },
  "spacing.FieldSet.labeledControlArea.padding.left": {
    "value": "var(--dlEvvf)",
    "variable": "var(--dlEvvf)"
  },
  "spacing.FormField.gap.field-toHelperArea": {
    "value": "var(--dquxNs)",
    "variable": "var(--dquxNs)"
  },
  "spacing.FormField.gap.field-toLabelArea": {
    "value": "var(--iSzYxI)",
    "variable": "var(--iSzYxI)"
  },
  "spacing.FormField.HelperArea.gap.icon-toText": {
    "value": "var(--icfFMp)",
    "variable": "var(--icfFMp)"
  },
  "spacing.FormField.labelArea.gap.label-toRequired": {
    "value": "var(--cMPOPA)",
    "variable": "var(--cMPOPA)"
  },
  "spacing.FormField.labelArea.gap.label-toOptional": {
    "value": "var(--kstHYr)",
    "variable": "var(--kstHYr)"
  },
  "spacing.Form.FormActions.marginTop": {
    "value": "var(--hItNSr)",
    "variable": "var(--hItNSr)"
  },
  "spacing.Form.FormField.marginBottom": {
    "value": "var(--kQFJwY)",
    "variable": "var(--kQFJwY)"
  },
  "spacing.Form.FieldSet.marginBottom": {
    "value": "var(--cjtJzQ)",
    "variable": "var(--cjtJzQ)"
  },
  "spacing.Gleam.padding.horz": {
    "value": "var(--bKKlVz)",
    "variable": "var(--bKKlVz)"
  },
  "spacing.IconButton.xs.padding": {
    "value": "var(--gCvLoM)",
    "variable": "var(--gCvLoM)"
  },
  "spacing.IconButton.sm.padding": {
    "value": "var(--gCGMel)",
    "variable": "var(--gCGMel)"
  },
  "spacing.IconButton.md.padding": {
    "value": "var(--exmvqC)",
    "variable": "var(--exmvqC)"
  },
  "spacing.IconButton.lg.padding": {
    "value": "var(--kTjthY)",
    "variable": "var(--kTjthY)"
  },
  "spacing.InlineFeedback.gap.icon-toText": {
    "value": "var(--JxPsN)",
    "variable": "var(--JxPsN)"
  },
  "spacing.Input.HelperArea.gap.icon-toText": {
    "value": "var(--jMhILX)",
    "variable": "var(--jMhILX)"
  },
  "spacing.Input.sm.gap.leading": {
    "value": "var(--dfmEQU)",
    "variable": "var(--dfmEQU)"
  },
  "spacing.Input.sm.gap.trailing": {
    "value": "var(--gkPDwq)",
    "variable": "var(--gkPDwq)"
  },
  "spacing.Input.sm.padding.horz": {
    "value": "var(--pRoqY)",
    "variable": "var(--pRoqY)"
  },
  "spacing.Input.sm.padding.horz-readOnly": {
    "value": "var(--dZXdTf)",
    "variable": "var(--dZXdTf)"
  },
  "spacing.Input.sm.padding.vert": {
    "value": "var(--pVTga)",
    "variable": "var(--pVTga)"
  },
  "spacing.Input.md.gap.leading": {
    "value": "var(--fEScIz)",
    "variable": "var(--fEScIz)"
  },
  "spacing.Input.md.gap.trailing": {
    "value": "var(--hDlZld)",
    "variable": "var(--hDlZld)"
  },
  "spacing.Input.md.padding.horz": {
    "value": "var(--iZfXRz)",
    "variable": "var(--iZfXRz)"
  },
  "spacing.Input.md.padding.horz-readOnly": {
    "value": "var(--emWtgg)",
    "variable": "var(--emWtgg)"
  },
  "spacing.Input.md.padding.vert": {
    "value": "var(--jeiKV)",
    "variable": "var(--jeiKV)"
  },
  "spacing.Input.lg.gap.leading": {
    "value": "var(--ihKinF)",
    "variable": "var(--ihKinF)"
  },
  "spacing.Input.lg.gap.trailing": {
    "value": "var(--drlMfP)",
    "variable": "var(--drlMfP)"
  },
  "spacing.Input.lg.padding.horz": {
    "value": "var(--mCtXJ)",
    "variable": "var(--mCtXJ)"
  },
  "spacing.Input.lg.padding.horz-readOnly": {
    "value": "var(--kWVeqm)",
    "variable": "var(--kWVeqm)"
  },
  "spacing.Input.lg.padding.vert": {
    "value": "var(--yzKXP)",
    "variable": "var(--yzKXP)"
  },
  "spacing.LabeledControl.gap.control-toLabel": {
    "value": "var(--iyRHQq)",
    "variable": "var(--iyRHQq)"
  },
  "spacing.LabeledControl.padding.vert.control": {
    "value": "var(--klgjbJ)",
    "variable": "var(--klgjbJ)"
  },
  "spacing.LabeledControl.padding.vert.label": {
    "value": "var(--jjDwWg)",
    "variable": "var(--jjDwWg)"
  },
  "spacing.LabeledControl.padding.vert.switch.md": {
    "value": "var(--IfNwo)",
    "variable": "var(--IfNwo)"
  },
  "spacing.LabeledControl.padding.vert.switch.lg": {
    "value": "var(--jgSjDG)",
    "variable": "var(--jgSjDG)"
  },
  "spacing.LabeledInput.LabelArea.padding.top.default": {
    "value": "var(--lbiAhm)",
    "variable": "var(--lbiAhm)"
  },
  "spacing.LabeledInput.LabelArea.padding.top.active": {
    "value": "var(--fOdETB)",
    "variable": "var(--fOdETB)"
  },
  "spacing.LabeledInput.padding.horz": {
    "value": "var(--itaYAE)",
    "variable": "var(--itaYAE)"
  },
  "spacing.LabeledInput.padding.horz-readOnly": {
    "value": "var(--kWQsFH)",
    "variable": "var(--kWQsFH)"
  },
  "spacing.LabeledInput.padding.top": {
    "value": "var(--fZXSoQ)",
    "variable": "var(--fZXSoQ)"
  },
  "spacing.LabeledInput.padding.bottom": {
    "value": "var(--hHBZkU)",
    "variable": "var(--hHBZkU)"
  },
  "spacing.Layout.Content.padding": {
    "value": "var(--bRUVWB)",
    "variable": "var(--bRUVWB)"
  },
  "spacing.Layout.Root.gap": {
    "value": "var(--euQPXF)",
    "variable": "var(--euQPXF)"
  },
  "spacing.List.Item.padding.horz": {
    "value": "var(--bByHKn)",
    "variable": "var(--bByHKn)"
  },
  "spacing.List.Item.padding.vert": {
    "value": "var(--jCTNnJ)",
    "variable": "var(--jCTNnJ)"
  },
  "spacing.List.Item.padding.first.top": {
    "value": "var(--khGGSU)",
    "variable": "var(--khGGSU)"
  },
  "spacing.List.Item.padding.last.bottom": {
    "value": "var(--edKiiQ)",
    "variable": "var(--edKiiQ)"
  },
  "spacing.List.padding.nested-horz": {
    "value": "var(--hXVPET)",
    "variable": "var(--hXVPET)"
  },
  "spacing.List.group-gap.default": {
    "value": "var(--kdMLHa)",
    "variable": "var(--kdMLHa)"
  },
  "spacing.Menu.Heading.gap.leading": {
    "value": "var(--kguSJj)",
    "variable": "var(--kguSJj)"
  },
  "spacing.Menu.Heading.padding.horz": {
    "value": "var(--klUTcP)",
    "variable": "var(--klUTcP)"
  },
  "spacing.Menu.Heading.padding.vert": {
    "value": "var(--bRbGeR)",
    "variable": "var(--bRbGeR)"
  },
  "spacing.Menu.Item.gap.leading": {
    "value": "var(--enhQG)",
    "variable": "var(--enhQG)"
  },
  "spacing.Menu.Item.padding.horz": {
    "value": "var(--cpRmZa)",
    "variable": "var(--cpRmZa)"
  },
  "spacing.Menu.Item.padding.vert": {
    "value": "var(--coarbc)",
    "variable": "var(--coarbc)"
  },
  "spacing.Modal.Backdrop.padding.default.horz": {
    "value": "var(--dWMTNz)",
    "variable": "var(--dWMTNz)"
  },
  "spacing.Modal.Backdrop.padding.default.vert": {
    "value": "var(--fneGkh)",
    "variable": "var(--fneGkh)"
  },
  "spacing.Modal.Backdrop.padding.fullScreen.horz": {
    "value": "var(--jUawSX)",
    "variable": "var(--jUawSX)"
  },
  "spacing.Modal.Backdrop.padding.fullScreen.vert": {
    "value": "var(--lgwPIJ)",
    "variable": "var(--lgwPIJ)"
  },
  "spacing.Modal.Body.padding.horz": {
    "value": "var(--gJGKlL)",
    "variable": "var(--gJGKlL)"
  },
  "spacing.Modal.Body.padding.vert": {
    "value": "var(--ginhbx)",
    "variable": "var(--ginhbx)"
  },
  "spacing.Modal.CloseButton.margin.top": {
    "value": "var(--fHZiHg)",
    "variable": "var(--fHZiHg)"
  },
  "spacing.Modal.CloseButton.margin.right": {
    "value": "var(--kdbPEP)",
    "variable": "var(--kdbPEP)"
  },
  "spacing.Modal.Content.offset": {
    "value": "var(--hGGlpk)",
    "variable": "var(--hGGlpk)"
  },
  "spacing.Modal.Footer.padding.horz": {
    "value": "var(--eLrTOK)",
    "variable": "var(--eLrTOK)"
  },
  "spacing.Modal.Footer.padding.vert": {
    "value": "var(--kQXvXk)",
    "variable": "var(--kQXvXk)"
  },
  "spacing.Modal.Header.padding.left": {
    "value": "var(--cZODTM)",
    "variable": "var(--cZODTM)"
  },
  "spacing.Modal.Header.padding.vert": {
    "value": "var(--eIeyvq)",
    "variable": "var(--eIeyvq)"
  },
  "spacing.Modal.Header.padding.right": {
    "value": "var(--gfrCur)",
    "variable": "var(--gfrCur)"
  },
  "spacing.NumberRating.gap.star-toNumber": {
    "value": "var(--fIykaA)",
    "variable": "var(--fIykaA)"
  },
  "spacing.Page.padding.horz.desktop": {
    "value": "var(--hnYpHx)",
    "variable": "var(--hnYpHx)"
  },
  "spacing.Page.padding.horz.tablet": {
    "value": "var(--iFMWbV)",
    "variable": "var(--iFMWbV)"
  },
  "spacing.Page.padding.horz.mobile": {
    "value": "var(--geTjSP)",
    "variable": "var(--geTjSP)"
  },
  "spacing.Page.padding.bottom": {
    "value": "var(--iXcABO)",
    "variable": "var(--iXcABO)"
  },
  "spacing.Page.Breadcrumb.margin.top.desktop": {
    "value": "var(--ifRZDY)",
    "variable": "var(--ifRZDY)"
  },
  "spacing.Page.Breadcrumb.margin.top.tablet": {
    "value": "var(--keLiNY)",
    "variable": "var(--keLiNY)"
  },
  "spacing.Page.Breadcrumb.margin.top.mobile": {
    "value": "var(--ejkCRy)",
    "variable": "var(--ejkCRy)"
  },
  "spacing.Page.Breadcrumb.margin.bottom": {
    "value": "var(--eoKPXz)",
    "variable": "var(--eoKPXz)"
  },
  "spacing.Page.Content.margin.vert.desktop": {
    "value": "var(--hMBFQY)",
    "variable": "var(--hMBFQY)"
  },
  "spacing.Page.Content.margin.vert.tablet": {
    "value": "var(--gIawWs)",
    "variable": "var(--gIawWs)"
  },
  "spacing.Page.Content.margin.vert.mobile": {
    "value": "var(--eNPPne)",
    "variable": "var(--eNPPne)"
  },
  "spacing.Page.Header.margin.bottom.desktop": {
    "value": "var(--kAkcVA)",
    "variable": "var(--kAkcVA)"
  },
  "spacing.Page.Header.margin.bottom.tablet": {
    "value": "var(--bzYExs)",
    "variable": "var(--bzYExs)"
  },
  "spacing.Page.Header.margin.bottom.mobile": {
    "value": "var(--fsQubG)",
    "variable": "var(--fsQubG)"
  },
  "spacing.Page.Header.margin.top.desktop": {
    "value": "var(--ifTgwQ)",
    "variable": "var(--ifTgwQ)"
  },
  "spacing.Page.Header.margin.top.tablet": {
    "value": "var(--hQAGNU)",
    "variable": "var(--hQAGNU)"
  },
  "spacing.Page.Header.margin.top.mobile": {
    "value": "var(--eeatXS)",
    "variable": "var(--eeatXS)"
  },
  "spacing.Pagination.Item.between-pages": {
    "value": "var(--cBFJON)",
    "variable": "var(--cBFJON)"
  },
  "spacing.Pagination.JumpItem.to-controls": {
    "value": "var(--fJoCVK)",
    "variable": "var(--fJoCVK)"
  },
  "spacing.Pagination.JumpItem.padding.horz": {
    "value": "var(--dBcrqX)",
    "variable": "var(--dBcrqX)"
  },
  "spacing.Pagination.JumpItem.padding.vert": {
    "value": "var(--cQtiUd)",
    "variable": "var(--cQtiUd)"
  },
  "spacing.Pagination.Root.gap-toDivider": {
    "value": "var(--bEhpys)",
    "variable": "var(--bEhpys)"
  },
  "spacing.PhotoCarousel.Dots.gap-betweenMarkers": {
    "value": "var(--daecYr)",
    "variable": "var(--daecYr)"
  },
  "spacing.PhotoCarousel.Dots.margin.bottom": {
    "value": "var(--gTrRnX)",
    "variable": "var(--gTrRnX)"
  },
  "spacing.PhotoCarousel.Dots.padding.horz": {
    "value": "var(--itTKAI)",
    "variable": "var(--itTKAI)"
  },
  "spacing.PhotoCarousel.Dots.padding.vert": {
    "value": "var(--lhqmIi)",
    "variable": "var(--lhqmIi)"
  },
  "spacing.Popover.Backdrop.padding.default.horz": {
    "value": "var(--ePmISV)",
    "variable": "var(--ePmISV)"
  },
  "spacing.Popover.Backdrop.padding.default.vert": {
    "value": "var(--bFEQiL)",
    "variable": "var(--bFEQiL)"
  },
  "spacing.Popover.Body.padding.horz": {
    "value": "var(--kcThjh)",
    "variable": "var(--kcThjh)"
  },
  "spacing.Popover.Body.padding.vert": {
    "value": "var(--jciJBL)",
    "variable": "var(--jciJBL)"
  },
  "spacing.Popover.CloseButton.margin.top": {
    "value": "var(--gOcrjS)",
    "variable": "var(--gOcrjS)"
  },
  "spacing.Popover.CloseButton.margin.right": {
    "value": "var(--CeQbN)",
    "variable": "var(--CeQbN)"
  },
  "spacing.Popover.Header.gap.leading": {
    "value": "var(--kxAJFK)",
    "variable": "var(--kxAJFK)"
  },
  "spacing.Popover.Header.padding.left": {
    "value": "var(--ehavRK)",
    "variable": "var(--ehavRK)"
  },
  "spacing.Popover.Header.padding.vert": {
    "value": "var(--kEeelc)",
    "variable": "var(--kEeelc)"
  },
  "spacing.Popover.Header.padding.right": {
    "value": "var(--ioWowZ)",
    "variable": "var(--ioWowZ)"
  },
  "spacing.ProgressMeter.gap.label-toMeta": {
    "value": "var(--bfbDpi)",
    "variable": "var(--bfbDpi)"
  },
  "spacing.ProgressMeter.gap.horizontal.node-toLabel": {
    "value": "var(--hcYNuk)",
    "variable": "var(--hcYNuk)"
  },
  "spacing.ProgressMeter.gap.vertical.node-toLabel": {
    "value": "var(--jVfGpA)",
    "variable": "var(--jVfGpA)"
  },
  "spacing.ProgressMeter.padding.tag-top": {
    "value": "var(--hRHmIs)",
    "variable": "var(--hRHmIs)"
  },
  "spacing.PropertyCard.BadgeArea.gap": {
    "value": "var(--cSGGbk)",
    "variable": "var(--cSGGbk)"
  },
  "spacing.PropertyCard.Badge.padding.horz": {
    "value": "var(--gJKbyC)",
    "variable": "var(--gJKbyC)"
  },
  "spacing.PropertyCard.Badge.padding.vert": {
    "value": "var(--iXTKxQ)",
    "variable": "var(--iXTKxQ)"
  },
  "spacing.PropertyCard.DataArea.dataDivider.gap-toDataItem": {
    "value": "var(--MlMti)",
    "variable": "var(--MlMti)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.between-dataItems.default": {
    "value": "var(--bTLfsn)",
    "variable": "var(--bTLfsn)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.between-dataItems.loading": {
    "value": "var(--dMXXdC)",
    "variable": "var(--dMXXdC)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.dataArea1-toIcon": {
    "value": "var(--hDVbwX)",
    "variable": "var(--hDVbwX)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.horz": {
    "value": "var(--gnCbqQ)",
    "variable": "var(--gnCbqQ)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.top": {
    "value": "var(--bsXpWo)",
    "variable": "var(--bsXpWo)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.bottom": {
    "value": "var(--iKVqPg)",
    "variable": "var(--iKVqPg)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.between-dataItems.default": {
    "value": "var(--bdBQll)",
    "variable": "var(--bdBQll)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.between-dataItems.loading": {
    "value": "var(--fmNUyQ)",
    "variable": "var(--fmNUyQ)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.dataArea1-toIcon": {
    "value": "var(--hnhnEZ)",
    "variable": "var(--hnhnEZ)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.horz": {
    "value": "var(--bblBne)",
    "variable": "var(--bblBne)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.top": {
    "value": "var(--fppvLi)",
    "variable": "var(--fppvLi)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.bottom": {
    "value": "var(--cRlyXe)",
    "variable": "var(--cRlyXe)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.between-dataItems.default": {
    "value": "var(--daEFPI)",
    "variable": "var(--daEFPI)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.between-dataItems.loading": {
    "value": "var(--kmjEeB)",
    "variable": "var(--kmjEeB)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.dataArea1-toIcon": {
    "value": "var(--fvjhEs)",
    "variable": "var(--fvjhEs)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.horz": {
    "value": "var(--cTilsH)",
    "variable": "var(--cTilsH)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.top": {
    "value": "var(--eEJIpr)",
    "variable": "var(--eEJIpr)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.bottom": {
    "value": "var(--ZnlKz)",
    "variable": "var(--ZnlKz)"
  },
  "spacing.PropertyCard.FlexArea.gap.dataWrapper-toFlexArea": {
    "value": "var(--fHKjRO)",
    "variable": "var(--fHKjRO)"
  },
  "spacing.PropertyCard.FlexArea.padding.horz": {
    "value": "var(--gDXDFn)",
    "variable": "var(--gDXDFn)"
  },
  "spacing.PropertyCard.FlexArea.padding.vert": {
    "value": "var(--iBIBiJ)",
    "variable": "var(--iBIBiJ)"
  },
  "spacing.PropertyCard.PhotoHeader.margin.horz": {
    "value": "var(--gQLpmv)",
    "variable": "var(--gQLpmv)"
  },
  "spacing.PropertyCard.PhotoHeader.margin.vert": {
    "value": "var(--hASgMx)",
    "variable": "var(--hASgMx)"
  },
  "spacing.PropertyCard.PhotoFooter.logo.padding.horz": {
    "value": "var(--hlfwJk)",
    "variable": "var(--hlfwJk)"
  },
  "spacing.PropertyCard.PhotoFooter.logo.padding.vert": {
    "value": "var(--bvYjsK)",
    "variable": "var(--bvYjsK)"
  },
  "spacing.PropertyCard.Root.sm.gap.card-toDataArea5": {
    "value": "var(--leTSFy)",
    "variable": "var(--leTSFy)"
  },
  "spacing.PropertyCard.Root.horiz.gap.card-toDataArea5": {
    "value": "var(--bEpUmm)",
    "variable": "var(--bEpUmm)"
  },
  "spacing.PropertyCard.SaveButton.padding.top": {
    "value": "var(--cujLhE)",
    "variable": "var(--cujLhE)"
  },
  "spacing.PropertyCard.SaveButton.padding.right": {
    "value": "var(--gncOYP)",
    "variable": "var(--gncOYP)"
  },
  "spacing.PropertyCard.SaveButton.padding.bottom": {
    "value": "var(--gATURI)",
    "variable": "var(--gATURI)"
  },
  "spacing.PropertyCard.SaveButton.padding.left": {
    "value": "var(--kkcFcY)",
    "variable": "var(--kkcFcY)"
  },
  "spacing.Range.Root.margin.vert": {
    "value": "var(--ebimgE)",
    "variable": "var(--ebimgE)"
  },
  "spacing.Range.Handle.margin.top": {
    "value": "var(--ckWLMC)",
    "variable": "var(--ckWLMC)"
  },
  "spacing.RatingStars.gap.between-stars": {
    "value": "var(--fFJOJd)",
    "variable": "var(--fFJOJd)"
  },
  "spacing.RatingStars.gap.stars-toContent": {
    "value": "var(--cNHGJR)",
    "variable": "var(--cNHGJR)"
  },
  "spacing.RatingStars.gap.star-toNumber": {
    "value": "var(--jBfKhs)",
    "variable": "var(--jBfKhs)"
  },
  "spacing.RatingStars.gap.divider-toContent": {
    "value": "var(--SIBf)",
    "variable": "var(--SIBf)"
  },
  "spacing.ShowHide.Button.margin.top": {
    "value": "var(--erXIUm)",
    "variable": "var(--erXIUm)"
  },
  "spacing.ShowHide.gap.label-toIcon": {
    "value": "var(--jjEfAp)",
    "variable": "var(--jjEfAp)"
  },
  "spacing.ShowHide.gap.button-toContent": {
    "value": "var(--ekXPFz)",
    "variable": "var(--ekXPFz)"
  },
  "spacing.Switch.Track.md.padding.horz": {
    "value": "var(--bMdaDF)",
    "variable": "var(--bMdaDF)"
  },
  "spacing.Switch.Track.md.padding.vert": {
    "value": "var(--bndXcH)",
    "variable": "var(--bndXcH)"
  },
  "spacing.Switch.Track.lg.padding.horz": {
    "value": "var(--bEWBPD)",
    "variable": "var(--bEWBPD)"
  },
  "spacing.Switch.Track.lg.padding.vert": {
    "value": "var(--cgYpWl)",
    "variable": "var(--cgYpWl)"
  },
  "spacing.Switch.Handle.md.position.top": {
    "value": "var(--hLAhSQ)",
    "variable": "var(--hLAhSQ)"
  },
  "spacing.Switch.Handle.md.position.left": {
    "value": "var(--kgwRjw)",
    "variable": "var(--kgwRjw)"
  },
  "spacing.Switch.Handle.lg.position.top": {
    "value": "var(--bnQnIW)",
    "variable": "var(--bnQnIW)"
  },
  "spacing.Switch.Handle.lg.position.left": {
    "value": "var(--dIMWZC)",
    "variable": "var(--dIMWZC)"
  },
  "spacing.Table.Cell.gap.icon-toLabel": {
    "value": "var(--bYZrAz)",
    "variable": "var(--bYZrAz)"
  },
  "spacing.Table.Cell.padding.size.sm.horz": {
    "value": "var(--cqdTGj)",
    "variable": "var(--cqdTGj)"
  },
  "spacing.Table.Cell.padding.size.sm.vert": {
    "value": "var(--gFctQl)",
    "variable": "var(--gFctQl)"
  },
  "spacing.Table.Cell.padding.size.md.horz": {
    "value": "var(--hXJpwg)",
    "variable": "var(--hXJpwg)"
  },
  "spacing.Table.Cell.padding.size.md.vert": {
    "value": "var(--jnwRqe)",
    "variable": "var(--jnwRqe)"
  },
  "spacing.Table.Cell.padding.size.lg.horz": {
    "value": "var(--cxwWLi)",
    "variable": "var(--cxwWLi)"
  },
  "spacing.Table.Cell.padding.size.lg.vert": {
    "value": "var(--dsWmDY)",
    "variable": "var(--dsWmDY)"
  },
  "spacing.Tabs.gap.leading": {
    "value": "var(--fYbadB)",
    "variable": "var(--fYbadB)"
  },
  "spacing.Tabs.gap.trailing": {
    "value": "var(--bYpqpT)",
    "variable": "var(--bYpqpT)"
  },
  "spacing.Tabs.offsetBorder": {
    "value": "var(--dfAadf)",
    "variable": "var(--dfAadf)"
  },
  "spacing.Tabs.padding.panel": {
    "value": "var(--gWIeqQ)",
    "variable": "var(--gWIeqQ)"
  },
  "spacing.Tabs.padding.horz": {
    "value": "var(--jxAGIl)",
    "variable": "var(--jxAGIl)"
  },
  "spacing.Tabs.padding.vert": {
    "value": "var(--khVvNT)",
    "variable": "var(--khVvNT)"
  },
  "spacing.Tabs.padding.file.active.top": {
    "value": "var(--dvTDYf)",
    "variable": "var(--dvTDYf)"
  },
  "spacing.Tag.sm.gap.label-toIcon": {
    "value": "var(--ioVLjH)",
    "variable": "var(--ioVLjH)"
  },
  "spacing.Tag.sm.padding.horz": {
    "value": "var(--dDoFBQ)",
    "variable": "var(--dDoFBQ)"
  },
  "spacing.Tag.sm.padding.vert": {
    "value": "var(--idUucK)",
    "variable": "var(--idUucK)"
  },
  "spacing.Tag.md.gap.label-toIcon": {
    "value": "var(--cFfuoA)",
    "variable": "var(--cFfuoA)"
  },
  "spacing.Tag.md.padding.horz": {
    "value": "var(--haOdqX)",
    "variable": "var(--haOdqX)"
  },
  "spacing.Tag.md.padding.vert": {
    "value": "var(--QKiwd)",
    "variable": "var(--QKiwd)"
  },
  "spacing.TextButton.gap.label-toIcon": {
    "value": "var(--jDlTnB)",
    "variable": "var(--jDlTnB)"
  },
  "spacing.TextButton.padding.horz": {
    "value": "var(--eqFQxq)",
    "variable": "var(--eqFQxq)"
  },
  "spacing.TextButton.padding.vert": {
    "value": "var(--fzZijY)",
    "variable": "var(--fzZijY)"
  },
  "spacing.Textarea.padding.horz": {
    "value": "var(--gEyEaD)",
    "variable": "var(--gEyEaD)"
  },
  "spacing.Textarea.padding.horz-readOnly": {
    "value": "var(--vEpgo)",
    "variable": "var(--vEpgo)"
  },
  "spacing.Textarea.padding.vert": {
    "value": "var(--kVwiEp)",
    "variable": "var(--kVwiEp)"
  },
  "spacing.Toast.gap.content-toAction": {
    "value": "var(--iXated)",
    "variable": "var(--iXated)"
  },
  "spacing.Toast.gap.leading": {
    "value": "var(--dRdCFI)",
    "variable": "var(--dRdCFI)"
  },
  "spacing.Toast.gap.trailing": {
    "value": "var(--eoFbYO)",
    "variable": "var(--eoFbYO)"
  },
  "spacing.Toast.padding.horz": {
    "value": "var(--iThVU)",
    "variable": "var(--iThVU)"
  },
  "spacing.Toast.padding.vert": {
    "value": "var(--caNeNe)",
    "variable": "var(--caNeNe)"
  },
  "spacing.Toast.CloseButton.margin.top": {
    "value": "var(--gGJMCC)",
    "variable": "var(--gGJMCC)"
  },
  "spacing.Toast.CloseButton.margin.right": {
    "value": "var(--euRCSx)",
    "variable": "var(--euRCSx)"
  },
  "spacing.ToggleButton.sm.gap.label-toIcon": {
    "value": "var(--gtgfbp)",
    "variable": "var(--gtgfbp)"
  },
  "spacing.ToggleButton.sm.padding.bare.horz": {
    "value": "var(--gGJogb)",
    "variable": "var(--gGJogb)"
  },
  "spacing.ToggleButton.sm.padding.bare.horz-narrow": {
    "value": "var(--cJpYmt)",
    "variable": "var(--cJpYmt)"
  },
  "spacing.ToggleButton.sm.padding.bare.horz-narrowest": {
    "value": "var(--dqbDeH)",
    "variable": "var(--dqbDeH)"
  },
  "spacing.ToggleButton.sm.padding.horz": {
    "value": "var(--eiQEuW)",
    "variable": "var(--eiQEuW)"
  },
  "spacing.ToggleButton.sm.padding.vert": {
    "value": "var(--jNnzUs)",
    "variable": "var(--jNnzUs)"
  },
  "spacing.ToggleButton.md.gap.label-toIcon": {
    "value": "var(--fjSVfq)",
    "variable": "var(--fjSVfq)"
  },
  "spacing.ToggleButton.md.padding.bare.horz": {
    "value": "var(--dwYtSU)",
    "variable": "var(--dwYtSU)"
  },
  "spacing.ToggleButton.md.padding.bare.horz-narrow": {
    "value": "var(--fgZCvW)",
    "variable": "var(--fgZCvW)"
  },
  "spacing.ToggleButton.md.padding.bare.horz-narrowest": {
    "value": "var(--cWeqzc)",
    "variable": "var(--cWeqzc)"
  },
  "spacing.ToggleButton.md.padding.horz": {
    "value": "var(--fHajJ)",
    "variable": "var(--fHajJ)"
  },
  "spacing.ToggleButton.md.padding.vert": {
    "value": "var(--dKVsMv)",
    "variable": "var(--dKVsMv)"
  },
  "spacing.ToggleButton.lg.gap.label-toIcon": {
    "value": "var(--gMSDxQ)",
    "variable": "var(--gMSDxQ)"
  },
  "spacing.ToggleButton.lg.padding.bare.horz": {
    "value": "var(--kEUXji)",
    "variable": "var(--kEUXji)"
  },
  "spacing.ToggleButton.lg.padding.bare.horz-narrow": {
    "value": "var(--frFILY)",
    "variable": "var(--frFILY)"
  },
  "spacing.ToggleButton.lg.padding.bare.horz-narrowest": {
    "value": "var(--caDONi)",
    "variable": "var(--caDONi)"
  },
  "spacing.ToggleButton.lg.padding.horz": {
    "value": "var(--kFyAvX)",
    "variable": "var(--kFyAvX)"
  },
  "spacing.ToggleButton.lg.padding.vert": {
    "value": "var(--eNTpWF)",
    "variable": "var(--eNTpWF)"
  },
  "spacing.ToggleCard.Footer.margin.to-Body": {
    "value": "var(--gSeOjl)",
    "variable": "var(--gSeOjl)"
  },
  "spacing.ToggleCard.Footer.padding.from-Footer": {
    "value": "var(--jpBqSy)",
    "variable": "var(--jpBqSy)"
  },
  "spacing.ToggleCard.Header.margin.to-Body": {
    "value": "var(--fSjNIT)",
    "variable": "var(--fSjNIT)"
  },
  "spacing.ToggleCard.Header.padding.from-Header": {
    "value": "var(--fgPYq)",
    "variable": "var(--fgPYq)"
  },
  "spacing.ToggleCard.Root.padding": {
    "value": "var(--txHQa)",
    "variable": "var(--txHQa)"
  },
  "spacing.Tooltip.mWeb.padding.horz": {
    "value": "var(--bOYYAQ)",
    "variable": "var(--bOYYAQ)"
  },
  "spacing.Tooltip.mWeb.padding.vert": {
    "value": "var(--jEggW)",
    "variable": "var(--jEggW)"
  },
  "spacing.Tooltip.desktop.padding.horz": {
    "value": "var(--ipLmUL)",
    "variable": "var(--ipLmUL)"
  },
  "spacing.Tooltip.desktop.padding.vert": {
    "value": "var(--dkOyop)",
    "variable": "var(--dkOyop)"
  },
  "spacing.TriggerText.padding": {
    "value": "var(--dbWCmG)",
    "variable": "var(--dbWCmG)"
  },
  "spacing.UpsellBanner.Action.margin.content-toActions.horz": {
    "value": "var(--kvIRaJ)",
    "variable": "var(--kvIRaJ)"
  },
  "spacing.UpsellBanner.Action.margin.content-toActions.vert": {
    "value": "var(--gqXmhD)",
    "variable": "var(--gqXmhD)"
  },
  "spacing.UpsellBanner.Body.margin.heading-toMessage.horz": {
    "value": "var(--fUHwFU)",
    "variable": "var(--fUHwFU)"
  },
  "spacing.UpsellBanner.Body.margin.heading-toMessage.vert": {
    "value": "var(--iqJBxK)",
    "variable": "var(--iqJBxK)"
  },
  "spacing.UpsellBanner.Header.margin.content-toClose": {
    "value": "var(--gfbWGl)",
    "variable": "var(--gfbWGl)"
  },
  "spacing.UpsellBanner.Root.gap.leading": {
    "value": "var(--iGkwIx)",
    "variable": "var(--iGkwIx)"
  },
  "spacing.UpsellBanner.Root.gap.trailing": {
    "value": "var(--kNMYvT)",
    "variable": "var(--kNMYvT)"
  },
  "spacing.UpsellBanner.Root.padding.horz": {
    "value": "var(--iDhaul)",
    "variable": "var(--iDhaul)"
  },
  "spacing.UpsellBanner.Root.padding.vert": {
    "value": "var(--bfVzDn)",
    "variable": "var(--bfVzDn)"
  },
  "spacing.UpsellBanner.CloseButton.margin.top": {
    "value": "var(--hJHynY)",
    "variable": "var(--hJHynY)"
  },
  "spacing.UpsellBanner.CloseButton.margin.right": {
    "value": "var(--cZWSCT)",
    "variable": "var(--cZWSCT)"
  },
  "spacing.Upsell.Action.margin.content-toActions": {
    "value": "var(--eykslP)",
    "variable": "var(--eykslP)"
  },
  "spacing.Upsell.Body.margin.heading-toMessage": {
    "value": "var(--cpFKXy)",
    "variable": "var(--cpFKXy)"
  },
  "spacing.Upsell.Header.gap.content-toClose": {
    "value": "var(--XCyuN)",
    "variable": "var(--XCyuN)"
  },
  "spacing.Upsell.Legal.margin.content-toActions": {
    "value": "var(--vkpyO)",
    "variable": "var(--vkpyO)"
  },
  "spacing.Upsell.Root.gap.img-toText": {
    "value": "var(--laNBLB)",
    "variable": "var(--laNBLB)"
  },
  "spacing.Upsell.Root.gap.icon-toText": {
    "value": "var(--gCsqnd)",
    "variable": "var(--gCsqnd)"
  },
  "spacing.Upsell.Root.padding.horz": {
    "value": "var(--aAMAN)",
    "variable": "var(--aAMAN)"
  },
  "spacing.Upsell.Root.padding.vert": {
    "value": "var(--jaTNpz)",
    "variable": "var(--jaTNpz)"
  },
  "spacing.Upsell.CloseButton.margin.top": {
    "value": "var(--wsvUA)",
    "variable": "var(--wsvUA)"
  },
  "spacing.Upsell.CloseButton.margin.right": {
    "value": "var(--bpUfxn)",
    "variable": "var(--bpUfxn)"
  },
  "spacing.VerticalNav.Divider.padding.vert": {
    "value": "var(--dAQaqk)",
    "variable": "var(--dAQaqk)"
  },
  "spacing.VerticalNav.Divider.gap.toNavItems": {
    "value": "var(--coeCWC)",
    "variable": "var(--coeCWC)"
  },
  "spacing.VerticalNav.Heading.padding.horz": {
    "value": "var(--gMewhn)",
    "variable": "var(--gMewhn)"
  },
  "spacing.VerticalNav.Heading.padding.vert": {
    "value": "var(--iLWGTF)",
    "variable": "var(--iLWGTF)"
  },
  "spacing.VerticalNav.Item.gap.leading": {
    "value": "var(--bDlGZK)",
    "variable": "var(--bDlGZK)"
  },
  "spacing.VerticalNav.Item.padding.horz": {
    "value": "var(--dvbYUm)",
    "variable": "var(--dvbYUm)"
  },
  "spacing.VerticalNav.Item.padding.vert": {
    "value": "var(--kkTJOo)",
    "variable": "var(--kkTJOo)"
  },
  "spacing.VerticalNav.List.gap.betweenItems": {
    "value": "var(--kcoIZB)",
    "variable": "var(--kcoIZB)"
  },
  "spacing.VerticalNav.List.padding.vert": {
    "value": "var(--ebedhT)",
    "variable": "var(--ebedhT)"
  },
  "spacing.VerticalNav.Root.padding.vert": {
    "value": "var(--fXnZST)",
    "variable": "var(--fXnZST)"
  },
  "spacing.VerticalNav.Root.padding.horz": {
    "value": "var(--kUBZjt)",
    "variable": "var(--kUBZjt)"
  },
  "spacing.device.margin.mobile": {
    "value": "var(--dPWswx)",
    "variable": "var(--dPWswx)"
  },
  "spacing.device.margin.tablet": {
    "value": "var(--cVXwjX)",
    "variable": "var(--cVXwjX)"
  },
  "spacing.device.margin.desktop": {
    "value": "var(--jMivYf)",
    "variable": "var(--jMivYf)"
  },
  "spacing.tightest": {
    "value": "var(--gOoWtX)",
    "variable": "var(--gOoWtX)"
  },
  "spacing.tighter": {
    "value": "var(--hLkrWi)",
    "variable": "var(--hLkrWi)"
  },
  "spacing.tight": {
    "value": "var(--jKknzl)",
    "variable": "var(--jKknzl)"
  },
  "spacing.default": {
    "value": "var(--hRrfDo)",
    "variable": "var(--hRrfDo)"
  },
  "spacing.loose": {
    "value": "var(--dmLIIl)",
    "variable": "var(--dmLIIl)"
  },
  "spacing.looser": {
    "value": "var(--bqtQgP)",
    "variable": "var(--bqtQgP)"
  },
  "spacing.none": {
    "value": "var(--jWXhYR)",
    "variable": "var(--jWXhYR)"
  },
  "spacing.conjoined-offsetBorder": {
    "value": "var(--gYvjwC)",
    "variable": "var(--gYvjwC)"
  },
  "spacing.layout.tightest": {
    "value": "var(--gilTII)",
    "variable": "var(--gilTII)"
  },
  "spacing.layout.tighter": {
    "value": "var(--icAmQN)",
    "variable": "var(--icAmQN)"
  },
  "spacing.layout.tight": {
    "value": "var(--btpFxC)",
    "variable": "var(--btpFxC)"
  },
  "spacing.layout.default": {
    "value": "var(--bArDtj)",
    "variable": "var(--bArDtj)"
  },
  "spacing.layout.loose": {
    "value": "var(--fgohXG)",
    "variable": "var(--fgohXG)"
  },
  "spacing.layout.looser": {
    "value": "var(--fpICwE)",
    "variable": "var(--fpICwE)"
  },
  "spacing.layout.loosest": {
    "value": "var(--fxUeRh)",
    "variable": "var(--fxUeRh)"
  },
  "spacing.layout.vast.default": {
    "value": "var(--dGXRfu)",
    "variable": "var(--dGXRfu)"
  },
  "spacing.layout.vast.loose": {
    "value": "var(--lfGjAb)",
    "variable": "var(--lfGjAb)"
  },
  "spacing.layout.vast.looser": {
    "value": "var(--ibzIPx)",
    "variable": "var(--ibzIPx)"
  },
  "spacing.micro.tight": {
    "value": "var(--gYfDtm)",
    "variable": "var(--gYfDtm)"
  },
  "spacing.micro.default": {
    "value": "var(--kbxbWf)",
    "variable": "var(--kbxbWf)"
  },
  "spacing.xxs": {
    "value": "var(--eooIFU)",
    "variable": "var(--eooIFU)"
  },
  "spacing.xs": {
    "value": "var(--icrUDE)",
    "variable": "var(--icrUDE)"
  },
  "spacing.sm": {
    "value": "var(--jolVMp)",
    "variable": "var(--jolVMp)"
  },
  "spacing.md": {
    "value": "var(--eEeglK)",
    "variable": "var(--eEeglK)"
  },
  "spacing.lg": {
    "value": "var(--fFUZAQ)",
    "variable": "var(--fFUZAQ)"
  },
  "spacing.xl": {
    "value": "var(--gvVjyT)",
    "variable": "var(--gvVjyT)"
  },
  "sizes.Accordion.Header.icon.height": {
    "value": "var(--dUuXlC)",
    "variable": "var(--dUuXlC)"
  },
  "sizes.Accordion.Header.icon.width": {
    "value": "var(--ckxBL)",
    "variable": "var(--ckxBL)"
  },
  "sizes.AdornedInput.Icon.height": {
    "value": "var(--gBhSpF)",
    "variable": "var(--gBhSpF)"
  },
  "sizes.AdornedInput.Icon.width": {
    "value": "var(--bOwaqs)",
    "variable": "var(--bOwaqs)"
  },
  "sizes.Avatar.Badge.sm.icon.default": {
    "value": "var(--iBxkpO)",
    "variable": "var(--iBxkpO)"
  },
  "sizes.Avatar.Badge.sm.icon.bare": {
    "value": "var(--hWOsnN)",
    "variable": "var(--hWOsnN)"
  },
  "sizes.Avatar.Badge.md.icon.default": {
    "value": "var(--jjvGhx)",
    "variable": "var(--jjvGhx)"
  },
  "sizes.Avatar.Badge.md.icon.bare": {
    "value": "var(--kYUsJa)",
    "variable": "var(--kYUsJa)"
  },
  "sizes.Avatar.Badge.lg.icon.default": {
    "value": "var(--dFoXar)",
    "variable": "var(--dFoXar)"
  },
  "sizes.Avatar.Badge.lg.icon.bare": {
    "value": "var(--felzA)",
    "variable": "var(--felzA)"
  },
  "sizes.Avatar.Icon.xs": {
    "value": "var(--ewEddJ)",
    "variable": "var(--ewEddJ)"
  },
  "sizes.Avatar.Icon.sm": {
    "value": "var(--khcRxE)",
    "variable": "var(--khcRxE)"
  },
  "sizes.Avatar.Icon.md": {
    "value": "var(--hWBBLz)",
    "variable": "var(--hWBBLz)"
  },
  "sizes.Avatar.Icon.lg": {
    "value": "var(--cWDtPR)",
    "variable": "var(--cWDtPR)"
  },
  "sizes.Avatar.Icon.xl": {
    "value": "var(--dshawy)",
    "variable": "var(--dshawy)"
  },
  "sizes.Avatar.Icon.xxl": {
    "value": "var(--lcJBNS)",
    "variable": "var(--lcJBNS)"
  },
  "sizes.Avatar.Root.xs.size": {
    "value": "var(--cPlPHM)",
    "variable": "var(--cPlPHM)"
  },
  "sizes.Avatar.Root.sm.size": {
    "value": "var(--blikKp)",
    "variable": "var(--blikKp)"
  },
  "sizes.Avatar.Root.md.size": {
    "value": "var(--emAhje)",
    "variable": "var(--emAhje)"
  },
  "sizes.Avatar.Root.lg.size": {
    "value": "var(--bplgtU)",
    "variable": "var(--bplgtU)"
  },
  "sizes.Avatar.Root.xl.size": {
    "value": "var(--knjsKL)",
    "variable": "var(--knjsKL)"
  },
  "sizes.Avatar.Root.xxl.size": {
    "value": "var(--bcxeWn)",
    "variable": "var(--bcxeWn)"
  },
  "sizes.Button.xs.tapArea": {
    "value": "var(--gNgfRf)",
    "variable": "var(--gNgfRf)"
  },
  "sizes.Button.sm.tapArea": {
    "value": "var(--dDSjIS)",
    "variable": "var(--dDSjIS)"
  },
  "sizes.Button.md.tapArea": {
    "value": "var(--dTpajF)",
    "variable": "var(--dTpajF)"
  },
  "sizes.Button.lg.tapArea": {
    "value": "var(--ijRyFf)",
    "variable": "var(--ijRyFf)"
  },
  "sizes.Calendar.ControlButton.width": {
    "value": "var(--ebhvKB)",
    "variable": "var(--ebhvKB)"
  },
  "sizes.Calendar.ControlButton.height": {
    "value": "var(--fAeyRM)",
    "variable": "var(--fAeyRM)"
  },
  "sizes.Calendar.Day.width": {
    "value": "var(--sAJjY)",
    "variable": "var(--sAJjY)"
  },
  "sizes.Calendar.Day.height": {
    "value": "var(--fQnuhd)",
    "variable": "var(--fQnuhd)"
  },
  "sizes.Calendar.YearSelect.button.width": {
    "value": "var(--JCoxQ)",
    "variable": "var(--JCoxQ)"
  },
  "sizes.Calendar.YearSelect.button.height": {
    "value": "var(--kFzOJt)",
    "variable": "var(--kFzOJt)"
  },
  "sizes.Calendar.YearSelect.icon.width": {
    "value": "var(--hbEJzN)",
    "variable": "var(--hbEJzN)"
  },
  "sizes.Calendar.YearSelect.icon.height": {
    "value": "var(--gmMuys)",
    "variable": "var(--gmMuys)"
  },
  "sizes.Carousel.SkipLink.height": {
    "value": "var(--kXgqKa)",
    "variable": "var(--kXgqKa)"
  },
  "sizes.Checkbox.box": {
    "value": "var(--jbUpgn)",
    "variable": "var(--jbUpgn)"
  },
  "sizes.Checkbox.frame": {
    "value": "var(--hBAPyn)",
    "variable": "var(--hBAPyn)"
  },
  "sizes.Checkbox.icon": {
    "value": "var(--CGfPh)",
    "variable": "var(--CGfPh)"
  },
  "sizes.Chip.height-min": {
    "value": "var(--jIRRsH)",
    "variable": "var(--jIRRsH)"
  },
  "sizes.Chip.icon": {
    "value": "var(--MdJIY)",
    "variable": "var(--MdJIY)"
  },
  "sizes.Chip.slot": {
    "value": "var(--iwunAT)",
    "variable": "var(--iwunAT)"
  },
  "sizes.Chip.tapArea": {
    "value": "var(--kARFSZ)",
    "variable": "var(--kARFSZ)"
  },
  "sizes.Chip.Close.height": {
    "value": "var(--dedBzH)",
    "variable": "var(--dedBzH)"
  },
  "sizes.Chip.Close.width": {
    "value": "var(--bybRXy)",
    "variable": "var(--bybRXy)"
  },
  "sizes.CloseButton": {
    "value": "var(--fRnjA)",
    "variable": "var(--fRnjA)"
  },
  "sizes.Combobox.Adornment.height": {
    "value": "var(--cHnGWC)",
    "variable": "var(--cHnGWC)"
  },
  "sizes.Combobox.Adornment.width": {
    "value": "var(--kUZaMn)",
    "variable": "var(--kUZaMn)"
  },
  "sizes.Combobox.Clear.width": {
    "value": "var(--bnACdC)",
    "variable": "var(--bnACdC)"
  },
  "sizes.Combobox.Content.height.max": {
    "value": "var(--iqIdHe)",
    "variable": "var(--iqIdHe)"
  },
  "sizes.Combobox.Heading.icon.height": {
    "value": "var(--jTXdqM)",
    "variable": "var(--jTXdqM)"
  },
  "sizes.Combobox.Heading.icon.width": {
    "value": "var(--dslauF)",
    "variable": "var(--dslauF)"
  },
  "sizes.Combobox.InputGroup.height.min": {
    "value": "var(--gOksDY)",
    "variable": "var(--gOksDY)"
  },
  "sizes.Combobox.OptionMedia.icon.height": {
    "value": "var(--cHMLvf)",
    "variable": "var(--cHMLvf)"
  },
  "sizes.Combobox.OptionMedia.icon.width": {
    "value": "var(--gHIrvm)",
    "variable": "var(--gHIrvm)"
  },
  "sizes.DatePicker.Trigger.icon.sm.width": {
    "value": "var(--bJDUoV)",
    "variable": "var(--bJDUoV)"
  },
  "sizes.DatePicker.Trigger.icon.sm.height": {
    "value": "var(--efyvIg)",
    "variable": "var(--efyvIg)"
  },
  "sizes.DatePicker.Trigger.icon.md.width": {
    "value": "var(--ekZyBu)",
    "variable": "var(--ekZyBu)"
  },
  "sizes.DatePicker.Trigger.icon.md.height": {
    "value": "var(--hyEPZD)",
    "variable": "var(--hyEPZD)"
  },
  "sizes.DatePicker.Trigger.icon.lg.width": {
    "value": "var(--hOPIlw)",
    "variable": "var(--hOPIlw)"
  },
  "sizes.DatePicker.Trigger.icon.lg.height": {
    "value": "var(--PwLKl)",
    "variable": "var(--PwLKl)"
  },
  "sizes.DateTimeBlock.Day.minHeight": {
    "value": "var(--dlMdch)",
    "variable": "var(--dlMdch)"
  },
  "sizes.Divider.width.horizontal": {
    "value": "var(--khujvt)",
    "variable": "var(--khujvt)"
  },
  "sizes.Divider.width.emphasized": {
    "value": "var(--eSUmnL)",
    "variable": "var(--eSUmnL)"
  },
  "sizes.Divider.height.vertical": {
    "value": "var(--iETFbU)",
    "variable": "var(--iETFbU)"
  },
  "sizes.Divider.weight.emphasized.horizontal": {
    "value": "var(--hxvxha)",
    "variable": "var(--hxvxha)"
  },
  "sizes.Divider.weight.horizontal": {
    "value": "var(--iIqGrT)",
    "variable": "var(--iIqGrT)"
  },
  "sizes.Divider.weight.vertical": {
    "value": "var(--hhOptb)",
    "variable": "var(--hhOptb)"
  },
  "sizes.Dropdown.Heading.icon.height": {
    "value": "var(--cWfgQS)",
    "variable": "var(--cWfgQS)"
  },
  "sizes.Dropdown.Heading.icon.width": {
    "value": "var(--ssYFb)",
    "variable": "var(--ssYFb)"
  },
  "sizes.DuoColorIcon.Root.size": {
    "value": "var(--kKKiYT)",
    "variable": "var(--kKKiYT)"
  },
  "sizes.DuoColorIcon.Icon.size": {
    "value": "var(--gGOMWy)",
    "variable": "var(--gGOMWy)"
  },
  "sizes.FieldSet.HelperArea.icon": {
    "value": "var(--bkAUeu)",
    "variable": "var(--bkAUeu)"
  },
  "sizes.Gleam.height.min": {
    "value": "var(--bQgupD)",
    "variable": "var(--bQgupD)"
  },
  "sizes.Gleam.height.dot": {
    "value": "var(--boNztW)",
    "variable": "var(--boNztW)"
  },
  "sizes.Gleam.width.min": {
    "value": "var(--eIGowy)",
    "variable": "var(--eIGowy)"
  },
  "sizes.Gleam.width.dot": {
    "value": "var(--fKMMrr)",
    "variable": "var(--fKMMrr)"
  },
  "sizes.Gleam.positioning.default": {
    "value": "var(--gMTyGo)",
    "variable": "var(--gMTyGo)"
  },
  "sizes.Gleam.positioning.avatar.md": {
    "value": "var(--ksBLya)",
    "variable": "var(--ksBLya)"
  },
  "sizes.Gleam.positioning.avatar.lg": {
    "value": "var(--ifZMoA)",
    "variable": "var(--ifZMoA)"
  },
  "sizes.Gleam.positioning.avatar.xl": {
    "value": "var(--kWNpXP)",
    "variable": "var(--kWNpXP)"
  },
  "sizes.Gleam.positioning.avatar.xxl": {
    "value": "var(--jJNufr)",
    "variable": "var(--jJNufr)"
  },
  "sizes.Gleam.positioning.icon.sm": {
    "value": "var(--bXsWfz)",
    "variable": "var(--bXsWfz)"
  },
  "sizes.Gleam.positioning.icon.xl": {
    "value": "var(--bFloQp)",
    "variable": "var(--bFloQp)"
  },
  "sizes.IconButton.xs": {
    "value": "var(--jGGfuf)",
    "variable": "var(--jGGfuf)"
  },
  "sizes.IconButton.sm": {
    "value": "var(--fUINWG)",
    "variable": "var(--fUINWG)"
  },
  "sizes.IconButton.md": {
    "value": "var(--egOuHt)",
    "variable": "var(--egOuHt)"
  },
  "sizes.IconButton.lg": {
    "value": "var(--hjHOVz)",
    "variable": "var(--hjHOVz)"
  },
  "sizes.Layout.Root.fixed": {
    "value": "var(--dkFkxO)",
    "variable": "var(--dkFkxO)"
  },
  "sizes.Menu.Content.width.max": {
    "value": "var(--cLQuQZ)",
    "variable": "var(--cLQuQZ)"
  },
  "sizes.Menu.Content.width.min": {
    "value": "var(--byNnBz)",
    "variable": "var(--byNnBz)"
  },
  "sizes.Menu.Heading.icon.height": {
    "value": "var(--dZOLKC)",
    "variable": "var(--dZOLKC)"
  },
  "sizes.Menu.Heading.icon.width": {
    "value": "var(--jzkwaL)",
    "variable": "var(--jzkwaL)"
  },
  "sizes.Menu.ItemIcon.icon.height": {
    "value": "var(--gSJBJE)",
    "variable": "var(--gSJBJE)"
  },
  "sizes.Menu.ItemIcon.icon.width": {
    "value": "var(--eeuESJ)",
    "variable": "var(--eeuESJ)"
  },
  "sizes.Modal.Content.size.xs": {
    "value": "var(--dtotTl)",
    "variable": "var(--dtotTl)"
  },
  "sizes.Modal.Content.size.sm": {
    "value": "var(--ipixNo)",
    "variable": "var(--ipixNo)"
  },
  "sizes.Modal.Content.size.md": {
    "value": "var(--hvhrdr)",
    "variable": "var(--hvhrdr)"
  },
  "sizes.Modal.Content.size.lg": {
    "value": "var(--fjWtEx)",
    "variable": "var(--fjWtEx)"
  },
  "sizes.Modal.Content.size.xl": {
    "value": "var(--eafnaW)",
    "variable": "var(--eafnaW)"
  },
  "sizes.Modal.Content.size.fullScreen": {
    "value": "var(--bxEKfN)",
    "variable": "var(--bxEKfN)"
  },
  "sizes.NumberRating.icon.height": {
    "value": "var(--OESLk)",
    "variable": "var(--OESLk)"
  },
  "sizes.NumberRating.icon.width": {
    "value": "var(--vDrlR)",
    "variable": "var(--vDrlR)"
  },
  "sizes.Page.width.max": {
    "value": "var(--cgcDhJ)",
    "variable": "var(--cgcDhJ)"
  },
  "sizes.Pagination.PageButton.height": {
    "value": "var(--dloKTe)",
    "variable": "var(--dloKTe)"
  },
  "sizes.Pagination.PageButton.width": {
    "value": "var(--iYxLjT)",
    "variable": "var(--iYxLjT)"
  },
  "sizes.Pagination.PageButton.border": {
    "value": "var(--dVpoeR)",
    "variable": "var(--dVpoeR)"
  },
  "sizes.PhotoCarousel.Dot.current": {
    "value": "var(--VGbvG)",
    "variable": "var(--VGbvG)"
  },
  "sizes.PhotoCarousel.Dot.sm": {
    "value": "var(--jnAvwB)",
    "variable": "var(--jnAvwB)"
  },
  "sizes.PhotoCarousel.Dot.xs": {
    "value": "var(--bjmRcE)",
    "variable": "var(--bjmRcE)"
  },
  "sizes.PhotoCarousel.Dots.height": {
    "value": "var(--dJfEfn)",
    "variable": "var(--dJfEfn)"
  },
  "sizes.Popover.Content.height.max": {
    "value": "var(--kJjPZK)",
    "variable": "var(--kJjPZK)"
  },
  "sizes.Popover.Content.width.max": {
    "value": "var(--dihYkH)",
    "variable": "var(--dihYkH)"
  },
  "sizes.Popover.Header.icon.height": {
    "value": "var(--irmBtT)",
    "variable": "var(--irmBtT)"
  },
  "sizes.Popover.Header.icon.width": {
    "value": "var(--hAeEte)",
    "variable": "var(--hAeEte)"
  },
  "sizes.ProgressIndicator.bar.sm.height": {
    "value": "var(--fhnQMh)",
    "variable": "var(--fhnQMh)"
  },
  "sizes.ProgressIndicator.bar.md.height": {
    "value": "var(--istBSi)",
    "variable": "var(--istBSi)"
  },
  "sizes.ProgressMeter.Node.default": {
    "value": "var(--ggItEB)",
    "variable": "var(--ggItEB)"
  },
  "sizes.ProgressMeter.Node.container.default": {
    "value": "var(--SOAln)",
    "variable": "var(--SOAln)"
  },
  "sizes.ProgressMeter.Node.container.width.min": {
    "value": "var(--jusOZN)",
    "variable": "var(--jusOZN)"
  },
  "sizes.ProgressMeter.Node.marker.active": {
    "value": "var(--fyhOwt)",
    "variable": "var(--fyhOwt)"
  },
  "sizes.ProgressMeter.Node.marker.notStarted": {
    "value": "var(--kwkVzV)",
    "variable": "var(--kwkVzV)"
  },
  "sizes.ProgressMeter.Node.focusRing.active": {
    "value": "var(--iRFNKx)",
    "variable": "var(--iRFNKx)"
  },
  "sizes.ProgressMeter.Node.focusRing.vertical.active": {
    "value": "var(--gAysHu)",
    "variable": "var(--gAysHu)"
  },
  "sizes.ProgressMeter.Node.focusRing.default.hover": {
    "value": "var(--eDQhuB)",
    "variable": "var(--eDQhuB)"
  },
  "sizes.ProgressMeter.Node.focusRing.default.pressed": {
    "value": "var(--fhRHgt)",
    "variable": "var(--fhRHgt)"
  },
  "sizes.ProgressMeter.Node.focusRing.notStarted.hover": {
    "value": "var(--iCJQFy)",
    "variable": "var(--iCJQFy)"
  },
  "sizes.ProgressMeter.Node.focusRing.notStarted.pressed": {
    "value": "var(--jIMRza)",
    "variable": "var(--jIMRza)"
  },
  "sizes.ProgressMeter.Node.icon.default": {
    "value": "var(--gsELSL)",
    "variable": "var(--gsELSL)"
  },
  "sizes.ProgressMeter.Node.icon.complete": {
    "value": "var(--ibdSfd)",
    "variable": "var(--ibdSfd)"
  },
  "sizes.ProgressMeter.Node.icon.incomplete": {
    "value": "var(--bKrhpe)",
    "variable": "var(--bKrhpe)"
  },
  "sizes.ProgressMeter.Track.weight": {
    "value": "var(--eqycEp)",
    "variable": "var(--eqycEp)"
  },
  "sizes.ProgressMeter.Track.lengthOffset": {
    "value": "var(--fgpsEE)",
    "variable": "var(--fgpsEE)"
  },
  "sizes.PropertyCard.ActionArea.large": {
    "value": "var(--fFZSlD)",
    "variable": "var(--fFZSlD)"
  },
  "sizes.PropertyCard.ActionArea.small": {
    "value": "var(--jheOeR)",
    "variable": "var(--jheOeR)"
  },
  "sizes.PropertyCard.ActionArea.horizontal": {
    "value": "var(--cidZYI)",
    "variable": "var(--cidZYI)"
  },
  "sizes.PropertyCard.DataArea.buttonSlot.height": {
    "value": "var(--cihHaA)",
    "variable": "var(--cihHaA)"
  },
  "sizes.PropertyCard.DataArea.buttonSlot.width": {
    "value": "var(--cNIbLF)",
    "variable": "var(--cNIbLF)"
  },
  "sizes.PropertyCard.DataWrapper.large.minHeight": {
    "value": "var(--fRBmMt)",
    "variable": "var(--fRBmMt)"
  },
  "sizes.PropertyCard.DataWrapper.small.minHeight": {
    "value": "var(--iPswaj)",
    "variable": "var(--iPswaj)"
  },
  "sizes.PropertyCard.DataWrapper.horizontal.minWidth": {
    "value": "var(--hwhdJf)",
    "variable": "var(--hwhdJf)"
  },
  "sizes.PropertyCard.PhotoFallback.large.icon.height": {
    "value": "var(--itsmLa)",
    "variable": "var(--itsmLa)"
  },
  "sizes.PropertyCard.PhotoFallback.large.icon.width": {
    "value": "var(--kKPTtr)",
    "variable": "var(--kKPTtr)"
  },
  "sizes.PropertyCard.PhotoFallback.small.icon.height": {
    "value": "var(--jgEmJk)",
    "variable": "var(--jgEmJk)"
  },
  "sizes.PropertyCard.PhotoFallback.small.icon.width": {
    "value": "var(--DlYXl)",
    "variable": "var(--DlYXl)"
  },
  "sizes.PropertyCard.PhotoFallback.horizontal.icon.height": {
    "value": "var(--fiCfbd)",
    "variable": "var(--fiCfbd)"
  },
  "sizes.PropertyCard.PhotoFallback.horizontal.icon.width": {
    "value": "var(--fJdxDk)",
    "variable": "var(--fJdxDk)"
  },
  "sizes.PropertyCard.PhotoFooter.logo.maxHeight": {
    "value": "var(--gqtXrL)",
    "variable": "var(--gqtXrL)"
  },
  "sizes.PropertyCard.PhotoFooter.logo.maxWidth": {
    "value": "var(--eKxgIO)",
    "variable": "var(--eKxgIO)"
  },
  "sizes.PropertyCard.PhotoWrapper.large.minHeight": {
    "value": "var(--RlzHZ)",
    "variable": "var(--RlzHZ)"
  },
  "sizes.PropertyCard.PhotoWrapper.small.minHeight": {
    "value": "var(--elwQzH)",
    "variable": "var(--elwQzH)"
  },
  "sizes.PropertyCard.PhotoWrapper.horizontal.minHeight": {
    "value": "var(--cntGKe)",
    "variable": "var(--cntGKe)"
  },
  "sizes.PropertyCard.PhotoWrapper.horizontal.minWidth": {
    "value": "var(--cdGadr)",
    "variable": "var(--cdGadr)"
  },
  "sizes.PropertyCard.Root.large.min": {
    "value": "var(--ggQrEP)",
    "variable": "var(--ggQrEP)"
  },
  "sizes.PropertyCard.Root.large.max": {
    "value": "var(--hXIjCp)",
    "variable": "var(--hXIjCp)"
  },
  "sizes.PropertyCard.Root.small.min": {
    "value": "var(--gOsZnF)",
    "variable": "var(--gOsZnF)"
  },
  "sizes.PropertyCard.Root.small.max": {
    "value": "var(--bNWLrP)",
    "variable": "var(--bNWLrP)"
  },
  "sizes.PropertyCard.Root.horizontal.min": {
    "value": "var(--dtbyhM)",
    "variable": "var(--dtbyhM)"
  },
  "sizes.PropertyCard.Root.horizontal.max": {
    "value": "var(--eVOtgK)",
    "variable": "var(--eVOtgK)"
  },
  "sizes.PropertyCard.SaveButton.height": {
    "value": "var(--iVIHpP)",
    "variable": "var(--iVIHpP)"
  },
  "sizes.PropertyCard.SaveButton.width": {
    "value": "var(--iOMibi)",
    "variable": "var(--iOMibi)"
  },
  "sizes.Radio.ring.height": {
    "value": "var(--gtIrDo)",
    "variable": "var(--gtIrDo)"
  },
  "sizes.Radio.ring.width": {
    "value": "var(--bgjqHN)",
    "variable": "var(--bgjqHN)"
  },
  "sizes.Range.Track.height": {
    "value": "var(--kbhKlv)",
    "variable": "var(--kbhKlv)"
  },
  "sizes.Range.Handle": {
    "value": "var(--CGjYo)",
    "variable": "var(--CGjYo)"
  },
  "sizes.RatingStars.icon.height": {
    "value": "var(--iXpZyA)",
    "variable": "var(--iXpZyA)"
  },
  "sizes.RatingStars.icon.width": {
    "value": "var(--bmFJhx)",
    "variable": "var(--bmFJhx)"
  },
  "sizes.Select.icon": {
    "value": "var(--opFvC)",
    "variable": "var(--opFvC)"
  },
  "sizes.Slider.Root.height": {
    "value": "var(--chMCic)",
    "variable": "var(--chMCic)"
  },
  "sizes.Slider.Track.height": {
    "value": "var(--hbbpYZ)",
    "variable": "var(--hbbpYZ)"
  },
  "sizes.Slider.Handle": {
    "value": "var(--MJOKS)",
    "variable": "var(--MJOKS)"
  },
  "sizes.Switch.Track.md.height": {
    "value": "var(--kzEzJS)",
    "variable": "var(--kzEzJS)"
  },
  "sizes.Switch.Track.md.width": {
    "value": "var(--bEARdv)",
    "variable": "var(--bEARdv)"
  },
  "sizes.Switch.Track.lg.height": {
    "value": "var(--bwJBOQ)",
    "variable": "var(--bwJBOQ)"
  },
  "sizes.Switch.Track.lg.width": {
    "value": "var(--ietjYl)",
    "variable": "var(--ietjYl)"
  },
  "sizes.Switch.Handle.md": {
    "value": "var(--eEpCWV)",
    "variable": "var(--eEpCWV)"
  },
  "sizes.Switch.Handle.lg": {
    "value": "var(--gCQQYf)",
    "variable": "var(--gCQQYf)"
  },
  "sizes.Tabs.indicator": {
    "value": "var(--cfhGNQ)",
    "variable": "var(--cfhGNQ)"
  },
  "sizes.Toast.maxWidth": {
    "value": "var(--egWxpG)",
    "variable": "var(--egWxpG)"
  },
  "sizes.UpsellBanner.Media.icon.height": {
    "value": "var(--dLGZfW)",
    "variable": "var(--dLGZfW)"
  },
  "sizes.UpsellBanner.Media.icon.width": {
    "value": "var(--dAEPnP)",
    "variable": "var(--dAEPnP)"
  },
  "sizes.Upsell.Media.icon.height": {
    "value": "var(--hubHia)",
    "variable": "var(--hubHia)"
  },
  "sizes.Upsell.Media.icon.width": {
    "value": "var(--gtftHL)",
    "variable": "var(--gtftHL)"
  },
  "sizes.VerticalNav.Root.minWidth": {
    "value": "var(--qfQHl)",
    "variable": "var(--qfQHl)"
  },
  "sizes.action.xxs": {
    "value": "var(--llENfQ)",
    "variable": "var(--llENfQ)"
  },
  "sizes.action.xs": {
    "value": "var(--fgCUtQ)",
    "variable": "var(--fgCUtQ)"
  },
  "sizes.action.sm": {
    "value": "var(--kGaGYR)",
    "variable": "var(--kGaGYR)"
  },
  "sizes.action.md": {
    "value": "var(--fyDbHa)",
    "variable": "var(--fyDbHa)"
  },
  "sizes.action.lg": {
    "value": "var(--dJRBFQ)",
    "variable": "var(--dJRBFQ)"
  },
  "sizes.handle.xs": {
    "value": "var(--joRNEQ)",
    "variable": "var(--joRNEQ)"
  },
  "sizes.handle.sm": {
    "value": "var(--gUerdB)",
    "variable": "var(--gUerdB)"
  },
  "sizes.handle.md": {
    "value": "var(--gNFvIy)",
    "variable": "var(--gNFvIy)"
  },
  "sizes.handle.lg": {
    "value": "var(--hSguQQ)",
    "variable": "var(--hSguQQ)"
  },
  "sizes.handle.xl": {
    "value": "var(--fCZxcv)",
    "variable": "var(--fCZxcv)"
  },
  "sizes.icon.xs": {
    "value": "var(--giGyLp)",
    "variable": "var(--giGyLp)"
  },
  "sizes.icon.sm": {
    "value": "var(--crmrmM)",
    "variable": "var(--crmrmM)"
  },
  "sizes.icon.md": {
    "value": "var(--vmplf)",
    "variable": "var(--vmplf)"
  },
  "sizes.icon.lg": {
    "value": "var(--bVuKlx)",
    "variable": "var(--bVuKlx)"
  },
  "sizes.icon.xl": {
    "value": "var(--hhdBum)",
    "variable": "var(--hhdBum)"
  },
  "sizes.icon.xxl": {
    "value": "var(--cUyVZi)",
    "variable": "var(--cUyVZi)"
  },
  "sizes.indicator.xxs": {
    "value": "var(--kDfPQj)",
    "variable": "var(--kDfPQj)"
  },
  "sizes.indicator.xs": {
    "value": "var(--VdhvL)",
    "variable": "var(--VdhvL)"
  },
  "sizes.indicator.sm": {
    "value": "var(--gsYVrO)",
    "variable": "var(--gsYVrO)"
  },
  "sizes.indicator.md": {
    "value": "var(--bvLNhF)",
    "variable": "var(--bvLNhF)"
  },
  "sizes.indicator.lg": {
    "value": "var(--kNwmUb)",
    "variable": "var(--kNwmUb)"
  },
  "sizes.indicator.xl": {
    "value": "var(--coHsag)",
    "variable": "var(--coHsag)"
  },
  "sizes.obj.xxs": {
    "value": "var(--bDvoOh)",
    "variable": "var(--bDvoOh)"
  },
  "sizes.obj.xs": {
    "value": "var(--ciKIep)",
    "variable": "var(--ciKIep)"
  },
  "sizes.obj.sm": {
    "value": "var(--hQZIgs)",
    "variable": "var(--hQZIgs)"
  },
  "sizes.obj.md": {
    "value": "var(--cgsOGD)",
    "variable": "var(--cgsOGD)"
  },
  "sizes.obj.lg": {
    "value": "var(--iUaELB)",
    "variable": "var(--iUaELB)"
  },
  "sizes.obj.xl": {
    "value": "var(--evVWEO)",
    "variable": "var(--evVWEO)"
  },
  "sizes.obj.xxl": {
    "value": "var(--iWxXXu)",
    "variable": "var(--iWxXXu)"
  },
  "sizes.pipe.weight.default": {
    "value": "var(--htAnLf)",
    "variable": "var(--htAnLf)"
  },
  "sizes.pipe.weight.thick": {
    "value": "var(--WvteV)",
    "variable": "var(--WvteV)"
  },
  "sizes.pipe.weight.thicker": {
    "value": "var(--cAJcPK)",
    "variable": "var(--cAJcPK)"
  },
  "sizes.pipe.weight.thickest": {
    "value": "var(--bVWMaT)",
    "variable": "var(--bVWMaT)"
  },
  "sizes.tapArea.mobile.min": {
    "value": "var(--dXOMRQ)",
    "variable": "var(--dXOMRQ)"
  },
  "sizes.tapArea.mobile.sm": {
    "value": "var(--eJoNfE)",
    "variable": "var(--eJoNfE)"
  },
  "sizes.tapArea.mobile.default": {
    "value": "var(--hKlJFl)",
    "variable": "var(--hKlJFl)"
  },
  "sizes.tapArea.mobile.lg": {
    "value": "var(--hOxqih)",
    "variable": "var(--hOxqih)"
  },
  "sizes.xs": {
    "value": "var(--izvCpj)",
    "variable": "var(--izvCpj)"
  },
  "sizes.sm": {
    "value": "var(--aTIGG)",
    "variable": "var(--aTIGG)"
  },
  "sizes.md": {
    "value": "var(--kMQJUV)",
    "variable": "var(--kMQJUV)"
  },
  "sizes.lg": {
    "value": "var(--dyNKmL)",
    "variable": "var(--dyNKmL)"
  },
  "textDecoration.Anchor.default": {
    "value": "var(--dogKDe)",
    "variable": "var(--dogKDe)"
  },
  "textDecoration.Anchor.hover": {
    "value": "var(--lgvrH)",
    "variable": "var(--lgvrH)"
  },
  "textDecoration.TextButton.default": {
    "value": "var(--gaAIcs)",
    "variable": "var(--gaAIcs)"
  },
  "textDecoration.TextButton.hover": {
    "value": "var(--heSHIF)",
    "variable": "var(--heSHIF)"
  },
  "textDecoration.TextButton.onImpact.default": {
    "value": "var(--iBjVMS)",
    "variable": "var(--iBjVMS)"
  },
  "textDecoration.TextButton.onImpact.hover": {
    "value": "var(--gJkaNn)",
    "variable": "var(--gJkaNn)"
  },
  "textDecoration.TextButton.onImpact.neutral.default": {
    "value": "var(--cwXBOC)",
    "variable": "var(--cwXBOC)"
  },
  "textDecoration.TextButton.onImpact.neutral.hover": {
    "value": "var(--isWLIj)",
    "variable": "var(--isWLIj)"
  },
  "shadows.Calendar.YearSelect.Button.focus": {
    "value": "var(--gHFLvl)",
    "variable": "var(--gHFLvl)"
  },
  "shadows.Card.Root.elevated.default": {
    "value": "var(--itMXXd)",
    "variable": "var(--itMXXd)"
  },
  "shadows.Card.Root.interactive.default": {
    "value": "var(--eeeUur)",
    "variable": "var(--eeeUur)"
  },
  "shadows.Card.Root.interactive.hover": {
    "value": "var(--btuNku)",
    "variable": "var(--btuNku)"
  },
  "shadows.Card.Root.interactive.pressed": {
    "value": "var(--eAtQLO)",
    "variable": "var(--eAtQLO)"
  },
  "shadows.Chip.elevated.default": {
    "value": "var(--ewKbss)",
    "variable": "var(--ewKbss)"
  },
  "shadows.Chip.elevated.hover": {
    "value": "var(--kGyefd)",
    "variable": "var(--kGyefd)"
  },
  "shadows.Chip.elevated.pressed": {
    "value": "var(--inxFIV)",
    "variable": "var(--inxFIV)"
  },
  "shadows.Chip.elevated.disabled": {
    "value": "var(--eOeUQP)",
    "variable": "var(--eOeUQP)"
  },
  "shadows.Combobox.Content": {
    "value": "var(--gDjJkO)",
    "variable": "var(--gDjJkO)"
  },
  "shadows.DatePicker.Content": {
    "value": "var(--kzsHmR)",
    "variable": "var(--kzsHmR)"
  },
  "shadows.Dropdown.Content": {
    "value": "var(--finIqc)",
    "variable": "var(--finIqc)"
  },
  "shadows.Menu.Content": {
    "value": "var(--kWuBrM)",
    "variable": "var(--kWuBrM)"
  },
  "shadows.Modal.Content": {
    "value": "var(--Ljfro)",
    "variable": "var(--Ljfro)"
  },
  "shadows.PhotoCarousel.NavControls": {
    "value": "var(--eCUnUz)",
    "variable": "var(--eCUnUz)"
  },
  "shadows.Popover.Content": {
    "value": "var(--bnEqCi)",
    "variable": "var(--bnEqCi)"
  },
  "shadows.PropertyCard.Body.default": {
    "value": "var(--bVmCBz)",
    "variable": "var(--bVmCBz)"
  },
  "shadows.PropertyCard.Body.hover": {
    "value": "var(--ZosNm)",
    "variable": "var(--ZosNm)"
  },
  "shadows.PropertyCard.Body.pressed": {
    "value": "var(--dDgTiO)",
    "variable": "var(--dDgTiO)"
  },
  "shadows.PropertyCard.SaveButton.default": {
    "value": "var(--gSNEwA)",
    "variable": "var(--gSNEwA)"
  },
  "shadows.PropertyCard.SaveButton.hover": {
    "value": "var(--dxhUSV)",
    "variable": "var(--dxhUSV)"
  },
  "shadows.PropertyCard.SaveButton.pressed": {
    "value": "var(--fgKKFZ)",
    "variable": "var(--fgKKFZ)"
  },
  "shadows.PropertyCard.SaveButton.selected": {
    "value": "var(--lasQlu)",
    "variable": "var(--lasQlu)"
  },
  "shadows.PropertyCard.SaveButton.selectedHover": {
    "value": "var(--eLjGnY)",
    "variable": "var(--eLjGnY)"
  },
  "shadows.PropertyCard.SaveButton.selectedPressed": {
    "value": "var(--fjtGTY)",
    "variable": "var(--fjtGTY)"
  },
  "shadows.Range.Handle.default": {
    "value": "var(--XGfNh)",
    "variable": "var(--XGfNh)"
  },
  "shadows.Range.Handle.hover": {
    "value": "var(--bEAhJI)",
    "variable": "var(--bEAhJI)"
  },
  "shadows.Range.Handle.pressed": {
    "value": "var(--cCjkiU)",
    "variable": "var(--cCjkiU)"
  },
  "shadows.Slider.Handle.default": {
    "value": "var(--fDASKP)",
    "variable": "var(--fDASKP)"
  },
  "shadows.Slider.Handle.hover": {
    "value": "var(--cHPzwS)",
    "variable": "var(--cHPzwS)"
  },
  "shadows.Slider.Handle.pressed": {
    "value": "var(--oPbaK)",
    "variable": "var(--oPbaK)"
  },
  "shadows.Toast": {
    "value": "var(--fLuEBe)",
    "variable": "var(--fLuEBe)"
  },
  "shadows.ToggleCard.Root.default": {
    "value": "var(--jhajuw)",
    "variable": "var(--jhajuw)"
  },
  "shadows.ToggleCard.Root.hover": {
    "value": "var(--iFqDKB)",
    "variable": "var(--iFqDKB)"
  },
  "shadows.ToggleCard.Root.pressed": {
    "value": "var(--ifCFbx)",
    "variable": "var(--ifCFbx)"
  },
  "shadows.Tooltip": {
    "value": "var(--guDbxS)",
    "variable": "var(--guDbxS)"
  },
  "shadows.Upsell.Root": {
    "value": "var(--eWnEfH)",
    "variable": "var(--eWnEfH)"
  },
  "shadows.VerticalNav.Root.elevated": {
    "value": "var(--gHRExs)",
    "variable": "var(--gHRExs)"
  },
  "transitions.Combobox.OptionMedia.control": {
    "value": "var(--LAkqT)",
    "variable": "var(--LAkqT)"
  },
  "transitions.Combobox.Option": {
    "value": "var(--gyUpkl)",
    "variable": "var(--gyUpkl)"
  },
  "transitions.LabeledInput.Input": {
    "value": "var(--judnzA)",
    "variable": "var(--judnzA)"
  },
  "transitions.LabeledInput.Label": {
    "value": "var(--irIurA)",
    "variable": "var(--irIurA)"
  },
  "transitions.PhotoCarousel.Dot": {
    "value": "var(--eeBHgY)",
    "variable": "var(--eeBHgY)"
  },
  "transitions.PhotoCarousel.NavControls": {
    "value": "var(--igaaEq)",
    "variable": "var(--igaaEq)"
  },
  "transitions.PhotoCarousel.Slide": {
    "value": "var(--bedGec)",
    "variable": "var(--bedGec)"
  },
  "transitions.ProgressIndicator.bar": {
    "value": "var(--dVEptO)",
    "variable": "var(--dVEptO)"
  },
  "transitions.ProgressMeter.Node.focusRing": {
    "value": "var(--dhpAGC)",
    "variable": "var(--dhpAGC)"
  },
  "transitions.PropertyCard.Body": {
    "value": "var(--gmIQY)",
    "variable": "var(--gmIQY)"
  },
  "transitions.Switch.Track": {
    "value": "var(--jTkRKe)",
    "variable": "var(--jTkRKe)"
  },
  "transitions.Switch.Handle": {
    "value": "var(--kGKZwz)",
    "variable": "var(--kGKZwz)"
  },
  "opacity.Modal.Backdrop": {
    "value": "var(--cvrsvr)",
    "variable": "var(--cvrsvr)"
  },
  "opacity.Popover.Backdrop": {
    "value": "var(--jCkCZd)",
    "variable": "var(--jCkCZd)"
  },
  "opacity.ProgressMeter.Node.focusRing": {
    "value": "var(--ftAQMb)",
    "variable": "var(--ftAQMb)"
  },
  "opacity.invisible": {
    "value": "var(--cfgyPe)",
    "variable": "var(--cfgyPe)"
  },
  "opacity.disabled": {
    "value": "var(--kOrReb)",
    "variable": "var(--kOrReb)"
  },
  "opacity.dialogScrim": {
    "value": "var(--dhIIHR)",
    "variable": "var(--dhIIHR)"
  },
  "opacity.loadingMask": {
    "value": "var(--bjybDp)",
    "variable": "var(--bjybDp)"
  },
  "opacity.action.default": {
    "value": "var(--ZPhyz)",
    "variable": "var(--ZPhyz)"
  },
  "opacity.action.hover": {
    "value": "var(--bpPRxO)",
    "variable": "var(--bpPRxO)"
  },
  "opacity.action.pressed": {
    "value": "var(--flROfa)",
    "variable": "var(--flROfa)"
  },
  "opacity.action.active": {
    "value": "var(--bpTwww)",
    "variable": "var(--bpTwww)"
  },
  "opacity.action.focus": {
    "value": "var(--hKVYjA)",
    "variable": "var(--hKVYjA)"
  },
  "opacity.action.disabled": {
    "value": "var(--lfkYYk)",
    "variable": "var(--lfkYYk)"
  },
  "opacity.opacity100": {
    "value": "var(--iMbrnL)",
    "variable": "var(--iMbrnL)"
  },
  "opacity.opacity200": {
    "value": "var(--bKSpSA)",
    "variable": "var(--bKSpSA)"
  },
  "opacity.opacity300": {
    "value": "var(--lozTiR)",
    "variable": "var(--lozTiR)"
  },
  "opacity.opacity400": {
    "value": "var(--cUKiCm)",
    "variable": "var(--cUKiCm)"
  },
  "opacity.opacity500": {
    "value": "var(--biWctH)",
    "variable": "var(--biWctH)"
  },
  "opacity.mask": {
    "value": "var(--eDUDTr)",
    "variable": "var(--eDUDTr)"
  },
  "fonts.Page.Header.default": {
    "value": "var(--eUmBjR)",
    "variable": "var(--eUmBjR)"
  },
  "fonts.heading": {
    "value": "var(--bTZOq)",
    "variable": "var(--bTZOq)"
  },
  "fonts.heading-alt": {
    "value": "var(--eeBaXG)",
    "variable": "var(--eeBaXG)"
  },
  "fonts.default": {
    "value": "var(--faGMXV)",
    "variable": "var(--faGMXV)"
  },
  "fonts.sansSerif": {
    "value": "var(--gXAUcK)",
    "variable": "var(--gXAUcK)"
  },
  "fonts.serif": {
    "value": "var(--guQdxN)",
    "variable": "var(--guQdxN)"
  },
  "lineHeights.ProgressMeter.Label.default": {
    "value": "var(--iSveYP)",
    "variable": "var(--iSveYP)"
  },
  "lineHeights.heading-xl": {
    "value": "var(--dpmFeB)",
    "variable": "var(--dpmFeB)"
  },
  "lineHeights.heading-lg": {
    "value": "var(--jDQva)",
    "variable": "var(--jDQva)"
  },
  "lineHeights.heading-md": {
    "value": "var(--ikpxsU)",
    "variable": "var(--ikpxsU)"
  },
  "lineHeights.heading-sm": {
    "value": "var(--ggWjEj)",
    "variable": "var(--ggWjEj)"
  },
  "lineHeights.heading-xs": {
    "value": "var(--hnMgsC)",
    "variable": "var(--hnMgsC)"
  },
  "lineHeights.body-lg": {
    "value": "var(--knSypq)",
    "variable": "var(--knSypq)"
  },
  "lineHeights.body": {
    "value": "var(--jazbJU)",
    "variable": "var(--jazbJU)"
  },
  "lineHeights.body-sm": {
    "value": "var(--gfWCcb)",
    "variable": "var(--gfWCcb)"
  },
  "lineHeights.body-xs": {
    "value": "var(--bvvfpa)",
    "variable": "var(--bvvfpa)"
  },
  "lineHeights.fineprint": {
    "value": "var(--exfYFZ)",
    "variable": "var(--exfYFZ)"
  },
  "lineHeights.fineprint-sm": {
    "value": "var(--chYLmm)",
    "variable": "var(--chYLmm)"
  },
  "lineHeights.responsive.heading-xl.mobile": {
    "value": "var(--hQXSIF)",
    "variable": "var(--hQXSIF)"
  },
  "lineHeights.responsive.heading-xl.tablet": {
    "value": "var(--bidYkL)",
    "variable": "var(--bidYkL)"
  },
  "lineHeights.responsive.heading-xl.desktop": {
    "value": "var(--dFqQzH)",
    "variable": "var(--dFqQzH)"
  },
  "lineHeights.responsive.heading-lg.mobile": {
    "value": "var(--kzGagG)",
    "variable": "var(--kzGagG)"
  },
  "lineHeights.responsive.heading-lg.tablet": {
    "value": "var(--eAPGDU)",
    "variable": "var(--eAPGDU)"
  },
  "lineHeights.responsive.heading-lg.desktop": {
    "value": "var(--bfJCQc)",
    "variable": "var(--bfJCQc)"
  },
  "lineHeights.responsive.heading-md.mobile": {
    "value": "var(--kabIwI)",
    "variable": "var(--kabIwI)"
  },
  "lineHeights.responsive.heading-md.tablet": {
    "value": "var(--eqMJHm)",
    "variable": "var(--eqMJHm)"
  },
  "lineHeights.responsive.heading-md.desktop": {
    "value": "var(--ldjPvu)",
    "variable": "var(--ldjPvu)"
  },
  "lineHeights.responsive.heading-sm.mobile": {
    "value": "var(--XYQDP)",
    "variable": "var(--XYQDP)"
  },
  "lineHeights.responsive.heading-sm.tablet": {
    "value": "var(--bmAidl)",
    "variable": "var(--bmAidl)"
  },
  "lineHeights.responsive.heading-sm.desktop": {
    "value": "var(--fYFtpd)",
    "variable": "var(--fYFtpd)"
  },
  "lineHeights.responsive.heading-xs.mobile": {
    "value": "var(--lggUwa)",
    "variable": "var(--lggUwa)"
  },
  "lineHeights.responsive.heading-xs.tablet": {
    "value": "var(--fhqATo)",
    "variable": "var(--fhqATo)"
  },
  "lineHeights.responsive.heading-xs.desktop": {
    "value": "var(--hFfjYs)",
    "variable": "var(--hFfjYs)"
  },
  "lineHeights.responsive.body-lg.mobile": {
    "value": "var(--dUKSRe)",
    "variable": "var(--dUKSRe)"
  },
  "lineHeights.responsive.body-lg.tablet": {
    "value": "var(--exRiGk)",
    "variable": "var(--exRiGk)"
  },
  "lineHeights.responsive.body-lg.desktop": {
    "value": "var(--kBWicQ)",
    "variable": "var(--kBWicQ)"
  },
  "lineHeights.responsive.body.mobile": {
    "value": "var(--eABQhA)",
    "variable": "var(--eABQhA)"
  },
  "lineHeights.responsive.body.tablet": {
    "value": "var(--lokavO)",
    "variable": "var(--lokavO)"
  },
  "lineHeights.responsive.body.desktop": {
    "value": "var(--gjmpiK)",
    "variable": "var(--gjmpiK)"
  },
  "lineHeights.responsive.body-sm.mobile": {
    "value": "var(--jyshnb)",
    "variable": "var(--jyshnb)"
  },
  "lineHeights.responsive.body-sm.tablet": {
    "value": "var(--iduAgh)",
    "variable": "var(--iduAgh)"
  },
  "lineHeights.responsive.body-sm.desktop": {
    "value": "var(--cdePDt)",
    "variable": "var(--cdePDt)"
  },
  "lineHeights.responsive.body-xs.mobile": {
    "value": "var(--fMPWCq)",
    "variable": "var(--fMPWCq)"
  },
  "lineHeights.responsive.body-xs.tablet": {
    "value": "var(--gpWmrw)",
    "variable": "var(--gpWmrw)"
  },
  "lineHeights.responsive.body-xs.desktop": {
    "value": "var(--hxNKBw)",
    "variable": "var(--hxNKBw)"
  },
  "lineHeights.responsive.fineprint.mobile": {
    "value": "var(--eNRxEB)",
    "variable": "var(--eNRxEB)"
  },
  "lineHeights.responsive.fineprint.tablet": {
    "value": "var(--dmiIkb)",
    "variable": "var(--dmiIkb)"
  },
  "lineHeights.responsive.fineprint.desktop": {
    "value": "var(--xMjqH)",
    "variable": "var(--xMjqH)"
  },
  "lineHeights.responsive.fineprint-sm.mobile": {
    "value": "var(--iPmoLm)",
    "variable": "var(--iPmoLm)"
  },
  "lineHeights.responsive.fineprint-sm.tablet": {
    "value": "var(--bPlRcI)",
    "variable": "var(--bPlRcI)"
  },
  "lineHeights.responsive.fineprint-sm.desktop": {
    "value": "var(--bRNBaY)",
    "variable": "var(--bRNBaY)"
  },
  "lineHeights.h1": {
    "value": "var(--kxZHAB)",
    "variable": "var(--kxZHAB)"
  },
  "lineHeights.h2": {
    "value": "var(--kqjwdu)",
    "variable": "var(--kqjwdu)"
  },
  "lineHeights.h3": {
    "value": "var(--iEamkP)",
    "variable": "var(--iEamkP)"
  },
  "lineHeights.h4": {
    "value": "var(--jPBVgU)",
    "variable": "var(--jPBVgU)"
  },
  "lineHeights.h5": {
    "value": "var(--idsLop)",
    "variable": "var(--idsLop)"
  },
  "lineHeights.h6": {
    "value": "var(--hVCzRi)",
    "variable": "var(--hVCzRi)"
  },
  "lineHeights.bodyHeading": {
    "value": "var(--LBZKs)",
    "variable": "var(--LBZKs)"
  },
  "lineHeights.bodySmallHeading": {
    "value": "var(--hyhyFb)",
    "variable": "var(--hyhyFb)"
  },
  "lineHeights.bodySmall": {
    "value": "var(--hXGhPb)",
    "variable": "var(--hXGhPb)"
  },
  "lineHeights.finePrintHeading": {
    "value": "var(--fSYGNl)",
    "variable": "var(--fSYGNl)"
  },
  "lineHeights.legal": {
    "value": "var(--bHjNsX)",
    "variable": "var(--bHjNsX)"
  },
  "translate.Switch.Handle.md.x": {
    "value": "var(--hNpAdU)",
    "variable": "var(--hNpAdU)"
  },
  "translate.Switch.Handle.lg.x": {
    "value": "var(--cCdyhC)",
    "variable": "var(--cCdyhC)"
  },
  "fontWeights.VerticalNav.Item.active": {
    "value": "var(--jFKFPw)",
    "variable": "var(--jFKFPw)"
  },
  "fontWeights.h0": {
    "value": "var(--PRIrC)",
    "variable": "var(--PRIrC)"
  },
  "fontWeights.h1": {
    "value": "var(--ktvyyX)",
    "variable": "var(--ktvyyX)"
  },
  "fontWeights.h2": {
    "value": "var(--kkImtw)",
    "variable": "var(--kkImtw)"
  },
  "fontWeights.h3": {
    "value": "var(--iyQtbV)",
    "variable": "var(--iyQtbV)"
  },
  "fontWeights.h4": {
    "value": "var(--jLRVWe)",
    "variable": "var(--jLRVWe)"
  },
  "fontWeights.h5": {
    "value": "var(--iaacED)",
    "variable": "var(--iaacED)"
  },
  "fontWeights.h6": {
    "value": "var(--hRmQzc)",
    "variable": "var(--hRmQzc)"
  },
  "fontWeights.bodyHeading": {
    "value": "var(--HVSsi)",
    "variable": "var(--HVSsi)"
  },
  "fontWeights.bodySmallHeading": {
    "value": "var(--hDaZht)",
    "variable": "var(--hDaZht)"
  },
  "fontWeights.bodySmall": {
    "value": "var(--hYHEsF)",
    "variable": "var(--hYHEsF)"
  },
  "fontWeights.finePrintHeading": {
    "value": "var(--fPHXdP)",
    "variable": "var(--fPHXdP)"
  },
  "fontWeights.legal": {
    "value": "var(--bKRNDx)",
    "variable": "var(--bKRNDx)"
  },
  "fontSizes.heading-xl": {
    "value": "var(--jkUKjO)",
    "variable": "var(--jkUKjO)"
  },
  "fontSizes.heading-lg": {
    "value": "var(--wODFN)",
    "variable": "var(--wODFN)"
  },
  "fontSizes.heading-md": {
    "value": "var(--jlRGvD)",
    "variable": "var(--jlRGvD)"
  },
  "fontSizes.heading-sm": {
    "value": "var(--fJEwns)",
    "variable": "var(--fJEwns)"
  },
  "fontSizes.heading-xs": {
    "value": "var(--bWPmTF)",
    "variable": "var(--bWPmTF)"
  },
  "fontSizes.body-lg": {
    "value": "var(--knxioJ)",
    "variable": "var(--knxioJ)"
  },
  "fontSizes.body": {
    "value": "var(--jbcuDz)",
    "variable": "var(--jbcuDz)"
  },
  "fontSizes.body-sm": {
    "value": "var(--hMAEYg)",
    "variable": "var(--hMAEYg)"
  },
  "fontSizes.body-xs": {
    "value": "var(--eQVust)",
    "variable": "var(--eQVust)"
  },
  "fontSizes.fineprint": {
    "value": "var(--iYvKHe)",
    "variable": "var(--iYvKHe)"
  },
  "fontSizes.fineprint-sm": {
    "value": "var(--giwSB)",
    "variable": "var(--giwSB)"
  },
  "fontSizes.responsive.heading-xl.mobile": {
    "value": "var(--kRxMJK)",
    "variable": "var(--kRxMJK)"
  },
  "fontSizes.responsive.heading-xl.tablet": {
    "value": "var(--eRKlgc)",
    "variable": "var(--eRKlgc)"
  },
  "fontSizes.responsive.heading-xl.desktop": {
    "value": "var(--mSEbE)",
    "variable": "var(--mSEbE)"
  },
  "fontSizes.responsive.heading-lg.mobile": {
    "value": "var(--iYIkoh)",
    "variable": "var(--iYIkoh)"
  },
  "fontSizes.responsive.heading-lg.tablet": {
    "value": "var(--fWKNSv)",
    "variable": "var(--fWKNSv)"
  },
  "fontSizes.responsive.heading-lg.desktop": {
    "value": "var(--bjDorz)",
    "variable": "var(--bjDorz)"
  },
  "fontSizes.responsive.heading-md.mobile": {
    "value": "var(--lasoYv)",
    "variable": "var(--lasoYv)"
  },
  "fontSizes.responsive.heading-md.tablet": {
    "value": "var(--ixrhUp)",
    "variable": "var(--ixrhUp)"
  },
  "fontSizes.responsive.heading-md.desktop": {
    "value": "var(--bIAPMh)",
    "variable": "var(--bIAPMh)"
  },
  "fontSizes.responsive.heading-sm.mobile": {
    "value": "var(--fUIsIc)",
    "variable": "var(--fUIsIc)"
  },
  "fontSizes.responsive.heading-sm.tablet": {
    "value": "var(--dORBaq)",
    "variable": "var(--dORBaq)"
  },
  "fontSizes.responsive.heading-sm.desktop": {
    "value": "var(--dJHawG)",
    "variable": "var(--dJHawG)"
  },
  "fontSizes.responsive.heading-xs.mobile": {
    "value": "var(--cjtybl)",
    "variable": "var(--cjtybl)"
  },
  "fontSizes.responsive.heading-xs.tablet": {
    "value": "var(--kwRLev)",
    "variable": "var(--kwRLev)"
  },
  "fontSizes.responsive.heading-xs.desktop": {
    "value": "var(--bkXzof)",
    "variable": "var(--bkXzof)"
  },
  "fontSizes.responsive.body-lg.mobile": {
    "value": "var(--hiipxl)",
    "variable": "var(--hiipxl)"
  },
  "fontSizes.responsive.body-lg.tablet": {
    "value": "var(--eMnsNH)",
    "variable": "var(--eMnsNH)"
  },
  "fontSizes.responsive.body-lg.desktop": {
    "value": "var(--ajrRP)",
    "variable": "var(--ajrRP)"
  },
  "fontSizes.responsive.body.mobile": {
    "value": "var(--eZoqIz)",
    "variable": "var(--eZoqIz)"
  },
  "fontSizes.responsive.body.tablet": {
    "value": "var(--duweRp)",
    "variable": "var(--duweRp)"
  },
  "fontSizes.responsive.body.desktop": {
    "value": "var(--dxsbMl)",
    "variable": "var(--dxsbMl)"
  },
  "fontSizes.responsive.body-sm.mobile": {
    "value": "var(--drlkDU)",
    "variable": "var(--drlkDU)"
  },
  "fontSizes.responsive.body-sm.tablet": {
    "value": "var(--eRVdWi)",
    "variable": "var(--eRVdWi)"
  },
  "fontSizes.responsive.body-sm.desktop": {
    "value": "var(--fuBEWa)",
    "variable": "var(--fuBEWa)"
  },
  "fontSizes.responsive.body-xs.mobile": {
    "value": "var(--jBmgzZ)",
    "variable": "var(--jBmgzZ)"
  },
  "fontSizes.responsive.body-xs.tablet": {
    "value": "var(--hfrjQv)",
    "variable": "var(--hfrjQv)"
  },
  "fontSizes.responsive.body-xs.desktop": {
    "value": "var(--eEINdP)",
    "variable": "var(--eEINdP)"
  },
  "fontSizes.responsive.fineprint.mobile": {
    "value": "var(--hSLAUm)",
    "variable": "var(--hSLAUm)"
  },
  "fontSizes.responsive.fineprint.tablet": {
    "value": "var(--gseRFs)",
    "variable": "var(--gseRFs)"
  },
  "fontSizes.responsive.fineprint.desktop": {
    "value": "var(--cGFvRk)",
    "variable": "var(--cGFvRk)"
  },
  "fontSizes.responsive.fineprint-sm.mobile": {
    "value": "var(--boQjUV)",
    "variable": "var(--boQjUV)"
  },
  "fontSizes.responsive.fineprint-sm.tablet": {
    "value": "var(--cleidb)",
    "variable": "var(--cleidb)"
  },
  "fontSizes.responsive.fineprint-sm.desktop": {
    "value": "var(--fhrIFz)",
    "variable": "var(--fhrIFz)"
  },
  "fontSizes.h1": {
    "value": "var(--ePchQC)",
    "variable": "var(--ePchQC)"
  },
  "fontSizes.h2": {
    "value": "var(--vgpah)",
    "variable": "var(--vgpah)"
  },
  "fontSizes.h3": {
    "value": "var(--dskZkE)",
    "variable": "var(--dskZkE)"
  },
  "fontSizes.h4": {
    "value": "var(--bFpHWH)",
    "variable": "var(--bFpHWH)"
  },
  "fontSizes.h5": {
    "value": "var(--eCushe)",
    "variable": "var(--eCushe)"
  },
  "fontSizes.h6": {
    "value": "var(--iyzqJ)",
    "variable": "var(--iyzqJ)"
  },
  "fontSizes.bodyHeading": {
    "value": "var(--dFinpz)",
    "variable": "var(--dFinpz)"
  },
  "fontSizes.bodySmallHeading": {
    "value": "var(--jDYsEY)",
    "variable": "var(--jDYsEY)"
  },
  "fontSizes.bodySmall": {
    "value": "var(--esoDCI)",
    "variable": "var(--esoDCI)"
  },
  "fontSizes.finePrintHeading": {
    "value": "var(--fCZEi)",
    "variable": "var(--fCZEi)"
  },
  "fontSizes.legal": {
    "value": "var(--htyijA)",
    "variable": "var(--htyijA)"
  },
  "letterSpacings.heading-xl": {
    "value": "var(--flpzqL)",
    "variable": "var(--flpzqL)"
  },
  "letterSpacings.heading-lg": {
    "value": "var(--hqfldE)",
    "variable": "var(--hqfldE)"
  },
  "letterSpacings.heading-md": {
    "value": "var(--jxKnpS)",
    "variable": "var(--jxKnpS)"
  },
  "letterSpacings.heading-sm": {
    "value": "var(--juMFuF)",
    "variable": "var(--juMFuF)"
  },
  "letterSpacings.heading-xs": {
    "value": "var(--kyBLSQ)",
    "variable": "var(--kyBLSQ)"
  },
  "letterSpacings.body-lg": {
    "value": "var(--bbcvwk)",
    "variable": "var(--bbcvwk)"
  },
  "letterSpacings.body": {
    "value": "var(--kngkcm)",
    "variable": "var(--kngkcm)"
  },
  "letterSpacings.body-sm": {
    "value": "var(--fHcIKx)",
    "variable": "var(--fHcIKx)"
  },
  "letterSpacings.body-xs": {
    "value": "var(--ifkLtM)",
    "variable": "var(--ifkLtM)"
  },
  "letterSpacings.fineprint": {
    "value": "var(--jyIyX)",
    "variable": "var(--jyIyX)"
  },
  "letterSpacings.fineprint-sm": {
    "value": "var(--dFTYEk)",
    "variable": "var(--dFTYEk)"
  },
  "letterSpacings.responsive.heading-xl.mobile": {
    "value": "var(--kJxXVn)",
    "variable": "var(--kJxXVn)"
  },
  "letterSpacings.responsive.heading-xl.tablet": {
    "value": "var(--gicRqZ)",
    "variable": "var(--gicRqZ)"
  },
  "letterSpacings.responsive.heading-xl.desktop": {
    "value": "var(--eFqxBp)",
    "variable": "var(--eFqxBp)"
  },
  "letterSpacings.responsive.heading-lg.mobile": {
    "value": "var(--bWDTIE)",
    "variable": "var(--bWDTIE)"
  },
  "letterSpacings.responsive.heading-lg.tablet": {
    "value": "var(--jJdjBq)",
    "variable": "var(--jJdjBq)"
  },
  "letterSpacings.responsive.heading-lg.desktop": {
    "value": "var(--jCqaPW)",
    "variable": "var(--jCqaPW)"
  },
  "letterSpacings.responsive.heading-md.mobile": {
    "value": "var(--fZWwFi)",
    "variable": "var(--fZWwFi)"
  },
  "letterSpacings.responsive.heading-md.tablet": {
    "value": "var(--lgOMmU)",
    "variable": "var(--lgOMmU)"
  },
  "letterSpacings.responsive.heading-md.desktop": {
    "value": "var(--kaXXAo)",
    "variable": "var(--kaXXAo)"
  },
  "letterSpacings.responsive.heading-sm.mobile": {
    "value": "var(--bFvChx)",
    "variable": "var(--bFvChx)"
  },
  "letterSpacings.responsive.heading-sm.tablet": {
    "value": "var(--hlGFAr)",
    "variable": "var(--hlGFAr)"
  },
  "letterSpacings.responsive.heading-sm.desktop": {
    "value": "var(--eoqSYP)",
    "variable": "var(--eoqSYP)"
  },
  "letterSpacings.responsive.heading-xs.mobile": {
    "value": "var(--fKaJFA)",
    "variable": "var(--fKaJFA)"
  },
  "letterSpacings.responsive.heading-xs.tablet": {
    "value": "var(--chepZq)",
    "variable": "var(--chepZq)"
  },
  "letterSpacings.responsive.heading-xs.desktop": {
    "value": "var(--doEamu)",
    "variable": "var(--doEamu)"
  },
  "letterSpacings.responsive.body-lg.mobile": {
    "value": "var(--gvzGXA)",
    "variable": "var(--gvzGXA)"
  },
  "letterSpacings.responsive.body-lg.tablet": {
    "value": "var(--grqAJi)",
    "variable": "var(--grqAJi)"
  },
  "letterSpacings.responsive.body-lg.desktop": {
    "value": "var(--fodThG)",
    "variable": "var(--fodThG)"
  },
  "letterSpacings.responsive.body.mobile": {
    "value": "var(--LWGYa)",
    "variable": "var(--LWGYa)"
  },
  "letterSpacings.responsive.body.tablet": {
    "value": "var(--iQmDyY)",
    "variable": "var(--iQmDyY)"
  },
  "letterSpacings.responsive.body.desktop": {
    "value": "var(--jEDLpE)",
    "variable": "var(--jEDLpE)"
  },
  "letterSpacings.responsive.body-sm.mobile": {
    "value": "var(--hQWGOB)",
    "variable": "var(--hQWGOB)"
  },
  "letterSpacings.responsive.body-sm.tablet": {
    "value": "var(--gzLjRL)",
    "variable": "var(--gzLjRL)"
  },
  "letterSpacings.responsive.body-sm.desktop": {
    "value": "var(--iajRAX)",
    "variable": "var(--iajRAX)"
  },
  "letterSpacings.responsive.body-xs.mobile": {
    "value": "var(--hcaBmU)",
    "variable": "var(--hcaBmU)"
  },
  "letterSpacings.responsive.body-xs.tablet": {
    "value": "var(--gXRuYC)",
    "variable": "var(--gXRuYC)"
  },
  "letterSpacings.responsive.body-xs.desktop": {
    "value": "var(--ydQRa)",
    "variable": "var(--ydQRa)"
  },
  "letterSpacings.responsive.fineprint.mobile": {
    "value": "var(--ijLumD)",
    "variable": "var(--ijLumD)"
  },
  "letterSpacings.responsive.fineprint.tablet": {
    "value": "var(--GmMLJ)",
    "variable": "var(--GmMLJ)"
  },
  "letterSpacings.responsive.fineprint.desktop": {
    "value": "var(--bwmcEN)",
    "variable": "var(--bwmcEN)"
  },
  "letterSpacings.responsive.fineprint-sm.mobile": {
    "value": "var(--eAnWlc)",
    "variable": "var(--eAnWlc)"
  },
  "letterSpacings.responsive.fineprint-sm.tablet": {
    "value": "var(--fwQTvG)",
    "variable": "var(--fwQTvG)"
  },
  "letterSpacings.responsive.fineprint-sm.desktop": {
    "value": "var(--dXvcDO)",
    "variable": "var(--dXvcDO)"
  },
  "colors.border.action.disabled": {
    "value": "var(--enPcae)",
    "variable": "var(--enPcae)"
  },
  "colors.border.action.disabled-alt": {
    "value": "var(--hWqCKa)",
    "variable": "var(--hWqCKa)"
  },
  "colors.icon.onHero.link.fixed.default": {
    "value": "var(--gdDnhL)",
    "variable": "var(--gdDnhL)"
  },
  "colors.icon.onHero.link.fixed.hover": {
    "value": "var(--bJnjrO)",
    "variable": "var(--bJnjrO)"
  },
  "colors.icon.onHero.link.fixed.pressed": {
    "value": "var(--eQmmTi)",
    "variable": "var(--eQmmTi)"
  },
  "colors.icon.onImpact.express.energy.hero": {
    "value": "var(--cOQDtA)",
    "variable": "var(--cOQDtA)"
  },
  "colors.text.link.selected": {
    "value": "var(--jZEbSY)",
    "variable": "var(--jZEbSY)"
  },
  "colors.Accordion.Panel.icon.leading": {
    "value": "var(--btikik)",
    "variable": "var(--btikik)"
  },
  "colors.Accordion.Panel.icon.trailing": {
    "value": "var(--ceQZPa)",
    "variable": "var(--ceQZPa)"
  },
  "colors.Accordion.Panel.label.default": {
    "value": "var(--lidBZu)",
    "variable": "var(--lidBZu)"
  },
  "colors.Accordion.Panel.label.trailing": {
    "value": "var(--iQQUGj)",
    "variable": "var(--iQQUGj)"
  },
  "colors.Anchor.onImpact.active": {
    "value": "var(--jnzjwi)",
    "variable": "var(--jnzjwi)"
  },
  "colors.DatePicker.InputGroup.bg.autofill": {
    "value": "var(--ewRzlP)",
    "variable": "var(--ewRzlP)"
  },
  "colors.DatePicker.InputGroup.text.adornment.default": {
    "value": "var(--bqXgTl)",
    "variable": "var(--bqXgTl)"
  },
  "colors.DatePicker.InputGroup.text.adornment.readOnly": {
    "value": "var(--hjjkGc)",
    "variable": "var(--hjjkGc)"
  },
  "colors.FieldSet.helperArea.icon.default": {
    "value": "var(--ghkSPg)",
    "variable": "var(--ghkSPg)"
  },
  "colors.FieldSet.helperArea.icon.error": {
    "value": "var(--gRrkQb)",
    "variable": "var(--gRrkQb)"
  },
  "colors.FieldSet.helperArea.text.default": {
    "value": "var(--kQmxXO)",
    "variable": "var(--kQmxXO)"
  },
  "colors.FieldSet.helperArea.text.error": {
    "value": "var(--enfBZZ)",
    "variable": "var(--enfBZZ)"
  },
  "colors.IconButton.onImpact.filled.critical.border.default": {
    "value": "var(--bZArWN)",
    "variable": "var(--bZArWN)"
  },
  "colors.IconButton.onImpact.filled.critical.border.hover": {
    "value": "var(--cwopHw)",
    "variable": "var(--cwopHw)"
  },
  "colors.IconButton.onImpact.bare.brand.border.default": {
    "value": "var(--ccKkIv)",
    "variable": "var(--ccKkIv)"
  },
  "colors.IconButton.onImpact.bare.brand.border.hover": {
    "value": "var(--dbrkmG)",
    "variable": "var(--dbrkmG)"
  },
  "colors.IconButton.onImpact.bare.brand.border.pressed": {
    "value": "var(--kEKyyq)",
    "variable": "var(--kEKyyq)"
  },
  "colors.Input.border.readOnly": {
    "value": "var(--fWJjLg)",
    "variable": "var(--fWJjLg)"
  },
  "colors.ProgressIndicator.circular.track.bg.default": {
    "value": "var(--FONTw)",
    "variable": "var(--FONTw)"
  },
  "colors.ProgressIndicator.circular.track.bg.active": {
    "value": "var(--dllpZH)",
    "variable": "var(--dllpZH)"
  },
  "colors.ProgressIndicator.spinner.text.default": {
    "value": "var(--mPGBG)",
    "variable": "var(--mPGBG)"
  },
  "colors.ProgressIndicator.spinner.text.onImpact": {
    "value": "var(--eClwnW)",
    "variable": "var(--eClwnW)"
  },
  "colors.ProgressMeter.Node.complete.border": {
    "value": "var(--jkYTOO)",
    "variable": "var(--jkYTOO)"
  },
  "colors.ProgressMeter.Node.incomplete.border": {
    "value": "var(--hjYVqV)",
    "variable": "var(--hjYVqV)"
  },
  "colors.Range.Track.bg.active": {
    "value": "var(--YVaYQ)",
    "variable": "var(--YVaYQ)"
  },
  "colors.Range.Handle.bg.activeActive": {
    "value": "var(--ewPRUZ)",
    "variable": "var(--ewPRUZ)"
  },
  "colors.Range.Handle.border.activeActive": {
    "value": "var(--knwxxw)",
    "variable": "var(--knwxxw)"
  },
  "colors.Tabs.file.label.hover": {
    "value": "var(--iGcKOj)",
    "variable": "var(--iGcKOj)"
  },
  "colors.Tabs.file.label.pressed": {
    "value": "var(--jGIZdD)",
    "variable": "var(--jGIZdD)"
  },
  "colors.Tabs.file.label.active": {
    "value": "var(--kqAeuZ)",
    "variable": "var(--kqAeuZ)"
  },
  "colors.Tabs.file.icon.default": {
    "value": "var(--gOceWj)",
    "variable": "var(--gOceWj)"
  },
  "colors.Tabs.file.icon.hover": {
    "value": "var(--eIhCxy)",
    "variable": "var(--eIhCxy)"
  },
  "colors.Tabs.file.icon.pressed": {
    "value": "var(--cphebq)",
    "variable": "var(--cphebq)"
  },
  "colors.Tabs.file.icon.active": {
    "value": "var(--eRznbQ)",
    "variable": "var(--eRznbQ)"
  },
  "radii.Button.xs": {
    "value": "var(--gurypJ)",
    "variable": "var(--gurypJ)"
  },
  "spacing.Accordion.Header.gap.between-tags": {
    "value": "var(--fRjuod)",
    "variable": "var(--fRjuod)"
  },
  "spacing.Alert.gap.message-toFlexArea": {
    "value": "var(--cLyUkK)",
    "variable": "var(--cLyUkK)"
  },
  "spacing.ButtonGroup.textButton.padding.horz": {
    "value": "var(--hXLxzu)",
    "variable": "var(--hXLxzu)"
  },
  "spacing.ButtonGroup.textButton.padding.vert": {
    "value": "var(--gihyzU)",
    "variable": "var(--gihyzU)"
  },
  "spacing.FormField.HelperArea.gap.text-toCharCount": {
    "value": "var(--gKblKh)",
    "variable": "var(--gKblKh)"
  },
  "spacing.Input.sm.gap.input-toAdornment": {
    "value": "var(--hzyLYM)",
    "variable": "var(--hzyLYM)"
  },
  "spacing.Input.md.gap.input-toAdornment": {
    "value": "var(--dJoDHL)",
    "variable": "var(--dJoDHL)"
  },
  "spacing.Input.lg.gap.input-toAdornment": {
    "value": "var(--gmgJmR)",
    "variable": "var(--gmgJmR)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.dataArea1-toSupportRows": {
    "value": "var(--fqMqrq)",
    "variable": "var(--fqMqrq)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.dataArea1-toSupportRows": {
    "value": "var(--jZLUXs)",
    "variable": "var(--jZLUXs)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.dataArea1-toSupportRows": {
    "value": "var(--gFynLZ)",
    "variable": "var(--gFynLZ)"
  },
  "sizes.DatePicker.Trigger.width": {
    "value": "var(--bRfJtM)",
    "variable": "var(--bRfJtM)"
  },
  "sizes.DatePicker.Trigger.height": {
    "value": "var(--bFDVuR)",
    "variable": "var(--bFDVuR)"
  },
  "sizes.FieldSet.helperArea.icon": {
    "value": "var(--lcRDBy)",
    "variable": "var(--lcRDBy)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar